import { __decorate, __awaiter } from 'tslib';
import * as i0 from '@angular/core';
import { Injectable, Optional, Inject, PLATFORM_ID, Injector } from '@angular/core';
import * as i1 from '@angular/common/http';
import { HttpParams, HttpClient } from '@angular/common/http';
import { map, filter, take, tap, delay, switchMap } from 'rxjs/operators';
import { BehaviorSubject, Observable, Subject, ReplaySubject, of } from 'rxjs';
import { Centrifuge } from 'centrifuge';
import { isPlatformBrowser } from '@angular/common';
import { Subject as Subject$1 } from 'rxjs/internal/Subject';
import { captureException } from '@sentry/angular';
import { FormGroup } from '@angular/forms';

import * as ɵngcc0 from '@angular/core';
import * as ɵngcc1 from '@angular/common/http';
const HockeyPenaltyTypes = [
    { id: 1, code: 'АГРЕС', title: 'Агрессор в драке' },
    { id: 2, code: 'АТ-В-ГОЛ', title: 'Атака в голову или шею' },
    { id: 3, code: 'АТ-ВР', title: 'Атака вратаря' },
    { id: 4, code: 'АТ-СЗ', title: 'Атака сзади' },
    { id: 5, code: 'БЛОК', title: 'Блокировка' },
    { id: 6, code: 'БР-КЛ', title: 'Бросок клюшки' },
    { id: 7, code: 'ВБ-ШБ', title: 'Выброс шайбы' },
    { id: 8, code: 'ГРУБ', title: 'Грубость' },
    { id: 9, code: 'ДИСЦ', title: 'Дисциплинарный штраф' },
    { id: 10, code: 'ДИС-КН', title: 'Дисциплинарный до конца матча' },
    { id: 11, code: 'ДРАКА', title: 'Драка' },
    { id: 12, code: 'ЗАЧИН', title: 'Зачинщик драки' },
    { id: 13, code: 'ЗД-ИГ', title: 'Задержка игры' },
    { id: 14, code: 'ЗД-КЛ-СП', title: 'Задержка клюшки соперника' },
    { id: 15, code: 'ЗД-КЛ', title: 'Задержка клюшкой' },
    { id: 16, code: 'ЗД-СП', title: 'Задержка соперника' },
    { id: 17, code: 'ЗД-ШБ', title: 'Задержка шайбы руками' },
    { id: 18, code: 'СЛ-КЛ', title: 'Игра со сломанной клюшкой' },
    { id: 19, code: 'ВП-КЛ', title: 'Игра высоко поднятой клюшкой' },
    { id: 20, code: 'КЛ-УД', title: 'Колющий удар' },
    { id: 21, code: 'СК-ШТ', title: 'Малый скамеечный штраф' },
    { id: 22, code: 'МШ', title: 'Матч-штраф' },
    { id: 23, code: 'НП-АТ', title: 'Неправильная атака' },
    { id: 24, code: 'ЧС-СТ', title: 'Нарушение численного состава' },
    { id: 25, code: 'НС-КЛ', title: 'Нестандартная клюшка' },
    { id: 26, code: 'НАР-ЭК', title: 'Опасное снаряжение' },
    { id: 27, code: 'НС-ПВ', title: 'Оскорбление судей и неспортивное поведение' },
    { id: 28, code: 'ОТ-ИГ', title: 'Отказ начать игру' },
    { id: 29, code: 'ОТСЧ', title: 'Отсечение' },
    { id: 30, code: 'ПЛЕВОК', title: 'Плевок' },
    { id: 31, code: 'ПОДН', title: 'Подножка' },
    { id: 32, code: 'ПОДС', title: 'Подсечка' },
    { id: 33, code: 'ПР-ИН', title: 'Предупреждение инфекций' },
    { id: 34, code: 'ПК-СК', title: 'Покидание скамейки во время конфликта' },
    { id: 35, code: 'СД-ВР', title: 'Сдвиг ворот' },
    { id: 36, code: 'СИМ', title: 'Симуляция' },
    { id: 37, code: 'ТЛ-БР', title: 'Толчок на борт' },
    { id: 38, code: 'ТЛ-КЛ', title: 'Толчок клюшкой' },
    { id: 39, code: 'УД-ГОЛ', title: 'Удар головой' },
    { id: 40, code: 'УД-КЛ', title: 'Удар клюшкой' },
    { id: 41, code: 'УД-К-КЛ', title: 'Удар концом клюшки' },
    { id: 42, code: 'УД-КОЛ', title: 'Удар коленом' },
    { id: 43, code: 'УД-ЛОК', title: 'Удар локтем' },
    { id: 44, code: 'УД-НГ', title: 'Удар ногой' },
    { id: 45, code: 'УКУС', title: 'Укус' },
    { id: 46, code: 'КН-ЗР', title: 'Физический контакт со зрителем' },
    { id: 47, code: 'ШТ-ВР', title: 'Штраф вратаря' },
];
const HockeyPenaltyTypesEn = [
    { id: 1, code: 'AGGR', title: 'Агрессор в драке' },
    { id: 2, code: 'AT-HD', title: 'Attack to the head or neck' },
    { id: 3, code: 'AT-GO', title: 'Goalkeeper attack' },
    { id: 4, code: 'AT-BH', title: 'Attack from behind' },
    { id: 5, code: 'BLOCK', title: 'Blocking' },
    { id: 6, code: 'TH-ST', title: 'Throwing a stick' },
    { id: 7, code: 'PC-RL', title: 'Puck release' },
    { id: 8, code: 'RUDE', title: 'Rudeness' },
    { id: 9, code: 'DISC', title: 'Disciplinary penalty' },
    { id: 10, code: 'DISC-EM', title: 'Disciplinary until the end of the match' },
    { id: 11, code: 'FIGHT', title: 'Fight' },
    { id: 12, code: 'IN-FG', title: 'The instigator of the fight' },
    { id: 13, code: 'GD', title: 'Game delay' },
    { id: 14, code: 'HD-OP-ST', title: 'Holding an opponent\'s stick' },
    { id: 15, code: 'ST-HD', title: 'Stick hold' },
    { id: 16, code: 'DL-OP', title: 'Delaying the opponent' },
    { id: 17, code: 'HL-PC-HD', title: 'Holding the puck with your hands' },
    { id: 18, code: 'PL-BS', title: 'Playing with a broken stick' },
    { id: 19, code: 'HSP', title: 'High stick play' },
    { id: 20, code: 'THR', title: 'Thrust' },
    { id: 21, code: 'MI-BE', title: 'Minor bench penalty' },
    { id: 22, code: 'MP', title: 'Match penalty' },
    { id: 23, code: 'WR-AT', title: 'Wrong attack' },
    { id: 24, code: 'NM-VO', title: 'Violation of numerical composition' },
    { id: 25, code: 'NS-ST', title: 'Non-standard stick' },
    { id: 26, code: 'DE', title: 'Dangerous equipment' },
    { id: 27, code: 'INS-REF', title: 'Insulting referees and unsportsmanlike conduct' },
    { id: 28, code: 'RF-SG', title: 'Refusal to start the game' },
    { id: 29, code: 'CO', title: 'Cut-off' },
    { id: 30, code: 'SPIT', title: 'Spit' },
    { id: 31, code: 'STEP', title: 'Step' },
    { id: 32, code: 'UND', title: 'Undercut' },
    { id: 33, code: 'PR-INF', title: 'Prevention of infections' },
    { id: 34, code: 'LE-BE', title: 'Leaving the bench during a conflict' },
    { id: 35, code: 'GA-SH', title: 'Gate shift' },
    { id: 36, code: 'SIM', title: 'Simulation' },
    { id: 37, code: 'PU-BR', title: 'Push on board' },
    { id: 38, code: 'PU-ST', title: 'Stick push' },
    { id: 39, code: 'AT-HD', title: 'Head kick' },
    { id: 40, code: 'HT-ST', title: 'Hit with a stick' },
    { id: 41, code: 'HT-ST-E', title: 'Hit with the end of the stick' },
    { id: 42, code: 'ST-KN', title: 'Knee strike' },
    { id: 43, code: 'ST-EB', title: 'Elbow strike' },
    { id: 44, code: 'KICK', title: 'Kick' },
    { id: 45, code: 'BITE', title: 'Bite' },
    { id: 46, code: 'CN-VW', title: 'Physical contact with the viewer' },
    { id: 47, code: 'PN-GO', title: 'Goalkeeper penalty' },
];

const MODEL_MAPPING_FIELDS_KEY = '_mapping_fields_';
const MODEL_RELATION_KEY = '_relation_';
const MODEL_TO_FRONT_KEY = '_to_front_';
const MODEL_TO_BACK_KEY = '_to_back_';
class BaseModel {
    constructor(data) {
        if (data) {
            for (const key of Object.keys(data)) {
                this[key] = data[key];
            }
        }
    }
    static toFront(dto) {
        return undefined;
    }
    static toBack(dto) {
        return undefined;
    }
}
function enumField(enumClass) {
    return {
        toFront: (value) => {
            if (value === null || value === undefined) {
                return value;
            }
            if (isNaN(+value)) {
                return enumClass[value];
            }
            else {
                return value;
            }
        },
        toBack: (value) => {
            if (value === null || value === undefined) {
                return value;
            }
            if (isNaN(+value)) {
                return value;
            }
            else {
                return enumClass[value];
            }
        }
    };
}
function penaltyTypeField() {
    return {
        toFront: (data) => {
            if (!data) {
                return null;
            }
            if (typeof data === 'object') {
                return data;
            }
            return HockeyPenaltyTypes.find(item => item.id === data);
        },
        toBack: (data) => {
            if (!data) {
                return null;
            }
            if (typeof data === 'object') {
                return data.id;
            }
            return data;
        }
    };
}
function listField(modelClass) {
    return {
        toFront: (value) => {
            if (!Array.isArray(value)) {
                return [];
            }
            return value.map(item => modelClass.toFront(item));
        },
        toBack: (value) => {
            if (!Array.isArray(value)) {
                return [];
            }
            return value.map(item => modelClass.toBack(item));
        }
    };
}
class DateField extends BaseModel {
    static toFront(date) {
        if (date) {
            return new Date(date);
        }
        else {
            return undefined;
        }
    }
    static toBack(date) {
        if (date) {
            const dateUtc = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
            return dateUtc.toISOString().slice(0, 10);
        }
        else {
            return undefined;
        }
    }
}
class DateTimeField extends BaseModel {
    static toFront(date) {
        if (date) {
            return new Date(date);
        }
        else {
            return undefined;
        }
    }
    static toBack(date) {
        if (date) {
            const dateUtc = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds()));
            return date.toISOString();
        }
        else {
            return undefined;
        }
    }
}
function ModelInstance(config) {
    return (target) => {
        if (config) {
            if (config.mappingFields) {
                target[MODEL_MAPPING_FIELDS_KEY] = config.mappingFields;
            }
            if (config.relation) {
                target[MODEL_RELATION_KEY] = config.relation;
            }
            target[MODEL_TO_FRONT_KEY] = (dto) => {
                return toFront(target, dto);
            };
            target[MODEL_TO_BACK_KEY] = (dto) => {
                return toBack(target, dto);
            };
        }
    };
}
const ToFrontHook = (target, key, descriptor) => {
    return {
        value: (...args) => {
            const parseMethod = target[MODEL_TO_FRONT_KEY];
            if (parseMethod) {
                return parseMethod(args[0]);
            }
            return undefined;
        }
    };
};
const ToBackHook = (target, key, descriptor) => {
    return {
        value: (...args) => {
            const parseMethod = target[MODEL_TO_BACK_KEY];
            if (parseMethod) {
                return parseMethod(args[0]);
            }
            return undefined;
        }
    };
};
function extractValue(key, data) {
    if (!data) {
        return undefined;
    }
    const keyParts = key.split('.');
    if (keyParts.length === 1) {
        if (key in data) {
            return data[key];
        }
        else {
            return undefined;
        }
    }
    for (const k of keyParts) {
        if (data && k in data) {
            data = data[k];
        }
        else {
            return undefined;
        }
    }
    return data;
}
function toFront(modelType, data) {
    // Check if recursion is required
    if (Array.isArray(data)) {
        return data.map(item => {
            return toFront(modelType, item);
        });
    }
    const instance = new modelType();
    // Mapping fields
    const mappingFields = modelType[MODEL_MAPPING_FIELDS_KEY];
    const relation = modelType[MODEL_RELATION_KEY];
    if (mappingFields) {
        for (const backField of Object.keys(mappingFields)) {
            const frontField = mappingFields[backField];
            const value = extractValue(backField, data);
            if (relation && relation.hasOwnProperty(frontField)) {
                instance[frontField] = relation[frontField].toFront(value);
            }
            else {
                instance[frontField] = value;
            }
        }
    }
    return instance;
}
function toBack(modelType, instance) {
    if (!instance) {
        return instance;
    }
    // Check if recursion is required
    if (Array.isArray(instance)) {
        return instance.map(item => {
            return toBack(modelType, item);
        });
    }
    const data = {};
    const mappingFields = modelType[MODEL_MAPPING_FIELDS_KEY];
    const relation = modelType[MODEL_RELATION_KEY];
    if (mappingFields) {
        for (const backField of Object.keys(mappingFields)) {
            const frontField = mappingFields[backField];
            if (relation && relation.hasOwnProperty(frontField) && instance[frontField] !== undefined) {
                data[backField] = relation[frontField].toBack(instance[frontField]);
            }
            else {
                data[backField] = instance[frontField];
            }
        }
    }
    return data;
}

var FileEngine;
(function (FileEngine) {
    FileEngine[FileEngine["django"] = 1] = "django";
    FileEngine[FileEngine["s3"] = 2] = "s3";
})(FileEngine || (FileEngine = {}));
let File = class File {
    set originalName(name) {
        this._originalName = name;
    }
    get originalName() {
        return this._originalName || this.name;
    }
    set path(filePath) {
        this._path = filePath;
    }
    get path() {
        return this.resizedPath || this._path;
    }
    static toFront(data) {
        return null;
    }
    static toBack(file) {
        return null;
    }
};
__decorate([
    ToFrontHook
], File, "toFront", null);
__decorate([
    ToBackHook
], File, "toBack", null);
File = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            original_name: 'originalName',
            path: 'path',
            resized_path: 'resizedPath',
            mime_type: 'mimeType',
            size: 'size',
            engine: 'engine',
            created_at: 'createdAt',
        },
        relation: {
            engine: enumField(FileEngine),
            createdAt: DateTimeField,
        }
    })
], File);

var SportTypes;
(function (SportTypes) {
    SportTypes[SportTypes["basketball"] = 1] = "basketball";
    SportTypes[SportTypes["volleyball"] = 2] = "volleyball";
    SportTypes[SportTypes["classic_basketball"] = 3] = "classic_basketball";
    SportTypes[SportTypes["streetball"] = 4] = "streetball";
    SportTypes[SportTypes["classic_volleyball"] = 5] = "classic_volleyball";
    SportTypes[SportTypes["beach_volleyball"] = 6] = "beach_volleyball";
    SportTypes[SportTypes["hockey"] = 7] = "hockey";
    SportTypes[SportTypes["ice_hockey"] = 8] = "ice_hockey";
    SportTypes[SportTypes["ball_hockey"] = 9] = "ball_hockey";
    SportTypes[SportTypes["football"] = 10] = "football";
    SportTypes[SportTypes["classic_football"] = 11] = "classic_football";
    SportTypes[SportTypes["mini_football"] = 12] = "mini_football";
    SportTypes[SportTypes["handball"] = 13] = "handball";
    SportTypes[SportTypes["handball_classic"] = 14] = "handball_classic";
    SportTypes[SportTypes["rugby"] = 15] = "rugby";
    SportTypes[SportTypes["rugby15"] = 16] = "rugby15";
    SportTypes[SportTypes["rugby7"] = 17] = "rugby7";
    SportTypes[SportTypes["basketball_1x1"] = 18] = "basketball_1x1";
    SportTypes[SportTypes["waterpolo"] = 19] = "waterpolo";
    SportTypes[SportTypes["classic_waterpolo"] = 20] = "classic_waterpolo";
    SportTypes[SportTypes["mini_waterpolo"] = 21] = "mini_waterpolo";
    SportTypes[SportTypes["media_basket"] = 22] = "media_basket";
    SportTypes[SportTypes["moneyball_basket"] = 23] = "moneyball_basket";
    SportTypes[SportTypes["wrestball"] = 24] = "wrestball";
    SportTypes[SportTypes["wrestball_classic"] = 25] = "wrestball_classic";
    SportTypes[SportTypes["winline_basket"] = 26] = "winline_basket";
})(SportTypes || (SportTypes = {}));
let Sport = class Sport extends BaseModel {
    isBasketball() {
        return this.id === SportTypes.basketball || this.parentId === SportTypes.basketball;
    }
    isClassicBasketball() {
        return this.id === SportTypes.classic_basketball;
    }
    isStreetball() {
        return this.id === SportTypes.streetball;
    }
    isBasketball1x1() {
        return this.id === SportTypes.basketball_1x1;
    }
    isMediaBasket() {
        return this.id === SportTypes.media_basket;
    }
    isMoneyballBasket() {
        return this.id === SportTypes.moneyball_basket;
    }
    isWinlinebasket() {
        return this.id === SportTypes.winline_basket;
    }
    isVolleyball() {
        return this.id === SportTypes.volleyball || this.parentId === SportTypes.volleyball;
    }
    isClassicVolleyball() {
        return this.id === SportTypes.classic_volleyball;
    }
    isBeachVolleyball() {
        return this.id === SportTypes.beach_volleyball;
    }
    isHockey() {
        return this.id === SportTypes.hockey || this.parentId === SportTypes.hockey;
    }
    isIceHockey() {
        return this.id === SportTypes.ice_hockey;
    }
    isBallHockey() {
        return this.id === SportTypes.ball_hockey;
    }
    isFootball() {
        return this.id === SportTypes.football || this.parentId === SportTypes.football;
    }
    isClassicFootball() {
        return this.id === SportTypes.classic_football;
    }
    isMiniFootball() {
        return this.id === SportTypes.mini_football;
    }
    isHandball() {
        return this.id === SportTypes.handball || this.parentId === SportTypes.handball;
    }
    isHandballClassic() {
        return this.id === SportTypes.handball_classic;
    }
    isRugby() {
        return this.id === SportTypes.rugby || this.parentId === SportTypes.rugby;
    }
    isRugby15() {
        return this.id === SportTypes.rugby15;
    }
    isRugby7() {
        return this.id === SportTypes.rugby7;
    }
    isWaterpolo() {
        return this.id === SportTypes.waterpolo || this.parentId === SportTypes.waterpolo;
    }
    isClassicWaterpolo() {
        return this.id === SportTypes.classic_waterpolo;
    }
    isMiniWaterpolo() {
        return this.id === SportTypes.mini_waterpolo;
    }
    isWrestball() {
        return this.id === SportTypes.wrestball || this.parentId === SportTypes.wrestball;
    }
    static toFront(data) {
        return null;
    }
    static toBack(sport) {
        return null;
    }
};
__decorate([
    ToFrontHook
], Sport, "toFront", null);
__decorate([
    ToBackHook
], Sport, "toBack", null);
Sport = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            parent_id: 'parentId',
            sub_sports: 'subSports'
        }
    })
], Sport);

let UserProfile = class UserProfile {
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], UserProfile, "toFront", null);
__decorate([
    ToBackHook
], UserProfile, "toBack", null);
UserProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            height: 'height',
            weight: 'weight'
        }
    })
], UserProfile);

var Country;
(function (Country) {
    Country["RU"] = "RU";
    Country["BL"] = "BL";
    Country["AM"] = "AM";
    Country["KZ"] = "KZ";
    Country["KG"] = "KG";
    Country["USA"] = "USA";
    Country["GE"] = "GE";
    Country["AZ"] = "AZ";
    Country["CHN"] = "CHN";
    Country["EGY"] = "EGY";
    Country["IRN"] = "IRN";
    Country["GRC"] = "GRC";
})(Country || (Country = {}));
let City = class City extends BaseModel {
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], City, "toFront", null);
__decorate([
    ToBackHook
], City, "toBack", null);
City = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            name_en: 'nameEn',
            country: 'country',
        },
        relation: {
            country: enumField(Country),
        }
    })
], City);

var GameBasketballPosition;
(function (GameBasketballPosition) {
    GameBasketballPosition[GameBasketballPosition["point_guard"] = 1] = "point_guard";
    GameBasketballPosition[GameBasketballPosition["shooting_guard"] = 2] = "shooting_guard";
    GameBasketballPosition[GameBasketballPosition["small_forward"] = 3] = "small_forward";
    GameBasketballPosition[GameBasketballPosition["power_forward"] = 4] = "power_forward";
    GameBasketballPosition[GameBasketballPosition["center"] = 5] = "center";
})(GameBasketballPosition || (GameBasketballPosition = {}));
var WorkHand;
(function (WorkHand) {
    WorkHand[WorkHand["left"] = 1] = "left";
    WorkHand[WorkHand["right"] = 2] = "right";
})(WorkHand || (WorkHand = {}));
let BasketballProfile = class BasketballProfile extends BaseModel {
    static toFront(value) {
    }
    static toBack(value) {
    }
};
__decorate([
    ToFrontHook
], BasketballProfile, "toFront", null);
__decorate([
    ToBackHook
], BasketballProfile, "toBack", null);
BasketballProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            position: 'position',
            work_hand: 'workHand'
        },
        relation: {
            position: enumField(GameBasketballPosition),
            workHand: enumField(WorkHand)
        }
    })
], BasketballProfile);

var GameVolleyballPosition;
(function (GameVolleyballPosition) {
    GameVolleyballPosition[GameVolleyballPosition["setter"] = 1] = "setter";
    GameVolleyballPosition[GameVolleyballPosition["libero"] = 2] = "libero";
    GameVolleyballPosition[GameVolleyballPosition["middle_player"] = 3] = "middle_player";
    GameVolleyballPosition[GameVolleyballPosition["receiver_attacker"] = 4] = "receiver_attacker";
    GameVolleyballPosition[GameVolleyballPosition["dioganal"] = 5] = "dioganal";
})(GameVolleyballPosition || (GameVolleyballPosition = {}));
var VolleyballWorkHand;
(function (VolleyballWorkHand) {
    VolleyballWorkHand[VolleyballWorkHand["left"] = 1] = "left";
    VolleyballWorkHand[VolleyballWorkHand["right"] = 2] = "right";
})(VolleyballWorkHand || (VolleyballWorkHand = {}));
let VolleyballProfile = class VolleyballProfile extends BaseModel {
    static toFront(value) {
    }
    static toBack(value) {
    }
};
__decorate([
    ToFrontHook
], VolleyballProfile, "toFront", null);
__decorate([
    ToBackHook
], VolleyballProfile, "toBack", null);
VolleyballProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            position: 'position',
            work_hand: 'workHand'
        },
        relation: {
            position: enumField(GameVolleyballPosition),
            workHand: enumField(VolleyballWorkHand)
        }
    })
], VolleyballProfile);

var GameHockeyPosition;
(function (GameHockeyPosition) {
    GameHockeyPosition[GameHockeyPosition["defensemen"] = 1] = "defensemen";
    GameHockeyPosition[GameHockeyPosition["forward"] = 2] = "forward";
    GameHockeyPosition[GameHockeyPosition["goaltender"] = 3] = "goaltender";
})(GameHockeyPosition || (GameHockeyPosition = {}));
var HockeyWorkHand;
(function (HockeyWorkHand) {
    HockeyWorkHand[HockeyWorkHand["left"] = 1] = "left";
    HockeyWorkHand[HockeyWorkHand["right"] = 2] = "right";
})(HockeyWorkHand || (HockeyWorkHand = {}));
let HockeyProfile = class HockeyProfile extends BaseModel {
    static toFront(value) {
    }
    static toBack(value) {
    }
};
__decorate([
    ToFrontHook
], HockeyProfile, "toFront", null);
__decorate([
    ToBackHook
], HockeyProfile, "toBack", null);
HockeyProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            position: 'position',
            work_hand: 'workHand'
        },
        relation: {
            position: enumField(GameHockeyPosition),
            workHand: enumField(HockeyWorkHand)
        }
    })
], HockeyProfile);

var GameFootballPosition;
(function (GameFootballPosition) {
    GameFootballPosition[GameFootballPosition["defensemen"] = 1] = "defensemen";
    GameFootballPosition[GameFootballPosition["midfielder"] = 2] = "midfielder";
    GameFootballPosition[GameFootballPosition["forward"] = 3] = "forward";
    GameFootballPosition[GameFootballPosition["goalkeeper"] = 4] = "goalkeeper";
})(GameFootballPosition || (GameFootballPosition = {}));
var FootballWorkFoot;
(function (FootballWorkFoot) {
    FootballWorkFoot[FootballWorkFoot["left"] = 1] = "left";
    FootballWorkFoot[FootballWorkFoot["right"] = 2] = "right";
    FootballWorkFoot[FootballWorkFoot["both"] = 3] = "both";
})(FootballWorkFoot || (FootballWorkFoot = {}));
let FootballProfile = class FootballProfile extends BaseModel {
    static toFront(value) {
    }
    static toBack(value) {
    }
};
__decorate([
    ToFrontHook
], FootballProfile, "toFront", null);
__decorate([
    ToBackHook
], FootballProfile, "toBack", null);
FootballProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            position: 'position',
            work_foot: 'workFoot'
        },
        relation: {
            position: enumField(GameFootballPosition),
            workFoot: enumField(FootballWorkFoot)
        }
    })
], FootballProfile);

var GameHandballPosition;
(function (GameHandballPosition) {
    GameHandballPosition[GameHandballPosition["goalkeeper"] = 1] = "goalkeeper";
    GameHandballPosition[GameHandballPosition["winger"] = 2] = "winger";
    GameHandballPosition[GameHandballPosition["pivot"] = 3] = "pivot";
    GameHandballPosition[GameHandballPosition["centre_back"] = 4] = "centre_back";
    GameHandballPosition[GameHandballPosition["fullback"] = 5] = "fullback";
})(GameHandballPosition || (GameHandballPosition = {}));
let HandballProfile = class HandballProfile extends BaseModel {
    static toFront(value) {
    }
    static toBack(value) {
    }
};
__decorate([
    ToFrontHook
], HandballProfile, "toFront", null);
__decorate([
    ToBackHook
], HandballProfile, "toBack", null);
HandballProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            position: 'position',
            work_hand: 'workHand'
        },
        relation: {
            position: enumField(GameHandballPosition),
            workHand: enumField(WorkHand)
        }
    })
], HandballProfile);

var GameRugbyPosition;
(function (GameRugbyPosition) {
    GameRugbyPosition[GameRugbyPosition["front_line"] = 1] = "front_line";
    GameRugbyPosition[GameRugbyPosition["second_line"] = 2] = "second_line";
    GameRugbyPosition[GameRugbyPosition["back_line"] = 3] = "back_line";
    GameRugbyPosition[GameRugbyPosition["halfback"] = 4] = "halfback";
    GameRugbyPosition[GameRugbyPosition["three_quarter"] = 5] = "three_quarter";
    GameRugbyPosition[GameRugbyPosition["fullback"] = 6] = "fullback";
})(GameRugbyPosition || (GameRugbyPosition = {}));
let RugbyProfile = class RugbyProfile extends BaseModel {
    static toFront(value) {
    }
    static toBack(value) {
    }
};
__decorate([
    ToFrontHook
], RugbyProfile, "toFront", null);
__decorate([
    ToBackHook
], RugbyProfile, "toBack", null);
RugbyProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            position: 'position'
        },
        relation: {
            position: enumField(GameRugbyPosition),
        }
    })
], RugbyProfile);

var GameWaterpoloPosition;
(function (GameWaterpoloPosition) {
    GameWaterpoloPosition[GameWaterpoloPosition["goalkeeper"] = 1] = "goalkeeper";
    GameWaterpoloPosition[GameWaterpoloPosition["defensemen"] = 2] = "defensemen";
    GameWaterpoloPosition[GameWaterpoloPosition["center_forward"] = 3] = "center_forward";
    GameWaterpoloPosition[GameWaterpoloPosition["mobile_forward"] = 4] = "mobile_forward";
})(GameWaterpoloPosition || (GameWaterpoloPosition = {}));
var WaterpoloWorkHand;
(function (WaterpoloWorkHand) {
    WaterpoloWorkHand[WaterpoloWorkHand["left"] = 1] = "left";
    WaterpoloWorkHand[WaterpoloWorkHand["right"] = 2] = "right";
})(WaterpoloWorkHand || (WaterpoloWorkHand = {}));
let WaterpoloProfile = class WaterpoloProfile extends BaseModel {
    static toFront(value) {
    }
    static toBack(value) {
    }
};
__decorate([
    ToFrontHook
], WaterpoloProfile, "toFront", null);
__decorate([
    ToBackHook
], WaterpoloProfile, "toBack", null);
WaterpoloProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            position: 'position',
            work_hand: 'workHand'
        },
        relation: {
            position: enumField(GameWaterpoloPosition),
            workHand: enumField(WaterpoloWorkHand)
        }
    })
], WaterpoloProfile);

var WrestballWorkHand;
(function (WrestballWorkHand) {
    WrestballWorkHand[WrestballWorkHand["left"] = 1] = "left";
    WrestballWorkHand[WrestballWorkHand["right"] = 2] = "right";
})(WrestballWorkHand || (WrestballWorkHand = {}));
let WrestballProfile = class WrestballProfile extends BaseModel {
    static toFront(value) {
    }
    static toBack(value) {
    }
};
__decorate([
    ToFrontHook
], WrestballProfile, "toFront", null);
__decorate([
    ToBackHook
], WrestballProfile, "toBack", null);
WrestballProfile = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            work_hand: 'workHand'
        },
        relation: {
            workHand: enumField(WrestballWorkHand)
        }
    })
], WrestballProfile);

var UserGender;
(function (UserGender) {
    UserGender[UserGender["male"] = 1] = "male";
    UserGender[UserGender["female"] = 2] = "female";
})(UserGender || (UserGender = {}));
let User = class User extends BaseModel {
    static toFront(data) {
        return null;
    }
    static toBack(user) {
        return null;
    }
    get fullName() {
        return [this.lastName, this.firstName].filter(s => s).join(' ');
    }
    get shortName() {
        return [this.lastName, this.firstName].filter(s => s).join(' ');
    }
    get initials() {
        return [this.lastName, this.firstName].filter(s => s).map(s => s.substr(0, 1)).join('');
    }
    get age() {
        if (!this.birthDate) {
            return null;
        }
        const diff = (new Date()).getTime() - this.birthDate.getTime();
        return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
    }
};
__decorate([
    ToFrontHook
], User, "toFront", null);
__decorate([
    ToBackHook
], User, "toBack", null);
User = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            last_name: 'lastName',
            first_name: 'firstName',
            middle_name: 'middleName',
            email: 'email',
            phone: 'phone',
            birth_date: 'birthDate',
            photo: 'photo',
            profile: 'profile',
            basketball_profile: 'basketballProfile',
            volleyball_profile: 'volleyballProfile',
            hockey_profile: 'hockeyProfile',
            football_profile: 'footballProfile',
            handball_profile: 'handballProfile',
            rugby_profile: 'rugbyProfile',
            waterpolo_profile: 'waterpoloProfile',
            wrestball_profile: 'wrestballProfile',
            wizards: 'wizards',
            city: 'city',
            gender: 'gender',
            is_active: 'isActive',
            unique_code: 'uniqueCode',
            created_by_league_id: 'createdByLeagueId',
        },
        relation: {
            birthDate: DateField,
            photo: File,
            profile: UserProfile,
            basketballProfile: BasketballProfile,
            volleyballProfile: VolleyballProfile,
            hockeyProfile: HockeyProfile,
            footballProfile: FootballProfile,
            handballProfile: HandballProfile,
            rugbyProfile: RugbyProfile,
            waterpoloProfile: WaterpoloProfile,
            wrestballProfile: WrestballProfile,
            city: City,
            gender: enumField(UserGender)
        }
    })
], User);

let Team = class Team extends BaseModel {
    getEmptyLogoClass() {
        const classList = ['empty-logo'];
        if (this.sport.isBasketball()) {
            classList.push('empty-logo-basketball');
        }
        if (this.sport.isVolleyball()) {
            classList.push('empty-logo-volleyball');
        }
        if (this.sport.isHockey()) {
            classList.push('empty-logo-hockey');
        }
        if (this.sport.isFootball()) {
            classList.push('empty-logo-football');
        }
        if (this.sport.isHandball()) {
            classList.push('empty-logo-handball');
        }
        if (this.sport.isRugby()) {
            classList.push('empty-logo-rugby');
        }
        if (this.sport.isWaterpolo()) {
            classList.push('empty-logo-waterpolo');
        }
        if (this.sport.isWrestball()) {
            classList.push('empty-logo-basketball');
        }
        return classList.join(' ');
    }
    static toFront(data) {
        return null;
    }
    static toBack(team) {
        return null;
    }
};
__decorate([
    ToFrontHook
], Team, "toFront", null);
__decorate([
    ToBackHook
], Team, "toBack", null);
Team = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            sport: 'sport',
            logo: 'logo',
            owner: 'owner',
            city: 'city',
            users_count: 'usersCount',
            won_games_count: 'wonGamesCount',
            games_count: 'gamesCount',
            score_sum: 'scoreSum',
            closest_game_datetime: 'closestGameDatetime',
            created_by_league_id: 'createdByLeagueId',
            unique_code: 'uniqueCode',
        },
        relation: {
            sport: Sport,
            logo: File,
            owner: User,
            city: City,
            closestGameDatetime: DateField,
        }
    })
], Team);

var OrganizationStatuses;
(function (OrganizationStatuses) {
    OrganizationStatuses[OrganizationStatuses["active"] = 1] = "active";
    OrganizationStatuses[OrganizationStatuses["blocked"] = 2] = "blocked";
    OrganizationStatuses[OrganizationStatuses["not_confirmed"] = 3] = "not_confirmed";
})(OrganizationStatuses || (OrganizationStatuses = {}));
let Organization = class Organization extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], Organization, "toFront", null);
__decorate([
    ToBackHook
], Organization, "toBack", null);
Organization = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            owner_id: 'ownerId',
            owner: 'owner',
            status: 'status',
            name: 'name',
            phone: 'phone',
            email: 'email',
            unpaid_bills_sum: 'unpaidBillsSum',
            unpaid_game_bills_sum: 'unpaidGameBillsSum',
        },
        relation: {
            owner: User,
            status: enumField(OrganizationStatuses)
        }
    })
], Organization);

let League = class League extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
    get vkLink() {
        return this.socialLinks.find(link => link.indexOf('vk.com/') > -1);
    }
    get fbLink() {
        return this.socialLinks.find(link => link.indexOf('facebook.com/') > -1);
    }
    get instaLink() {
        return this.socialLinks.find(link => link.indexOf('instagram.com/') > -1);
    }
    get youtubeLink() {
        return this.socialLinks.find(link => link.indexOf('youtube.com/') > -1);
    }
    get telegramLink() {
        return this.socialLinks.find(link => link.substr(0, 13) === 'https://t.me/' ||
            link.substr(0, 17) === 'https://www.t.me/');
    }
    get tiktokLink() {
        return this.socialLinks.find(link => link.indexOf('tiktok.com/') > -1);
    }
    checkRuDomain() {
        const domainSplit = this.domain.split('.');
        return domainSplit[(domainSplit.length - 1)] === 'ru';
    }
};
__decorate([
    ToFrontHook
], League, "toFront", null);
__decorate([
    ToBackHook
], League, "toBack", null);
League = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            logo: 'logo',
            contact_email: 'contactEmail',
            contact_phone: 'contactPhone',
            name: 'name',
            alias: 'alias',
            domain: 'domain',
            sport: 'sport',
            description: 'description',
            social_links: 'socialLinks',
            links: 'links',
            organization: 'organization',
            tournaments_count: 'tournamentsCount',
            documents_count: 'documentsCount',
            closest_game_datetime: 'closestGameDatetime',
            cover: 'cover',
            cover_mobile: 'coverMobile',
            about: 'about',
            locale: 'locale',
        },
        relation: {
            organization: Organization,
            logo: File,
            cover: File,
            coverMobile: File,
            sport: Sport,
        }
    })
], League);

var TournamentSeasonStatuses;
(function (TournamentSeasonStatuses) {
    TournamentSeasonStatuses[TournamentSeasonStatuses["open"] = 0] = "open";
    TournamentSeasonStatuses[TournamentSeasonStatuses["in_progress"] = 1] = "in_progress";
    TournamentSeasonStatuses[TournamentSeasonStatuses["closed"] = 2] = "closed";
})(TournamentSeasonStatuses || (TournamentSeasonStatuses = {}));
let TournamentSeason = class TournamentSeason extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentSeason, "toFront", null);
__decorate([
    ToBackHook
], TournamentSeason, "toBack", null);
TournamentSeason = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            alias: 'alias',
            logo: 'logo',
            cover: 'cover',
            preview_image: 'previewImage',
            status: 'status',
            start_date: 'startDate',
            closed_date: 'closedDate',
            tournaments: 'tournaments',
        },
        relation: {
            logo: File,
            cover: File,
            previewImage: File,
            status: enumField(TournamentSeasonStatuses),
            startDate: DateField,
            closedDate: DateField,
        }
    })
], TournamentSeason);

var TournamentTypes;
(function (TournamentTypes) {
    TournamentTypes["group"] = "group";
    TournamentTypes["elimination"] = "elimination";
    TournamentTypes["fiba"] = "fiba";
})(TournamentTypes || (TournamentTypes = {}));
var TournamentStatuses;
(function (TournamentStatuses) {
    TournamentStatuses[TournamentStatuses["open"] = 0] = "open";
    TournamentStatuses[TournamentStatuses["in_progress"] = 1] = "in_progress";
    TournamentStatuses[TournamentStatuses["closed"] = 2] = "closed";
})(TournamentStatuses || (TournamentStatuses = {}));
var TournamentGender;
(function (TournamentGender) {
    TournamentGender[TournamentGender["male"] = 1] = "male";
    TournamentGender[TournamentGender["female"] = 2] = "female";
    TournamentGender[TournamentGender["all"] = 3] = "all";
})(TournamentGender || (TournamentGender = {}));
var BasketballStatisticTypes;
(function (BasketballStatisticTypes) {
    BasketballStatisticTypes[BasketballStatisticTypes["standard"] = 1] = "standard";
    BasketballStatisticTypes[BasketballStatisticTypes["light"] = 2] = "light";
    BasketballStatisticTypes[BasketballStatisticTypes["advanced"] = 3] = "advanced";
})(BasketballStatisticTypes || (BasketballStatisticTypes = {}));
var VolleyballStatisticTypes;
(function (VolleyballStatisticTypes) {
    VolleyballStatisticTypes[VolleyballStatisticTypes["standard"] = 1] = "standard";
    VolleyballStatisticTypes[VolleyballStatisticTypes["light"] = 2] = "light";
    VolleyballStatisticTypes[VolleyballStatisticTypes["advanced"] = 3] = "advanced";
})(VolleyballStatisticTypes || (VolleyballStatisticTypes = {}));
var RugbyStatisticTypes;
(function (RugbyStatisticTypes) {
    RugbyStatisticTypes[RugbyStatisticTypes["light"] = 1] = "light";
    RugbyStatisticTypes[RugbyStatisticTypes["standard"] = 2] = "standard";
})(RugbyStatisticTypes || (RugbyStatisticTypes = {}));
var WaterpoloStatisticTypes;
(function (WaterpoloStatisticTypes) {
    WaterpoloStatisticTypes[WaterpoloStatisticTypes["standard"] = 1] = "standard";
    WaterpoloStatisticTypes[WaterpoloStatisticTypes["light"] = 2] = "light";
})(WaterpoloStatisticTypes || (WaterpoloStatisticTypes = {}));
var WrestballStatisticTypes;
(function (WrestballStatisticTypes) {
    WrestballStatisticTypes[WrestballStatisticTypes["standard"] = 1] = "standard";
})(WrestballStatisticTypes || (WrestballStatisticTypes = {}));
var GameTimeTypes;
(function (GameTimeTypes) {
    GameTimeTypes[GameTimeTypes["clean"] = 1] = "clean";
    GameTimeTypes[GameTimeTypes["dirty"] = 2] = "dirty";
})(GameTimeTypes || (GameTimeTypes = {}));
var OvertimeTypes;
(function (OvertimeTypes) {
    OvertimeTypes[OvertimeTypes["to_score_total"] = 1] = "to_score_total";
    OvertimeTypes[OvertimeTypes["to_score_diff"] = 2] = "to_score_diff";
    OvertimeTypes[OvertimeTypes["time"] = 3] = "time";
    OvertimeTypes[OvertimeTypes["without_overtime"] = 4] = "without_overtime";
    OvertimeTypes[OvertimeTypes["to_first_goal"] = 5] = "to_first_goal";
    OvertimeTypes[OvertimeTypes["to_first_goal_and_bullitts"] = 6] = "to_first_goal_and_bullitts";
    OvertimeTypes[OvertimeTypes["bullitts"] = 7] = "bullitts";
    OvertimeTypes[OvertimeTypes["penalties"] = 8] = "penalties";
    OvertimeTypes[OvertimeTypes["time_and_penalties"] = 9] = "time_and_penalties";
    OvertimeTypes[OvertimeTypes["time_and_first_goal"] = 10] = "time_and_first_goal";
})(OvertimeTypes || (OvertimeTypes = {}));
var TimerTypes;
(function (TimerTypes) {
    TimerTypes[TimerTypes["backward"] = 1] = "backward";
    TimerTypes[TimerTypes["forward"] = 2] = "forward";
})(TimerTypes || (TimerTypes = {}));
var SubstituteManageTypes;
(function (SubstituteManageTypes) {
    SubstituteManageTypes[SubstituteManageTypes["goalkeeper_only"] = 1] = "goalkeeper_only";
    SubstituteManageTypes[SubstituteManageTypes["additional_screen"] = 2] = "additional_screen";
    SubstituteManageTypes[SubstituteManageTypes["one_screen"] = 3] = "one_screen";
    SubstituteManageTypes[SubstituteManageTypes["split_screen"] = 4] = "split_screen";
})(SubstituteManageTypes || (SubstituteManageTypes = {}));
let TournamentSettings = class TournamentSettings extends BaseModel {
    get substituteManageMode() {
        if (this._substituteManageMode) {
            return this._substituteManageMode;
        }
        if (this.substituteManageEnabled) {
            return SubstituteManageTypes.split_screen;
        }
        return SubstituteManageTypes.goalkeeper_only;
    }
    set substituteManageMode(value) {
        this._substituteManageMode = value;
    }
    get genderTitle() {
        const yearDiff = new Date().getFullYear() - this.birthYearFrom;
        if (this.gender === TournamentGender.male) {
            if (yearDiff < 15) {
                return 'Мальчики';
            }
            if (yearDiff < 21) {
                return 'Юноши';
            }
            return 'Мужчины';
        }
        if (this.gender === TournamentGender.female) {
            if (yearDiff < 15) {
                return 'Девочки';
            }
            if (yearDiff < 21) {
                return 'Девушки';
            }
            return 'Женщины';
        }
        return 'Смешанный';
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentSettings, "toFront", null);
__decorate([
    ToBackHook
], TournamentSettings, "toBack", null);
TournamentSettings = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            gender: 'gender',
            birth_year_from: 'birthYearFrom',
            birth_year_to: 'birthYearTo',
            max_team_players: 'maxTeamPlayers',
            max_game_players: 'maxGamePlayers',
            type: 'type',
            tours_count: 'toursCount',
            periods_count: 'periodsCount',
            period_time: 'periodTime',
            overtime_type: 'overtimeType',
            overtime_time: 'overtimeTime',
            overtime_score: 'overtimeScore',
            game_type: 'gameType',
            timeout_count: 'timeoutCount',
            timeout_time: 'timeoutTime',
            substitute_count: 'substituteCount',
            game_up_to_score: 'gameUpToScore',
            volleyball_score_in_set: 'volleyballScoreInSet',
            volleyball_score_in_last_set: 'volleyballScoreInLastSet',
            manage_team_application: 'manageTeamApplication',
            recruitment_is_open: 'recruitmentIsOpen',
            transfer_is_open: 'transferIsOpen',
            basketball_statistic_type: 'basketballStatisticType',
            volleyball_statistic_type: 'volleyballStatisticType',
            rugby_statistic_type: 'rugbyStatisticType',
            waterpolo_statistic_type: 'waterpoloStatisticType',
            wrestball_statistic_type: 'wrestballStatisticType',
            shot_clock_enabled: 'shotClockEnabled',
            game_time_type: 'gameTimeType',
            with_result_table: 'withResultTable',
            free_substitute_enabled: 'freeSubstituteEnabled',
            substitute_manage_enabled: 'substituteManageEnabled',
            substitute_manage_mode: 'substituteManageMode',
            bonus_points_enabled: 'bonusPointsEnabled',
            minor_penalty_time: 'minorPenaltyTime',
            major_penalty_time: 'majorPenaltyTime',
            misconduct_penalty_time: 'misconductPenaltyTime',
            game_misconduct_penalty_time: 'gameMisconductPenaltyTime',
            match_penalty_time: 'matchPenaltyTime',
            timer_type: 'timerType',
            hide_on_league_main_page: 'hideOnLeagueMainPage',
            wrestler_scrums_count: 'wrestlerScrumsCount',
            wrestlers_count: 'wrestlersCount',
        },
        relation: {
            type: enumField(TournamentTypes),
            gender: enumField(TournamentGender),
            basketballStatisticType: enumField(BasketballStatisticTypes),
            volleyballStatisticType: enumField(VolleyballStatisticTypes),
            rugbyStatisticType: enumField(RugbyStatisticTypes),
            waterpoloStatisticType: enumField(WaterpoloStatisticTypes),
            wrestballStatisticType: enumField(WrestballStatisticTypes),
            gameTimeType: enumField(GameTimeTypes),
            overtimeType: enumField(OvertimeTypes),
            timerType: enumField(TimerTypes),
            substituteManageMode: enumField(SubstituteManageTypes),
        }
    })
], TournamentSettings);
let TournamentTeamWinner = class TournamentTeamWinner extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentTeamWinner, "toFront", null);
__decorate([
    ToBackHook
], TournamentTeamWinner, "toBack", null);
TournamentTeamWinner = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team_id: 'teamId',
            tournament_id: 'tournamentId',
            name: 'name',
            logo: 'logo',
            team: 'team',
            points: 'points',
        },
        relation: {
            logo: File,
            team: Team,
        }
    })
], TournamentTeamWinner);
let Tournament = class Tournament extends BaseModel {
    getEmptyLogoClass() {
        const classList = ['empty-logo'];
        if (this.sport.isBasketball()) {
            classList.push('empty-logo-basketball');
        }
        if (this.sport.isVolleyball()) {
            classList.push('empty-logo-volleyball');
        }
        if (this.sport.isHockey()) {
            classList.push('empty-logo-hockey');
        }
        if (this.sport.isFootball()) {
            classList.push('empty-logo-football');
        }
        if (this.sport.isHandball()) {
            classList.push('empty-logo-handball');
        }
        if (this.sport.isRugby()) {
            classList.push('empty-logo-rugby');
        }
        if (this.sport.isWaterpolo()) {
            classList.push('empty-logo-waterpolo');
        }
        return classList.join(' ');
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], Tournament, "toFront", null);
__decorate([
    ToBackHook
], Tournament, "toBack", null);
Tournament = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            alias: 'alias',
            logo: 'logo',
            cover: 'cover',
            cover_mobile: 'coverMobile',
            preview_image: 'previewImage',
            city: 'city',
            sport: 'sport',
            location: 'location',
            description: 'description',
            date: 'date',
            price: 'price',
            regulation_files: 'regulationFiles',
            settings: 'settings',
            league: 'league',
            teams_count: 'teamsCount',
            closest_game_datetime: 'closestGameDatetime',
            status: 'status',
            team_winner: 'teamWinner',
            team_second: 'teamSecond',
            team_third: 'teamThird',
            season: 'season',
            season_id: 'seasonId',
            game_price: 'gamePrice',
            season_tournament_id: 'seasonTournamentId',
            sort: 'sort',
        },
        relation: {
            logo: File,
            cover: File,
            coverMobile: File,
            previewImage: File,
            city: City,
            sport: Sport,
            regulationFile: File,
            settings: TournamentSettings,
            date: DateTimeField,
            league: League,
            status: enumField(TournamentStatuses),
            teamWinner: TournamentTeamWinner,
            teamSecond: TournamentTeamWinner,
            teamThird: TournamentTeamWinner,
            season: TournamentSeason,
        }
    })
], Tournament);

let BasketballGameConfig = class BasketballGameConfig extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], BasketballGameConfig, "toFront", null);
__decorate([
    ToBackHook
], BasketballGameConfig, "toBack", null);
BasketballGameConfig = __decorate([
    ModelInstance({
        mappingFields: {
            periods_count: 'periodsCount',
            period_time: 'periodTime',
            game_up_to_score: 'gameUpToScore',
            overtime_type: 'overtimeType',
            overtime_time: 'overtimeTime',
            overtime_score: 'overtimeScore',
            max_game_players: 'maxGamePlayers',
            timeout_count: 'timeoutCount',
            overtime_timeout_count: 'overtimeTimeoutCount',
            timeout_time: 'timeoutTime',
            statistic_type: 'statisticType',
            shot_clock_enabled: 'shotClockEnabled',
            game_time_type: 'gameTimeType',
            timer_type: 'timerType',
        },
        relation: {
            overtimeType: enumField(OvertimeTypes),
            statisticType: enumField(BasketballStatisticTypes),
            gameTimeType: enumField(GameTimeTypes),
            timerType: enumField(TimerTypes),
        }
    })
], BasketballGameConfig);

var VolleyballGameTypes;
(function (VolleyballGameTypes) {
    VolleyballGameTypes[VolleyballGameTypes["best_of_five"] = 1] = "best_of_five";
    VolleyballGameTypes[VolleyballGameTypes["best_of_three"] = 2] = "best_of_three";
})(VolleyballGameTypes || (VolleyballGameTypes = {}));
let VolleyballGameConfig = class VolleyballGameConfig extends BaseModel {
    get setsCount() {
        return this.gameType === VolleyballGameTypes.best_of_three ? 3 : 5;
    }
    getSetMaxScore(set) {
        return set === this.setsCount ? this.scoreInLastSet : this.scoreInSet;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], VolleyballGameConfig, "toFront", null);
__decorate([
    ToBackHook
], VolleyballGameConfig, "toBack", null);
VolleyballGameConfig = __decorate([
    ModelInstance({
        mappingFields: {
            game_type: 'gameType',
            timeout_count: 'timeoutCount',
            timeout_time: 'timeoutTime',
            substitute_count: 'substituteCount',
            score_in_set: 'scoreInSet',
            score_in_last_set: 'scoreInLastSet',
            statistic_type: 'statisticType',
            libero_user_ids: 'liberoUserIds',
        },
        relation: {
            gameType: enumField(VolleyballGameTypes),
            statisticType: enumField(VolleyballStatisticTypes),
        }
    })
], VolleyballGameConfig);

let LeagueCourt = class LeagueCourt extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeagueCourt, "toFront", null);
__decorate([
    ToBackHook
], LeagueCourt, "toBack", null);
LeagueCourt = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            address: 'address',
            league_id: 'leagueId',
            active_games_count: 'activeGamesCount',
        }
    })
], LeagueCourt);

let MediaItem = class MediaItem extends BaseModel {
    get isVideo() {
        return Boolean(this.videoUrl);
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], MediaItem, "toFront", null);
__decorate([
    ToBackHook
], MediaItem, "toBack", null);
MediaItem = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            original_photo: 'originalPhoto',
            list_photo: 'listPhoto',
            detail_photo: 'detailPhoto',
            game: 'game',
            tournament: 'tournament',
            game_id: 'gameId',
            tournament_id: 'tournament_id',
            video_url: 'videoUrl',
            video_preview: 'videoPreview',
            is_live: 'isLive',
        },
        relation: {
            originalPhoto: File,
            listPhoto: File,
            detailPhoto: File,
            videoPreview: File
        }
    })
], MediaItem);

let HockeyGameConfig = class HockeyGameConfig extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
    get overtimePeriod() {
        return this.periodsCount + 1;
    }
    get bullitsPeriod() {
        return this.periodsCount + 2;
    }
    get playoffBullitsPeriod() {
        if (this.playoffSeriesOvertimeType === OvertimeTypes.to_first_goal_and_bullitts) {
            return this.periodsCount + 4;
        }
        else {
            return this.periodsCount + 3;
        }
    }
    get playoffOvertimePeriod() {
        if (this.playoffSeriesOvertimeType === OvertimeTypes.to_first_goal_and_bullitts) {
            return this.periodsCount + 3;
        }
        else {
            return null;
        }
    }
};
__decorate([
    ToFrontHook
], HockeyGameConfig, "toFront", null);
__decorate([
    ToBackHook
], HockeyGameConfig, "toBack", null);
HockeyGameConfig = __decorate([
    ModelInstance({
        mappingFields: {
            periods_count: 'periodsCount',
            period_time: 'periodTime',
            overtime_type: 'overtimeType',
            overtime_time: 'overtimeTime',
            max_game_players: 'maxGamePlayers',
            timeout_count: 'timeoutCount',
            overtime_timeout_count: 'overtimeTimeoutCount',
            timeout_time: 'timeoutTime',
            game_time_type: 'gameTimeType',
            substitute_manage_enabled: 'substituteManageEnabled',
            minor_penalty_time: 'minorPenaltyTime',
            major_penalty_time: 'majorPenaltyTime',
            misconduct_penalty_time: 'misconductPenaltyTime',
            game_misconduct_penalty_time: 'gameMisconductPenaltyTime',
            match_penalty_time: 'matchPenaltyTime',
            playoff_series_overtime_type: 'playoffSeriesOvertimeType',
            playoff_series_overtime_time: 'playoffSeriesOvertimeTime',
            timer_type: 'timerType',
        },
        relation: {
            overtimeType: enumField(OvertimeTypes),
            gameTimeType: enumField(GameTimeTypes),
            playoffSeriesOvertimeType: enumField(OvertimeTypes),
            timerType: enumField(TimerTypes),
        }
    })
], HockeyGameConfig);

let FootballGameConfig = class FootballGameConfig extends BaseModel {
    get penaltyPeriod() {
        if (this.overtimeType !== OvertimeTypes.time_and_penalties) {
            return +this.periodsCount + 1;
        }
        return +this.periodsCount + this.overtimePeriods + 1;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], FootballGameConfig, "toFront", null);
__decorate([
    ToBackHook
], FootballGameConfig, "toBack", null);
FootballGameConfig = __decorate([
    ModelInstance({
        mappingFields: {
            periods_count: 'periodsCount',
            period_time: 'periodTime',
            overtime_type: 'overtimeType',
            overtime_time: 'overtimeTime',
            overtime_periods: 'overtimePeriods',
            max_game_players: 'maxGamePlayers',
            timeout_count: 'timeoutCount',
            overtime_timeout_count: 'overtimeTimeoutCount',
            timeout_time: 'timeoutTime',
            game_time_type: 'gameTimeType',
            substitute_count: 'substituteCount',
            free_substitute_enabled: 'freeSubstituteEnabled',
            substitute_manage_enabled: 'substituteManageEnabled',
            timer_type: 'timerType',
        },
        relation: {
            overtimeType: enumField(OvertimeTypes),
            gameTimeType: enumField(GameTimeTypes),
            timerType: enumField(TimerTypes),
        }
    })
], FootballGameConfig);

let HandballGameConfig = class HandballGameConfig extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], HandballGameConfig, "toFront", null);
__decorate([
    ToBackHook
], HandballGameConfig, "toBack", null);
HandballGameConfig = __decorate([
    ModelInstance({
        mappingFields: {
            periods_count: 'periodsCount',
            period_time: 'periodTime',
            overtime_type: 'overtimeType',
            overtime_time: 'overtimeTime',
            max_game_players: 'maxGamePlayers',
            timeout_count: 'timeoutCount',
            overtime_timeout_count: 'overtimeTimeoutCount',
            timeout_time: 'timeoutTime',
            game_time_type: 'gameTimeType',
            substitute_manage_enabled: 'substituteManageEnabled',
            timer_type: 'timerType',
        },
        relation: {
            overtimeType: enumField(OvertimeTypes),
            gameTimeType: enumField(GameTimeTypes),
            timerType: enumField(TimerTypes),
        }
    })
], HandballGameConfig);

function generateArray(length) {
    if (+length <= 0) {
        return [];
    }
    return Array.apply(null, Array(length)).map((_, i) => i + 1);
}
function getArrayChunks(array, length) {
    const chunks = [];
    const chunkLength = Math.ceil(array.length / length);
    if (chunkLength === 0) {
        return [array];
    }
    for (let i = 0; i < chunkLength; i++) {
        chunks.push(array.slice(i * length, (i + 1) * length));
    }
    return chunks;
}

var PlayoffTypes;
(function (PlayoffTypes) {
    PlayoffTypes["double_elimination"] = "double_elimination";
    PlayoffTypes["elimination"] = "elimination";
})(PlayoffTypes || (PlayoffTypes = {}));
let PlayoffSettings = class PlayoffSettings extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], PlayoffSettings, "toFront", null);
__decorate([
    ToBackHook
], PlayoffSettings, "toBack", null);
PlayoffSettings = __decorate([
    ModelInstance({
        mappingFields: {
            rounds: 'rounds',
            final_rounds: 'finalRounds',
            third_place_rounds: 'thirdPlaceRounds',
            loser_final_rounds: 'loserFinalRounds',
            teams_count: 'teamsCount',
            type: 'type',
            min_player_games_count: 'minPlayerGamesCount',
            min_player_time: 'minPlayerTime',
        },
        relation: {
            type: enumField(PlayoffTypes)
        }
    })
], PlayoffSettings);
let Playoff = class Playoff extends BaseModel {
    constructor() {
        super(...arguments);
        this.stages = [];
    }
    static toFront(data) { }
    static toBack(data) { }
    get stagesCount() {
        return Math.log(this.settings.teamsCount) / Math.log(2);
    }
    getPlayoffStages() {
        if (this.stages.length === 0 && this.settings.teamsCount) {
            const stagesCount = Math.log(this.settings.teamsCount) / Math.log(2);
            this.stages = generateArray(stagesCount).map(stage => {
                const playoffStage = this.settings.teamsCount / Math.pow(2, stage);
                let title = '';
                if (playoffStage === 1) {
                    title = 'Финал';
                }
                else {
                    title = `1 / ${playoffStage}`;
                }
                return {
                    value: stage,
                    title
                };
            });
        }
        return this.stages;
    }
};
__decorate([
    ToFrontHook
], Playoff, "toFront", null);
__decorate([
    ToBackHook
], Playoff, "toBack", null);
Playoff = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            settings: 'settings',
            tournament_id: 'tournamentId',
            tournament_stage_id: 'tournamentStageId',
            is_official: 'isOfficial',
            tournament_round_id: 'tournamentRoundId',
            division_id: 'divisionId',
            winner_place: 'winnerPlace',
        },
        relation: {
            settings: PlayoffSettings
        }
    })
], Playoff);

let TournamentGroup = class TournamentGroup extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentGroup, "toFront", null);
__decorate([
    ToBackHook
], TournamentGroup, "toBack", null);
TournamentGroup = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            sort: 'sort',
            tournament_stage_id: 'tournamentStageId',
            tournament_round_id: 'tournamentRoundId',
            division_id: 'divisionId',
        }
    })
], TournamentGroup);

let RugbyGameConfig = class RugbyGameConfig extends BaseModel {
    get penaltyPeriod() {
        if (this.overtimeType !== OvertimeTypes.time_and_penalties) {
            return +this.periodsCount + 1;
        }
        return +this.periodsCount + this.overtimePeriods + 1;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], RugbyGameConfig, "toFront", null);
__decorate([
    ToBackHook
], RugbyGameConfig, "toBack", null);
RugbyGameConfig = __decorate([
    ModelInstance({
        mappingFields: {
            periods_count: 'periodsCount',
            period_time: 'periodTime',
            overtime_type: 'overtimeType',
            overtime_time: 'overtimeTime',
            overtime_periods: 'overtimePeriods',
            max_game_players: 'maxGamePlayers',
            game_time_type: 'gameTimeType',
            substitute_count: 'substituteCount',
            free_substitute_enabled: 'freeSubstituteEnabled',
            statistic_type: 'statisticType',
            timer_type: 'timerType',
        },
        relation: {
            overtimeType: enumField(OvertimeTypes),
            gameTimeType: enumField(GameTimeTypes),
            statisticType: enumField(RugbyStatisticTypes),
            timerType: enumField(TimerTypes),
        }
    })
], RugbyGameConfig);

let WaterpoloGameConfig = class WaterpoloGameConfig extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
    get overtimePeriod() {
        return this.periodsCount + 1;
    }
    get bullitsPeriod() {
        return this.periodsCount + 2;
    }
    get playoffBullitsPeriod() {
        return this.periodsCount + 3;
    }
};
__decorate([
    ToFrontHook
], WaterpoloGameConfig, "toFront", null);
__decorate([
    ToBackHook
], WaterpoloGameConfig, "toBack", null);
WaterpoloGameConfig = __decorate([
    ModelInstance({
        mappingFields: {
            periods_count: 'periodsCount',
            period_time: 'periodTime',
            overtime_type: 'overtimeType',
            overtime_time: 'overtimeTime',
            max_game_players: 'maxGamePlayers',
            timeout_count: 'timeoutCount',
            overtime_timeout_count: 'overtimeTimeoutCount',
            timeout_time: 'timeoutTime',
            game_time_type: 'gameTimeType',
            substitute_manage_enabled: 'substituteManageEnabled',
            shot_clock_enabled: 'shotClockEnabled',
            statistic_type: 'statisticType',
            timer_type: 'timerType',
        },
        relation: {
            overtimeType: enumField(OvertimeTypes),
            gameTimeType: enumField(GameTimeTypes),
            statisticType: enumField(WaterpoloStatisticTypes),
            timerType: enumField(TimerTypes),
        }
    })
], WaterpoloGameConfig);

let WrestballGameConfig = class WrestballGameConfig extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], WrestballGameConfig, "toFront", null);
__decorate([
    ToBackHook
], WrestballGameConfig, "toBack", null);
WrestballGameConfig = __decorate([
    ModelInstance({
        mappingFields: {
            periods_count: 'periodsCount',
            period_time: 'periodTime',
            game_up_to_score: 'gameUpToScore',
            overtime_type: 'overtimeType',
            overtime_time: 'overtimeTime',
            overtime_score: 'overtimeScore',
            max_game_players: 'maxGamePlayers',
            timeout_count: 'timeoutCount',
            overtime_timeout_count: 'overtimeTimeoutCount',
            timeout_time: 'timeoutTime',
            statistic_type: 'statisticType',
            shot_clock_enabled: 'shotClockEnabled',
            game_time_type: 'gameTimeType',
            timer_type: 'timerType',
            wrestler_scrums_count: 'wrestlerScrumsCount',
            wrestlers_count: 'wrestlersCount',
            wrestler_user_ids: 'wrestlerUserIds',
        },
        relation: {
            overtimeType: enumField(OvertimeTypes),
            statisticType: enumField(WrestballStatisticTypes),
            gameTimeType: enumField(GameTimeTypes),
            timerType: enumField(TimerTypes),
        }
    })
], WrestballGameConfig);

var GameStatuses;
(function (GameStatuses) {
    GameStatuses[GameStatuses["open"] = 1] = "open";
    GameStatuses[GameStatuses["in_progress"] = 2] = "in_progress";
    GameStatuses[GameStatuses["closed"] = 3] = "closed";
    GameStatuses[GameStatuses["archived"] = 4] = "archived";
    GameStatuses[GameStatuses["draft"] = 5] = "draft";
})(GameStatuses || (GameStatuses = {}));
var GameResultTypes;
(function (GameResultTypes) {
    GameResultTypes[GameResultTypes["team_won"] = 1] = "team_won";
    GameResultTypes[GameResultTypes["competitor_team_won"] = 2] = "competitor_team_won";
    GameResultTypes[GameResultTypes["team_technical_defeat"] = 3] = "team_technical_defeat";
    GameResultTypes[GameResultTypes["competitor_team_technical_defeat"] = 4] = "competitor_team_technical_defeat";
    GameResultTypes[GameResultTypes["draw"] = 5] = "draw";
})(GameResultTypes || (GameResultTypes = {}));
let GameAdditionalData = class GameAdditionalData {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], GameAdditionalData, "toFront", null);
__decorate([
    ToBackHook
], GameAdditionalData, "toBack", null);
GameAdditionalData = __decorate([
    ModelInstance({
        mappingFields: {
            mhl_carousel: 'mhlCarousel',
        }
    })
], GameAdditionalData);
let GameTeamAdditionalData = class GameTeamAdditionalData {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], GameTeamAdditionalData, "toFront", null);
__decorate([
    ToBackHook
], GameTeamAdditionalData, "toBack", null);
GameTeamAdditionalData = __decorate([
    ModelInstance({
        mappingFields: {
            nickname: 'nickname',
            color: 'color',
        }
    })
], GameTeamAdditionalData);
let TournamentTeamShort = class TournamentTeamShort extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentTeamShort, "toFront", null);
__decorate([
    ToBackHook
], TournamentTeamShort, "toBack", null);
TournamentTeamShort = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            logo: 'logo',
            additional_data: 'additionalData',
        },
        relation: {
            logo: File,
            additionalData: GameTeamAdditionalData,
        }
    })
], TournamentTeamShort);
let MhlCarouselTeam = class MhlCarouselTeam extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], MhlCarouselTeam, "toFront", null);
__decorate([
    ToBackHook
], MhlCarouselTeam, "toBack", null);
MhlCarouselTeam = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            tournament_team: 'tournamentTeam',
            score: 'score',
            score_by_period: 'scoreByPeriod',
            game_ids: 'gameIds',
        },
        relation: {
            team: Team,
            tournamentTeam: TournamentTeamShort,
        }
    })
], MhlCarouselTeam);
let MhlCarousel = class MhlCarousel extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], MhlCarousel, "toFront", null);
__decorate([
    ToBackHook
], MhlCarousel, "toBack", null);
MhlCarousel = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            game_ids: 'gameIds',
            winner_team_id: 'winnerTeamId',
            teams: 'teams',
        },
        relation: {
            teams: listField(MhlCarouselTeam),
        }
    })
], MhlCarousel);
let Game = class Game extends BaseModel {
    get basketballGameConfig() {
        if (this._basketballGameConfig && this._basketballGameConfig.periodsCount) {
            return this._basketballGameConfig;
        }
        if (this.gameConfig) {
            this._basketballGameConfig = BasketballGameConfig.toFront(this.gameConfig);
        }
        return this._basketballGameConfig;
    }
    set basketballGameConfig(value) {
        this._basketballGameConfig = value;
    }
    get volleyballGameConfig() {
        if (this._volleyballGameConfig && this._volleyballGameConfig.setsCount) {
            return this._volleyballGameConfig;
        }
        if (this.gameConfig) {
            this._volleyballGameConfig = VolleyballGameConfig.toFront(this.gameConfig);
        }
        return this._volleyballGameConfig;
    }
    set volleyballGameConfig(value) {
        this._volleyballGameConfig = value;
    }
    get hockeyGameConfig() {
        if (this._hockeyGameConfig && this._hockeyGameConfig.periodsCount) {
            return this._hockeyGameConfig;
        }
        if (this.gameConfig) {
            this._hockeyGameConfig = HockeyGameConfig.toFront(this.gameConfig);
        }
        return this._hockeyGameConfig;
    }
    set hockeyGameConfig(value) {
        this._hockeyGameConfig = value;
    }
    get handballGameConfig() {
        if (this._handballGameConfig && this._handballGameConfig.periodsCount) {
            return this._handballGameConfig;
        }
        if (this.gameConfig) {
            this._handballGameConfig = HandballGameConfig.toFront(this.gameConfig);
        }
        return this._handballGameConfig;
    }
    set handballGameConfig(value) {
        this._handballGameConfig = value;
    }
    get footballGameConfig() {
        if (this._footballGameConfig && this._footballGameConfig.periodsCount) {
            return this._footballGameConfig;
        }
        if (this.gameConfig) {
            this._footballGameConfig = FootballGameConfig.toFront(this.gameConfig);
        }
        return this._footballGameConfig;
    }
    set footballGameConfig(value) {
        this._footballGameConfig = value;
    }
    get rugbyGameConfig() {
        if (this._rugbyGameConfig && this._rugbyGameConfig.periodsCount) {
            return this._rugbyGameConfig;
        }
        if (this.gameConfig) {
            this._rugbyGameConfig = RugbyGameConfig.toFront(this.gameConfig);
        }
        return this._rugbyGameConfig;
    }
    set rugbyGameConfig(value) {
        this._rugbyGameConfig = value;
    }
    get waterpoloGameConfig() {
        if (this._waterpoloGameConfig && this._waterpoloGameConfig.periodsCount) {
            return this._waterpoloGameConfig;
        }
        if (this.gameConfig) {
            this._waterpoloGameConfig = WaterpoloGameConfig.toFront(this.gameConfig);
        }
        return this._waterpoloGameConfig;
    }
    set waterpoloGameConfig(value) {
        this._waterpoloGameConfig = value;
    }
    get wrestballGameConfig() {
        if (this._wrestballGameConfig && this._wrestballGameConfig.periodsCount) {
            return this._wrestballGameConfig;
        }
        if (this.gameConfig) {
            this._wrestballGameConfig = WrestballGameConfig.toFront(this.gameConfig);
        }
        return this._wrestballGameConfig;
    }
    set wrestballGameConfig(value) {
        this._wrestballGameConfig = value;
    }
    get scoreByPeriodList() {
        if (!this.scoreByPeriod) {
            return [];
        }
        return Object.keys(this.scoreByPeriod).map(period => ({
            period: +period,
            teamScore: this.scoreByPeriod[period][0],
            competitorTeamScore: this.scoreByPeriod[period][1]
        }));
    }
    get isClosed() {
        return this.status === GameStatuses.closed;
    }
    get isTeamWon() {
        return [GameResultTypes.team_won, GameResultTypes.competitor_team_technical_defeat].includes(this.resultType);
    }
    get isCompetitorTeamWon() {
        return [GameResultTypes.competitor_team_won, GameResultTypes.team_technical_defeat].includes(this.resultType);
    }
    get teamWinnerId() {
        if (!this.isClosed) {
            return null;
        }
        if (this.isTeamWon) {
            return this.team.id || this.teamId;
        }
        if (this.isCompetitorTeamWon) {
            return this.competitorTeam.id || this.competitorTeamId;
        }
        return null;
    }
    get teamLoserId() {
        if (!this.isClosed) {
            return null;
        }
        if (this.isTeamWon) {
            return this.competitorTeam.id || this.competitorTeamId;
        }
        if (this.isCompetitorTeamWon) {
            return this.team.id || this.teamId;
        }
        return null;
    }
    get sport() {
        var _a, _b, _c, _d, _e, _f;
        if ((_b = (_a = this.tournament) === null || _a === void 0 ? void 0 : _a.sport) === null || _b === void 0 ? void 0 : _b.id) {
            return this.tournament.sport;
        }
        if ((_d = (_c = this.team) === null || _c === void 0 ? void 0 : _c.sport) === null || _d === void 0 ? void 0 : _d.id) {
            return this.team.sport;
        }
        if ((_f = (_e = this.competitorTeam) === null || _e === void 0 ? void 0 : _e.sport) === null || _f === void 0 ? void 0 : _f.id) {
            return this.competitorTeam.sport;
        }
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], Game, "toFront", null);
__decorate([
    ToBackHook
], Game, "toBack", null);
Game = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            status: 'status',
            team: 'team',
            tournament_team: 'tournamentTeam',
            tournament_team_id: 'tournamentTeamId',
            team_id: 'teamId',
            competitor_team: 'competitorTeam',
            competitor_tournament_team: 'competitorTournamentTeam',
            competitor_tournament_team_id: 'competitorTournamentTeamId',
            competitor_team_id: 'competitorTeamId',
            competitor_team_name: 'competitorTeamName',
            datetime: 'datetime',
            location: 'location',
            team_score: 'teamScore',
            competitor_team_score: 'competitorTeamScore',
            result_type: 'resultType',
            playoff_number: 'playoffNumber',
            tournament_id: 'tournamentId',
            tournament_tour: 'tournamentTour',
            game_config: 'gameConfig',
            basketball_game_config: 'basketballGameConfig',
            volleyball_game_config: 'volleyballGameConfig',
            hockey_game_config: 'hockeyGameConfig',
            football_game_config: 'footballGameConfig',
            handball_game_config: 'handballGameConfig',
            rugby_game_config: 'rugbyGameConfig',
            waterpolo_game_config: 'waterpoloGameConfig',
            wrestball_game_config: 'wrestballGameConfig',
            score_by_period: 'scoreByPeriod',
            playoff_stage: 'playoffStage',
            playoff_round: 'playoffRound',
            tournament_stage_id: 'tournamentStageId',
            tournament_playoff_id: 'tournamentPlayoffId',
            tournament_playoff: 'tournamentPlayoff',
            tournament_court: 'tournamentCourt',
            media_count: 'mediaCount',
            media_live_count: 'mediaLiveCount',
            media: 'media',
            tournament: 'tournament',
            tournament_group: 'tournamentGroup',
            additional_data: 'additionalData',
            mhl_carousel: 'mhlCarousel',
        },
        relation: {
            status: enumField(GameStatuses),
            team: Team,
            tournamentTeam: TournamentTeamShort,
            competitorTeam: Team,
            competitorTournamentTeam: TournamentTeamShort,
            datetime: DateTimeField,
            resultType: enumField(GameResultTypes),
            basketballGameConfig: BasketballGameConfig,
            volleyballGameConfig: VolleyballGameConfig,
            hockeyGameConfig: HockeyGameConfig,
            footballGameConfig: FootballGameConfig,
            handballGameConfig: HandballGameConfig,
            rugbyGameConfig: RugbyGameConfig,
            waterpoloGameConfig: WaterpoloGameConfig,
            wrestballGameConfig: WrestballGameConfig,
            tournamentPlayoff: Playoff,
            tournamentCourt: LeagueCourt,
            media: listField(MediaItem),
            tournament: Tournament,
            tournamentGroup: TournamentGroup,
            additionalData: GameAdditionalData,
            mhlCarousel: MhlCarousel,
        }
    })
], Game);

function updateItemInArray(data, item, force = false, checkFunction) {
    if (!Array.isArray(data)) {
        return data;
    }
    return data.map(v => {
        if (checkFunction && isFunction(checkFunction)) {
            if (!checkFunction(v)) {
                return v;
            }
        }
        else if (v.id !== item.id) {
            return v;
        }
        if (v.updatedAt && item.updatedAt && !force) {
            return v.updatedAt > item.updatedAt ? v : item;
        }
        return item;
    });
}
function updateItemsInArray(data, items, force = false, checkFunction) {
    items.forEach(item => {
        data = updateItemInArray(data, item, force, checkFunction);
    });
    return data;
}
function patchItemInArray(data, item, checkFunction) {
    if (!Array.isArray(data)) {
        return data;
    }
    return data.map(v => {
        if (checkFunction && isFunction(checkFunction)) {
            if (!checkFunction(v)) {
                return v;
            }
        }
        else if (v.id !== item.id) {
            return v;
        }
        return Object.assign(v, item);
    });
}
function addItemInArray(data, item, atEnd = false, checkFunction) {
    if (!Array.isArray(data)) {
        return [item];
    }
    if (data.find(i => isFunction(checkFunction) ? checkFunction(i) : i.id === item.id)) {
        return data;
    }
    return atEnd
        ? [...data, item]
        : [item, ...data];
}
function addItemsInArray(data, items, atEnd = false, checkFunction) {
    (!atEnd
        ? Object.assign([], items).reverse()
        : items).forEach(item => {
        data = addItemInArray(data, item, atEnd, checkFunction);
    });
    return data;
}
function deleteItemFromArray(data, item) {
    if (!Array.isArray(data)) {
        return [];
    }
    if (isFunction(item)) {
        return data.filter(i => !item(i));
    }
    else {
        return data.filter(v => v.id !== item.id);
    }
}
function isFunction(functionToCheck) {
    return functionToCheck && {}.toString.call(functionToCheck) === '[object Function]';
}

class Store {
    constructor(engine) {
        this.engine = engine;
        this.data = {};
    }
    get(key, defaultValue) {
        return this.getSubject(key).pipe(map(item => item === undefined ? defaultValue : item), filter(item => item !== undefined));
    }
    value(key, defaultValue) {
        return this.getSubject(key).value === undefined ? defaultValue : this.getSubject(key).value;
    }
    save(key, value) {
        this.getSubject(key).next(value);
        if (this.engine) {
            this.engine.save(key, value);
        }
    }
    appendItem(key, value, checkFunction) {
        this.save(key, addItemInArray(this.value(key) || [], value, true, checkFunction));
    }
    appendItems(key, value, checkFunction) {
        this.save(key, addItemsInArray(this.value(key) || [], value, true));
    }
    prependItem(key, value, checkFunction) {
        this.save(key, addItemInArray(this.value(key) || [], value, false, checkFunction));
    }
    prependItems(key, value, checkFunction) {
        this.save(key, addItemsInArray(this.value(key) || [], value, false, checkFunction));
    }
    updateItem(key, value, force, checkFunction) {
        this.save(key, updateItemInArray(this.value(key) || [], value, force, checkFunction));
    }
    updateItems(key, value, force, checkFunction) {
        this.save(key, updateItemsInArray(this.value(key) || [], value, force, checkFunction));
    }
    deleteItem(key, value) {
        this.save(key, deleteItemFromArray(this.value(key) || [], value));
    }
    dispose() {
        for (const key of Object.keys(this.data)) {
            this.data[key].complete();
            delete this.data[key];
        }
    }
    clearStorageData() {
        if (this.engine) {
            this.engine.clear();
        }
    }
    getEngine() {
        return this.engine;
    }
    getSubject(key) {
        if (!this.data[key]) {
            this.data[key] = new BehaviorSubject(this.engine ? this.engine.get(key) : undefined);
        }
        return this.data[key];
    }
}

class BaseService {
    constructor() {
        this.store = new Store();
    }
    dispose() {
        this.store.dispose();
    }
}
BaseService.ɵfac = function BaseService_Factory(t) { return new (t || BaseService)(); };
BaseService.ɵprov = i0.ɵɵdefineInjectable({ factory: function BaseService_Factory() { return new BaseService(); }, token: BaseService, providedIn: "root" });

const CONFIG_STORE_KEY = 'config';
const CONFIG_DATA = 'mtg-core-config-data';
class ConfigService extends BaseService {
    constructor(configData) {
        super();
        this.configData = configData;
        if (configData) {
            this.initialize(configData);
        }
    }
    get config$() {
        return this.store.get(CONFIG_STORE_KEY);
    }
    get config() {
        return this.store.value(CONFIG_STORE_KEY) || {};
    }
    initialize(data) {
        this.store.save(CONFIG_STORE_KEY, data);
    }
    set(key, value) {
        this.store.save(CONFIG_STORE_KEY, Object.assign(Object.assign({}, this.config), { [key]: value }));
    }
    get(key) {
        return this.store.value(CONFIG_STORE_KEY) && this.store.value(CONFIG_STORE_KEY)[key];
    }
}
ConfigService.ɵfac = function ConfigService_Factory(t) { return new (t || ConfigService)(ɵngcc0.ɵɵinject(CONFIG_DATA, 8)); };
ConfigService.ɵprov = i0.ɵɵdefineInjectable({ factory: function ConfigService_Factory() { return new ConfigService(i0.ɵɵinject("mtg-core-config-data", 8)); }, token: ConfigService, providedIn: "root" });
ConfigService.ctorParameters = () => [
    { type: undefined, decorators: [{ type: Optional }, { type: Inject, args: [CONFIG_DATA,] }] }
];

let TournamentDivision = class TournamentDivision extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentDivision, "toFront", null);
__decorate([
    ToBackHook
], TournamentDivision, "toBack", null);
TournamentDivision = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            cover: 'cover',
        },
        relation: {
            cover: File
        }
    })
], TournamentDivision);

class LeagueFieldBaseValue extends BaseModel {
}

var LeagueFieldTypes;
(function (LeagueFieldTypes) {
    LeagueFieldTypes[LeagueFieldTypes["text"] = 1] = "text";
    LeagueFieldTypes[LeagueFieldTypes["select"] = 2] = "select";
    LeagueFieldTypes[LeagueFieldTypes["file"] = 3] = "file";
})(LeagueFieldTypes || (LeagueFieldTypes = {}));
class LeagueFieldBase extends BaseModel {
    constructor() {
        super(...arguments);
        this._variantsMapping = {};
        this._variants = [];
    }
    set variants(value) {
        this._variants = value;
        this._variantsMapping = value.reduce((acc, item) => (Object.assign(Object.assign({}, acc), { [item.uuid]: item.name })), {});
    }
    get variants() {
        return this._variants;
    }
    getName(uuid) {
        return this._variantsMapping[uuid];
    }
}

let LeagueTeamField = class LeagueTeamField extends LeagueFieldBase {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeagueTeamField, "toFront", null);
__decorate([
    ToBackHook
], LeagueTeamField, "toBack", null);
LeagueTeamField = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            league_id: 'leagueId',
            name: 'name',
            type: 'type',
            is_multiple: 'isMultiple',
            variants: 'variants',
        },
        relation: {
            type: enumField(LeagueFieldTypes)
        }
    })
], LeagueTeamField);

let TournamentTeamFieldValue = class TournamentTeamFieldValue extends LeagueFieldBaseValue {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentTeamFieldValue, "toFront", null);
__decorate([
    ToBackHook
], TournamentTeamFieldValue, "toBack", null);
TournamentTeamFieldValue = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            league_team_field_id: 'leagueTeamFieldId',
            league_team_field: 'leagueTeamField',
            value: 'value',
            file: 'file',
            value_text: 'valueText',
        },
        relation: {
            file: File,
            leagueTeamField: LeagueTeamField,
        }
    })
], TournamentTeamFieldValue);

let TeamAdditionalData = class TeamAdditionalData {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamAdditionalData, "toFront", null);
__decorate([
    ToBackHook
], TeamAdditionalData, "toBack", null);
TeamAdditionalData = __decorate([
    ModelInstance({
        mappingFields: {
            nickname: 'nickname',
            color: 'color',
        }
    })
], TeamAdditionalData);
let TournamentTeam = class TournamentTeam extends BaseModel {
    get gamesWonPercent() {
        if (!this.gamesCount) {
            return 0;
        }
        return Math.floor(1000 * this.wonGamesCount / this.gamesCount) / 10;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentTeam, "toFront", null);
__decorate([
    ToBackHook
], TournamentTeam, "toBack", null);
TournamentTeam = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            logo: 'logo',
            team_photo: 'teamPhoto',
            team_uniform: 'teamUniform',
            team_id: 'teamId',
            tournament_id: 'tournamentId',
            tournament: 'tournament',
            team: 'team',
            group: 'group',
            division: 'division',
            final_standing: 'finalStanding',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            draw_games_count: 'drawGamesCount',
            lose_games_count: 'loseGamesCount',
            last_games_count: 'lastGamesCount',
            last_games_won: 'lastGamesWon',
            score_sum: 'scoreSum',
            missed_sum: 'missedSum',
            score_points_sum: 'scorePointsSum',
            missed_points_sum: 'missedPointsSum',
            points: 'points',
            mt_points: 'mtPoints',
            users_count: 'usersCount',
            games: 'games',
            notifications_count: 'notificationsCount',
            win_normal_time_games_count: 'winNormalTimeGamesCount',
            lose_normal_time_games_count: 'loseNormalTimeGamesCount',
            win_overtime_games_count: 'winOvertimeGamesCount',
            lose_overtime_games_count: 'loseOvertimeGamesCount',
            last_five_games: 'lastFiveGames',
            tries_scored: 'triesScored',
            tries_missed: 'triesMissed',
            attack_bonuses: 'attackBonuses',
            defense_bonuses: 'defenseBonuses',
            team_additional_data: 'teamAdditionalData',
            field_values: 'fieldValues',
        },
        relation: {
            logo: File,
            teamPhoto: File,
            teamUniform: File,
            tournament: Tournament,
            team: Team,
            group: TournamentGroup,
            games: Game,
            lastFiveGames: Game,
            division: TournamentDivision,
            teamAdditionalData: TeamAdditionalData,
            fieldValues: listField(TournamentTeamFieldValue),
        }
    })
], TournamentTeam);

var TeamUserRole;
(function (TeamUserRole) {
    TeamUserRole[TeamUserRole["member"] = 1] = "member";
    TeamUserRole[TeamUserRole["moderator"] = 2] = "moderator";
    TeamUserRole[TeamUserRole["admin"] = 3] = "admin";
    TeamUserRole[TeamUserRole["coach"] = 4] = "coach";
    TeamUserRole[TeamUserRole["head_coach"] = 5] = "head_coach";
    TeamUserRole[TeamUserRole["playing_coach"] = 6] = "playing_coach";
    TeamUserRole[TeamUserRole["manager"] = 7] = "manager";
    TeamUserRole[TeamUserRole["head_manager"] = 8] = "head_manager";
    TeamUserRole[TeamUserRole["captain"] = 9] = "captain";
    TeamUserRole[TeamUserRole["assistant"] = 10] = "assistant";
    TeamUserRole[TeamUserRole["president"] = 11] = "president";
    TeamUserRole[TeamUserRole["vice_president"] = 12] = "vice_president";
    TeamUserRole[TeamUserRole["press_attache"] = 13] = "press_attache";
    TeamUserRole[TeamUserRole["executive"] = 14] = "executive";
    TeamUserRole[TeamUserRole["senior_coach"] = 15] = "senior_coach";
    TeamUserRole[TeamUserRole["assistant_coach"] = 16] = "assistant_coach";
    TeamUserRole[TeamUserRole["serviceman"] = 17] = "serviceman";
    TeamUserRole[TeamUserRole["game_application_manager"] = 18] = "game_application_manager";
})(TeamUserRole || (TeamUserRole = {}));
let TeamUser = class TeamUser extends BaseModel {
    static toFront(data) {
    }
    static toBack(teamPlayer) {
    }
};
__decorate([
    ToFrontHook
], TeamUser, "toFront", null);
__decorate([
    ToBackHook
], TeamUser, "toBack", null);
TeamUser = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team_id: 'teamId',
            user: 'user',
            role: 'role',
            number: 'number',
            team: 'team',
        },
        relation: {
            user: User,
            team: Team,
            role: enumField(TeamUserRole)
        }
    })
], TeamUser);

let TournamentDisqualification = class TournamentDisqualification extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentDisqualification, "toFront", null);
__decorate([
    ToBackHook
], TournamentDisqualification, "toBack", null);
TournamentDisqualification = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            tournament_team_user_id: 'tournamentTeamUserId',
            date_from: 'dateFrom',
            date_to: 'dateTo',
            matches_count: 'matchesCount',
            reason: 'reason',
            is_conditional: 'isConditional',
        },
        relation: {
            dateFrom: DateField,
            dateTo: DateField,
        }
    })
], TournamentDisqualification);

let LeaguePlayerField = class LeaguePlayerField extends LeagueFieldBase {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeaguePlayerField, "toFront", null);
__decorate([
    ToBackHook
], LeaguePlayerField, "toBack", null);
LeaguePlayerField = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            league_id: 'leagueId',
            name: 'name',
            type: 'type',
            is_multiple: 'isMultiple',
            variants: 'variants',
        },
        relation: {
            type: enumField(LeagueFieldTypes)
        }
    })
], LeaguePlayerField);

let LeaguePlayerFieldValue = class LeaguePlayerFieldValue extends LeagueFieldBaseValue {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeaguePlayerFieldValue, "toFront", null);
__decorate([
    ToBackHook
], LeaguePlayerFieldValue, "toBack", null);
LeaguePlayerFieldValue = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            league_player_field_id: 'leaguePlayerFieldId',
            league_player_field: 'leaguePlayerField',
            value: 'value',
            file: 'file',
            value_text: 'valueText',
        },
        relation: {
            file: File,
            leaguePlayerField: LeaguePlayerField
        }
    })
], LeaguePlayerFieldValue);

var Locales;
(function (Locales) {
    Locales["ru"] = "ru-RU";
    Locales["en"] = "en-US";
})(Locales || (Locales = {}));

var Qualification;
(function (Qualification) {
    Qualification[Qualification["practician"] = 1] = "practician";
    Qualification[Qualification["amateur"] = 2] = "amateur";
    Qualification[Qualification["practician2"] = 3] = "practician2";
    Qualification[Qualification["practician3"] = 4] = "practician3";
    Qualification[Qualification["amateur2"] = 5] = "amateur2";
    Qualification[Qualification["theorist"] = 6] = "theorist";
    Qualification[Qualification["theorist2"] = 7] = "theorist2";
    Qualification[Qualification["theorist3"] = 8] = "theorist3";
    Qualification[Qualification["sportsman"] = 9] = "sportsman";
    Qualification[Qualification["lider"] = 10] = "lider";
    Qualification[Qualification["master"] = 11] = "master";
    Qualification[Qualification["profi"] = 12] = "profi";
    Qualification[Qualification["goalkeeper"] = 13] = "goalkeeper";
    Qualification[Qualification["goalkeeper2"] = 14] = "goalkeeper2";
    Qualification[Qualification["goalkeeper_sh"] = 15] = "goalkeeper_sh";
    Qualification[Qualification["goalkeeper_ul"] = 16] = "goalkeeper_ul";
    Qualification[Qualification["goalkeeper_mhl"] = 17] = "goalkeeper_mhl";
    Qualification[Qualification["goalkeeper_vhl"] = 18] = "goalkeeper_vhl";
    Qualification[Qualification["goalkeeper_khl"] = 19] = "goalkeeper_khl";
    Qualification[Qualification["beginner"] = 20] = "beginner";
    Qualification[Qualification["junior"] = 21] = "junior";
    Qualification[Qualification["debutant"] = 22] = "debutant";
    Qualification[Qualification["schoolchild"] = 23] = "schoolchild";
    Qualification[Qualification["preschool_child"] = 24] = "preschool_child";
})(Qualification || (Qualification = {}));
const QualificationLocalization = {
    [Locales.ru]: {
        [Qualification.practician]: 'Практик',
        [Qualification.practician2]: 'Практик 2',
        [Qualification.practician3]: 'Практик 3',
        [Qualification.amateur]: 'Любитель',
        [Qualification.amateur2]: 'Любитель 2',
        [Qualification.theorist]: 'Теоретик',
        [Qualification.theorist2]: 'Теоретик 2',
        [Qualification.theorist3]: 'Теоретик 3',
        [Qualification.sportsman]: 'Спортсмен',
        [Qualification.lider]: 'Лидер',
        [Qualification.master]: 'Мастер',
        [Qualification.profi]: 'Профи',
        [Qualification.goalkeeper]: 'Вратарь',
        [Qualification.goalkeeper2]: 'Вратарь 2',
        [Qualification.goalkeeper_sh]: 'Вратарь СШ',
        [Qualification.goalkeeper_ul]: 'Вратарь ЮЛ',
        [Qualification.goalkeeper_mhl]: 'Вратарь МХЛ',
        [Qualification.goalkeeper_vhl]: 'Вратарь ВХЛ',
        [Qualification.goalkeeper_khl]: 'Вратарь КХЛ',
        [Qualification.beginner]: 'Новичок',
        [Qualification.junior]: 'Юниор',
        [Qualification.debutant]: 'Дебютант',
        [Qualification.schoolchild]: 'Школьник',
        [Qualification.preschool_child]: 'Дошкольник',
    },
    [Locales.en]: {
        [Qualification.practician]: 'Practician',
        [Qualification.practician2]: 'Practician 2',
        [Qualification.practician3]: 'Практик 3',
        [Qualification.amateur]: 'Amateur',
        [Qualification.amateur2]: 'Amateur 2',
        [Qualification.theorist]: 'Theorist',
        [Qualification.theorist2]: 'Theorist 2',
        [Qualification.theorist3]: 'Theorist 3',
        [Qualification.sportsman]: 'Sportsman',
        [Qualification.lider]: 'Leader',
        [Qualification.master]: 'Master',
        [Qualification.profi]: 'Professional',
        [Qualification.goalkeeper]: 'Goalkeeper',
        [Qualification.goalkeeper2]: 'Goalkeeper 2',
        [Qualification.goalkeeper_sh]: 'Goalkeeper SH',
        [Qualification.goalkeeper_ul]: 'Goalkeeper UL',
        [Qualification.goalkeeper_mhl]: 'Goalkeeper MHL',
        [Qualification.goalkeeper_vhl]: 'Goalkeeper VHL',
        [Qualification.goalkeeper_khl]: 'Goalkeeper KHL',
        [Qualification.beginner]: 'Beginner',
        [Qualification.junior]: 'Junior',
        [Qualification.debutant]: 'Debutant',
        [Qualification.schoolchild]: 'Schoolchild',
        [Qualification.preschool_child]: 'Preschool child',
    }
};
let LeaguePlayer = class LeaguePlayer extends BaseModel {
    get fullName() {
        return [this.lastName, this.firstName, this.middleName].filter(s => s).join(' ');
    }
    get shortName() {
        return [this.lastName, this.firstName].filter(s => s).join(' ');
    }
    get initials() {
        return [this.lastName, this.firstName].filter(s => s).map(s => s.substr(0, 1)).join('');
    }
    get age() {
        if (!this.birthDate) {
            return null;
        }
        const diff = (new Date()).getTime() - this.birthDate.getTime();
        return Math.floor(diff / (1000 * 60 * 60 * 24 * 365.25));
    }
    static toFront(data) {
    }
    static toBack(data) {
    }
};
__decorate([
    ToFrontHook
], LeaguePlayer, "toFront", null);
__decorate([
    ToBackHook
], LeaguePlayer, "toBack", null);
LeaguePlayer = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            league_id: 'leagueId',
            first_name: 'firstName',
            last_name: 'lastName',
            middle_name: 'middleName',
            birth_date: 'birthDate',
            photo: 'photo',
            user: 'user',
            gender: 'gender',
            has_changes: 'hasChanges',
            rating: 'rating',
            qualification: 'qualification',
            field_values: 'fieldValues',
        },
        relation: {
            birthDate: DateField,
            photo: File,
            user: User,
            qualification: enumField(Qualification),
            fieldValues: listField(LeaguePlayerFieldValue),
            gender: enumField(UserGender),
        }
    })
], LeaguePlayer);

let TournamentTeamUser = class TournamentTeamUser extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentTeamUser, "toFront", null);
__decorate([
    ToBackHook
], TournamentTeamUser, "toBack", null);
TournamentTeamUser = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            active: 'active',
            tournament_team: 'tournamentTeam',
            team_user: 'teamUser',
            disqualified: 'disqualified',
            disqualification: 'disqualification',
            conditional_disqualification: 'conditionalDisqualification',
            league_player: 'leaguePlayer',
            games_count: 'gamesCount',
            mvp_count: 'mvpCount',
        },
        relation: {
            tournamentTeam: TournamentTeam,
            teamUser: TeamUser,
            disqualification: TournamentDisqualification,
            conditionalDisqualification: TournamentDisqualification,
            leaguePlayer: LeaguePlayer,
        }
    })
], TournamentTeamUser);

let BasketballStatistic = class BasketballStatistic extends BaseModel {
    get totalFouls() {
        return Math.floor(10 * ((this.personalFouls || 0) +
            (this.technicalFouls || 0) +
            (this.unsportsmanlikeFouls || 0) +
            (this.disqualificationFouls || 0))) / 10;
    }
    get gameMinutes() {
        return Math.floor(this.gameTime / 60);
    }
    get tournamentTeamPoints() {
        return this.tournamentTeam && this.tournamentTeam.points;
    }
    get onePointsPercent() {
        if (!this.onePointsMade || !this.onePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.onePointsMade / this.onePointAttempts) / 10;
    }
    get twoPointsPercent() {
        if (!this.twoPointsMade || !this.twoPointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.twoPointsMade / this.twoPointAttempts) / 10;
    }
    get threePointsPercent() {
        if (!this.threePointsMade || !this.threePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.threePointsMade / this.threePointAttempts) / 10;
    }
    get freeThrowsPercent() {
        if (!this.freeThrowsMade || !this.freeThrowAttempts) {
            return 0;
        }
        return Math.round(1000 * this.freeThrowsMade / this.freeThrowAttempts) / 10;
    }
    get totalRebounds() {
        return Math.floor(10 * ((this.offensiveRebounds || 0) + (this.defensiveRebounds || 0))) / 10;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], BasketballStatistic, "toFront", null);
__decorate([
    ToBackHook
], BasketballStatistic, "toBack", null);
BasketballStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            league_player: 'leaguePlayer',
            tournament_team_user: 'tournamentTeamUser',
            team: 'team',
            team_user: 'teamUser',
            user: 'user',
            tournament_team: 'tournamentTeam',
            month: 'month',
            win_lose: 'winLose',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            team_score_sum: 'teamScoreSum',
            team_missed_sum: 'teamMissedSum',
            tournament_points: 'tournamentPoints',
            points: 'points',
            two_points_made: 'twoPointsMade',
            three_points_made: 'threePointsMade',
            free_throws_made: 'freeThrowsMade',
            one_points_made: 'onePointsMade',
            two_point_attempts: 'twoPointAttempts',
            three_point_attempts: 'threePointAttempts',
            free_throw_attempts: 'freeThrowAttempts',
            one_point_attempts: 'onePointAttempts',
            two_point_percent: 'twoPointPercent',
            three_point_percent: 'threePointPercent',
            free_throw_percent: 'freeThrowPercent',
            one_point_percent: 'onePointPercent',
            assists: 'assists',
            blocks: 'blocks',
            rebounds: 'rebounds',
            offensive_rebounds: 'offensiveRebounds',
            defensive_rebounds: 'defensiveRebounds',
            steals: 'steals',
            turnovers: 'turnovers',
            personal_fouls: 'personalFouls',
            technical_fouls: 'technicalFouls',
            unsportsmanlike_fouls: 'unsportsmanlikeFouls',
            disqualification_fouls: 'disqualificationFouls',
            drawn_fouls: 'drawnFouls',
            player_efficiency: 'playerEfficiency',
            shots_blocked: 'shotsBlocked',
            four_point_attempts: 'fourPointAttempts',
            four_points_made: 'fourPointsMade',
            four_point_percent: 'fourPointPercent',
            dunk_attempts: 'dunkAttempts',
            dunks_made: 'dunksMade',
            shootouts_won: 'shootoutsWon',
            shootouts_lost: 'shootoutsLost',
            shootouts_total: 'shootoutsTotal',
            shootout_won_percent: 'shootoutWonPercent',
            moneyball_free_throw_attempts: 'moneyballFreeThrowAttempts',
            moneyball_free_throws_made: 'moneyballFreeThrowsMade',
            moneyball_free_throw_percent: 'moneyballFreeThrowPercent',
            game_time: 'gameTime',
            newbie: 'newbie',
            rank: 'rank',
        },
        relation: {
            leaguePlayer: LeaguePlayer,
            tournamentTeamUser: TournamentTeamUser,
            team: Team,
            teamUser: TeamUser,
            user: User,
            tournamentTeam: TournamentTeam,
            month: DateField
        }
    })
], BasketballStatistic);

let BasketballGameTeamStatistic = class BasketballGameTeamStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], BasketballGameTeamStatistic, "toFront", null);
__decorate([
    ToBackHook
], BasketballGameTeamStatistic, "toBack", null);
BasketballGameTeamStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            competitor_team: 'competitorTeam'
        },
        relation: {
            team: BasketballStatistic,
            competitorTeam: BasketballStatistic
        }
    })
], BasketballGameTeamStatistic);

let BasketballGameStatistic = class BasketballGameStatistic extends BaseModel {
    get id() {
        return this.gameUserId;
    }
    static toFront(data) { }
    static toBack(data) { }
    get totalFouls() {
        return (this.personalFouls || 0) + (this.technicalFouls || 0) + (this.unsportsmanlikeFouls || 0) + (this.disqualificationFouls || 0);
    }
    set onePointPercent(v) { }
    get onePointPercent() {
        if (!this.onePointsMade || !this.onePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.onePointsMade / this.onePointAttempts) / 10;
    }
    /**
     * @deprecated Use onePointPercent instead
     */
    get onePointsPercent() {
        if (!this.onePointsMade || !this.onePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.onePointsMade / this.onePointAttempts) / 10;
    }
    set twoPointPercent(v) { }
    get twoPointPercent() {
        if (!this.twoPointsMade || !this.twoPointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.twoPointsMade / this.twoPointAttempts) / 10;
    }
    /**
     * @deprecated Use twoPointPercent instead
     */
    get twoPointsPercent() {
        if (!this.twoPointsMade || !this.twoPointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.twoPointsMade / this.twoPointAttempts) / 10;
    }
    set threePointPercent(v) { }
    get threePointPercent() {
        if (!this.threePointsMade || !this.threePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.threePointsMade / this.threePointAttempts) / 10;
    }
    /**
     * @deprecated Use threePointPercent instead
     */
    get threePointsPercent() {
        if (!this.threePointsMade || !this.threePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.threePointsMade / this.threePointAttempts) / 10;
    }
    set freeThrowPercent(v) { }
    get freeThrowPercent() {
        if (!this.freeThrowsMade || !this.freeThrowAttempts) {
            return 0;
        }
        return Math.round(1000 * this.freeThrowsMade / this.freeThrowAttempts) / 10;
    }
    /**
     * @deprecated Use freeThrowPercent instead
     */
    get freeThrowsPercent() {
        if (!this.freeThrowsMade || !this.freeThrowAttempts) {
            return 0;
        }
        return Math.round(1000 * this.freeThrowsMade / this.freeThrowAttempts) / 10;
    }
    get totalRebounds() {
        return Math.floor(10 * ((this.offensiveRebounds || 0) + (this.defensiveRebounds || 0))) / 10;
    }
    set fourPointPercent(v) { }
    get fourPointPercent() {
        if (!this.fourPointAttempts || !this.fourPointsMade) {
            return 0;
        }
        return Math.round(1000 * this.fourPointsMade / this.fourPointAttempts) / 10;
    }
    set shootoutsTotal(v) { }
    get shootoutsTotal() {
        return (this.shootoutsLost || 0) + (this.shootoutsWon || 0);
    }
    set shootoutWonPercent(v) { }
    get shootoutWonPercent() {
        if (!this.shootoutsTotal || !this.shootoutsWon) {
            return 0;
        }
        return Math.round(1000 * this.shootoutsWon / this.shootoutsTotal) / 10;
    }
    set moneyballFreeThrowPercent(v) { }
    get moneyballFreeThrowPercent() {
        if (!this.moneyballFreeThrowsMade || !this.moneyballFreeThrowAttepts) {
            return 0;
        }
        return Math.round(1000 * this.moneyballFreeThrowsMade / this.moneyballFreeThrowAttepts) / 10;
    }
};
__decorate([
    ToFrontHook
], BasketballGameStatistic, "toFront", null);
__decorate([
    ToBackHook
], BasketballGameStatistic, "toBack", null);
BasketballGameStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            game_user_id: 'gameUserId',
            points: 'points',
            free_throws_made: 'freeThrowsMade',
            two_points_made: 'twoPointsMade',
            three_points_made: 'threePointsMade',
            one_points_made: 'onePointsMade',
            two_point_attempts: 'twoPointAttempts',
            three_point_attempts: 'threePointAttempts',
            free_throw_attempts: 'freeThrowAttempts',
            one_point_attempts: 'onePointAttempts',
            one_point_percent: 'onePointPercent',
            two_point_percent: 'twoPointPercent',
            three_point_percent: 'threePointPercent',
            free_throw_percent: 'freeThrowPercent',
            four_point_percent: 'fourPointPercent',
            assists: 'assists',
            blocks: 'blocks',
            rebounds: 'rebounds',
            offensive_rebounds: 'offensiveRebounds',
            defensive_rebounds: 'defensiveRebounds',
            steals: 'steals',
            turnovers: 'turnovers',
            personal_fouls: 'personalFouls',
            technical_fouls: 'technicalFouls',
            unsportsmanlike_fouls: 'unsportsmanlikeFouls',
            disqualification_fouls: 'disqualificationFouls',
            drawn_fouls: 'drawnFouls',
            player_efficiency: 'playerEfficiency',
            shots_blocked: 'shotsBlocked',
            four_point_attempts: 'fourPointAttempts',
            four_points_made: 'fourPointsMade',
            dunk_attempts: 'dunkAttempts',
            dunks_made: 'dunksMade',
            shootouts_won: 'shootoutsWon',
            shootouts_lost: 'shootoutsLost',
            shootouts_total: 'shootoutsTotal',
            shootout_won_percent: 'shootoutWonPercent',
            moneyball_free_throw_attepts: 'moneyballFreeThrowAttepts',
            moneyball_free_throws_made: 'moneyballFreeThrowsMade',
            plus_minus: 'plusMinus',
            game_time: 'gameTime',
            updated_at: 'updatedAt',
        },
        relation: {
            updatedAt: DateTimeField,
        }
    })
], BasketballGameStatistic);

var BasketballGameLogTypes;
(function (BasketballGameLogTypes) {
    BasketballGameLogTypes[BasketballGameLogTypes["enter_game"] = 1] = "enter_game";
    BasketballGameLogTypes[BasketballGameLogTypes["exit_game"] = 2] = "exit_game";
    BasketballGameLogTypes[BasketballGameLogTypes["remove_game"] = 3] = "remove_game";
    BasketballGameLogTypes[BasketballGameLogTypes["two_point_made"] = 4] = "two_point_made";
    BasketballGameLogTypes[BasketballGameLogTypes["three_point_made"] = 5] = "three_point_made";
    BasketballGameLogTypes[BasketballGameLogTypes["free_throw_made"] = 6] = "free_throw_made";
    BasketballGameLogTypes[BasketballGameLogTypes["two_point_attempt"] = 7] = "two_point_attempt";
    BasketballGameLogTypes[BasketballGameLogTypes["three_point_attempt"] = 8] = "three_point_attempt";
    BasketballGameLogTypes[BasketballGameLogTypes["free_throw_attempt"] = 9] = "free_throw_attempt";
    BasketballGameLogTypes[BasketballGameLogTypes["assist"] = 10] = "assist";
    BasketballGameLogTypes[BasketballGameLogTypes["block"] = 11] = "block";
    BasketballGameLogTypes[BasketballGameLogTypes["rebound"] = 12] = "rebound";
    BasketballGameLogTypes[BasketballGameLogTypes["offensive_rebound"] = 13] = "offensive_rebound";
    BasketballGameLogTypes[BasketballGameLogTypes["defensive_rebound"] = 14] = "defensive_rebound";
    BasketballGameLogTypes[BasketballGameLogTypes["steal"] = 15] = "steal";
    BasketballGameLogTypes[BasketballGameLogTypes["turnover"] = 16] = "turnover";
    BasketballGameLogTypes[BasketballGameLogTypes["personal_foul"] = 17] = "personal_foul";
    BasketballGameLogTypes[BasketballGameLogTypes["technical_foul"] = 18] = "technical_foul";
    BasketballGameLogTypes[BasketballGameLogTypes["unsportsmanlike_foul"] = 19] = "unsportsmanlike_foul";
    BasketballGameLogTypes[BasketballGameLogTypes["disqualification_foul"] = 20] = "disqualification_foul";
    BasketballGameLogTypes[BasketballGameLogTypes["one_point_attempt"] = 21] = "one_point_attempt";
    BasketballGameLogTypes[BasketballGameLogTypes["one_point_made"] = 22] = "one_point_made";
    BasketballGameLogTypes[BasketballGameLogTypes["timeout"] = 23] = "timeout";
    BasketballGameLogTypes[BasketballGameLogTypes["team_rebound"] = 24] = "team_rebound";
    BasketballGameLogTypes[BasketballGameLogTypes["four_point_attempt"] = 25] = "four_point_attempt";
    BasketballGameLogTypes[BasketballGameLogTypes["four_point_made"] = 26] = "four_point_made";
    BasketballGameLogTypes[BasketballGameLogTypes["dunk_attempt"] = 27] = "dunk_attempt";
    BasketballGameLogTypes[BasketballGameLogTypes["dunk_made"] = 28] = "dunk_made";
    BasketballGameLogTypes[BasketballGameLogTypes["shootout"] = 29] = "shootout";
    BasketballGameLogTypes[BasketballGameLogTypes["shootout_won"] = 30] = "shootout_won";
    BasketballGameLogTypes[BasketballGameLogTypes["shootout_lost"] = 31] = "shootout_lost";
    BasketballGameLogTypes[BasketballGameLogTypes["moneyball_free_throw_attempt"] = 32] = "moneyball_free_throw_attempt";
    BasketballGameLogTypes[BasketballGameLogTypes["moneyball_free_throw_made"] = 33] = "moneyball_free_throw_made";
})(BasketballGameLogTypes || (BasketballGameLogTypes = {}));
var BasketballSubLogTypes;
(function (BasketballSubLogTypes) {
    // Miss, Made
    BasketballSubLogTypes[BasketballSubLogTypes["jump_shot"] = 1] = "jump_shot";
    BasketballSubLogTypes[BasketballSubLogTypes["step_back_jump_shot"] = 2] = "step_back_jump_shot";
    BasketballSubLogTypes[BasketballSubLogTypes["floating_jump_shot"] = 3] = "floating_jump_shot";
    BasketballSubLogTypes[BasketballSubLogTypes["fade_away_jump_shot"] = 4] = "fade_away_jump_shot";
    BasketballSubLogTypes[BasketballSubLogTypes["pull_up_jump_shot"] = 5] = "pull_up_jump_shot";
    BasketballSubLogTypes[BasketballSubLogTypes["turnaround_jump_shot"] = 6] = "turnaround_jump_shot";
    BasketballSubLogTypes[BasketballSubLogTypes["dunk"] = 7] = "dunk";
    BasketballSubLogTypes[BasketballSubLogTypes["layup"] = 8] = "layup";
    BasketballSubLogTypes[BasketballSubLogTypes["driving_layup"] = 9] = "driving_layup";
    BasketballSubLogTypes[BasketballSubLogTypes["alley_oop"] = 10] = "alley_oop";
    BasketballSubLogTypes[BasketballSubLogTypes["hook_shot"] = 11] = "hook_shot";
    // foul
    BasketballSubLogTypes[BasketballSubLogTypes["offensive_foul"] = 12] = "offensive_foul";
    BasketballSubLogTypes[BasketballSubLogTypes["shot_foul"] = 13] = "shot_foul";
    BasketballSubLogTypes[BasketballSubLogTypes["mutual_foul"] = 14] = "mutual_foul";
    // Turnover
    BasketballSubLogTypes[BasketballSubLogTypes["bad_pass"] = 15] = "bad_pass";
    BasketballSubLogTypes[BasketballSubLogTypes["ball_handling"] = 16] = "ball_handling";
    BasketballSubLogTypes[BasketballSubLogTypes["travel"] = 17] = "travel";
    BasketballSubLogTypes[BasketballSubLogTypes["double_dribble"] = 18] = "double_dribble";
    BasketballSubLogTypes[BasketballSubLogTypes["out_of_bounds"] = 19] = "out_of_bounds";
    BasketballSubLogTypes[BasketballSubLogTypes["three_seconds"] = 20] = "three_seconds";
    BasketballSubLogTypes[BasketballSubLogTypes["five_seconds"] = 21] = "five_seconds";
    BasketballSubLogTypes[BasketballSubLogTypes["eight_seconds"] = 22] = "eight_seconds";
    BasketballSubLogTypes[BasketballSubLogTypes["twenty_four_seconds"] = 23] = "twenty_four_seconds";
    BasketballSubLogTypes[BasketballSubLogTypes["back_court"] = 24] = "back_court";
    BasketballSubLogTypes[BasketballSubLogTypes["offensive_goal_tending"] = 25] = "offensive_goal_tending";
    BasketballSubLogTypes[BasketballSubLogTypes["other_turnover"] = 26] = "other_turnover";
})(BasketballSubLogTypes || (BasketballSubLogTypes = {}));
var BasketballCourtZones;
(function (BasketballCourtZones) {
    BasketballCourtZones[BasketballCourtZones["paint"] = 1] = "paint";
    BasketballCourtZones[BasketballCourtZones["left_short_corner"] = 2] = "left_short_corner";
    BasketballCourtZones[BasketballCourtZones["right_short_corner"] = 3] = "right_short_corner";
    BasketballCourtZones[BasketballCourtZones["left_middle_post"] = 4] = "left_middle_post";
    BasketballCourtZones[BasketballCourtZones["right_middle_post"] = 5] = "right_middle_post";
    BasketballCourtZones[BasketballCourtZones["high_post"] = 6] = "high_post";
    BasketballCourtZones[BasketballCourtZones["left_corner"] = 7] = "left_corner";
    BasketballCourtZones[BasketballCourtZones["right_corner"] = 8] = "right_corner";
    BasketballCourtZones[BasketballCourtZones["left_wing"] = 9] = "left_wing";
    BasketballCourtZones[BasketballCourtZones["right_wing"] = 10] = "right_wing";
    BasketballCourtZones[BasketballCourtZones["top"] = 11] = "top";
})(BasketballCourtZones || (BasketballCourtZones = {}));
var BasketballCourtSides;
(function (BasketballCourtSides) {
    BasketballCourtSides[BasketballCourtSides["front"] = 1] = "front";
    BasketballCourtSides[BasketballCourtSides["back"] = 2] = "back";
})(BasketballCourtSides || (BasketballCourtSides = {}));
var BasketballPenaltyTypes;
(function (BasketballPenaltyTypes) {
    BasketballPenaltyTypes[BasketballPenaltyTypes["one_shot"] = 1] = "one_shot";
    BasketballPenaltyTypes[BasketballPenaltyTypes["two_shots"] = 2] = "two_shots";
    BasketballPenaltyTypes[BasketballPenaltyTypes["three_shots"] = 3] = "three_shots";
    BasketballPenaltyTypes[BasketballPenaltyTypes["possession"] = 4] = "possession";
    BasketballPenaltyTypes[BasketballPenaltyTypes["one_shot_and_possession"] = 5] = "one_shot_and_possession";
    BasketballPenaltyTypes[BasketballPenaltyTypes["two_shots_and_possession"] = 6] = "two_shots_and_possession";
    BasketballPenaltyTypes[BasketballPenaltyTypes["three_shots_and_possession"] = 7] = "three_shots_and_possession";
})(BasketballPenaltyTypes || (BasketballPenaltyTypes = {}));
let BasketballGameLog = class BasketballGameLog extends BaseModel {
    constructor() {
        super(...arguments);
        this.active = true;
    }
    isPointsType() {
        return [
            BasketballGameLogTypes.two_point_made,
            BasketballGameLogTypes.three_point_made,
            BasketballGameLogTypes.free_throw_made,
            BasketballGameLogTypes.one_point_made,
            BasketballGameLogTypes.four_point_made,
            BasketballGameLogTypes.dunk_made,
            BasketballGameLogTypes.shootout_won,
            BasketballGameLogTypes.moneyball_free_throw_made,
        ].indexOf(this.logType) > -1;
    }
    isReboundType() {
        return [
            BasketballGameLogTypes.rebound,
            BasketballGameLogTypes.offensive_rebound,
            BasketballGameLogTypes.defensive_rebound,
            BasketballGameLogTypes.team_rebound,
        ].indexOf(this.logType) > -1;
    }
    isFoulType() {
        return [
            BasketballGameLogTypes.personal_foul,
            BasketballGameLogTypes.technical_foul,
            BasketballGameLogTypes.unsportsmanlike_foul,
            BasketballGameLogTypes.disqualification_foul,
        ].indexOf(this.logType) > -1;
    }
    getScore() {
        const scoreMapping = {
            [BasketballGameLogTypes.one_point_made]: this.isAdditionalPoint ? 2 : 1,
            [BasketballGameLogTypes.free_throw_made]: 1,
            [BasketballGameLogTypes.two_point_made]: this.isAdditionalPoint ? 3 : 2,
            [BasketballGameLogTypes.three_point_made]: this.isAdditionalPoint ? 4 : 3,
            [BasketballGameLogTypes.four_point_made]: this.isAdditionalPoint ? 5 : 4,
            [BasketballGameLogTypes.dunk_made]: this.isAdditionalPoint ? 4 : 3,
            [BasketballGameLogTypes.moneyball_free_throw_made]: 2,
        };
        if (this.logType === BasketballGameLogTypes.shootout_won) {
            return this.shootoutPoints;
        }
        return scoreMapping[this.logType] || 0;
    }
    compare(model) {
        if (this.time === model.time && this.period === model.period) {
            if (this.datetime.getTime() === model.datetime.getTime()) {
                return this.id > model.id ? 1 : -1;
            }
            return this.datetime.getTime() < model.datetime.getTime() ? 1 : -1;
        }
        if (this.period === model.period) {
            return this.time < model.time ? 1 : -1;
        }
        return this.period < model.period ? 1 : -1;
    }
    get timeFormatted() {
        const minutes = Math.floor(this.time / 60);
        const seconds = this.time - minutes * 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], BasketballGameLog, "toFront", null);
__decorate([
    ToBackHook
], BasketballGameLog, "toBack", null);
BasketballGameLog = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            unique_id: 'uniqueId',
            game_id: 'gameId',
            game_user_id: 'gameUserId',
            team_id: 'teamId',
            log_type: 'logType',
            sub_log_type: 'subLogType',
            datetime: 'datetime',
            time: 'time',
            period: 'period',
            active: 'active',
            is_highlight: 'isHighlight',
            zone: 'zone',
            court_side: 'courtSide',
            foul_on_game_user_id: 'foulOnGameUserId',
            penalty_type: 'penaltyType',
            fast_break: 'fastBreak',
            is_coach: 'isCoach',
            is_bench: 'isBench',
            group: 'group',
            marked: 'marked',
            is_additional_point: 'isAdditionalPoint',
            coords: 'coords',
            shootout_points: 'shootoutPoints',
        },
        relation: {
            datetime: DateTimeField,
            logType: enumField(BasketballGameLogTypes),
            subLogType: enumField(BasketballSubLogTypes),
            penaltyType: enumField(BasketballPenaltyTypes),
            zone: enumField(BasketballCourtZones),
            courtSide: enumField(BasketballCourtSides),
        }
    })
], BasketballGameLog);

let GameUser = class GameUser extends BaseModel {
    get gameUserNumber() {
        return (this.number || this.number === 0) ? this.number : this.teamUser.number;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], GameUser, "toFront", null);
__decorate([
    ToBackHook
], GameUser, "toBack", null);
GameUser = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            game_id: 'gameId',
            team_user: 'teamUser',
            tournament_team_user: 'tournamentTeamUser',
            is_mvp: 'isMvp',
            number: 'number',
            updated_at: 'updatedAt'
        },
        relation: {
            teamUser: TeamUser,
            tournamentTeamUser: TournamentTeamUser,
            updatedAt: DateTimeField,
        }
    })
], GameUser);

let GameUserLimitationTypes = class GameUserLimitationTypes extends BaseModel {
    static toFront(data) {
    }
    static toBack(data) {
    }
};
__decorate([
    ToFrontHook
], GameUserLimitationTypes, "toFront", null);
__decorate([
    ToBackHook
], GameUserLimitationTypes, "toBack", null);
GameUserLimitationTypes = __decorate([
    ModelInstance({
        mappingFields: {
            min_user_games_count: 'minUserGamesCount',
            min_user_time: 'minUserTime',
            min_goalkeeper_user_games_count: 'minGoalkeeperUserGamesCount',
            min_goalkeeper_user_time: 'minGoalkeeperUserTime',
            manual: 'manual',
        },
    })
], GameUserLimitationTypes);
let GameUserLimitations = class GameUserLimitations extends BaseModel {
    static toFront(data) {
    }
    static toBack(data) {
    }
};
__decorate([
    ToFrontHook
], GameUserLimitations, "toFront", null);
__decorate([
    ToBackHook
], GameUserLimitations, "toBack", null);
GameUserLimitations = __decorate([
    ModelInstance({
        mappingFields: {
            tournament_team_user_id: 'tournamentTeamUserId',
            limitations: 'limitations'
        },
        relation: {
            limitations: GameUserLimitationTypes
        }
    })
], GameUserLimitations);

let GameUserDisqualification = class GameUserDisqualification extends BaseModel {
    static toFront(data) {
    }
    static toBack(data) {
    }
};
__decorate([
    ToFrontHook
], GameUserDisqualification, "toFront", null);
__decorate([
    ToBackHook
], GameUserDisqualification, "toBack", null);
GameUserDisqualification = __decorate([
    ModelInstance({
        mappingFields: {
            tournament_team_user_id: 'tournamentTeamUserId',
            disqualification: 'disqualification'
        },
        relation: {
            disqualification: TournamentDisqualification
        }
    })
], GameUserDisqualification);

class GameBaseApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getUsers(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/users/`).pipe(map(result => GameUser.toFront(result))).toPromise();
        });
    }
    getMvp(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/mvp/`).pipe(map(result => GameUser.toFront(result))).toPromise();
        });
    }
    getUsersLimitation(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/users_limitation/`).pipe(map(result => GameUserLimitations.toFront(result))).toPromise();
        });
    }
    getUsersDisqualification(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/users_disqualification/`).pipe(map(result => GameUserDisqualification.toFront(result))).toPromise();
        });
    }
    downloadApplication(gameId, format, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/game_application/`, {
                params: new HttpParams().set('file_type', format).set('application_type', type),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
GameBaseApi.ɵfac = function GameBaseApi_Factory(t) { return new (t || GameBaseApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
GameBaseApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function GameBaseApi_Factory() { return new GameBaseApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: GameBaseApi, providedIn: "root" });
GameBaseApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class BasketballGameApi extends GameBaseApi {
    constructor(httpClient, configService) {
        super(httpClient, configService);
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getTeamStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/team_statistic/`).pipe(map(result => BasketballGameTeamStatistic.toFront(result))).toPromise();
        });
    }
    getUserStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/user_statistic/`).pipe(map(result => BasketballGameStatistic.toFront(result))).toPromise();
        });
    }
    getLogs(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/logs/`).pipe(map(result => BasketballGameLog.toFront(result))).toPromise();
        });
    }
    downloadProtocol(gameId, fileType) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/game_protocol/?file_type=${fileType}`, { responseType: 'blob' })
                .toPromise();
        });
    }
    downloadFibaProtocol(gameId, fileType) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/game_protocol_fiba/?file_type=${fileType}`, { responseType: 'blob' })
                .toPromise();
        });
    }
    downloadMFBApplication(gameId, fileType) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_basketball_game/${gameId}/mfb_game_application_file/?file_type=${fileType}`, {
                params: new HttpParams().set('file_type', fileType),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
BasketballGameApi.ɵfac = function BasketballGameApi_Factory(t) { return new (t || BasketballGameApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
BasketballGameApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function BasketballGameApi_Factory() { return new BasketballGameApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: BasketballGameApi, providedIn: "root" });
BasketballGameApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let Feedback = class Feedback {
    static toFront(data) {
        return null;
    }
    static toBack(value) {
        return null;
    }
};
__decorate([
    ToFrontHook
], Feedback, "toFront", null);
__decorate([
    ToBackHook
], Feedback, "toBack", null);
Feedback = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            theme: 'theme',
            message: 'message',
            files: 'files',
            email: 'email',
            captcha: 'captcha',
        },
        relation: {
            files: File
        }
    })
], Feedback);

class FeedbackApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    sendFeedback(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/feedback/`, Feedback.toBack(data))
                .pipe(map(response => Feedback.toFront(response)))
                .toPromise();
        });
    }
    sendLeagueFeedback(leagueId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/feedback/`, Feedback.toBack(data))
                .pipe(map(response => Feedback.toFront(response)))
                .toPromise();
        });
    }
}
FeedbackApi.ɵfac = function FeedbackApi_Factory(t) { return new (t || FeedbackApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
FeedbackApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function FeedbackApi_Factory() { return new FeedbackApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: FeedbackApi, providedIn: "root" });
FeedbackApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class FileApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    upload(fileData, filename, width, height) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (width && height) {
                params = params.set('width', width.toString()).set('height', height.toString());
            }
            const formData = new FormData();
            formData.append('file', fileData, filename);
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/file/`, formData, { params })
                .pipe(map(data => File.toFront(data)))
                .toPromise();
        });
    }
    createZipArchive(files) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            for (const file of files) {
                formData.append('files', file.file, file.filename);
            }
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/file/zip_archive/`, formData, { responseType: 'blob' })
                .toPromise();
        });
    }
}
FileApi.ɵfac = function FileApi_Factory(t) { return new (t || FileApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
FileApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function FileApi_Factory() { return new FileApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: FileApi, providedIn: "root" });
FileApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

var HockeyGameLogTypes;
(function (HockeyGameLogTypes) {
    HockeyGameLogTypes[HockeyGameLogTypes["enter_game"] = 1] = "enter_game";
    HockeyGameLogTypes[HockeyGameLogTypes["exit_game"] = 2] = "exit_game";
    HockeyGameLogTypes[HockeyGameLogTypes["shot_miss"] = 3] = "shot_miss";
    HockeyGameLogTypes[HockeyGameLogTypes["shot_on_goal"] = 4] = "shot_on_goal";
    HockeyGameLogTypes[HockeyGameLogTypes["shot_blocked"] = 5] = "shot_blocked";
    HockeyGameLogTypes[HockeyGameLogTypes["goal"] = 6] = "goal";
    HockeyGameLogTypes[HockeyGameLogTypes["shootout_attempt"] = 7] = "shootout_attempt";
    HockeyGameLogTypes[HockeyGameLogTypes["shootout_goal"] = 8] = "shootout_goal";
    HockeyGameLogTypes[HockeyGameLogTypes["assist"] = 9] = "assist";
    HockeyGameLogTypes[HockeyGameLogTypes["block_shot"] = 10] = "block_shot";
    HockeyGameLogTypes[HockeyGameLogTypes["minor_penalty"] = 11] = "minor_penalty";
    HockeyGameLogTypes[HockeyGameLogTypes["major_penalty"] = 12] = "major_penalty";
    HockeyGameLogTypes[HockeyGameLogTypes["misconduct_penalty"] = 13] = "misconduct_penalty";
    HockeyGameLogTypes[HockeyGameLogTypes["game_misconduct_penalty"] = 14] = "game_misconduct_penalty";
    HockeyGameLogTypes[HockeyGameLogTypes["match_penalty"] = 15] = "match_penalty";
    HockeyGameLogTypes[HockeyGameLogTypes["penalty_shot"] = 16] = "penalty_shot";
    HockeyGameLogTypes[HockeyGameLogTypes["face_off_lose"] = 17] = "face_off_lose";
    HockeyGameLogTypes[HockeyGameLogTypes["face_off_win"] = 18] = "face_off_win";
    HockeyGameLogTypes[HockeyGameLogTypes["save"] = 19] = "save";
    HockeyGameLogTypes[HockeyGameLogTypes["timeout"] = 20] = "timeout";
    HockeyGameLogTypes[HockeyGameLogTypes["penalty_start"] = 21] = "penalty_start";
    HockeyGameLogTypes[HockeyGameLogTypes["penalty_end"] = 22] = "penalty_end";
    HockeyGameLogTypes[HockeyGameLogTypes["after_game_shootout_attempt"] = 23] = "after_game_shootout_attempt";
    HockeyGameLogTypes[HockeyGameLogTypes["after_game_shootout_goal"] = 24] = "after_game_shootout_goal";
    HockeyGameLogTypes[HockeyGameLogTypes["after_game_shootout_save"] = 25] = "after_game_shootout_save";
    HockeyGameLogTypes[HockeyGameLogTypes["shootout_save"] = 26] = "shootout_save";
    HockeyGameLogTypes[HockeyGameLogTypes["steal"] = 27] = "steal";
    HockeyGameLogTypes[HockeyGameLogTypes["loss"] = 28] = "loss";
    HockeyGameLogTypes[HockeyGameLogTypes["sharp_pass"] = 29] = "sharp_pass";
    HockeyGameLogTypes[HockeyGameLogTypes["qualified_for_playoff"] = 30] = "qualified_for_playoff";
    HockeyGameLogTypes[HockeyGameLogTypes["mhl_carousel_segment_end"] = 31] = "mhl_carousel_segment_end";
})(HockeyGameLogTypes || (HockeyGameLogTypes = {}));
var HockeyAdvantageTypes;
(function (HockeyAdvantageTypes) {
    HockeyAdvantageTypes[HockeyAdvantageTypes["power_play"] = 1] = "power_play";
    HockeyAdvantageTypes[HockeyAdvantageTypes["shorthanded"] = 2] = "shorthanded";
    HockeyAdvantageTypes[HockeyAdvantageTypes["even_strength"] = 3] = "even_strength";
})(HockeyAdvantageTypes || (HockeyAdvantageTypes = {}));
let HockeyGameLog = class HockeyGameLog extends BaseModel {
    constructor() {
        super(...arguments);
        this.active = true;
    }
    get penalizedGameUserId() {
        if (this._penalizedGameUserId) {
            return this._penalizedGameUserId;
        }
        return this.gameUserId;
    }
    set penalizedGameUserId(value) {
        this._penalizedGameUserId = value;
    }
    compare(model) {
        if (this.time === model.time && this.period === model.period) {
            return this.datetime.getTime() < model.datetime.getTime() ? 1 : -1;
        }
        if (this.period === model.period) {
            return this.time < model.time ? 1 : -1;
        }
        return this.period < model.period ? 1 : -1;
    }
    get timeFormatted() {
        const minutes = Math.floor(this.time / 60);
        const seconds = this.time - minutes * 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
    isScoreType() {
        return [HockeyGameLogTypes.goal, HockeyGameLogTypes.shootout_goal, HockeyGameLogTypes.after_game_shootout_goal].indexOf(this.logType) > -1;
    }
    isPenaltyType() {
        return [
            HockeyGameLogTypes.minor_penalty, HockeyGameLogTypes.major_penalty,
            HockeyGameLogTypes.misconduct_penalty, HockeyGameLogTypes.game_misconduct_penalty,
            HockeyGameLogTypes.penalty_shot, HockeyGameLogTypes.match_penalty
        ].indexOf(this.logType) > -1;
    }
    isAfter(log) {
        if (this.time === log.time && this.period === log.period) {
            return this.id > log.id;
        }
        if (this.period === log.period) {
            return this.time > log.time;
        }
        return this.period > log.period;
    }
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], HockeyGameLog, "toFront", null);
__decorate([
    ToBackHook
], HockeyGameLog, "toBack", null);
HockeyGameLog = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            unique_id: 'uniqueId',
            game_id: 'gameId',
            game_user_id: 'gameUserId',
            team_id: 'teamId',
            log_type: 'logType',
            datetime: 'datetime',
            time: 'time',
            period: 'period',
            active: 'active',
            is_highlight: 'isHighlight',
            advantage: 'advantage',
            advantage_num: 'advantageNum',
            is_goalie: 'isGoalie',
            penalty_type: 'penaltyType',
            penalized_game_user_id: 'penalizedGameUserId',
            mutual_penalty: 'mutualPenalty',
            foul_on_game_user_id: 'foulOnGameUserId',
        },
        relation: {
            datetime: DateTimeField,
            logType: enumField(HockeyGameLogTypes),
            advantage: enumField(HockeyAdvantageTypes),
            penaltyType: penaltyTypeField()
        }
    })
], HockeyGameLog);

let HockeyGameStatistic = class HockeyGameStatistic extends BaseModel {
    get id() {
        return this.gameUserId;
    }
    get shotsOnGoal() {
        return (this.evShotsOnGoal || 0) + (this.ppShotsOnGoal || 0) + (this.shShotsOnGoal || 0);
    }
    get shotsBlocked() {
        return (this.evShotsBlocked || 0) + (this.ppShotsBlocked || 0) + (this.shShotsBlocked || 0);
    }
    get shotMisses() {
        return (this.evShotMisses || 0) + (this.ppShotMisses || 0) + (this.shShotMisses || 0);
    }
    get ppShots() {
        return (this.ppShotMisses || 0) + (this.ppShotsOnGoal || 0) + (this.ppShotsBlocked || 0);
    }
    get evShots() {
        return (this.evShotMisses || 0) + (this.evShotsOnGoal || 0) + (this.evShotsBlocked || 0);
    }
    get shShots() {
        return (this.shShotMisses || 0) + (this.shShotsOnGoal || 0) + (this.shShotsBlocked || 0);
    }
    get shots() {
        return this.ppShots + this.evShots + this.shShots + (this.shootoutAttempts || 0);
    }
    get totalShots() {
        return this.shots + (this.shootoutAttempts || 0);
    }
    get goals() {
        return (this.ppGoals || 0) + (this.shGoals || 0) + (this.evGoals || 0);
    }
    get totalGoals() {
        return this.goals + (this.shootoutGoals || 0);
    }
    get totalGoalsPercent() {
        if (!this.totalGoals || !this.totalShots) {
            return 0;
        }
        return Math.round(1000 * this.totalGoals / this.totalShots) / 10;
    }
    get assists() {
        return (this.ppAssists || 0) + (this.evAssists || 0) + (this.shAssists || 0);
    }
    get faceOffs() {
        return (this.faceOffWins || 0) + (this.faceOffLosses || 0);
    }
    get shootOuts() {
        return (this.shootoutAttempts || 0) + (this.shootoutGoals || 0);
    }
    get shotsAgainst() {
        return (this.saves || 0) + (this.goalsAgainst || 0);
    }
    get shootoutShotsAgainst() {
        return (this.shootoutSaves || 0) + (this.shootoutGoalsAgainst || 0);
    }
    get totalShotsAgainst() {
        return this.shotsAgainst + this.shootoutShotsAgainst;
    }
    get savesPercent() {
        if (!this.shotsAgainst || !this.saves) {
            return 0;
        }
        return Math.round(1000 * this.saves / this.shotsAgainst) / 10;
    }
    get totalSaves() {
        return (this.saves || 0) + (this.shootoutSaves || 0);
    }
    get totalSavesPercent() {
        if (!this.totalShotsAgainst || !this.totalSaves) {
            return 0;
        }
        return Math.round(1000 * this.totalSaves / this.totalShotsAgainst) / 10;
    }
    get shootoutSavesPercent() {
        if (!this.shootoutShotsAgainst || !this.shootoutSaves) {
            return 0;
        }
        return Math.round(1000 * this.shootoutSaves / this.shootoutShotsAgainst) / 10;
    }
    get totalGoalsAgainst() {
        return (this.goalsAgainst || 0) + (this.shootoutGoalsAgainst || 0);
    }
    get gameMinutes() {
        return Math.floor(this.gameTime / 60);
    }
    get goalsPercent() {
        if (!this.totalGoals || !this.totalShots) {
            return 0;
        }
        return Math.round(1000 * this.totalGoals / this.totalShots) / 10;
    }
    get faceOffPercent() {
        if (!this.faceOffWins || !this.faceOffs) {
            return 0;
        }
        return Math.round(1000 * this.faceOffWins / this.faceOffs) / 10;
    }
    get goalpass() {
        return (this.totalGoals || 0) + (this.assists || 0);
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], HockeyGameStatistic, "toFront", null);
__decorate([
    ToBackHook
], HockeyGameStatistic, "toBack", null);
HockeyGameStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            game_user_id: 'gameUserId',
            updated_at: 'updatedAt',
            points: 'points',
            pp_shot_misses: 'ppShotMisses',
            pp_shots_on_goal: 'ppShotsOnGoal',
            pp_shots_blocked: 'ppShotsBlocked',
            ev_shot_misses: 'evShotMisses',
            ev_shots_on_goal: 'evShotsOnGoal',
            ev_shots_blocked: 'evShotsBlocked',
            sh_shot_misses: 'shShotMisses',
            sh_shots_on_goal: 'shShotsOnGoal',
            sh_shots_blocked: 'shShotsBlocked',
            pp_goals: 'ppGoals',
            ev_goals: 'evGoals',
            sh_goals: 'shGoals',
            pp_assists: 'ppAssists',
            ev_assists: 'evAssists',
            sh_assists: 'shAssists',
            shootout_attempts: 'shootoutAttempts',
            shootout_goals: 'shootoutGoals',
            after_game_shootout_attempts: 'afterGameShootoutAttempts',
            after_game_shootout_goals: 'afterGameShootoutGoals',
            block_shots: 'blockShots',
            face_off_losses: 'faceOffLosses',
            face_off_wins: 'faceOffWins',
            pp_saves: 'ppSaves',
            sh_saves: 'shSaves',
            ev_saves: 'evSaves',
            saves: 'saves',
            shootout_save: 'shootoutSaves',
            after_game_shootout_saves: 'afterGameShootoutSaves',
            pp_goals_against: 'ppGoalsAgainst',
            sh_goals_against: 'shGoalsAgainst',
            ev_goals_against: 'evGoalsAgainst',
            goals_against: 'goalsAgainst',
            shootout_goals_against: 'shootoutGoalsAgainst',
            after_game_shootout_goals_against: 'afterGameShootoutGoalsAgainst',
            safety_rate: 'safetyRate',
            penalty_minutes: 'penaltyMinutes',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            steals: 'steals',
            pp_steals: 'ppSteals',
            ev_steals: 'evSteals',
            sh_steals: 'shSteals',
            losses: 'losses',
            pp_losses: 'ppLosses',
            ev_losses: 'evLosses',
            sh_losses: 'shLosses',
            sharp_passes: 'sharpPasses',
            pp_sharp_passes: 'ppSharpPasses',
            ev_sharp_passes: 'evSharpPasses',
            sh_sharp_passes: 'shSharpPasses',
            drawn_fouls: 'drawnFouls',
            efficiency: 'efficiency',
            games_qualified_for_playoff: 'gamesQualifiedForPlayoff',
            shutout: 'shutout'
        },
        relation: {
            updatedAt: DateTimeField,
        }
    })
], HockeyGameStatistic);

let HockeyStatistic = class HockeyStatistic extends BaseModel {
    get assists() {
        return Math.floor(10 * ((this.ppAssists || 0) + (this.shAssists || 0) + (this.evAssists || 0))) / 10;
    }
    get goalpass() {
        return Math.floor(10 * ((this.totalGoals || 0) + (this.assists || 0))) / 10;
    }
    get userMinutes() {
        if (!this.gameTime) {
            return '00:00';
        }
        const minutes = Math.floor(this.gameTime / 60);
        const seconds = Math.floor(this.gameTime - minutes * 60);
        return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
    }
    get gamesWonPercent() {
        if (!this.gamesCount) {
            return 0;
        }
        return Math.floor(1000 * this.wonGamesCount / this.gamesCount) / 10;
    }
    get tournamentTeamPoints() {
        return this.tournamentTeam && this.tournamentTeam.points;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], HockeyStatistic, "toFront", null);
__decorate([
    ToBackHook
], HockeyStatistic, "toBack", null);
HockeyStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            league_player: 'leaguePlayer',
            tournament_team_user: 'tournamentTeamUser',
            team: 'team',
            team_user: 'teamUser',
            user: 'user',
            tournament_team: 'tournamentTeam',
            month: 'month',
            win_lose: 'winLose',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            lose_games_count: 'loseGamesCount',
            team_score_sum: 'teamScoreSum',
            team_missed_sum: 'teamMissedSum',
            tournament_points: 'tournamentPoints',
            points: 'points',
            pp_shots: 'ppShots',
            pp_shot_misses: 'ppShotMisses',
            pp_shots_on_goal: 'ppShotsOnGoal',
            pp_shots_blocked: 'ppShotsBlocked',
            ev_shots: 'evShots',
            ev_shot_misses: 'evShotMisses',
            ev_shots_on_goal: 'evShotsOnGoal',
            ev_shots_blocked: 'evShotsBlocked',
            sh_shots: 'shShots',
            sh_shot_misses: 'shShotMisses',
            sh_shots_on_goal: 'shShotsOnGoal',
            sh_shots_blocked: 'shShotsBlocked',
            pp_goals_percent: 'ppGoalsPercent',
            pp_goals: 'ppGoals',
            ev_goals_percent: 'evGoalsPercent',
            ev_goals: 'evGoals',
            sh_goals_percent: 'shGoalsPercent',
            goals: 'goals',
            total_goals: 'totalGoals',
            sh_goals: 'shGoals',
            shot_misses: 'shotMisses',
            shots_on_goal: 'shotsOnGoal',
            shots_blocked: 'shotsBlocked',
            shots: 'shots',
            total_shots: 'totalShots',
            goals_percent: 'goalsPercent',
            total_goals_percent: 'totalGoalsPercent',
            pp_assists: 'ppAssists',
            ev_assists: 'evAssists',
            sh_assists: 'shAssists',
            shootout_attempts: 'shootoutAttempts',
            shootout_goals: 'shootoutGoals',
            after_game_shootout_attempts: 'afterGameShootoutAttempts',
            after_game_shootout_goals: 'afterGameShootoutGoals',
            block_shots: 'blockShots',
            face_off_losses: 'faceOffLosses',
            face_off_wins: 'faceOffWins',
            face_offs: 'faceOffs',
            face_off_percent: 'faceOffPercent',
            pp_saves: 'ppSaves',
            sh_saves: 'shSaves',
            ev_saves: 'evSaves',
            saves: 'saves',
            total_saves: 'totalSaves',
            shootout_saves: 'shootoutSaves',
            shots_against: 'shotsAgainst',
            shootout_shots_against: 'shootoutShotsAgainst',
            total_shots_against: 'totalShotsAgainst',
            saves_percent: 'savesPercent',
            shootout_saves_percent: 'shootoutSavesPercent',
            total_saves_percent: 'totalSavesPercent',
            pp_goals_against: 'ppGoalsAgainst',
            sh_goals_against: 'shGoalsAgainst',
            ev_goals_against: 'evGoalsAgainst',
            goals_against: 'goalsAgainst',
            shootout_goals_against: 'shootoutGoalsAgainst',
            total_goals_against: 'totalGoalsAgainst',
            safety_rate: 'safetyRate',
            penalty_minutes: 'penaltyMinutes',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            steals: 'steals',
            pp_steals: 'ppSteals',
            ev_steals: 'evSteals',
            sh_steals: 'shSteals',
            losses: 'losses',
            pp_losses: 'ppLosses',
            ev_losses: 'evLosses',
            sh_losses: 'shLosses',
            sharp_passes: 'sharpPasses',
            pp_sharp_passes: 'ppSharpPasses',
            ev_sharp_passes: 'evSharpPasses',
            sh_sharp_passes: 'shSharpPasses',
            drawn_fouls: 'drawnFouls',
            efficiency: 'efficiency',
            newbie: 'newbie',
            rank: 'rank',
            shutout: 'shutout',
            shutout_percent: 'shutoutPercent',
            mvp_count: 'mvpCount',
            games_qualified_for_playoff: 'gamesQualifiedForPlayoff'
        },
        relation: {
            leaguePlayer: LeaguePlayer,
            tournamentTeamUser: TournamentTeamUser,
            team: Team,
            teamUser: TeamUser,
            user: User,
            tournamentTeam: TournamentTeam,
            month: DateField
        }
    })
], HockeyStatistic);

let HockeyGameTeamStatistic = class HockeyGameTeamStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], HockeyGameTeamStatistic, "toFront", null);
__decorate([
    ToBackHook
], HockeyGameTeamStatistic, "toBack", null);
HockeyGameTeamStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            competitor_team: 'competitorTeam'
        },
        relation: {
            team: HockeyStatistic,
            competitorTeam: HockeyStatistic
        }
    })
], HockeyGameTeamStatistic);

class HockeyGameApi extends GameBaseApi {
    constructor(httpClient, configService) {
        super(httpClient, configService);
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getTeamStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/team_statistic/`).pipe(map(result => HockeyGameTeamStatistic.toFront(result))).toPromise();
        });
    }
    getUserStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/user_statistic/`).pipe(map(result => HockeyGameStatistic.toFront(result))).toPromise();
        });
    }
    getLogs(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/logs/`).pipe(map(result => HockeyGameLog.toFront(result))).toPromise();
        });
    }
    downloadProtocol(gameId, format) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/game_protocol/`, {
                params: new HttpParams().set('file_type', format),
                responseType: 'blob'
            }).toPromise();
        });
    }
    downloadApplication(gameId, format, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_hockey_game/${gameId}/game_application_file/`, {
                params: new HttpParams().set('file_type', format).set('application_type', type),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
HockeyGameApi.ɵfac = function HockeyGameApi_Factory(t) { return new (t || HockeyGameApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
HockeyGameApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function HockeyGameApi_Factory() { return new HockeyGameApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: HockeyGameApi, providedIn: "root" });
HockeyGameApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

var FootballGameLogTypes;
(function (FootballGameLogTypes) {
    FootballGameLogTypes[FootballGameLogTypes["enter_game"] = 1] = "enter_game";
    FootballGameLogTypes[FootballGameLogTypes["exit_game"] = 2] = "exit_game";
    FootballGameLogTypes[FootballGameLogTypes["shot_miss"] = 3] = "shot_miss";
    FootballGameLogTypes[FootballGameLogTypes["shot_on_goal"] = 4] = "shot_on_goal";
    FootballGameLogTypes[FootballGameLogTypes["shot_blocked"] = 5] = "shot_blocked";
    FootballGameLogTypes[FootballGameLogTypes["goal"] = 6] = "goal";
    FootballGameLogTypes[FootballGameLogTypes["penalty_attempt"] = 7] = "penalty_attempt";
    FootballGameLogTypes[FootballGameLogTypes["penalty_goal"] = 8] = "penalty_goal";
    FootballGameLogTypes[FootballGameLogTypes["penalty_save"] = 9] = "penalty_save";
    FootballGameLogTypes[FootballGameLogTypes["small_penalty_attempt"] = 10] = "small_penalty_attempt";
    FootballGameLogTypes[FootballGameLogTypes["small_penalty_goal"] = 11] = "small_penalty_goal";
    FootballGameLogTypes[FootballGameLogTypes["small_penalty_save"] = 12] = "small_penalty_save";
    FootballGameLogTypes[FootballGameLogTypes["assist"] = 13] = "assist";
    FootballGameLogTypes[FootballGameLogTypes["block_shot"] = 14] = "block_shot";
    FootballGameLogTypes[FootballGameLogTypes["corner"] = 15] = "corner";
    FootballGameLogTypes[FootballGameLogTypes["free_kick"] = 16] = "free_kick";
    FootballGameLogTypes[FootballGameLogTypes["foul"] = 17] = "foul";
    FootballGameLogTypes[FootballGameLogTypes["save"] = 18] = "save";
    FootballGameLogTypes[FootballGameLogTypes["yellow_card"] = 19] = "yellow_card";
    FootballGameLogTypes[FootballGameLogTypes["red_card"] = 20] = "red_card";
    FootballGameLogTypes[FootballGameLogTypes["perfect_pass"] = 21] = "perfect_pass";
    FootballGameLogTypes[FootballGameLogTypes["loss"] = 22] = "loss";
    FootballGameLogTypes[FootballGameLogTypes["steal"] = 23] = "steal";
    FootballGameLogTypes[FootballGameLogTypes["out"] = 24] = "out";
    FootballGameLogTypes[FootballGameLogTypes["timeout"] = 25] = "timeout";
    FootballGameLogTypes[FootballGameLogTypes["auto_goal"] = 26] = "auto_goal";
    FootballGameLogTypes[FootballGameLogTypes["end_game_penalty_miss"] = 27] = "end_game_penalty_miss";
    FootballGameLogTypes[FootballGameLogTypes["end_game_penalty_goal"] = 28] = "end_game_penalty_goal";
    FootballGameLogTypes[FootballGameLogTypes["end_game_penalty_save"] = 29] = "end_game_penalty_save";
    FootballGameLogTypes[FootballGameLogTypes["duel_won"] = 30] = "duel_won";
    FootballGameLogTypes[FootballGameLogTypes["duel_lost"] = 31] = "duel_lost";
    FootballGameLogTypes[FootballGameLogTypes["double_goal"] = 32] = "double_goal";
    FootballGameLogTypes[FootballGameLogTypes["super_game"] = 33] = "super_game";
    FootballGameLogTypes[FootballGameLogTypes["color_ball"] = 34] = "color_ball";
})(FootballGameLogTypes || (FootballGameLogTypes = {}));
let FootballGameLog = class FootballGameLog extends BaseModel {
    constructor() {
        super(...arguments);
        this.active = true;
    }
    compare(model) {
        if (this.time === model.time && this.period === model.period) {
            return this.datetime.getTime() < model.datetime.getTime() ? 1 : -1;
        }
        if (this.period === model.period) {
            return this.time < model.time ? 1 : -1;
        }
        return this.period < model.period ? 1 : -1;
    }
    get timeFormatted() {
        const minutes = Math.floor(this.time / 60);
        const seconds = this.time - minutes * 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
    isScoreType() {
        return [
            FootballGameLogTypes.goal,
            FootballGameLogTypes.penalty_goal,
            FootballGameLogTypes.small_penalty_goal,
            FootballGameLogTypes.auto_goal,
            FootballGameLogTypes.end_game_penalty_goal,
            FootballGameLogTypes.double_goal
        ].indexOf(this.logType) > -1;
    }
    isAfter(log) {
        if (this.time === log.time && this.period === log.period) {
            return this.id > log.id;
        }
        if (this.period === log.period) {
            return this.time > log.time;
        }
        return this.period > log.period;
    }
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], FootballGameLog, "toFront", null);
__decorate([
    ToBackHook
], FootballGameLog, "toBack", null);
FootballGameLog = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            unique_id: 'uniqueId',
            game_id: 'gameId',
            game_user_id: 'gameUserId',
            team_id: 'teamId',
            log_type: 'logType',
            datetime: 'datetime',
            time: 'time',
            period: 'period',
            active: 'active',
            is_highlight: 'isHighlight',
            is_goalie: 'isGoalie',
        },
        relation: {
            datetime: DateTimeField,
            logType: enumField(FootballGameLogTypes)
        }
    })
], FootballGameLog);

let FootballGameStatistic = class FootballGameStatistic extends BaseModel {
    get id() {
        return this.gameUserId;
    }
    get shots() {
        return Math.floor(10 * ((this.shotMisses || 0) + (this.shotsOnGoal || 0) + (this.shotsBlocked || 0))) / 10;
    }
    get totalGoals() {
        return Math.floor(10 * ((this.goals || 0) +
            (this.penaltyGoals || 0) +
            (this.smallPenaltyGoals || 0) +
            ((this.doubleGoals || 0) * 2))) / 10;
    }
    get goalsPercent() {
        if (!this.shots || !this.totalGoals) {
            return 0;
        }
        return Math.round(1000 * this.totalGoals / this.shots) / 10;
    }
    get shotsOnGoalPercent() {
        if (!this.shotsOnGoal || !this.shots) {
            return 0;
        }
        return Math.round(1000 * this.shotsOnGoal / this.shots) / 10;
    }
    get penalties() {
        return Math.floor(10 * ((this.penaltyGoals || 0) + (this.penaltyAttempts || 0))) / 10;
    }
    get penaltyGoalsPercent() {
        if (!this.penalties || !this.penaltyGoals) {
            return 0;
        }
        return Math.round(1000 * this.penaltyGoals / this.penalties) / 10;
    }
    get smallPenalties() {
        return Math.floor(10 * ((this.smallPenaltyGoals || 0) + (this.smallPenaltyAttempts || 0))) / 10;
    }
    get smallPenaltyGoalsPercent() {
        if (!this.smallPenalties || !this.smallPenaltyGoals) {
            return 0;
        }
        return Math.round(1000 * this.smallPenaltyGoals / this.smallPenalties) / 10;
    }
    get shotsAgainst() {
        return Math.floor(10 * ((this.saves || 0) + (this.goalsAgainst || 0) + (this.doubleGoalsAgainst || 0))) / 10;
    }
    get penaltyShotsAgainst() {
        return Math.floor(10 * ((this.penaltySaves || 0) + (this.penaltyGoalsAgainst || 0))) / 10;
    }
    get smallPenaltyShotsAgainst() {
        return Math.floor(10 * ((this.smallPenaltySaves || 0) + (this.smallPenaltyGoalsAgainst || 0))) / 10;
    }
    get totalGoalsAgainst() {
        return Math.floor(10 * ((this.goalsAgainst || 0) +
            (this.penaltyGoalsAgainst || 0) +
            (this.smallPenaltyGoalsAgainst || 0) +
            (this.autoGoalsAgainst || 0) +
            ((this.doubleGoalsAgainst || 0) * 2))) / 10;
    }
    get totalSaves() {
        return Math.floor(10 * ((this.saves || 0) + (this.penaltySaves || 0) + (this.smallPenaltySaves || 0))) / 10;
    }
    get savesPercent() {
        if (!this.shotsAgainst || !this.saves) {
            return 0;
        }
        return Math.round(1000 * this.saves / this.shotsAgainst) / 10;
    }
    get penaltySavesPercent() {
        if (!this.penaltyShotsAgainst || !this.penaltySaves) {
            return 0;
        }
        return Math.round(1000 * this.penaltySaves / this.penaltyShotsAgainst) / 10;
    }
    get smallPenaltySavesPercent() {
        if (!this.smallPenaltyShotsAgainst || !this.smallPenaltySaves) {
            return 0;
        }
        return Math.round(1000 * this.smallPenaltySaves / this.smallPenaltyShotsAgainst) / 10;
    }
    get goalpass() {
        return (this.totalGoals || 0) + (this.assists || 0);
    }
    get gameMinutes() {
        return Math.floor(this.gameTime / 60);
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], FootballGameStatistic, "toFront", null);
__decorate([
    ToBackHook
], FootballGameStatistic, "toBack", null);
FootballGameStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            game_user_id: 'gameUserId',
            updated_at: 'updatedAt',
            points: 'points',
            shot_misses: 'shotMisses',
            shots_on_goal: 'shotsOnGoal',
            shots_blocked: 'shotsBlocked',
            goals: 'goals',
            assists: 'assists',
            corners: 'corners',
            free_kicks: 'freeKicks',
            penalty_goals: 'penaltyGoals',
            penalty_attempts: 'penaltyAttempts',
            penalty_goals_against: 'penaltyGoalsAgainst',
            penalty_saves: 'penaltySaves',
            small_penalty_goals: 'smallPenaltyGoals',
            small_penalty_attempts: 'smallPenaltyAttempts',
            small_penalty_goals_against: 'smallPenaltyGoalsAgainst',
            small_penalty_saves: 'smallPenaltySaves',
            saves: 'saves',
            goals_against: 'goalsAgainst',
            safety_rate: 'safetyRate',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            fouls: 'fouls',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            perfect_passes: 'perfectPasses',
            losses: 'losses',
            steals: 'steals',
            outs: 'outs',
            block_shots: 'blockShots',
            auto_goals: 'autoGoals',
            auto_goals_against: 'autoGoalsAgainst',
            end_game_penalty_goals: 'endGamePenaltyGoals',
            end_game_penalty_misses: 'endGamePenaltyMisses',
            end_game_penalty_saves: 'endGamePenaltySaves',
            duels_won: 'duelsWon',
            duels_lost: 'duelsLost',
            double_goals: 'doubleGoals',
            double_goals_against: 'doubleGoalsAgainst',
        },
        relation: {
            updatedAt: DateTimeField,
        }
    })
], FootballGameStatistic);

let FootballStatistic = class FootballStatistic extends BaseModel {
    get teamPlusMinus() {
        return (this.teamScoreSum || 0) - (this.teamMissedSum || 0);
    }
    get userMinutes() {
        if (!this.gameTime) {
            return '00:00';
        }
        const minutes = Math.floor(this.gameTime / 60);
        const seconds = Math.floor(this.gameTime - minutes * 60);
        return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
    }
    get penalties() {
        return Math.floor(10 * ((this.penaltyGoals || 0) + (this.penaltyAttempts || 0))) / 10;
    }
    get smallPenalties() {
        return Math.floor(10 * ((this.smallPenaltyGoals || 0) + (this.smallPenaltyAttempts || 0))) / 10;
    }
    get goalpass() {
        return Math.floor(10 * ((this.totalGoals || 0) + (this.assists || 0))) / 10;
    }
    get tournamentTeamPoints() {
        return this.tournamentTeam && this.tournamentTeam.points;
    }
    get tournamentTeamGamesCount() {
        return this.tournamentTeam && this.tournamentTeam.gamesCount;
    }
    get tournamentTeamWonGamesCount() {
        return this.tournamentTeam && this.tournamentTeam.wonGamesCount;
    }
    get tournamentTeamDrawGamesCount() {
        return this.tournamentTeam && this.tournamentTeam.drawGamesCount;
    }
    get tournamentTeamLostGamesCount() {
        if (!this.tournamentTeam) {
            return null;
        }
        return this.tournamentTeam.gamesCount - this.tournamentTeam.drawGamesCount - this.tournamentTeam.wonGamesCount;
    }
    get tournamentTeamScoreSum() {
        return this.tournamentTeam && this.tournamentTeam.scoreSum;
    }
    get tournamentTeamMissedSum() {
        return this.tournamentTeam && this.tournamentTeam.missedSum;
    }
    get tournamentTeamPlusMinus() {
        if (!this.tournamentTeam) {
            return null;
        }
        return this.tournamentTeam.scoreSum - this.tournamentTeam.missedSum;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], FootballStatistic, "toFront", null);
__decorate([
    ToBackHook
], FootballStatistic, "toBack", null);
FootballStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            league_player: 'leaguePlayer',
            tournament_team_user: 'tournamentTeamUser',
            team: 'team',
            team_user: 'teamUser',
            user: 'user',
            tournament_team: 'tournamentTeam',
            month: 'month',
            win_lose: 'winLose',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            lose_games_count: 'loseGamesCount',
            draw_games_count: 'drawGamesCount',
            team_score_sum: 'teamScoreSum',
            team_missed_sum: 'teamMissedSum',
            tournament_points: 'tournamentPoints',
            points: 'points',
            shot_misses: 'shotMisses',
            shots_on_goal: 'shotsOnGoal',
            shots_blocked: 'shotsBlocked',
            shots_on_goal_percent: 'shotsOnGoalPercent',
            shots: 'shots',
            goals: 'goals',
            goals_percent: 'goalsPercent',
            total_goals: 'totalGoals',
            assists: 'assists',
            penalty_goals: 'penaltyGoals',
            penalty_attempts: 'penaltyAttempts',
            penalty_goals_percent: 'penaltyGoalsPercent',
            penalty_saves: 'penaltySaves',
            penalty_goals_against: 'penaltyGoalsAgainst',
            penalty_shots_against: 'penaltyShotsAgainst',
            penalty_saves_percent: 'penaltySavesPercent',
            small_penalty_goals: 'smallPenaltyGoals',
            small_penalty_attempts: 'smallPenaltyAttempts',
            small_penalty_goals_percent: 'smallPenaltyGoalsPercent',
            small_penalty_saves: 'smallPenaltySaves',
            small_penalty_goals_against: 'smallPenaltyGoalsAgainst',
            small_penalty_shots_against: 'smallPenaltyShotsAgainst',
            small_penalty_saves_percent: 'smallPenaltySavesPercent',
            saves: 'saves',
            saves_percent: 'savesPercent',
            total_saves: 'totalSaves',
            goals_against: 'goalsAgainst',
            total_goals_against: 'totalGoalsAgainst',
            shots_against: 'shotsAgainst',
            safety_rate: 'safetyRate',
            fouls: 'fouls',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            perfect_passes: 'perfectPasses',
            losses: 'losses',
            steals: 'steals',
            outs: 'outs',
            block_shots: 'blockShots',
            corners: 'corners',
            free_kicks: 'freeKicks',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            newbie: 'newbie',
            rank: 'rank',
            auto_goals: 'autoGoals',
            auto_goals_against: 'autoGoalsAgainst',
            end_game_penalty_goals: 'endGamePenaltyGoals',
            end_game_penalty_misses: 'endGamePenaltyMisses',
            end_game_penalty_saves: 'endGamePenaltySaves',
            shutout: 'shutout',
            shutout_percent: 'shutoutPercent',
            duels_won: 'duelsWon',
            duels_lost: 'duelsLost',
            double_goals: 'doubleGoals',
            double_goals_against: 'doubleGoalsAgainst',
        },
        relation: {
            leaguePlayer: LeaguePlayer,
            tournamentTeamUser: TournamentTeamUser,
            team: Team,
            teamUser: TeamUser,
            user: User,
            tournamentTeam: TournamentTeam,
            month: DateField
        }
    })
], FootballStatistic);

let FootballGameTeamStatistic = class FootballGameTeamStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], FootballGameTeamStatistic, "toFront", null);
__decorate([
    ToBackHook
], FootballGameTeamStatistic, "toBack", null);
FootballGameTeamStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            competitor_team: 'competitorTeam'
        },
        relation: {
            team: FootballStatistic,
            competitorTeam: FootballStatistic
        }
    })
], FootballGameTeamStatistic);

class FootballGameApi extends GameBaseApi {
    constructor(httpClient, configService) {
        super(httpClient, configService);
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getTeamStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/team_statistic/`).pipe(map(result => FootballGameTeamStatistic.toFront(result))).toPromise();
        });
    }
    getUserStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/user_statistic/`).pipe(map(result => FootballGameStatistic.toFront(result))).toPromise();
        });
    }
    getLogs(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/logs/`).pipe(map(result => FootballGameLog.toFront(result))).toPromise();
        });
    }
    downloadProtocol(gameId, format) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/game_protocol/`, {
                params: new HttpParams().set('file_type', format),
                responseType: 'blob'
            }).toPromise();
        });
    }
    downloadApplication(gameId, format, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_football_game/${gameId}/game_application_file/`, {
                params: new HttpParams().set('file_type', format).set('application_type', type),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
FootballGameApi.ɵfac = function FootballGameApi_Factory(t) { return new (t || FootballGameApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
FootballGameApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function FootballGameApi_Factory() { return new FootballGameApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: FootballGameApi, providedIn: "root" });
FootballGameApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

var HandballGameLogTypes;
(function (HandballGameLogTypes) {
    HandballGameLogTypes[HandballGameLogTypes["enter_game"] = 1] = "enter_game";
    HandballGameLogTypes[HandballGameLogTypes["exit_game"] = 2] = "exit_game";
    HandballGameLogTypes[HandballGameLogTypes["shot_miss"] = 3] = "shot_miss";
    HandballGameLogTypes[HandballGameLogTypes["shot_on_goal"] = 4] = "shot_on_goal";
    HandballGameLogTypes[HandballGameLogTypes["shot_blocked"] = 5] = "shot_blocked";
    HandballGameLogTypes[HandballGameLogTypes["goal"] = 6] = "goal";
    HandballGameLogTypes[HandballGameLogTypes["assist"] = 7] = "assist";
    HandballGameLogTypes[HandballGameLogTypes["penalty_miss"] = 8] = "penalty_miss";
    HandballGameLogTypes[HandballGameLogTypes["penalty_shot_on_goal"] = 9] = "penalty_shot_on_goal";
    HandballGameLogTypes[HandballGameLogTypes["penalty_goal"] = 10] = "penalty_goal";
    HandballGameLogTypes[HandballGameLogTypes["save"] = 11] = "save";
    HandballGameLogTypes[HandballGameLogTypes["penalty_save"] = 12] = "penalty_save";
    HandballGameLogTypes[HandballGameLogTypes["foul"] = 13] = "foul";
    HandballGameLogTypes[HandballGameLogTypes["yellow_card"] = 14] = "yellow_card";
    HandballGameLogTypes[HandballGameLogTypes["red_card"] = 15] = "red_card";
    HandballGameLogTypes[HandballGameLogTypes["two_minute_foul"] = 16] = "two_minute_foul";
    HandballGameLogTypes[HandballGameLogTypes["turnover"] = 17] = "turnover";
    HandballGameLogTypes[HandballGameLogTypes["steal"] = 18] = "steal";
    HandballGameLogTypes[HandballGameLogTypes["block_shot"] = 19] = "block_shot";
    HandballGameLogTypes[HandballGameLogTypes["timeout"] = 20] = "timeout";
})(HandballGameLogTypes || (HandballGameLogTypes = {}));
let HandballGameLog = class HandballGameLog extends BaseModel {
    constructor() {
        super(...arguments);
        this.active = true;
    }
    compare(model) {
        if (this.time === model.time && this.period === model.period) {
            return this.datetime.getTime() < model.datetime.getTime() ? 1 : -1;
        }
        if (this.period === model.period) {
            return this.time < model.time ? 1 : -1;
        }
        return this.period < model.period ? 1 : -1;
    }
    get timeFormatted() {
        const minutes = Math.floor(this.time / 60);
        const seconds = this.time - minutes * 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
    isScoreType() {
        return [HandballGameLogTypes.goal, HandballGameLogTypes.penalty_goal].indexOf(this.logType) > -1;
    }
    isAfter(log) {
        if (this.time === log.time && this.period === log.period) {
            return this.id > log.id;
        }
        if (this.period === log.period) {
            return this.time > log.time;
        }
        return this.period > log.period;
    }
    isFoulType() {
        return [HandballGameLogTypes.foul, HandballGameLogTypes.yellow_card, HandballGameLogTypes.red_card].indexOf(this.logType) > -1;
    }
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], HandballGameLog, "toFront", null);
__decorate([
    ToBackHook
], HandballGameLog, "toBack", null);
HandballGameLog = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            unique_id: 'uniqueId',
            game_id: 'gameId',
            game_user_id: 'gameUserId',
            team_id: 'teamId',
            log_type: 'logType',
            datetime: 'datetime',
            time: 'time',
            period: 'period',
            active: 'active',
            is_highlight: 'isHighlight',
            is_goalie: 'isGoalie',
        },
        relation: {
            datetime: DateTimeField,
            logType: enumField(HandballGameLogTypes)
        }
    })
], HandballGameLog);

let HandballGameStatistic = class HandballGameStatistic extends BaseModel {
    get id() {
        return this.gameUserId;
    }
    get shots() {
        return Math.floor(10 * ((this.shotMisses || 0) + (this.shotsOnGoal || 0) + (this.shotsBlocked || 0))) / 10;
    }
    get totalGoals() {
        return Math.floor(10 * ((this.goals || 0) + (this.penaltyGoals || 0))) / 10;
    }
    get goalsPercent() {
        if (!this.shots || !this.totalGoals) {
            return 0;
        }
        return Math.round(1000 * this.totalGoals / this.shots) / 10;
    }
    get shotsOnGoalPercent() {
        if (!this.shotsOnGoal || !this.shots) {
            return 0;
        }
        return Math.round(1000 * this.shotsOnGoal / this.shots) / 10;
    }
    get penaltyShots() {
        return Math.floor(10 * ((this.penaltyShotsOnGoal || 0) + (this.penaltyMisses || 0))) / 10;
    }
    get penaltyGoalsPercent() {
        if (!this.penaltyShots || !this.penaltyGoals) {
            return 0;
        }
        return Math.round(1000 * this.penaltyGoals / this.penaltyShots) / 10;
    }
    get shotsAgainst() {
        return Math.floor(10 * ((this.saves || 0) + (this.goalsAgainst || 0))) / 10;
    }
    get penaltyShotsAgainst() {
        return Math.floor(10 * ((this.penaltySaves || 0) + (this.penaltyGoalsAgainst || 0))) / 10;
    }
    get totalGoalsAgainst() {
        return Math.floor(10 * ((this.goalsAgainst || 0) + (this.penaltyGoalsAgainst || 0))) / 10;
    }
    get totalSaves() {
        return Math.floor(10 * ((this.saves || 0) + (this.penaltySaves || 0))) / 10;
    }
    get savesPercent() {
        if (!this.shotsAgainst || !this.saves) {
            return 0;
        }
        return Math.round(1000 * this.saves / this.shotsAgainst) / 10;
    }
    get penaltySavesPercent() {
        if (!this.penaltyShotsAgainst || !this.penaltySaves) {
            return 0;
        }
        return Math.round(1000 * this.penaltySaves / this.penaltyShotsAgainst) / 10;
    }
    get gameMinutes() {
        return Math.floor(this.gameTime / 60);
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], HandballGameStatistic, "toFront", null);
__decorate([
    ToBackHook
], HandballGameStatistic, "toBack", null);
HandballGameStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            game_user_id: 'gameUserId',
            points: 'points',
            shot_misses: 'shotMisses',
            shots_on_goal: 'shotsOnGoal',
            shots_blocked: 'shotsBlocked',
            goals: 'goals',
            assists: 'assists',
            penalty_goals: 'penaltyGoals',
            penalty_misses: 'penaltyMisses',
            penalty_shots_on_goal: 'penaltyShotsOnGoal',
            saves: 'saves',
            penalty_saves: 'penaltySaves',
            goals_against: 'goalsAgainst',
            penalty_goals_against: 'penaltyGoalsAgainst',
            safety_rate: 'safetyRate',
            fouls: 'fouls',
            yellowCards: 'yellowCards',
            red_cards: 'redCards',
            two_minute_fouls: 'twoMinuteFouls',
            turnovers: 'turnovers',
            steals: 'steals',
            block_shots: 'blockShots',
            game_time: 'gameTime',
            plus_minus: 'plusMinus'
        }
    })
], HandballGameStatistic);

let HandballStatistic = class HandballStatistic extends BaseModel {
    get userMinutes() {
        if (!this.gameTime) {
            return '00:00';
        }
        const minutes = Math.floor(this.gameTime / 60);
        const seconds = Math.floor(this.gameTime - minutes * 60);
        return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
    }
    get tournamentTeamPoints() {
        return this.tournamentTeam && this.tournamentTeam.points;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], HandballStatistic, "toFront", null);
__decorate([
    ToBackHook
], HandballStatistic, "toBack", null);
HandballStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            league_player: 'leaguePlayer',
            tournament_team_user: 'tournamentTeamUser',
            team: 'team',
            team_user: 'teamUser',
            user: 'user',
            tournament_team: 'tournamentTeam',
            month: 'month',
            win_lose: 'winLose',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            team_score_sum: 'teamScoreSum',
            team_missed_sum: 'teamMissedSum',
            tournament_points: 'tournamentPoints',
            points: 'points',
            shot_misses: 'shotMisses',
            shots_on_goal: 'shotsOnGoal',
            shots_blocked: 'shotsBlocked',
            goals: 'goals',
            assists: 'assists',
            penalty_goals: 'penaltyGoals',
            penalty_misses: 'penaltyMisses',
            penalty_shots_on_goal: 'penaltyShotsOnGoal',
            saves: 'saves',
            penalty_saves: 'penaltySaves',
            goals_against: 'goalsAgainst',
            penalty_goals_against: 'penaltyGoalsAgainst',
            safety_rate: 'safetyRate',
            fouls: 'fouls',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            two_minute_fouls: 'twoMinuteFouls',
            turnovers: 'turnovers',
            steals: 'steals',
            block_shots: 'blockShots',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            shots: 'shots',
            goals_percent: 'goalsPercent',
            penalty_shots: 'penaltyShots',
            penalty_goals_percent: 'penaltyGoalsPercent',
            shots_against: 'shotsAgainst',
            saves_percent: 'savesPercent',
            penalty_shots_against: 'penaltyShotsAgainst',
            penalty_saves_percent: 'penaltySavesPercent',
            total_goals: 'totalGoals',
            total_saves: 'totalSaves',
            total_goals_against: 'totalGoalsAgainst',
            newbie: 'newbie',
            rank: 'rank',
        },
        relation: {
            leaguePlayer: LeaguePlayer,
            tournamentTeamUser: TournamentTeamUser,
            team: Team,
            teamUser: TeamUser,
            user: User,
            tournamentTeam: TournamentTeam,
            month: DateField
        }
    })
], HandballStatistic);

let HandballGameTeamStatistic = class HandballGameTeamStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], HandballGameTeamStatistic, "toFront", null);
__decorate([
    ToBackHook
], HandballGameTeamStatistic, "toBack", null);
HandballGameTeamStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            competitor_team: 'competitorTeam'
        },
        relation: {
            team: HandballStatistic,
            competitorTeam: HandballStatistic
        }
    })
], HandballGameTeamStatistic);

class HandballGameApi extends GameBaseApi {
    constructor(httpClient, configService) {
        super(httpClient, configService);
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getTeamStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/team_statistic/`).pipe(map(result => HandballGameTeamStatistic.toFront(result))).toPromise();
        });
    }
    getUserStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/user_statistic/`).pipe(map(result => HandballGameStatistic.toFront(result))).toPromise();
        });
    }
    getLogs(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/logs/`).pipe(map(result => HandballGameLog.toFront(result))).toPromise();
        });
    }
    downloadProtocol(gameId, format) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/game_protocol/`, {
                params: new HttpParams().set('file_type', format),
                responseType: 'blob'
            }).toPromise();
        });
    }
    downloadApplication(gameId, format, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_handball_game/${gameId}/game_application_file/`, {
                params: new HttpParams().set('file_type', format).set('application_type', type),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
HandballGameApi.ɵfac = function HandballGameApi_Factory(t) { return new (t || HandballGameApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
HandballGameApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function HandballGameApi_Factory() { return new HandballGameApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: HandballGameApi, providedIn: "root" });
HandballGameApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let TournamentNews = class TournamentNews extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentNews, "toFront", null);
__decorate([
    ToBackHook
], TournamentNews, "toBack", null);
TournamentNews = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            title: 'title',
            picture: 'picture',
            text: 'text',
            author: 'author',
            created_at: 'createdAt',
        },
        relation: {
            picture: File,
            author: User,
            createdAt: DateTimeField,
        }
    })
], TournamentNews);

let GameTimelineStageItem = class GameTimelineStageItem {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], GameTimelineStageItem, "toFront", null);
__decorate([
    ToBackHook
], GameTimelineStageItem, "toBack", null);
GameTimelineStageItem = __decorate([
    ModelInstance({
        mappingFields: {
            stage_id: 'stageId',
            tours_count: 'toursCount',
            playoff_stages_count: 'playoffStagesCount',
            playoff_teams_count: 'playoffTeamsCount',
        }
    })
], GameTimelineStageItem);
let GameTimelineStages = class GameTimelineStages extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], GameTimelineStages, "toFront", null);
__decorate([
    ToBackHook
], GameTimelineStages, "toBack", null);
GameTimelineStages = __decorate([
    ModelInstance({
        mappingFields: {
            tours_count: 'toursCount',
            playoff_stages_count: 'playoffStagesCount',
            playoff_teams_count: 'playoffTeamsCount',
            current_tour: 'currentTour',
            current_playoff_stage: 'currentPlayoffStage',
            current_playoff_round: 'currentPlayoffRound',
            stages: 'stages',
            tournament_stage_id: 'tournamentStageId',
            tournament_round_id: 'tournamentRoundId',
        },
        relation: {
            stages: listField(GameTimelineStageItem)
        }
    })
], GameTimelineStages);

var TournamentStageStatuses;
(function (TournamentStageStatuses) {
    TournamentStageStatuses[TournamentStageStatuses["open"] = 0] = "open";
    TournamentStageStatuses[TournamentStageStatuses["in_progress"] = 1] = "in_progress";
    TournamentStageStatuses[TournamentStageStatuses["closed"] = 2] = "closed";
})(TournamentStageStatuses || (TournamentStageStatuses = {}));
let TournamentStage = class TournamentStage extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentStage, "toFront", null);
__decorate([
    ToBackHook
], TournamentStage, "toBack", null);
TournamentStage = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            date: 'date',
            tournament_id: 'tournamentId',
            status: 'status',
        },
        relation: {
            date: DateField,
            status: enumField(TournamentStageStatuses)
        }
    })
], TournamentStage);

let VolleyballStatistic = class VolleyballStatistic extends BaseModel {
    get tournamentTeamPoints() {
        return this.tournamentTeam && this.tournamentTeam.points;
    }
    get totalReceives() {
        return Math.floor(10 * (this.receives + this.excellentReceives + this.receiveFaults)) / 10;
    }
    get totalServeReceives() {
        return Math.floor(10 * (this.serveReceives + this.excellentServeReceives + this.serveReceiveFaults)) / 10;
    }
    get totalServes() {
        return Math.floor(10 * (this.serveAces + this.serveHits + this.serveFaults + this.goodServes)) / 10;
    }
    get totalAttacks() {
        return Math.floor(10 * (this.attackSpikes + this.attackShots + this.attackFaults)) / 10;
    }
    get totalBlocks() {
        return Math.floor(10 * (this.stuffBlocks + this.blockRebounds + this.blockFaults)) / 10;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], VolleyballStatistic, "toFront", null);
__decorate([
    ToBackHook
], VolleyballStatistic, "toBack", null);
VolleyballStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            team_user: 'teamUser',
            league_player: 'leaguePlayer',
            tournament_team_user: 'tournamentTeamUser',
            tournament_team: 'tournamentTeam',
            user: 'user',
            month: 'month',
            win_lose: 'winLose',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            team_score_sum: 'teamScoreSum',
            team_missed_sum: 'teamMissedSum',
            tournament_points: 'tournamentPoints',
            serve_hits: 'serveHits',
            serve_faults: 'serveFaults',
            serve_aces: 'serveAces',
            serve_percent: 'servePercent',
            good_serves: 'goodServes',
            ace_percent: 'acePercent',
            stuff_blocks: 'stuffBlocks',
            block_faults: 'blockFaults',
            block_rebounds: 'blockRebounds',
            block_percent: 'blockPercent',
            attack_spikes: 'attackSpikes',
            attack_faults: 'attackFaults',
            attack_shots: 'attackShots',
            attack_percent: 'attackPercent',
            receives: 'receives',
            receive_faults: 'receiveFaults',
            excellent_receives: 'excellentReceives',
            receive_percent: 'receivePercent',
            serve_receives: 'serveReceives',
            serve_receive_faults: 'serveReceiveFaults',
            excellent_serve_receives: 'excellentServeReceives',
            serve_receive_percent: 'serveReceivePercent',
            points: 'points',
            faults: 'faults',
            newbie: 'newbie',
            rank: 'rank',
        },
        relation: {
            team: Team,
            teamUser: TeamUser,
            leaguePlayer: LeaguePlayer,
            tournamentTeamUser: TournamentTeamUser,
            tournamentTeam: TournamentTeam,
            user: User,
            month: DateField,
        }
    })
], VolleyballStatistic);

let StageTeamGame = class StageTeamGame extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], StageTeamGame, "toFront", null);
__decorate([
    ToBackHook
], StageTeamGame, "toBack", null);
StageTeamGame = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team_id: 'teamId',
            competitor_team_id: 'competitorTeamId',
            team_score: 'teamScore',
            competitor_team_score: 'competitorTeamScore',
        }
    })
], StageTeamGame);
let TournamentStageTeam = class TournamentStageTeam extends BaseModel {
    constructor() {
        super(...arguments);
        this.gamesMapping = {};
    }
    set games(value) {
        this._games = value;
        this.gamesMapping = value.reduce((acc, game) => {
            const competitorTeamId = game.teamId === this.tournamentTeam.team.id ? game.competitorTeamId : game.teamId;
            return Object.assign(Object.assign({}, acc), { [competitorTeamId]: [
                    ...(acc[competitorTeamId] || []),
                    game,
                ] });
        }, {});
    }
    get games() {
        return this._games;
    }
    get gamesWonPercent() {
        if (!this.gamesCount) {
            return 0;
        }
        return Math.floor(1000 * this.wonGamesCount / this.gamesCount) / 10;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentStageTeam, "toFront", null);
__decorate([
    ToBackHook
], TournamentStageTeam, "toBack", null);
TournamentStageTeam = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            tournament_team: 'tournamentTeam',
            group: 'group',
            tournament_stage_id: 'tournamentStageId',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            score_sum: 'scoreSum',
            missed_sum: 'missedSum',
            last_games_count: 'lastGamesCount',
            last_games_won: 'lastGamesWon',
            points: 'points',
            mt_points: 'mtPoints',
            final_standing: 'finalStanding',
            received_points: 'receivedPoints',
            received_mt_points: 'receivedMtPoints',
            tries_scored: 'triesScored',
            tries_missed: 'triesMissed',
            attack_bonuses: 'attackBonuses',
            defense_bonuses: 'defenseBonuses',
            games: 'games',
            draw_games_count: 'drawGamesCount',
            lose_games_count: 'loseGamesCount',
        },
        relation: {
            tournamentTeam: TournamentTeam,
            group: TournamentGroup,
            games: listField(StageTeamGame),
        }
    })
], TournamentStageTeam);

var LeagueNewsType;
(function (LeagueNewsType) {
    LeagueNewsType[LeagueNewsType["text"] = 1] = "text";
    LeagueNewsType[LeagueNewsType["video"] = 2] = "video";
})(LeagueNewsType || (LeagueNewsType = {}));
let LeagueNews = class LeagueNews extends BaseModel {
    static toFront(data) {
        return undefined;
    }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeagueNews, "toFront", null);
__decorate([
    ToBackHook
], LeagueNews, "toBack", null);
LeagueNews = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            title: 'title',
            datetime: 'datetime',
            preview_text: 'previewText',
            detail_text: 'detailText',
            picture: 'picture',
            cover: 'cover',
            mobile_picture: 'mobilePicture',
            is_main: 'isMain',
            tournaments: 'tournaments',
            type: 'type',
            video_link: 'videoLink',
            tag: 'tag',
        },
        relation: {
            datetime: DateTimeField,
            picture: File,
            cover: File,
            mobilePicture: File,
            tournaments: listField(Tournament),
            type: enumField(LeagueNewsType),
        }
    })
], LeagueNews);

var TournamentEventTypes;
(function (TournamentEventTypes) {
    TournamentEventTypes[TournamentEventTypes["game_closed"] = 1] = "game_closed";
    TournamentEventTypes[TournamentEventTypes["media_added"] = 2] = "media_added";
    TournamentEventTypes[TournamentEventTypes["news"] = 3] = "news";
})(TournamentEventTypes || (TournamentEventTypes = {}));
let TournamentEvent = class TournamentEvent extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentEvent, "toFront", null);
__decorate([
    ToBackHook
], TournamentEvent, "toBack", null);
TournamentEvent = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            game: 'game',
            news: 'news',
            league: 'league',
            tournaments: 'tournaments',
            event: 'event',
            datetime: 'datetime'
        },
        relation: {
            game: Game,
            news: LeagueNews,
            league: League,
            tournaments: listField(Tournament),
            datetime: DateField,
            event: enumField(TournamentEventTypes)
        }
    })
], TournamentEvent);

var LeagueUserRoles;
(function (LeagueUserRoles) {
    LeagueUserRoles[LeagueUserRoles["admin"] = 1] = "admin";
    LeagueUserRoles[LeagueUserRoles["moderator"] = 2] = "moderator";
    LeagueUserRoles[LeagueUserRoles["game_manager"] = 3] = "game_manager";
})(LeagueUserRoles || (LeagueUserRoles = {}));
var LeagueUserPermissions;
(function (LeagueUserPermissions) {
    LeagueUserPermissions[LeagueUserPermissions["settings"] = 1] = "settings";
    LeagueUserPermissions[LeagueUserPermissions["users"] = 2] = "users";
    LeagueUserPermissions[LeagueUserPermissions["teams"] = 3] = "teams";
    LeagueUserPermissions[LeagueUserPermissions["media"] = 4] = "media";
    LeagueUserPermissions[LeagueUserPermissions["news"] = 5] = "news";
    LeagueUserPermissions[LeagueUserPermissions["game_export"] = 6] = "game_export";
    LeagueUserPermissions[LeagueUserPermissions["schedule"] = 7] = "schedule";
    LeagueUserPermissions[LeagueUserPermissions["game_management"] = 8] = "game_management";
})(LeagueUserPermissions || (LeagueUserPermissions = {}));
let LeagueUser = class LeagueUser extends BaseModel {
    set role(value) {
        this._role = LeagueUserRoles[value];
    }
    get role() {
        return this._role;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeagueUser, "toFront", null);
__decorate([
    ToBackHook
], LeagueUser, "toBack", null);
LeagueUser = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user: 'user',
            role: 'role',
            permissions: 'permissions'
        },
        relation: {
            user: User,
            permissions: listField(enumField(LeagueUserPermissions))
        }
    })
], LeagueUser);

let RugbyStatistic = class RugbyStatistic extends BaseModel {
    get userMinutes() {
        if (!this.gameTime) {
            return '00:00';
        }
        const minutes = Math.floor(this.gameTime / 60);
        const seconds = Math.floor(this.gameTime - minutes * 60);
        return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
    }
    get totalFouls() {
        return Math.floor(10 * ((this.fouls || 0) + (this.teamFouls || 0))) / 10;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], RugbyStatistic, "toFront", null);
__decorate([
    ToBackHook
], RugbyStatistic, "toBack", null);
RugbyStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            league_player: 'leaguePlayer',
            tournament_team_user: 'tournamentTeamUser',
            team: 'team',
            team_user: 'teamUser',
            user: 'user',
            tournament_team: 'tournamentTeam',
            month: 'month',
            win_lose: 'winLose',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            lose_games_count: 'loseGamesCount',
            draw_games_count: 'drawGamesCount',
            team_score_sum: 'teamScoreSum',
            team_missed_sum: 'teamMissedSum',
            tournament_points: 'tournamentPoints',
            newbie: 'newbie',
            // User statistic
            points: 'points',
            tries: 'tries',
            conversion_kicks: 'conversionKicks',
            conversion_goals: 'conversionGoals',
            conversion_misses: 'conversionMisses',
            conversion_goals_percent: 'conversionGoalsPercent',
            penalties: 'penalties',
            penalty_kicks_on_goal: 'penaltyKicksOnGoal',
            penalty_misses: 'penaltyMisses',
            penalty_goals: 'penaltyGoals',
            tap_penalties: 'tapPenalties',
            penalty_kicks_to_touch: 'penaltyKicksToTouch',
            penalty_goals_percent: 'penaltyGoalsPercent',
            drop_goal_kicks: 'dropGoalKicks',
            drop_goals: 'dropGoals',
            drop_goal_misses: 'dropGoalMisses',
            drop_goals_percent: 'dropGoalsPercent',
            total_goals: 'totalGoals',
            free_kicks: 'freeKicks',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            offloads: 'offloads',
            tackles: 'tackles',
            handling_errors: 'handlingErrors',
            carries_over_gainline: 'carriesOverGainline',
            foot_field_shots: 'footFieldShots',
            foot_out_shots: 'footOutShots',
            foot_shots: 'footShots',
            foot_kicks_50_22: 'footKicks5022',
            runs: 'runs',
            plus_minus: 'plusMinus',
            game_time: 'gameTime',
            // Team statistic
            penalty_tries: 'penaltyTries',
            scrums: 'scrums',
            scrums_won: 'scrumsWon',
            scrums_lost: 'scrumsLost',
            scrums_won_percent: 'scrumsWonPercent',
            scrums_won_free: 'scrumsWonFree',
            opponent_scrums_won: 'opponentScrumsWon',
            opponent_scrums_lost: 'opponentScrumsLost',
            lineouts: 'lineouts',
            lineouts_won: 'lineoutsWon',
            lineouts_lost: 'lineoutsLost',
            lineouts_steal: 'lineoutsSteal',
            lineouts_won_percent: 'lineoutsWonPercent',
            opponent_lineouts_lost: 'opponentLineoutsLost',
            quick_throws: 'quickThrows',
            rucks: 'rucks',
            rucks_won: 'rucksWon',
            rucks_lost: 'rucksLost',
            rucks_won_percent: 'rucksWonPercent',
            opponent_rucks_won: 'opponentRucksWon',
            opponent_rucks_lost: 'opponentRucksLost',
            mauls: 'mauls',
            mauls_won: 'maulsWon',
            mauls_lost: 'maulsLost',
            mauls_won_percent: 'maulWonPercent',
            opponent_mauls_won: 'opponentMaulsWon',
            opponent_mauls_lost: 'opponentMaulsLost',
            fouls: 'fouls',
            team_fouls: 'teamFouls',
            outs: 'outs',
        },
        relation: {
            leaguePlayer: LeaguePlayer,
            tournamentTeamUser: TournamentTeamUser,
            team: Team,
            teamUser: TeamUser,
            user: User,
            tournamentTeam: TournamentTeam,
            month: DateField
        }
    })
], RugbyStatistic);

var AchievementTypes;
(function (AchievementTypes) {
    AchievementTypes[AchievementTypes["by_game"] = 1] = "by_game";
    AchievementTypes[AchievementTypes["by_stage"] = 2] = "by_stage";
})(AchievementTypes || (AchievementTypes = {}));
let Achievement = class Achievement extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], Achievement, "toFront", null);
__decorate([
    ToBackHook
], Achievement, "toBack", null);
Achievement = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            alias: 'type',
            value: 'value',
            type: 'type',
        },
        relation: {
            type: enumField(AchievementTypes),
        }
    })
], Achievement);

let TeamAchievement = class TeamAchievement extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamAchievement, "toFront", null);
__decorate([
    ToBackHook
], TeamAchievement, "toBack", null);
TeamAchievement = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            achievement: 'achievement',
            tournament_stage: 'tournamentStage',
            team_id: 'teamId',
            game: 'game',
            mt_points: 'mtPoints',
        },
        relation: {
            achievement: Achievement,
            tournamentStage: TournamentStage,
            game: Game
        }
    })
], TeamAchievement);

let WaterpoloStatistic = class WaterpoloStatistic extends BaseModel {
    get assists() {
        return Math.floor(10 * ((this.ppAssists || 0) + (this.shAssists || 0) + (this.evAssists || 0))) / 10;
    }
    get goalpass() {
        return Math.floor(10 * ((this.totalGoals || 0) + (this.assists || 0))) / 10;
    }
    get userMinutes() {
        if (!this.gameTime) {
            return '00:00';
        }
        const minutes = Math.floor(this.gameTime / 60);
        const seconds = Math.floor(this.gameTime - minutes * 60);
        return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
    }
    get penaltyTime() {
        if (!this.penaltyMinutes) {
            return '00:00';
        }
        const minutes = Math.floor(this.penaltyMinutes / 60);
        const seconds = Math.floor(this.penaltyMinutes - minutes * 60);
        return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
    }
    get gamesWonPercent() {
        if (!this.gamesCount) {
            return 0;
        }
        return Math.floor(1000 * this.wonGamesCount / this.gamesCount) / 10;
    }
    get tournamentTeamPoints() {
        return this.tournamentTeam && this.tournamentTeam.points;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], WaterpoloStatistic, "toFront", null);
__decorate([
    ToBackHook
], WaterpoloStatistic, "toBack", null);
WaterpoloStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            league_player: 'leaguePlayer',
            tournament_team_user: 'tournamentTeamUser',
            team: 'team',
            team_user: 'teamUser',
            user: 'user',
            tournament_team: 'tournamentTeam',
            month: 'month',
            win_lose: 'winLose',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            lose_games_count: 'loseGamesCount',
            team_score_sum: 'teamScoreSum',
            team_missed_sum: 'teamMissedSum',
            tournament_points: 'tournamentPoints',
            points: 'points',
            pp_shot_misses: 'ppShotMisses',
            pp_shots_on_goal: 'ppShotsOnGoal',
            pp_shots_blocked: 'ppShotsBlocked',
            ev_shot_misses: 'evShotMisses',
            ev_shots_on_goal: 'evShotsOnGoal',
            ev_shots_blocked: 'evShotsBlocked',
            sh_shot_misses: 'shShotMisses',
            sh_shots_on_goal: 'shShotsOnGoal',
            sh_shots_blocked: 'shShotsBlocked',
            pp_total_shots_on_goal: 'ppTotalShotsOnGoal',
            ev_total_shots_on_goal: 'evTotalShotsOnGoal',
            sh_total_shots_on_goal: 'shTotalShotsOnGoal',
            pp_goals: 'ppGoals',
            ev_goals: 'evGoals',
            sh_goals: 'shGoals',
            pp_counterattack_goals: 'ppCounterAttackGoals',
            pp_counterattack_on_goals: 'ppCounterAttackOnGoals',
            pp_counterattack_misses: 'ppCounterAttackMisses',
            pp_counterattack_shots_blocked: 'ppCounterAttackShotsBlocked',
            ev_counterattack_goals: 'evCounterAttackGoals',
            ev_counterattack_on_goals: 'evCounterAttackOnGoals',
            ev_counterattack_misses: 'evCounterAttackMisses',
            ev_counterattack_shots_blocked: 'evCounterAttackShotsBlocked',
            sh_counterattack_goals: 'shCounterAttackGoals',
            sh_counterattack_on_goals: 'shCounterAttackOnGoals',
            sh_counterattack_misses: 'shCounterAttackMisses',
            sh_counterattack_shots_blocked: 'shCounterAttackShotsBlocked',
            pp_maneuver_goals: 'ppManeuverGoals',
            pp_maneuver_on_goals: 'ppManeuverOnGoals',
            pp_maneuver_misses: 'ppManeuverMisses',
            pp_maneuver_shots_blocked: 'ppManeuverShotsBlocked',
            ev_maneuver_goals: 'evManeuverGoals',
            ev_maneuver_on_goals: 'evManeuverOnGoals',
            ev_maneuver_misses: 'evManeuverMisses',
            ev_maneuver_shots_blocked: 'evManeuverShotsBlocked',
            sh_maneuver_goals: 'shManeuverGoals',
            sh_maneuver_on_goals: 'shManeuverOnGoals',
            sh_maneuver_misses: 'shManeuverMisses',
            sh_maneuver_shots_blocked: 'shManeuverShotsBlocked',
            pp_center_forward_goals: 'ppCenterForwardGoals',
            pp_center_forward_on_goals: 'ppCenterForwardOnGoals',
            pp_center_forward_misses: 'ppCenterForwardMisses',
            pp_center_forward_shots_blocked: 'ppCenterForwardShotsBlocked',
            ev_center_forward_goals: 'evCenterForwardGoals',
            ev_center_forward_on_goals: 'evCenterForwardOnGoals',
            ev_center_forward_misses: 'evCenterForwardMisses',
            ev_center_forward_shots_blocked: 'evCenterForwardShotsBlocked',
            sh_center_forward_goals: 'shCenterForwardGoals',
            sh_center_forward_on_goals: 'shCenterForwardOnGoals',
            sh_center_forward_misses: 'shCenterForwardMisses',
            sh_center_forward_shots_blocked: 'shCenterForwardShotsBlocked',
            pp_assists: 'ppAssists',
            ev_assists: 'evAssists',
            sh_assists: 'shAssists',
            shootout_attempts: 'shootoutAttempts',
            shootout_goals: 'shootoutGoals',
            after_game_shootout_attempts: 'afterGameShootoutAttempts',
            after_game_shootout_goals: 'afterGameShootoutGoals',
            block_shots: 'blockShots',
            face_off_losses: 'faceOffLosses',
            face_off_wins: 'faceOffWins',
            pp_saves: 'ppSaves',
            sh_saves: 'shSaves',
            ev_saves: 'evSaves',
            pp_counterattack_saves: 'ppCounterAttackSaves',
            sh_counterattack_saves: 'shCounterAttackSaves',
            ev_counterattack_saves: 'evCounterAttackSaves',
            pp_maneuver_saves: 'ppManeuverSaves',
            sh_maneuver_saves: 'shManeuverSaves',
            ev_maneuver_saves: 'evManeuverSaves',
            pp_center_forward_saves: 'ppCenterForwardSaves',
            sh_center_forward_saves: 'shCenterForwardSaves',
            ev_center_forward_saves: 'evCenterForwardSaves',
            pp_free_kick_saves: 'ppFreeKickSaves',
            sh_free_kick_saves: 'shFreeKickSaves',
            ev_free_kick_saves: 'evFreeKickSaves',
            pp_corner_saves: 'ppCornerSaves',
            sh_corner_saves: 'shCornerSaves',
            ev_corner_saves: 'evCornerSaves',
            pp_total_game_saves: 'ppTotalGameSaves',
            sh_total_game_saves: 'shTotalGameSaves',
            ev_total_game_saves: 'evTotalGameSaves',
            shootout_saves: 'shootoutSaves',
            after_game_shootout_saves: 'afterGameShootoutSaves',
            pp_goals_against: 'ppGoalsAgainst',
            sh_goals_against: 'shGoalsAgainst',
            ev_goals_against: 'evGoalsAgainst',
            goals_against: 'goalsAgainst',
            pp_counterattack_goals_against: 'ppCounterAttackGoalsAgainst',
            sh_counterattack_goals_against: 'shCounterAttackGoalsAgainst',
            ev_counterattack_goals_against: 'evCounterAttackGoalsAgainst',
            counterattack_goals_against: 'counterAttackGoalsAgainst',
            pp_maneuver_goals_against: 'ppManeuverGoalsAgainst',
            sh_maneuver_goals_against: 'shManeuverGoalsAgainst',
            ev_maneuver_goals_against: 'evManeuverGoalsAgainst',
            maneuver_goals_against: 'maneuverGoalsAgainst',
            pp_center_forward_goals_against: 'ppCenterForwardGoalsAgainst',
            sh_center_forward_goals_against: 'shCenterForwardGoalsAgainst',
            ev_center_forward_goals_against: 'evCenterForwardGoalsAgainst',
            center_forward_goals_against: 'centerForwardGoalsAgainst',
            pp_free_kick_goals_against: 'ppFreeKickGoalsAgainst',
            sh_free_kick_goals_against: 'shFreeKickGoalsAgainst',
            ev_free_kick_goals_against: 'evFreeKickGoalsAgainst',
            free_kick_goals_against: 'freeKickGoalsAgainst',
            pp_corner_goals_against: 'ppCornerGoalsAgainst',
            sh_corner_goals_against: 'shCornerGoalsAgainst',
            ev_corner_goals_against: 'evCornerGoalsAgainst',
            corner_goals_against: 'cornerGoalsAgainst',
            shootout_goals_against: 'shootoutGoalsAgainst',
            after_game_shootout_goals_against: 'afterGameShootoutGoalsAgainst',
            safety_rate: 'safetyRate',
            penalty_minutes: 'penaltyMinutes',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            fouls: 'fouls',
            minor_penalties: 'minorPenalties',
            major_penalties: 'majorPenalties',
            match_penalties: 'matchPenalties',
            penalty_fouls: 'penaltyFouls',
            turnovers: 'turnovers',
            attack_fouls: 'attackFouls',
            personal_fouls: 'personalFouls',
            drawn_fouls: 'drawnFouls',
            drawn_turnovers: 'drawnTurnovers',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            losses: 'losses',
            steals: 'steals',
            pp_free_kick_goals: 'ppFreeKickGoals',
            pp_free_kick_on_goals: 'ppFreeKickOnGoals',
            pp_free_kick_misses: 'ppFreeKickMisses',
            pp_free_kick_shots_blocked: 'ppFreeKickShotsBlocked',
            sh_free_kick_goals: 'shFreeKickGoals',
            sh_free_kick_on_goals: 'shFreeKickOnGoals',
            sh_free_kick_misses: 'shFreeKickMisses',
            sh_free_kick_shots_blocked: 'shFreeKickShotsBlocked',
            ev_free_kick_goals: 'evFreeKickGoals',
            ev_free_kick_on_goals: 'evFreeKickOnGoals',
            ev_free_kick_misses: 'evFreeKickMisses',
            ev_free_kick_shots_blocked: 'evFreeKickShotsBlocked',
            free_kick_passes: 'freeKickPasses',
            free_kick_selfs: 'freeKickSelfs',
            pp_corner_goals: 'ppCornerGoals',
            pp_corner_on_goals: 'ppCornerOnGoals',
            pp_corner_misses: 'ppCornerMisses',
            pp_corner_shots_blocked: 'ppCornerShotsBlocked',
            sh_corner_goals: 'shCornerGoals',
            sh_corner_on_goals: 'shCornerOnGoals',
            sh_corner_misses: 'shCornerMisses',
            sh_corner_shots_blocked: 'shCornerShotsBlocked',
            ev_corner_goals: 'evCornerGoals',
            ev_corner_on_goals: 'evCornerOnGoals',
            ev_corner_misses: 'evCornerMisses',
            ev_corner_shots_blocked: 'evCornerShotsBlocked',
            corner_passes: 'cornerPasses',
            corner_selfs: 'cornerSelfs',
            tackles: 'tackles',
            player_efficiency: 'playerEfficiency',
            pp_shots: 'ppShots',
            ev_shots: 'evShots',
            sh_shots: 'shShots',
            pp_goals_percent: 'ppGoalsPercent',
            sh_goals_percent: 'shGoalsPercent',
            ev_goals_percent: 'evGoalsPercent',
            total_pp_goals: 'totalPpGoals',
            total_sh_goals: 'totalShGoals',
            total_ev_goals: 'totalEvGoals',
            goals: 'goals',
            total_goals: 'totalGoals',
            position_attack_goals: 'positionAttackGoals',
            position_attack_shots_on_goal: 'positionAttackShotsOnGoal',
            position_attack_shots_miss: 'positionAttackShotsMiss',
            position_attack_shots: 'positionAttackShots',
            position_attack_goals_percent: 'positionAttackGoalsPercent',
            total_counterattack_goals: 'totalCounterAttackGoals',
            counterattack_shot_on_goals: 'counterAttackShotOnGoals',
            counterattack_shot_misses: 'counterAttackShotMisses',
            counterattack_shots: 'counterAttackShots',
            counterattack_goals_percent: 'counterAttackGoalsPercent',
            total_maneuver_goals: 'totalManeuverGoals',
            maneuver_shot_misses: 'maneuverShotMisses',
            maneuver_shot_on_goals: 'maneuverShotOnGoals',
            maneuver_shots: 'maneuverShots',
            maneuver_goals_percent: 'maneuverGoalsPercent',
            total_center_forward_goals: 'totalCenterForwardGoals',
            center_forward_shot_on_goals: 'centerForwardShotOnGoals',
            center_forward_shot_misses: 'centerForwardShotMisses',
            center_forward_shots: 'centerForwardShots',
            center_forward_goals_percent: 'centerForwardGoalsPercent',
            total_free_kick_goals: 'totalFreeKickGoals',
            free_kick_shot_misses: 'freeKickShotMisses',
            free_kick_on_goals: 'freeKickOnGoals',
            total_free_kicks: 'totalFreeKicks',
            free_kick_goals_percent: 'freeKickGoalsPercent',
            total_corner_goals: 'totalCornerGoals',
            total_corners: 'totalCorners',
            total_in_game_goals: 'totalInGameGoals',
            in_game_shot_misses: 'inGameShotMisses',
            total_pp_shot_misses: 'totalPpShotMisses',
            shot_misses: 'shotMisses',
            total_pp_shots_on_goal: 'totalPpShotsOnGoal',
            in_game_shots_on_goals: 'inGameShotsOnGoals',
            shots_on_goal: 'shotsOnGoal',
            shots_blocked: 'shotsBlocked',
            shots: 'shots',
            shots_on_goal_percent: 'shotsOnGoalPercent',
            total_shots: 'totalShots',
            goals_percent: 'goalsPercent',
            total_goals_percent: 'totalGoalsPercent',
            face_offs: 'faceOffs',
            face_off_percent: 'faceOffPercent',
            total_fouls: 'totalFouls',
            total_penalties: 'totalPenalties',
            shootout_shots: 'shootoutShots',
            shootout_goals_percent: 'shootoutGoalsPercent',
            /*goalie stat*/
            position_attack_saves: 'positionAttackSaves',
            position_attack_shots_against: 'positionAttackShotsAgainst',
            position_attack_saves_percent: 'positionAttackSavesPercent',
            counterattack_saves: 'counterAttackSaves',
            counterattack_shots_against: 'counterAttackShotsAgainst',
            counterattack_saves_percent: 'counterAttackSavesPercent',
            center_forward_saves: 'centerForwardSaves',
            center_forward_shots_against: 'centerForwardShotsAgainst',
            center_forward_saves_percent: 'centerForwardSavesPercent',
            maneuver_saves: 'maneuverSaves',
            maneuver_shots_against: 'maneuverShotsAgainst',
            maneuver_saves_percent: 'maneuverSavesPercent',
            free_kick_saves: 'freeKickSaves',
            free_kick_shots_against: 'freeKickShotsAgainst',
            free_kick_saves_percent: 'freeKickSavesPercent',
            corner_saves: 'cornerSaves',
            corner_shots_against: 'cornerShotsAgainst',
            corner_saves_percent: 'cornerSavesPercent',
            in_game_saves: 'inGameSaves',
            saves: 'saves',
            total_saves: 'totalSaves',
            shootout_shots_against: 'shootoutShotsAgainst',
            shootout_saves_percent: 'shootoutSavesPercent',
            game_shots_against: 'gameShotsAgainst',
            saves_percent: 'savesPercent',
            total_shots_against: 'totalShotsAgainst',
            total_saves_percent: 'totalSavesPercent',
            in_game_goals_against: 'inGameGoalsAgainst',
            total_goals_against: 'totalGoalsAgainst',
            total_sh_saves: 'totalShSaves',
            total_sh_goals_against: 'totalShGoalsAgainst',
            total_sh_shots_against: 'totalShShotsAgainst',
            total_sh_saves_percent: 'totalShSavesPercent',
            total_ev_saves: 'totalEvSaves',
            total_ev_goals_against: 'totalEvGoalsAgainst',
            total_ev_shots_against: 'totalEvShotsAgainst',
            total_ev_saves_percent: 'totalEvSavesPercent',
            newbie: 'newbie',
            rank: 'rank',
        },
        relation: {
            leaguePlayer: LeaguePlayer,
            tournamentTeamUser: TournamentTeamUser,
            team: Team,
            teamUser: TeamUser,
            user: User,
            tournamentTeam: TournamentTeam,
            month: DateField
        }
    })
], WaterpoloStatistic);

var TournamentRoundTypes;
(function (TournamentRoundTypes) {
    TournamentRoundTypes[TournamentRoundTypes["group"] = 1] = "group";
    TournamentRoundTypes[TournamentRoundTypes["playoff"] = 2] = "playoff";
})(TournamentRoundTypes || (TournamentRoundTypes = {}));
class TournamentRoundSettings extends BaseModel {
}
let TournamentRound = class TournamentRound extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentRound, "toFront", null);
__decorate([
    ToBackHook
], TournamentRound, "toBack", null);
TournamentRound = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            type: 'type',
            divisions: 'divisions',
        },
        relation: {
            type: enumField(TournamentRoundTypes),
            divisions: listField(TournamentDivision),
        }
    })
], TournamentRound);

let WrestballStatistic = class WrestballStatistic extends BaseModel {
    get totalFouls() {
        return Math.floor(10 * ((this.personalFouls || 0))) / 10;
    }
    get gameMinutes() {
        return Math.floor(this.gameTime / 60);
    }
    get tournamentTeamPoints() {
        return this.tournamentTeam && this.tournamentTeam.points;
    }
    get onePointsPercent() {
        if (!this.onePointsMade || !this.onePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.onePointsMade / this.onePointAttempts) / 10;
    }
    get twoPointsPercent() {
        if (!this.twoPointsMade || !this.twoPointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.twoPointsMade / this.twoPointAttempts) / 10;
    }
    get threePointsPercent() {
        if (!this.threePointsMade || !this.threePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.threePointsMade / this.threePointAttempts) / 10;
    }
    get dunkMadePercent() {
        return !this.dunksMade || !this.dunkAttempts ? 0 : Math.round(1000 * this.dunksMade / this.dunkAttempts) / 10;
    }
    get freeThrowsPercent() {
        if (!this.freeThrowsMade || !this.freeThrowAttempts) {
            return 0;
        }
        return Math.round(1000 * this.freeThrowsMade / this.freeThrowAttempts) / 10;
    }
    get totalRebounds() {
        return Math.floor(10 * ((this.offensiveRebounds || 0) + (this.defensiveRebounds || 0))) / 10;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], WrestballStatistic, "toFront", null);
__decorate([
    ToBackHook
], WrestballStatistic, "toBack", null);
WrestballStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            league_player: 'leaguePlayer',
            tournament_team_user: 'tournamentTeamUser',
            team: 'team',
            team_user: 'teamUser',
            user: 'user',
            tournament_team: 'tournamentTeam',
            month: 'month',
            win_lose: 'winLose',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            team_score_sum: 'teamScoreSum',
            team_missed_sum: 'teamMissedSum',
            tournament_points: 'tournamentPoints',
            points: 'points',
            two_points_made: 'twoPointsMade',
            three_points_made: 'threePointsMade',
            free_throws_made: 'freeThrowsMade',
            two_points_free_throw_made: 'twoPointsFreeThrowMade',
            three_points_free_throw_made: 'threePointsFreeThrowMade',
            total_free_throw_made: 'totalFreeThrowMade',
            one_points_made: 'onePointsMade',
            dunks_made: 'dunksMade',
            two_point_attempts: 'twoPointAttempts',
            three_point_attempts: 'threePointAttempts',
            free_throw_attempts: 'freeThrowAttempts',
            two_point_free_throw_attempts: 'twoPointFreeThrowAttempts',
            three_point_free_throw_attempts: 'threePointFreeThrowAttempts',
            total_free_throw_attempts: 'totalFreeThrowAttempts',
            one_point_attempts: 'onePointAttempts',
            dunk_attempts: 'dunkAttempts',
            two_point_percent: 'twoPointPercent',
            three_point_percent: 'threePointPercent',
            free_throw_percent: 'freeThrowPercent',
            total_free_throw_percent: 'totalFreeThrowPercent',
            one_point_percent: 'onePointPercent',
            dunks_made_percent: 'dunksMadePercent',
            assists: 'assists',
            blocks: 'blocks',
            rebounds: 'rebounds',
            offensive_rebounds: 'offensiveRebounds',
            defensive_rebounds: 'defensiveRebounds',
            steals: 'steals',
            turnovers: 'turnovers',
            personal_fouls: 'personalFouls',
            drawn_fouls: 'drawnFouls',
            drawn_wrestler_attempts: 'drawnWrestlerAttempts',
            drawn_wrestler_won_attempts: 'drawnWrestlerWonAttempts',
            drawn_wrestler_lost_attempts: 'drawnWrestlerLostAttempts',
            wrestler_scrums_won: 'wrestlerScrumsWon',
            wrestler_scrums_lost: 'wrestlerScrumsLost',
            wrestler_scrums_tie: 'wrestlerScrumsTie',
            wrestler_scrum_points: 'wrestlerScrumPoints',
            wrestler_scrums_counterattack: 'wrestlerScrumsCounterattack',
            wrestler_scrums_counterattack_points: 'wrestlerScrumsCounterattackPoints',
            scrums_won: 'scrumsWon',
            scrums_lost: 'scrumsLost',
            scrums_tie: 'scrumsTie',
            scrum_points: 'scrumPoints',
            scrums_ball_advantage_won: 'scrumsBallAdvantageWon',
            scrums_ball_advantage_lost: 'scrumsBallAdvantageLost',
            scrums_ball_advantage_tie: 'scrumsBallAdvantageTie',
            scrums_ball_advantage_total: 'scrumsBallAdvantageTotal',
            scrums_ball_advantage_won_percent: 'scrumsBallAdvantageWonPercent',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            wrestler_scrums: 'wrestlerScrums',
            wrestler_scrums_won_percent: 'wrestlerScrumsWonPercent',
            scrums: 'scrums',
            scrums_won_percent: 'scrumsWonPercent',
            total_scrums: 'totalScrums',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            newbie: 'newbie',
            rank: 'rank',
        },
        relation: {
            leaguePlayer: LeaguePlayer,
            tournamentTeamUser: TournamentTeamUser,
            team: Team,
            teamUser: TeamUser,
            user: User,
            tournamentTeam: TournamentTeam,
            month: DateField
        }
    })
], WrestballStatistic);

class TournamentApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/`)
                .pipe(map(result => Tournament.toFront(result)))
                .toPromise();
        });
    }
    getByAlias(leagueId, alias) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/tournaments/${alias}/`)
                .pipe(map(result => Tournament.toFront(result)))
                .toPromise();
        });
    }
    getSeasonTournaments(seasonTournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/season_tournament/${seasonTournamentId}/tournaments/`)
                .pipe(map(result => Tournament.toFront(result)))
                .toPromise();
        });
    }
    getNews(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/news/`)
                .pipe(map(result => TournamentNews.toFront(result)))
                .toPromise();
        });
    }
    getEvents(tournamentId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString())
                .set('size', size.toString());
            if (filters) {
                if (filters.event) {
                    params = params.set('event', TournamentEventTypes[filters.event]);
                }
                if (filters.search) {
                    params = params.set('search', filters.search);
                }
                if (filters.tournamentTour) {
                    params = params.set('tournament_tour', filters.tournamentTour.toString());
                }
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/events/`, { params, observe: 'response' })
                .pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: TournamentEvent.toFront(result.body)
            })))
                .toPromise();
        });
    }
    getTournamentStages(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/stages/`).pipe(map(data => TournamentStage.toFront(data))).toPromise();
        });
    }
    getTournamentRounds(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/rounds/`).pipe(map(data => TournamentRound.toFront(data))).toPromise();
        });
    }
    getTournamentDivisions(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/divisions/`).pipe(map(data => TournamentDivision.toFront(data))).toPromise();
        });
    }
    getPlayoff(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/playoff/`).pipe(map(result => Playoff.toFront(result))).toPromise();
        });
    }
    getPlayoffGames(playoffId, playoffNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (playoffNumber) {
                params = params.set('playoff_number', playoffNumber);
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_playoff/${playoffId}/games/`, { params }).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getGamesStages(tournamentId, roundId) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (roundId) {
                params = params.set('tournament_round_id', roundId.toString());
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/games_stages/`, { params })
                .pipe(map(data => GameTimelineStages.toFront(data)))
                .toPromise();
        });
    }
    getGames(tournamentId, page, size, filters = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString());
            if (size) {
                params = params.set('size', size.toString());
            }
            params = applyGamesFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/games/`, { params, observe: 'response' })
                .pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: Game.toFront(result.body)
            }))).toPromise();
        });
    }
    getGamesDates(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/games_dates/`, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: result.body
            }))).toPromise();
        });
    }
    getGroups(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/groups/`)
                .pipe(map(result => TournamentGroup.toFront(result)))
                .toPromise();
        });
    }
    getTeams(tournamentId, groupId, short) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (groupId) {
                params = params.set('group_id', groupId.toString());
            }
            if (short) {
                params = params.set('short', '1');
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/teams/`, { params })
                .pipe(map(result => TournamentTeam.toFront(result)))
                .toPromise();
        });
    }
    getStageTeams(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/stage_teams/`)
                .pipe(map(result => TournamentStageTeam.toFront(result)))
                .toPromise();
        });
    }
    getTeamsAchievements(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/achievements/`)
                .pipe(map(result => TeamAchievement.toFront(result)))
                .toPromise();
        });
    }
    getTeamById(tournamentTeamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_team/${tournamentTeamId}/`)
                .pipe(map(result => TournamentTeam.toFront(result)))
                .toPromise();
        });
    }
    getUserById(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_team_user/${userId}/`)
                .pipe(map(result => TournamentTeamUser.toFront(result)))
                .toPromise();
        });
    }
    getUserGames(tournamentUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_team_user/${tournamentUserId}/games/`)
                .pipe(map(result => Game.toFront(result)))
                .toPromise();
        });
    }
    downloadTable(tournamentId, format, isChess) {
        return __awaiter(this, void 0, void 0, function* () {
            let httpParams = new HttpParams().set('file_type', format);
            if (isChess) {
                httpParams = httpParams.set('isChess', true);
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/table_file/`, {
                params: httpParams,
                responseType: 'blob'
            }).toPromise();
        });
    }
    getBasketballStatisticLeaders(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            params = applyStatisticLeadersFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/basketball_statistic_leaders/`, { params }).pipe(map((result) => {
                for (const key of Object.keys(result)) {
                    result[key] = BasketballStatistic.toFront(result[key]);
                }
                return result;
            })).toPromise();
        });
    }
    getVolleyballStatisticLeaders(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            params = applyStatisticLeadersFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/volleyball_statistic_leaders/`, { params }).pipe(map((result) => {
                for (const key of Object.keys(result)) {
                    result[key] = VolleyballStatistic.toFront(result[key]);
                }
                return result;
            })).toPromise();
        });
    }
    getHockeyStatisticLeaders(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            params = applyStatisticLeadersFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/hockey_statistic_leaders/`, { params }).pipe(map((result) => {
                for (const key of Object.keys(result)) {
                    result[key] = HockeyStatistic.toFront(result[key]);
                }
                return result;
            })).toPromise();
        });
    }
    getFootballStatisticLeaders(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            params = applyStatisticLeadersFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/football_statistic_leaders/`, { params }).pipe(map((result) => {
                for (const key of Object.keys(result)) {
                    result[key] = FootballStatistic.toFront(result[key]);
                }
                return result;
            })).toPromise();
        });
    }
    getHandballStatisticLeaders(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            params = applyStatisticLeadersFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/handball_statistic_leaders/`, { params }).pipe(map((result) => {
                for (const key of Object.keys(result)) {
                    result[key] = HandballStatistic.toFront(result[key]);
                }
                return result;
            })).toPromise();
        });
    }
    getWaterpoloStatisticLeaders(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            params = applyStatisticLeadersFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/waterpolo_statistic_leaders/`, { params }).pipe(map((result) => {
                for (const key of Object.keys(result)) {
                    result[key] = WaterpoloStatistic.toFront(result[key]);
                }
                return result;
            })).toPromise();
        });
    }
    getBasketballStatistic(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = applyStatisticFilters(filters);
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/basketball_statistic/`, data, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: BasketballStatistic.toFront(result.body)
            }))).toPromise();
        });
    }
    getVolleyballStatistic(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = applyStatisticFilters(filters);
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/volleyball_statistic/`, data, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: VolleyballStatistic.toFront(result.body)
            }))).toPromise();
        });
    }
    getHockeyStatistic(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = applyStatisticFilters(filters);
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/hockey_statistic/`, data, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: HockeyStatistic.toFront(result.body)
            }))).toPromise();
        });
    }
    getFootballStatistic(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = applyStatisticFilters(filters);
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/football_statistic/`, data, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: FootballStatistic.toFront(result.body)
            }))).toPromise();
        });
    }
    getHandballStatistic(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = applyStatisticFilters(filters);
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/handball_statistic/`, data, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: HandballStatistic.toFront(result.body)
            }))).toPromise();
        });
    }
    getRugbyStatistic(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = applyStatisticFilters(filters);
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/rugby_statistic/`, data, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: RugbyStatistic.toFront(result.body)
            }))).toPromise();
        });
    }
    getWaterpoloStatistic(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = applyStatisticFilters(filters);
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/waterpolo_statistic/`, data, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: WaterpoloStatistic.toFront(result.body)
            }))).toPromise();
        });
    }
    getWrestballStatistic(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            const data = applyStatisticFilters(filters);
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/wrestball_statistic/`, data, { observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: WrestballStatistic.toFront(result.body)
            }))).toPromise();
        });
    }
    getTournamentTeamUsers(tournamentTeamId, includes = []) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            for (const include of includes) {
                params = params.append('include', include);
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_team/${tournamentTeamId}/users/`, { params }).pipe(map(result => TournamentTeamUser.toFront(result))).toPromise();
        });
    }
    myPermission(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/permission/`).pipe(map((data) => (data.permissions || []).map(item => LeagueUserPermissions[item]))).toPromise();
        });
    }
    getTournamentTeamTournaments(tournamentTeamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_team/${tournamentTeamId}/tournaments/`).pipe(map(result => Tournament.toFront(result))).toPromise();
        });
    }
    getTournamentUserTournaments(tournamentTeamUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_team_user/${tournamentTeamUserId}/tournaments/`).pipe(map(result => Tournament.toFront(result))).toPromise();
        });
    }
    getTournamentTeamUsersLimitation(tournamentTeamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_team/${tournamentTeamId}/users_limitation/`).pipe(map(result => GameUserLimitations.toFront(result))).toPromise();
        });
    }
    downloadTeamSanctionList(tournamentTeamId, fileType) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_team/${tournamentTeamId}/sanction_list_file/?file_type=${fileType}`, {
                params: new HttpParams().set('file_type', fileType),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
TournamentApi.ɵfac = function TournamentApi_Factory(t) { return new (t || TournamentApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
TournamentApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function TournamentApi_Factory() { return new TournamentApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: TournamentApi, providedIn: "root" });
TournamentApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];
function applyGamesFilters(filters, params) {
    if (filters.tournamentIds) {
        params = params.set('tournament_ids', filters.tournamentIds.join(','));
    }
    if (filters.tournamentStageId) {
        params = params.set('tournament_stage_id', filters.tournamentStageId.toString());
    }
    if (filters.tournamentRoundId) {
        params = params.set('tournament_round_id', filters.tournamentRoundId.toString());
    }
    if (filters.tournamentGroupId) {
        params = params.set('tournament_group_id', filters.tournamentGroupId.toString());
    }
    if (filters.divisionId) {
        params = params.set('division_id', filters.divisionId.toString());
    }
    if (filters.tournamentTour) {
        params = params.set('tournament_tour', filters.tournamentTour.toString());
    }
    if (filters.playoffStage) {
        params = params.set('playoff_stage', filters.playoffStage.toString());
    }
    if (filters.playoffRound) {
        params = params.set('playoff_round', filters.playoffRound.toString());
    }
    if (filters.teamId) {
        params = params.set('team_id', filters.teamId.toString());
    }
    if (filters.status) {
        params = params.set('status', GameStatuses[filters.status]);
    }
    if (filters.statuses) {
        const statuses = filters.statuses.map(i => GameStatuses[i]);
        params = params.set('statuses', statuses.join(','));
    }
    if (filters.tournamentCourtId) {
        params = params.set('tournament_court_id', filters.tournamentCourtId.toString());
    }
    if (filters.leaguePlayerId) {
        params = params.set('league_player_id', filters.leaguePlayerId.toString());
    }
    if (filters.userId) {
        params = params.set('user_id', filters.userId.toString());
    }
    if (filters.query) {
        params = params.set('query', filters.query);
    }
    if (filters.date_from) {
        params = params.set('date_from', filters.date_from);
    }
    if (filters.date_to) {
        params = params.set('date_to', filters.date_to);
    }
    if (filters.isPlayoff !== undefined && filters.isPlayoff !== null) {
        params = params.set('is_playoff', filters.isPlayoff ? '1' : '0');
    }
    return params;
}
function applyStatisticFilters(filters) {
    const rawFilters = {};
    for (const key of Object.keys(filters)) {
        if (filters[key]) {
            if (key === 'basketball_position') {
                rawFilters[key] = GameBasketballPosition[filters[key]];
            }
            else if (key === 'volleyball_position') {
                rawFilters[key] = GameVolleyballPosition[filters[key]];
            }
            else if (key === 'hockey_position') {
                rawFilters[key] = GameHockeyPosition[filters[key]];
            }
            else if (key === 'football_position') {
                rawFilters[key] = GameFootballPosition[filters[key]];
            }
            else if (key === 'handball_position') {
                rawFilters[key] = GameHandballPosition[filters[key]];
            }
            else if (key === 'waterpolo_position') {
                rawFilters[key] = GameWaterpoloPosition[filters[key]];
            }
            else if (key === 'rugby_position') {
                rawFilters[key] = GameRugbyPosition[filters[key]];
            }
            else {
                rawFilters[key] = filters[key];
            }
        }
    }
    if (filters.per_game !== undefined) {
        rawFilters['per_game'] = filters.per_game ? '1' : '0';
    }
    if (filters.tournament_ids) {
        rawFilters['tournament_ids'] = filters.tournament_ids.join(',');
    }
    if (filters.tournament_season_ids) {
        rawFilters['tournament_season_ids'] = filters.tournament_season_ids.join(',');
    }
    if (filters.is_playoff !== undefined && filters.is_playoff !== null) {
        rawFilters['is_playoff'] = filters.is_playoff ? '1' : '0';
    }
    if (filters.only_closed !== undefined && filters.only_closed !== null) {
        rawFilters['only_closed'] = filters.only_closed ? '1' : '0';
    }
    if (filters.check_ignore_game !== undefined && filters.check_ignore_game !== null) {
        rawFilters['check_ignore_game'] = filters.check_ignore_game ? '1' : '0';
    }
    return rawFilters;
}
function applyStatisticLeadersFilters(filters, params) {
    for (const key of Object.keys(filters)) {
        if (filters[key]) {
            params = params.set(key, filters[key]);
        }
    }
    if (filters.per_game !== undefined) {
        params = params.set('per_game', filters.per_game ? '1' : '0');
    }
    if (filters.tournament_ids) {
        params = params.set('tournament_ids', filters.tournament_ids.join(','));
    }
    if (filters.fields) {
        params = params.set('fields', filters.fields.join(','));
    }
    return params;
}

let LeaguePartner = class LeaguePartner extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeaguePartner, "toFront", null);
__decorate([
    ToBackHook
], LeaguePartner, "toBack", null);
LeaguePartner = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            title: 'title',
            picture: 'picture',
            link: 'link',
            sort: 'sort',
        },
        relation: {
            picture: File
        }
    })
], LeaguePartner);

var BannerLocation;
(function (BannerLocation) {
    BannerLocation["slider"] = "slider";
    BannerLocation["central"] = "central";
    BannerLocation["media"] = "media";
})(BannerLocation || (BannerLocation = {}));
let LeagueBanner = class LeagueBanner extends BaseModel {
    static toFront(data) {
    }
    static toBack(data) {
    }
};
__decorate([
    ToFrontHook
], LeagueBanner, "toFront", null);
__decorate([
    ToBackHook
], LeagueBanner, "toBack", null);
LeagueBanner = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            title: 'title',
            picture: 'picture',
            link: 'link',
            sort: 'sort',
            location: 'location',
        },
        relation: {
            picture: File,
            location: enumField(BannerLocation),
        }
    })
], LeagueBanner);

let LeagueDocument = class LeagueDocument extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeagueDocument, "toFront", null);
__decorate([
    ToBackHook
], LeagueDocument, "toBack", null);
LeagueDocument = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            file: 'file',
        },
        relation: {
            file: File,
        }
    })
], LeagueDocument);

let TeamsAndUsers = class TeamsAndUsers extends BaseModel {
    get isEmpty() {
        return (!this.teams || this.teams.length === 0) &&
            (!this.leaguePlayers || this.leaguePlayers.length === 0);
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamsAndUsers, "toFront", null);
__decorate([
    ToBackHook
], TeamsAndUsers, "toBack", null);
TeamsAndUsers = __decorate([
    ModelInstance({
        mappingFields: {
            teams: 'teams',
            league_players: 'leaguePlayers',
        },
        relation: {
            teams: listField(Team),
            leaguePlayers: listField(LeaguePlayer),
        }
    })
], TeamsAndUsers);

let SeasonTournament = class SeasonTournament extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], SeasonTournament, "toFront", null);
__decorate([
    ToBackHook
], SeasonTournament, "toBack", null);
SeasonTournament = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
        },
    })
], SeasonTournament);

class LeagueApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getByAlias(alias) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${alias}/`).pipe(map(result => League.toFront(result))).toPromise();
        });
    }
    getByDomain(domain) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/by_domain/${domain}/`).pipe(map(result => League.toFront(result))).toPromise();
        });
    }
    getSeasonTournaments(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/season_tournaments/`).pipe(map(response => SeasonTournament.toFront(response))).toPromise();
        });
    }
    getTournaments(leagueId, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (filters) {
                if (filters.statuses) {
                    params = params.set('statuses', filters.statuses.map(s => TournamentStatuses[s]).join(','));
                }
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/tournaments/`, { params }).pipe(map(result => Tournament.toFront(result))).toPromise();
        });
    }
    getEvents(leagueId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString())
                .set('size', size.toString());
            if (filters) {
                if (filters.event) {
                    params = params.set('event', TournamentEventTypes[filters.event]);
                }
                if (filters.search) {
                    params = params.set('search', filters.search);
                }
                if (filters.tournamentTour) {
                    params = params.set('tournament_tour', filters.tournamentTour.toString());
                }
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/events/`, { params, observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: TournamentEvent.toFront(result.body)
            }))).toPromise();
        });
    }
    getTournamentSeasons(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/tournament_seasons/`).pipe(map(result => TournamentSeason.toFront(result))).toPromise();
        });
    }
    getGames(leagueId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString());
            if (size) {
                params = params.set('size', size.toString());
            }
            params = applyGamesFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/games/`, { params, observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: Game.toFront(result.body)
            }))).toPromise();
        });
    }
    getSeasons(leagueId, page = 1, size = 20, notClosed, include) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = new HttpParams()
                .set('page', page.toString())
                .set('size', size.toString())
                .set('not_closed', notClosed ? '1' : '')
                .set('include', include ? include.join(',') : '');
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/tournament_seasons/`, {
                params,
                observe: 'response'
            })
                .pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: TournamentSeason.toFront(result.body)
            })))
                .toPromise();
        });
    }
    getPartners(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/partners/`).pipe(map(result => LeaguePartner.toFront(result))).toPromise();
        });
    }
    getBanners(leagueId, location) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = location ? new HttpParams().set('location', location) : new HttpParams();
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/banners/`, { params }).pipe(map(result => LeagueBanner.toFront(result))).toPromise();
        });
    }
    getCourts(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/courts/`).pipe(map(result => LeagueCourt.toFront(result))).toPromise();
        });
    }
    getGraphicSettings(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/graphic_settings/`)
                .toPromise();
        });
    }
    getDocuments(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/documents/`).pipe(map(result => LeagueDocument.toFront(result))).toPromise();
        });
    }
    searchTeamsAndUsers(leagueId, query) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = (new HttpParams()).set('query', query);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/team_and_user_search/`, { params }).pipe(map(result => TeamsAndUsers.toFront(result))).toPromise();
        });
    }
    getLeaguePlayerFields(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/player_fields/`).pipe(map(result => LeaguePlayerField.toFront(result))).toPromise();
        });
    }
}
LeagueApi.ɵfac = function LeagueApi_Factory(t) { return new (t || LeagueApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
LeagueApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function LeagueApi_Factory() { return new LeagueApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: LeagueApi, providedIn: "root" });
LeagueApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class LeagueNewsApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getLeagueNewsList(leagueId, page, size, type = LeagueNewsType.text, seasonId) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString())
                .set('size', size.toString())
                .set('type', LeagueNewsType[type]);
            if (seasonId) {
                params = params.set('season', seasonId.toString());
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/news/`, { params, observe: 'response' })
                .pipe(map(response => ({
                total: +response.headers.get('X-Page-Count'),
                data: LeagueNews.toFront(response.body)
            })))
                .toPromise();
        });
    }
    getMainLeagueNews(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/news/?is_main=true`)
                .pipe(map(response => response && response.length > 0 ? LeagueNews.toFront(response[0]) : null))
                .toPromise();
        });
    }
    getMainLeagueNewsList(leagueId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/news/?is_main=true`)
                .pipe(map(response => LeagueNews.toFront(response)))
                .toPromise();
        });
    }
    getNewsById(newsId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_news/${newsId}/`)
                .pipe(map(response => LeagueNews.toFront(response)))
                .toPromise();
        });
    }
    getTournamentNewsList(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/news/`, { observe: 'response' })
                .pipe(map(response => ({
                total: +response.headers.get('X-Page-Count'),
                data: LeagueNews.toFront(response.body)
            })))
                .toPromise();
        });
    }
}
LeagueNewsApi.ɵfac = function LeagueNewsApi_Factory(t) { return new (t || LeagueNewsApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
LeagueNewsApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function LeagueNewsApi_Factory() { return new LeagueNewsApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: LeagueNewsApi, providedIn: "root" });
LeagueNewsApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class LeaguePlayerApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(leaguePlayerId) {
        return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_player/${leaguePlayerId}/`).pipe(map(item => LeaguePlayer.toFront(item))).toPromise();
    }
    getTournamentUsers(leaguePlayerId, seasonId) {
        let params = new HttpParams();
        if (seasonId) {
            params = params.set('season_id', seasonId.toString());
        }
        return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_player/${leaguePlayerId}/tournament_users/`, { params }).pipe(map(item => TournamentTeamUser.toFront(item))).toPromise();
    }
}
LeaguePlayerApi.ɵfac = function LeaguePlayerApi_Factory(t) { return new (t || LeaguePlayerApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
LeaguePlayerApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function LeaguePlayerApi_Factory() { return new LeaguePlayerApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: LeaguePlayerApi, providedIn: "root" });
LeaguePlayerApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class LeagueTeamApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getLeagueTeams(filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (filters) {
                if (filters.tournament_id) {
                    params = params.set('tournament_id', filters.tournament_id);
                }
                if (filters.tournament_season_id) {
                    params = params.set('tournament_season_id', filters.tournament_season_id);
                }
                if (filters.query) {
                    params = params.set('query', filters.query);
                }
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_team/`, { params }).pipe(map(response => response.map(item => Team.toFront(item)))).toPromise();
        });
    }
    getLeagueTeam(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league_team/${teamId}/`).pipe(map(response => Team.toFront(response))).toPromise();
        });
    }
}
LeagueTeamApi.ɵfac = function LeagueTeamApi_Factory(t) { return new (t || LeagueTeamApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
LeagueTeamApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function LeagueTeamApi_Factory() { return new LeagueTeamApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: LeagueTeamApi, providedIn: "root" });
LeagueTeamApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class MediaApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getMedia(mediaId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/media/${mediaId}/`).pipe(map(result => MediaItem.toFront(result))).toPromise();
        });
    }
    getTournamentGameMedia(tournamentId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString()).set('size', size.toString());
            params = applyGameMediaFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/game_media/`, { observe: 'response', params }).pipe(map(response => {
                return {
                    total: +response.headers.get('X-Page-Count'),
                    data: Game.toFront(response.body)
                };
            })).toPromise();
        });
    }
    getLeagueGameMedia(leagueId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString()).set('size', size.toString());
            params = applyGameMediaFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/game_media/`, { observe: 'response', params }).pipe(map(response => {
                return {
                    total: +response.headers.get('X-Page-Count'),
                    data: Game.toFront(response.body)
                };
            })).toPromise();
        });
    }
    getLeagueMedia(leagueId, page, size, filters = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString()).set('size', size.toString());
            if (filters.mediaType) {
                params = params.set('media_type', filters.mediaType);
            }
            if (filters.sort) {
                params = params.set('sort', filters.sort);
            }
            if (filters.teamId) {
                params = params.set('team_id', filters.teamId.toString());
            }
            if (filters.statuses) {
                const statuses = filters.statuses.map(i => GameStatuses[i]);
                params = params.set('statuses', statuses.join(','));
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/media/`, { params, observe: 'response' })
                .pipe(map(response => ({
                total: +response.headers.get('X-Page-Count'),
                data: MediaItem.toFront(response.body)
            }))).toPromise();
        });
    }
    getGameMediaById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/game_media/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getGameMedia(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_game/${gameId}/media/?size=1000`).pipe(map(result => MediaItem.toFront(result))).toPromise();
        });
    }
    createZip(mediaIds) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/media/zip/`, mediaIds, { responseType: 'blob' })
                .toPromise();
        });
    }
    downloadMedia(mediaId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/media/${mediaId}/download/`, { responseType: 'blob' })
                .toPromise();
        });
    }
}
MediaApi.ɵfac = function MediaApi_Factory(t) { return new (t || MediaApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
MediaApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function MediaApi_Factory() { return new MediaApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: MediaApi, providedIn: "root" });
MediaApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];
function applyGameMediaFilters(filters, params) {
    if (filters) {
        params = applyGamesFilters(filters, params);
        if (filters.tournamentTour) {
            params = params.set('tournament_tour', filters.tournamentTour.toString());
        }
        if (filters.teamId) {
            params = params.set('team_id', filters.teamId.toString());
        }
        if (filters.tournamentStageId) {
            params = params.set('tournament_stage_id', filters.tournamentStageId.toString());
        }
        if (filters.playoffId) {
            params = params.set('playoff_id', filters.playoffId.toString());
        }
        if (filters.playoffStage) {
            params = params.set('playoff_stage', filters.playoffStage.toString());
        }
        if (filters.playoffRound) {
            params = params.set('playoff_round', filters.playoffRound.toString());
        }
        if (filters.status) {
            params = params.set('status', GameStatuses[filters.status]);
        }
        if (filters.mediaCount) {
            params = params.set('media_count', filters.mediaCount.toString());
        }
    }
    return params;
}

var PollStatuses;
(function (PollStatuses) {
    PollStatuses[PollStatuses["open"] = 1] = "open";
    PollStatuses[PollStatuses["closed"] = 2] = "closed";
    PollStatuses[PollStatuses["archived"] = 3] = "archived";
})(PollStatuses || (PollStatuses = {}));
let PollVariant = class PollVariant extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], PollVariant, "toFront", null);
__decorate([
    ToBackHook
], PollVariant, "toBack", null);
PollVariant = __decorate([
    ModelInstance({
        mappingFields: {
            uuid: 'uuid',
            name: 'name'
        }
    })
], PollVariant);
let PollAnswer = class PollAnswer extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], PollAnswer, "toFront", null);
__decorate([
    ToBackHook
], PollAnswer, "toBack", null);
PollAnswer = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            answer_uuid: 'answerUuid',
            user: 'user',
            poll_id: 'pollId',
        },
        relation: {
            user: User
        }
    })
], PollAnswer);
let Poll = class Poll extends BaseModel {
    constructor() {
        super(...arguments);
        this.variantsWithAnswers = [];
    }
    set variants(value) {
        this._variants = value || [];
        if (this._answers) {
            this.calculateAnswersPercentage();
        }
    }
    get variants() {
        return this._variants;
    }
    set answers(value) {
        this._answers = value || [];
        if (this._variants) {
            this.calculateAnswersPercentage();
        }
    }
    get answers() {
        return this._answers;
    }
    calculateAnswersPercentage() {
        if (!this._answers.length) {
            return;
        }
        const variants = this._variants.map(v => v.uuid);
        const answersByVariant = this._answers.reduce((acc, item) => {
            if (variants.indexOf(item.answerUuid) < 0) {
                return acc;
            }
            if (!acc[item.answerUuid]) {
                acc[item.answerUuid] = 0;
            }
            acc[item.answerUuid]++;
            return acc;
        }, {});
        this.variantsWithAnswers = this._variants.map(item => ({
            variant: item,
            percent: answersByVariant[item.uuid] ? Math.round(100 * answersByVariant[item.uuid] / this._answers.length) : 0
        }))
            .sort((a, b) => a.percent > b.percent ? -1 : 1);
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], Poll, "toFront", null);
__decorate([
    ToBackHook
], Poll, "toBack", null);
Poll = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            active: 'active',
            status: 'status',
            team_id: 'teamId',
            name: 'name',
            description: 'description',
            variants: 'variants',
            author: 'author',
            answers: 'answers',
            multiple_answer: 'multipleAnswer',
            anonymous: 'anonymous',
            created_at: 'createdAt'
        },
        relation: {
            status: enumField(PollStatuses),
            variants: PollVariant,
            author: User,
            answers: PollAnswer,
            createdAt: DateTimeField,
        }
    })
], Poll);

let TeamInvite = class TeamInvite extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamInvite, "toFront", null);
__decorate([
    ToBackHook
], TeamInvite, "toBack", null);
TeamInvite = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            user_id: 'userId',
            user: 'user',
            team: 'team',
            team_id: 'teamId',
            user_accept: 'userAccept',
            team_accept: 'teamAccept',
            users_count: 'usersCount',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            score_sum: 'scoreSum',
            created_at: 'createdAt',
            updated_at: 'updatedAt',
        },
        relation: {
            user: User,
            team: Team,
            createdAt: DateTimeField,
            updateAt: DateTimeField,
        }
    })
], TeamInvite);

var GameInviteStatus;
(function (GameInviteStatus) {
    GameInviteStatus[GameInviteStatus["accepted"] = 1] = "accepted";
    GameInviteStatus[GameInviteStatus["declined"] = 2] = "declined";
})(GameInviteStatus || (GameInviteStatus = {}));
let GameInvite = class GameInvite extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], GameInvite, "toFront", null);
__decorate([
    ToBackHook
], GameInvite, "toBack", null);
GameInvite = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team_user: 'teamUser',
            game_id: 'gameId',
            game: 'game',
            status: 'status',
        },
        relation: {
            game: Game,
            teamUser: TeamUser,
            status: enumField(GameInviteStatus),
        }
    })
], GameInvite);

var TeamEventTypes;
(function (TeamEventTypes) {
    TeamEventTypes[TeamEventTypes["training"] = 1] = "training";
    TeamEventTypes[TeamEventTypes["other"] = 2] = "other";
})(TeamEventTypes || (TeamEventTypes = {}));

const TeamEventTypeLocalization = {
    [Locales.ru]: {
        [TeamEventTypes.training]: 'Тренировка',
        [TeamEventTypes.other]: 'Другое',
    },
    [Locales.en]: {
        [TeamEventTypes.training]: 'Training',
        [TeamEventTypes.other]: 'Other',
    }
};

let TeamEvent = class TeamEvent extends BaseModel {
    get name() {
        if (this.eventType === TeamEventTypes.other) {
            return this.eventCustomName;
        }
        return TeamEventTypeLocalization[this.eventType];
    }
    get isClosed() {
        return this.datetime.getTime() < new Date().getTime();
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamEvent, "toFront", null);
__decorate([
    ToBackHook
], TeamEvent, "toBack", null);
TeamEvent = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team_id: 'teamId',
            team: 'team',
            event_type: 'eventType',
            event_custom_name: 'eventCustomName',
            description: 'description',
            datetime: 'datetime',
            location: 'location',
        },
        relation: {
            eventType: enumField(TeamEventTypes),
            team: Team,
            datetime: DateTimeField,
        }
    })
], TeamEvent);

var TeamEventInviteStatuses;
(function (TeamEventInviteStatuses) {
    TeamEventInviteStatuses[TeamEventInviteStatuses["accepted"] = 1] = "accepted";
    TeamEventInviteStatuses[TeamEventInviteStatuses["declined"] = 2] = "declined";
})(TeamEventInviteStatuses || (TeamEventInviteStatuses = {}));
let TeamEventInvite = class TeamEventInvite {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamEventInvite, "toFront", null);
__decorate([
    ToBackHook
], TeamEventInvite, "toBack", null);
TeamEventInvite = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team_event_id: 'teamEventId',
            team_user_id: 'teamUserId',
            status: 'status',
        },
        relation: {
            status: enumField(TeamEventInviteStatuses)
        }
    })
], TeamEventInvite);

let TournamentTeamUserInvite = class TournamentTeamUserInvite extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentTeamUserInvite, "toFront", null);
__decorate([
    ToBackHook
], TournamentTeamUserInvite, "toBack", null);
TournamentTeamUserInvite = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            tournament_team_invite_id: 'tournamentTeamInviteId',
            tournament_team_id: 'tournamentTeamId',
            team_user: 'teamUser',
            accepted: 'accepted'
        },
        relation: {
            teamUser: TeamUser
        }
    })
], TournamentTeamUserInvite);

let TournamentInvite = class TournamentInvite extends BaseModel {
    get isOpen() {
        return (this.teamAccept === null || this.organizationAccept === null) && this.teamAccept !== false && this.organizationAccept !== false;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentInvite, "toFront", null);
__decorate([
    ToBackHook
], TournamentInvite, "toBack", null);
TournamentInvite = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team: 'team',
            tournament: 'tournament',
            team_accept: 'teamAccept',
            organization_accept: 'organizationAccept',
            user_invites_count: 'userInvitesCount',
            user_invites: 'userInvites',
            notifications_count: 'notificationsCount',
        },
        relation: {
            team: Team,
            tournament: Tournament,
            userInvites: TournamentTeamUserInvite,
        }
    })
], TournamentInvite);

var NotificationType;
(function (NotificationType) {
    NotificationType[NotificationType["team_updated"] = 1] = "team_updated";
    NotificationType[NotificationType["team_invited"] = 2] = "team_invited";
    NotificationType[NotificationType["team_join_request"] = 3] = "team_join_request";
    NotificationType[NotificationType["team_join_declined_by_team"] = 4] = "team_join_declined_by_team";
    NotificationType[NotificationType["team_join_declined_by_user"] = 5] = "team_join_declined_by_user";
    NotificationType[NotificationType["team_join_canceled_by_team"] = 6] = "team_join_canceled_by_team";
    NotificationType[NotificationType["team_join_canceled_by_user"] = 7] = "team_join_canceled_by_user";
    NotificationType[NotificationType["team_joined_for_user"] = 8] = "team_joined_for_user";
    NotificationType[NotificationType["team_joined_for_team"] = 9] = "team_joined_for_team";
    NotificationType[NotificationType["team_user_role_changed_for_user"] = 10] = "team_user_role_changed_for_user";
    NotificationType[NotificationType["team_user_role_changed_for_team"] = 11] = "team_user_role_changed_for_team";
    NotificationType[NotificationType["team_user_number_changed"] = 12] = "team_user_number_changed";
    NotificationType[NotificationType["team_user_deleted_for_user"] = 13] = "team_user_deleted_for_user";
    NotificationType[NotificationType["team_user_deleted_for_team"] = 14] = "team_user_deleted_for_team";
    NotificationType[NotificationType["team_user_left"] = 15] = "team_user_left";
    NotificationType[NotificationType["game_updated"] = 16] = "game_updated";
    NotificationType[NotificationType["game_invited"] = 17] = "game_invited";
    NotificationType[NotificationType["game_invite_accepted"] = 18] = "game_invite_accepted";
    NotificationType[NotificationType["game_invite_declined"] = 19] = "game_invite_declined";
    NotificationType[NotificationType["game_remind"] = 20] = "game_remind";
    NotificationType[NotificationType["game_won"] = 21] = "game_won";
    NotificationType[NotificationType["game_losing"] = 22] = "game_losing";
    NotificationType[NotificationType["game_tech_defeat"] = 23] = "game_tech_defeat";
    NotificationType[NotificationType["game_tech_victory"] = 24] = "game_tech_victory";
    NotificationType[NotificationType["poll_created"] = 25] = "poll_created";
    NotificationType[NotificationType["poll_closed"] = 26] = "poll_closed";
    NotificationType[NotificationType["team_event_invited"] = 27] = "team_event_invited";
    NotificationType[NotificationType["team_event_accepted"] = 28] = "team_event_accepted";
    NotificationType[NotificationType["team_event_declined"] = 29] = "team_event_declined";
    NotificationType[NotificationType["team_event_remind"] = 30] = "team_event_remind";
    NotificationType[NotificationType["tournament_invited"] = 31] = "tournament_invited";
    NotificationType[NotificationType["tournament_joined"] = 32] = "tournament_joined";
    NotificationType[NotificationType["tournament_join_declined"] = 33] = "tournament_join_declined";
    NotificationType[NotificationType["tournament_join_canceled"] = 34] = "tournament_join_canceled";
    NotificationType[NotificationType["tournament_user_invited"] = 35] = "tournament_user_invited";
    NotificationType[NotificationType["tournament_user_accepted_for_team"] = 36] = "tournament_user_accepted_for_team";
    NotificationType[NotificationType["tournament_user_accepted_for_user"] = 37] = "tournament_user_accepted_for_user";
    NotificationType[NotificationType["tournament_user_added"] = 38] = "tournament_user_added";
    NotificationType[NotificationType["tournament_user_declined_for_team"] = 39] = "tournament_user_declined_for_team";
    NotificationType[NotificationType["tournament_user_declined_for_user"] = 40] = "tournament_user_declined_for_user";
    NotificationType[NotificationType["tournament_user_invite_deleted"] = 41] = "tournament_user_invite_deleted";
    NotificationType[NotificationType["tournament_user_deleted"] = 42] = "tournament_user_deleted";
    NotificationType[NotificationType["tournament_user_disqualified_for_team"] = 43] = "tournament_user_disqualified_for_team";
    NotificationType[NotificationType["tournament_user_disqualified_for_user"] = 44] = "tournament_user_disqualified_for_user";
    NotificationType[NotificationType["tournament_user_disqualification_updated_for_team"] = 45] = "tournament_user_disqualification_updated_for_team";
    NotificationType[NotificationType["tournament_user_disqualification_updated_for_user"] = 46] = "tournament_user_disqualification_updated_for_user";
    NotificationType[NotificationType["tournament_team_deleted"] = 47] = "tournament_team_deleted";
    NotificationType[NotificationType["org_tournament_invite_created"] = 48] = "org_tournament_invite_created";
    NotificationType[NotificationType["org_tournament_invite_declined"] = 49] = "org_tournament_invite_declined";
    NotificationType[NotificationType["org_tournament_invite_deleted"] = 50] = "org_tournament_invite_deleted";
    NotificationType[NotificationType["org_tournament_invite_changed"] = 51] = "org_tournament_invite_changed";
    NotificationType[NotificationType["org_tournament_user_deleted"] = 52] = "org_tournament_user_deleted";
    NotificationType[NotificationType["org_tournament_user_invited"] = 53] = "org_tournament_user_invited";
    NotificationType[NotificationType["org_tournament_user_has_changes"] = 54] = "org_tournament_user_has_changes";
    NotificationType[NotificationType["org_tournament_team_leave"] = 55] = "org_tournament_team_leave";
})(NotificationType || (NotificationType = {}));
var NotificationServiceEnum;
(function (NotificationServiceEnum) {
    NotificationServiceEnum[NotificationServiceEnum["public"] = 1] = "public";
    NotificationServiceEnum[NotificationServiceEnum["org"] = 2] = "org";
})(NotificationServiceEnum || (NotificationServiceEnum = {}));
let Notification = class Notification extends BaseModel {
    get important() {
        return true;
    }
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], Notification, "toFront", null);
__decorate([
    ToBackHook
], Notification, "toBack", null);
Notification = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            event_type: 'event',
            data: 'data',
            initiator: 'initiator',
            team: 'team',
            team_invite: 'teamInvite',
            team_user: 'teamUser',
            poll: 'poll',
            game: 'game',
            game_invite: 'gameInvite',
            team_event: 'teamEvent',
            team_event_invite: 'teamEventInvite',
            tournament: 'tournament',
            tournament_invite: 'tournamentInvite',
            tournament_team: 'tournamentTeam',
            viewed: 'viewed',
            protected: 'protected',
            service: 'service',
            created_at: 'createdAt',
        },
        relation: {
            event: enumField(NotificationType),
            initiator: User,
            team: Team,
            teamInvite: TeamInvite,
            teamUser: TeamUser,
            poll: Poll,
            game: Game,
            gameInvite: GameInvite,
            teamEvent: TeamEvent,
            teamEventInvite: TeamEventInvite,
            tournament: Tournament,
            tournamentInvite: TournamentInvite,
            tournamentTeam: TournamentTeam,
            service: enumField(NotificationServiceEnum),
            createdAt: DateTimeField,
        }
    })
], Notification);

var NotificationAllowTypes;
(function (NotificationAllowTypes) {
    NotificationAllowTypes[NotificationAllowTypes["all"] = 1] = "all";
    NotificationAllowTypes[NotificationAllowTypes["important"] = 2] = "important";
    NotificationAllowTypes[NotificationAllowTypes["none"] = 3] = "none";
})(NotificationAllowTypes || (NotificationAllowTypes = {}));
let NotificationSettings = class NotificationSettings extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], NotificationSettings, "toFront", null);
__decorate([
    ToBackHook
], NotificationSettings, "toBack", null);
NotificationSettings = __decorate([
    ModelInstance({
        mappingFields: {
            user_id: 'userId',
            popup: 'popup',
            sound: 'sound',
            browser: 'browser',
            email: 'email'
        },
        relation: {
            sound: enumField(NotificationAllowTypes),
            browser: enumField(NotificationAllowTypes),
        }
    })
], NotificationSettings);

class NotificationBaseApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getCount() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}${this.apiUrl}/notification/count/`)
                .pipe(map(data => +data))
                .toPromise();
        });
    }
    getList(page, size, filters = {}) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams()
                .set('page', page.toString())
                .set('size', size.toString());
            for (const key of Object.keys(filters)) {
                params = params.set(key, filters[key]);
            }
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}${this.apiUrl}/notification/`, { params, observe: 'response' })
                .pipe(map(response => {
                const data = Notification.toFront(response.body);
                return {
                    total: +response.headers.get('x-page-count'),
                    data
                };
            })).toPromise();
        });
    }
    markViewed(notificationId, viewed) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}${this.apiUrl}/notification/${notificationId}/viewed/`, { viewed })
                .pipe(map(data => Notification.toFront(data)))
                .toPromise();
        });
    }
    markAllViewed() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}${this.apiUrl}/notification/viewed/`, {})
                .pipe(map(data => Notification.toFront(data)))
                .toPromise();
        });
    }
    getNotificationSettings() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}${this.apiUrl}/notification_settings/`)
                .pipe(map(data => NotificationSettings.toFront(data)))
                .toPromise();
        });
    }
    updateNotificationSettings(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.post(`${this.configService.get('apiUrl')}${this.apiUrl}/notification_settings/`, NotificationSettings.toBack(data))
                .pipe(map(result => NotificationSettings.toFront(result)))
                .toPromise();
        });
    }
}
NotificationBaseApi.ɵfac = function NotificationBaseApi_Factory(t) { return new (t || NotificationBaseApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
NotificationBaseApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function NotificationBaseApi_Factory() { return new NotificationBaseApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: NotificationBaseApi, providedIn: "root" });
NotificationBaseApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class NotificationApi extends NotificationBaseApi {
    constructor() {
        super(...arguments);
        this.apiUrl = '/api/v1';
    }
}
NotificationApi.ɵfac = /*@__PURE__*/ function () { let ɵNotificationApi_BaseFactory; return function NotificationApi_Factory(t) { return (ɵNotificationApi_BaseFactory || (ɵNotificationApi_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(NotificationApi)))(t || NotificationApi); }; }();
NotificationApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function NotificationApi_Factory() { return new NotificationApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: NotificationApi, providedIn: "root" });

class OrgNotificationApi extends NotificationBaseApi {
    constructor() {
        super(...arguments);
        this.apiUrl = '/org/api/v1';
    }
}
OrgNotificationApi.ɵfac = /*@__PURE__*/ function () { let ɵOrgNotificationApi_BaseFactory; return function OrgNotificationApi_Factory(t) { return (ɵOrgNotificationApi_BaseFactory || (ɵOrgNotificationApi_BaseFactory = ɵngcc0.ɵɵgetInheritedFactory(OrgNotificationApi)))(t || OrgNotificationApi); }; }();
OrgNotificationApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function OrgNotificationApi_Factory() { return new OrgNotificationApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: OrgNotificationApi, providedIn: "root" });

class ReferenceApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getCities() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/reference/cities/`)
                .pipe(map(data => City.toFront(data))).toPromise();
        });
    }
    getSports() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/sport/`)
                .pipe(map(data => Sport.toFront(data))).toPromise();
        });
    }
}
ReferenceApi.ɵfac = function ReferenceApi_Factory(t) { return new (t || ReferenceApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
ReferenceApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function ReferenceApi_Factory() { return new ReferenceApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: ReferenceApi, providedIn: "root" });
ReferenceApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let RugbyGameTeamStatistic = class RugbyGameTeamStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], RugbyGameTeamStatistic, "toFront", null);
__decorate([
    ToBackHook
], RugbyGameTeamStatistic, "toBack", null);
RugbyGameTeamStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            competitor_team: 'competitorTeam'
        },
        relation: {
            team: RugbyStatistic,
            competitorTeam: RugbyStatistic
        }
    })
], RugbyGameTeamStatistic);

let RugbyGameStatistic = class RugbyGameStatistic extends BaseModel {
    get id() {
        return this.gameUserId;
    }
    get gameMinutes() {
        return Math.floor(this.gameTime / 60);
    }
    get conversionKicks() {
        return (this.conversionGoals || 0) + (this.conversionMisses || 0);
    }
    get conversionGoalsPercent() {
        if (!this.conversionKicks) {
            return 0;
        }
        return Math.floor(1000 * this.conversionGoals / this.conversionKicks) / 10;
    }
    get penaltyKicksOnGoal() {
        return (this.penaltyGoals || 0) + (this.penaltyMisses || 0);
    }
    get penaltyGoalsPercent() {
        if (!this.penaltyKicksOnGoal) {
            return 0;
        }
        return Math.floor(1000 * this.penaltyGoals / this.penaltyKicksOnGoal) / 10;
    }
    get dropGoalKicks() {
        return (this.dropGoals || 0) + (this.dropGoalMisses || 0);
    }
    get dropGoalsPercent() {
        if (!this.dropGoalKicks) {
            return 0;
        }
        return Math.floor(1000 * this.dropGoals / this.dropGoalKicks) / 10;
    }
    get totalGoals() {
        return (this.conversionGoals || 0) + (this.dropGoals || 0) + (this.penaltyGoals || 0);
    }
    get footShots() {
        return (this.footFieldShots || 0) + (this.footOutShots || 0) + (this.footKicks5022 || 0);
    }
    get totalFouls() {
        return (this.fouls || 0) + (this.teamFouls || 0);
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], RugbyGameStatistic, "toFront", null);
__decorate([
    ToBackHook
], RugbyGameStatistic, "toBack", null);
RugbyGameStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            game_user_id: 'gameUserId',
            updated_at: 'updatedAt',
            points: 'points',
            tries: 'tries',
            penalty_tries: 'penaltyTries',
            conversion_goals: 'conversionGoals',
            conversion_misses: 'conversionMisses',
            penalty_misses: 'penaltyMisses',
            penalty_goals: 'penaltyGoals',
            drop_goals: 'dropGoals',
            drop_goal_misses: 'dropGoalMisses',
            free_kicks: 'freeKicks',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            offloads: 'offloads',
            tackles: 'tackles',
            handling_errors: 'handlingErrors',
            carries_over_gainline: 'carriesOverGainline',
            foot_field_shots: 'footFieldShots',
            foot_out_shots: 'footOutShots',
            foot_kicks_50_22: 'footKicks5022',
            fouls: 'fouls',
            team_fouls: 'teamFouls',
            outs: 'outs',
            runs: 'runs',
            game_time: 'gameTime',
            plus_minus: 'plusMinus'
        },
        relation: {
            updatedAt: DateTimeField,
        }
    })
], RugbyGameStatistic);

var RugbyFoulSanctions;
(function (RugbyFoulSanctions) {
    RugbyFoulSanctions[RugbyFoulSanctions["scrum"] = 1] = "scrum";
    RugbyFoulSanctions[RugbyFoulSanctions["lineout"] = 2] = "lineout";
    RugbyFoulSanctions[RugbyFoulSanctions["free_kick"] = 3] = "free_kick";
    RugbyFoulSanctions[RugbyFoulSanctions["penalty_shot"] = 4] = "penalty_shot";
    RugbyFoulSanctions[RugbyFoulSanctions["yellow_card"] = 5] = "yellow_card";
    RugbyFoulSanctions[RugbyFoulSanctions["red_card"] = 6] = "red_card";
    RugbyFoulSanctions[RugbyFoulSanctions["start_kick"] = 7] = "start_kick";
    RugbyFoulSanctions[RugbyFoulSanctions["twenty_two_meters_kick"] = 8] = "twenty_two_meters_kick";
    RugbyFoulSanctions[RugbyFoulSanctions["conversion_cancel"] = 9] = "conversion_cancel";
})(RugbyFoulSanctions || (RugbyFoulSanctions = {}));
var RugbyFoulGameStage;
(function (RugbyFoulGameStage) {
    RugbyFoulGameStage[RugbyFoulGameStage["start_kick"] = 1] = "start_kick";
    RugbyFoulGameStage[RugbyFoulGameStage["open_game"] = 2] = "open_game";
    RugbyFoulGameStage[RugbyFoulGameStage["tackle"] = 3] = "tackle";
    RugbyFoulGameStage[RugbyFoulGameStage["ruck_or_maul"] = 4] = "ruck_or_maul";
    RugbyFoulGameStage[RugbyFoulGameStage["scrum"] = 5] = "scrum";
    RugbyFoulGameStage[RugbyFoulGameStage["out_and_lineout"] = 6] = "out_and_lineout";
    RugbyFoulGameStage[RugbyFoulGameStage["scoring_field"] = 7] = "scoring_field";
    RugbyFoulGameStage[RugbyFoulGameStage["kick_on_goal"] = 8] = "kick_on_goal";
    RugbyFoulGameStage[RugbyFoulGameStage["free_kick"] = 9] = "free_kick";
    RugbyFoulGameStage[RugbyFoulGameStage["team"] = 10] = "team";
})(RugbyFoulGameStage || (RugbyFoulGameStage = {}));
let RugbyFoulType = class RugbyFoulType extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], RugbyFoulType, "toFront", null);
__decorate([
    ToBackHook
], RugbyFoulType, "toBack", null);
RugbyFoulType = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            sanction: 'sanction',
            game_stage: 'gameStage',
        },
        relation: {
            sanction: listField(enumField(RugbyFoulSanctions)),
            gameStage: enumField(RugbyFoulGameStage),
        }
    })
], RugbyFoulType);

var RugbyGameLogTypes;
(function (RugbyGameLogTypes) {
    RugbyGameLogTypes[RugbyGameLogTypes["enter_game"] = 1] = "enter_game";
    RugbyGameLogTypes[RugbyGameLogTypes["exit_game"] = 2] = "exit_game";
    RugbyGameLogTypes[RugbyGameLogTypes["try"] = 3] = "try";
    RugbyGameLogTypes[RugbyGameLogTypes["penalty_try"] = 4] = "penalty_try";
    RugbyGameLogTypes[RugbyGameLogTypes["conversion_goal"] = 5] = "conversion_goal";
    RugbyGameLogTypes[RugbyGameLogTypes["conversion_miss"] = 6] = "conversion_miss";
    RugbyGameLogTypes[RugbyGameLogTypes["penalty_miss"] = 7] = "penalty_miss";
    RugbyGameLogTypes[RugbyGameLogTypes["penalty_goal"] = 8] = "penalty_goal";
    RugbyGameLogTypes[RugbyGameLogTypes["drop_goal"] = 9] = "drop_goal";
    RugbyGameLogTypes[RugbyGameLogTypes["drop_goal_miss"] = 10] = "drop_goal_miss";
    RugbyGameLogTypes[RugbyGameLogTypes["free_kick"] = 11] = "free_kick";
    RugbyGameLogTypes[RugbyGameLogTypes["foul"] = 12] = "foul";
    RugbyGameLogTypes[RugbyGameLogTypes["yellow_card"] = 13] = "yellow_card";
    RugbyGameLogTypes[RugbyGameLogTypes["red_card"] = 14] = "red_card";
    RugbyGameLogTypes[RugbyGameLogTypes["offload"] = 15] = "offload";
    RugbyGameLogTypes[RugbyGameLogTypes["tackle"] = 16] = "tackle";
    RugbyGameLogTypes[RugbyGameLogTypes["handling_error"] = 17] = "handling_error";
    RugbyGameLogTypes[RugbyGameLogTypes["carries_over_gainline"] = 18] = "carries_over_gainline";
    RugbyGameLogTypes[RugbyGameLogTypes["bleeding_injury"] = 19] = "bleeding_injury";
    RugbyGameLogTypes[RugbyGameLogTypes["head_injury"] = 20] = "head_injury";
    RugbyGameLogTypes[RugbyGameLogTypes["end_game_penalty_miss"] = 21] = "end_game_penalty_miss";
    RugbyGameLogTypes[RugbyGameLogTypes["end_game_penalty_goal"] = 22] = "end_game_penalty_goal";
    RugbyGameLogTypes[RugbyGameLogTypes["foot_field_shot"] = 23] = "foot_field_shot";
    RugbyGameLogTypes[RugbyGameLogTypes["foot_out_shot"] = 24] = "foot_out_shot";
    RugbyGameLogTypes[RugbyGameLogTypes["foot_kick_50_22"] = 25] = "foot_kick_50_22";
    RugbyGameLogTypes[RugbyGameLogTypes["run"] = 26] = "run";
    // team actions
    RugbyGameLogTypes[RugbyGameLogTypes["timeout"] = 27] = "timeout";
    RugbyGameLogTypes[RugbyGameLogTypes["tap_penalty"] = 28] = "tap_penalty";
    RugbyGameLogTypes[RugbyGameLogTypes["penalty_kick_to_touch"] = 29] = "penalty_kick_to_touch";
    RugbyGameLogTypes[RugbyGameLogTypes["scrum_won"] = 30] = "scrum_won";
    RugbyGameLogTypes[RugbyGameLogTypes["scrum_lost"] = 31] = "scrum_lost";
    RugbyGameLogTypes[RugbyGameLogTypes["scrum_won_free"] = 32] = "scrum_won_free";
    RugbyGameLogTypes[RugbyGameLogTypes["lineout_won"] = 33] = "lineout_won";
    RugbyGameLogTypes[RugbyGameLogTypes["lineout_lost"] = 34] = "lineout_lost";
    RugbyGameLogTypes[RugbyGameLogTypes["quick_throw"] = 35] = "quick_throw";
    RugbyGameLogTypes[RugbyGameLogTypes["ruck_won"] = 36] = "ruck_won";
    RugbyGameLogTypes[RugbyGameLogTypes["ruck_lost"] = 37] = "ruck_lost";
    RugbyGameLogTypes[RugbyGameLogTypes["maul_won"] = 38] = "maul_won";
    RugbyGameLogTypes[RugbyGameLogTypes["maul_lost"] = 39] = "maul_lost";
    RugbyGameLogTypes[RugbyGameLogTypes["team_foul"] = 40] = "team_foul";
    RugbyGameLogTypes[RugbyGameLogTypes["start_kick"] = 41] = "start_kick";
    RugbyGameLogTypes[RugbyGameLogTypes["twenty_two_meters_kick"] = 42] = "twenty_two_meters_kick";
    RugbyGameLogTypes[RugbyGameLogTypes["goal_kick"] = 43] = "goal_kick";
    RugbyGameLogTypes[RugbyGameLogTypes["out"] = 44] = "out";
})(RugbyGameLogTypes || (RugbyGameLogTypes = {}));
const RUGBY_GAME_LOG_TYPE_POINTS = {
    [RugbyGameLogTypes.penalty_try]: 7,
    [RugbyGameLogTypes.try]: 5,
    [RugbyGameLogTypes.conversion_goal]: 2,
    [RugbyGameLogTypes.penalty_goal]: 3,
    [RugbyGameLogTypes.drop_goal]: 3,
    [RugbyGameLogTypes.end_game_penalty_goal]: 1, // Не влияет на общий счет
};
const RUGBY_TEAM_LOG_TYPES = [
    RugbyGameLogTypes.timeout, RugbyGameLogTypes.scrum_won, RugbyGameLogTypes.scrum_lost, RugbyGameLogTypes.scrum_won_free,
    RugbyGameLogTypes.lineout_won, RugbyGameLogTypes.lineout_lost,
    RugbyGameLogTypes.quick_throw, RugbyGameLogTypes.ruck_won, RugbyGameLogTypes.ruck_lost,
    RugbyGameLogTypes.maul_won, RugbyGameLogTypes.maul_lost, RugbyGameLogTypes.team_foul,
    RugbyGameLogTypes.penalty_kick_to_touch, RugbyGameLogTypes.tap_penalty,
    RugbyGameLogTypes.start_kick, RugbyGameLogTypes.twenty_two_meters_kick, RugbyGameLogTypes.goal_kick,
    RugbyGameLogTypes.penalty_try, RugbyGameLogTypes.out
];
let RugbyGameLog = class RugbyGameLog extends BaseModel {
    constructor() {
        super(...arguments);
        this.active = true;
    }
    compare(model) {
        if (this.time === model.time && this.period === model.period) {
            return this.datetime.getTime() < model.datetime.getTime() ? 1 : -1;
        }
        if (this.period === model.period) {
            return this.time < model.time ? 1 : -1;
        }
        return this.period < model.period ? 1 : -1;
    }
    get timeFormatted() {
        const minutes = Math.floor(this.time / 60);
        const seconds = this.time - minutes * 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
    isScoreType() {
        return RUGBY_GAME_LOG_TYPE_POINTS[this.logType] !== undefined;
    }
    scorePoints() {
        return RUGBY_GAME_LOG_TYPE_POINTS[this.logType];
    }
    isAfter(log) {
        if (this.time === log.time && this.period === log.period) {
            return this.id > log.id;
        }
        if (this.period === log.period) {
            return this.time > log.time;
        }
        return this.period > log.period;
    }
    isFoulType() {
        return [RugbyGameLogTypes.team_foul, RugbyGameLogTypes.foul].indexOf(this.logType) > -1;
    }
    isTeamType() {
        return RUGBY_TEAM_LOG_TYPES.includes(this.logType);
    }
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], RugbyGameLog, "toFront", null);
__decorate([
    ToBackHook
], RugbyGameLog, "toBack", null);
RugbyGameLog = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            unique_id: 'uniqueId',
            group: 'group',
            game_id: 'gameId',
            game_user_id: 'gameUserId',
            team_id: 'teamId',
            log_type: 'logType',
            datetime: 'datetime',
            time: 'time',
            period: 'period',
            active: 'active',
            is_highlight: 'isHighlight',
            foul_type: 'foulType',
            foul_sanction: 'foulSanction',
            foul_game_stage: 'foulGameStage',
        },
        relation: {
            datetime: DateTimeField,
            logType: enumField(RugbyGameLogTypes),
            foulType: RugbyFoulType,
            foulSanction: enumField(RugbyFoulSanctions),
            foulGameStage: enumField(RugbyFoulGameStage),
        }
    })
], RugbyGameLog);

class RugbyGameApi extends GameBaseApi {
    constructor(httpClient, configService) {
        super(httpClient, configService);
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getTeamStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/team_statistic/`).pipe(map(result => RugbyGameTeamStatistic.toFront(result))).toPromise();
        });
    }
    getUserStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/user_statistic/`).pipe(map(result => RugbyGameStatistic.toFront(result))).toPromise();
        });
    }
    getLogs(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/logs/`).pipe(map(result => RugbyGameLog.toFront(result))).toPromise();
        });
    }
    getFoulTypes() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/foul_types/`).pipe(map(result => RugbyFoulType.toFront(result))).toPromise();
        });
    }
    downloadProtocol(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_rugby_game/${gameId}/game_protocol/`, {
                params: new HttpParams().set('file_type', 'pdf'),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
RugbyGameApi.ɵfac = function RugbyGameApi_Factory(t) { return new (t || RugbyGameApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
RugbyGameApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function RugbyGameApi_Factory() { return new RugbyGameApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: RugbyGameApi, providedIn: "root" });
RugbyGameApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let TeamInviteExternal = class TeamInviteExternal extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamInviteExternal, "toFront", null);
__decorate([
    ToBackHook
], TeamInviteExternal, "toBack", null);
TeamInviteExternal = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team_id: 'teamId',
            email: 'email',
            first_name: 'firstName',
            last_name: 'lastName',
        },
    })
], TeamInviteExternal);

var TeamPermissionTypes;
(function (TeamPermissionTypes) {
    TeamPermissionTypes[TeamPermissionTypes["for_all"] = 1] = "for_all";
    TeamPermissionTypes[TeamPermissionTypes["for_users"] = 2] = "for_users";
    TeamPermissionTypes[TeamPermissionTypes["for_team"] = 3] = "for_team";
})(TeamPermissionTypes || (TeamPermissionTypes = {}));
let TeamPermission = class TeamPermission extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamPermission, "toFront", null);
__decorate([
    ToBackHook
], TeamPermission, "toBack", null);
TeamPermission = __decorate([
    ModelInstance({
        mappingFields: {
            players: 'players',
            games: 'games',
            statistic: 'statistic',
            polls: 'polls',
            events: 'events'
        },
        relation: {
            players: enumField(TeamPermissionTypes),
            games: enumField(TeamPermissionTypes),
            statistic: enumField(TeamPermissionTypes),
            polls: enumField(TeamPermissionTypes),
            events: enumField(TeamPermissionTypes)
        }
    })
], TeamPermission);

let TeamAccess = class TeamAccess extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TeamAccess, "toFront", null);
__decorate([
    ToBackHook
], TeamAccess, "toBack", null);
TeamAccess = __decorate([
    ModelInstance({
        mappingFields: {
            can_edit: 'canEdit',
            can_view_users: 'canViewUsers',
            can_manage_permission: 'canManagePermission',
            can_change_owner: 'canChangeOwner',
            can_delete: 'canDelete',
            can_manage_invites: 'canManageInvites',
            can_view_invites: 'canViewInvites',
            can_manage_polls: 'canManagePolls',
            can_view_polls: 'canViewPolls',
            can_answer_poll: 'canAnswerPoll',
            can_manage_games: 'canManageGames',
            can_view_games: 'canViewGames',
            can_view_statistic: 'canViewStatistic',
            can_promote_users: 'canPromoteUsers',
            can_edit_users: 'canEditUsers',
            can_delete_users: 'canDeleteUsers',
            can_view_events: 'canViewEvents',
            can_manage_events: 'canManageEvents',
            can_view_tournaments: 'canViewTournaments',
            can_manage_tournaments: 'canManageTournaments',
            role: 'role'
        },
        relation: {
            role: enumField(TeamUserRole)
        }
    })
], TeamAccess);

class TeamApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    search(query, sportId) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = (new HttpParams()).set('search', query);
            if (sportId) {
                params = params.set('sport', sportId.toString());
            }
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/`, { params })
                .pipe(map(data => Team.toFront(data)))
                .toPromise();
        });
    }
    create(team) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/`, Team.toBack(team))
                .pipe(map(data => Team.toFront(data)))
                .toPromise();
        });
    }
    getById(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/`)
                .pipe(map(data => Team.toFront(data)))
                .toPromise();
        });
    }
    getTeamAccess(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/access/`)
                .pipe(map(data => TeamAccess.toFront(data)))
                .toPromise();
        });
    }
    update(teamId, values) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/`, Team.toBack(values))
                .pipe(map(data => Team.toFront(data)))
                .toPromise();
        });
    }
    delete(team) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .delete(`${this.configService.get('apiUrl')}/api/v1/team/${team.id}/`)
                .toPromise();
        });
    }
    getPermission(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/permission/`)
                .pipe(map(data => TeamPermission.toFront(data)))
                .toPromise();
        });
    }
    updatePermission(teamId, permission) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/permission/`, TeamPermission.toBack(permission))
                .pipe(map(data => TeamPermission.toFront(data)))
                .toPromise();
        });
    }
    getUsers(teamId, tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (tournamentId) {
                params = params.set('tournament_id', tournamentId.toString());
            }
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/users/`, { params })
                .pipe(map(data => TeamUser.toFront(data)))
                .toPromise();
        });
    }
    updateUserRole(teamId, teamUserId, role) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/users/${teamUserId}/role/`, { role: TeamUserRole[role] })
                .pipe(map(data => TeamUser.toFront(data)))
                .toPromise();
        });
    }
    updateUserNumber(teamId, teamUserId, gameNumber) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/users/${teamUserId}/number/`, { number: gameNumber.toString() })
                .pipe(map(data => TeamUser.toFront(data)))
                .toPromise();
        });
    }
    deleteUser(teamUser) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .delete(`${this.configService.get('apiUrl')}/api/v1/team/${teamUser.teamId}/users/${teamUser.id}/`)
                .toPromise();
        });
    }
    changeOwner(teamId, user) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/owner/`, { id: user.id })
                .pipe(map(data => Team.toFront(data)))
                .toPromise();
        });
    }
    getInvites(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/invites/`)
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    sendInvite(teamId, user) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/invites/`, { user })
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    acceptInvite(invite) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team_invite/${invite.id}/accept/`, {})
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    declineInvite(invite) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team_invite/${invite.id}/decline/`, {})
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    resendInvite(invite) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team_invite/${invite.id}/resend/`, {})
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    getInvitesExternal(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/invites_external/`)
                .pipe(map(data => TeamInviteExternal.toFront(data)))
                .toPromise();
        });
    }
    sendInviteExternal(teamId, invite) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/invites_external/`, TeamInviteExternal.toBack(invite))
                .pipe(map(data => TeamInviteExternal.toFront(data)))
                .toPromise();
        });
    }
    deleteInviteExternal(invite) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .delete(`${this.configService.get('apiUrl')}/api/v1/invites_external/${invite.id}/`)
                .toPromise();
        });
    }
    resendInviteExternal(invite) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/invites_external/${invite.id}/resend/`, {})
                .pipe(map(data => TeamInviteExternal.toFront(data)))
                .toPromise();
        });
    }
    getPolls(teamId, archive = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/polls/${archive ? '?archive=1' : ''}`)
                .pipe(map(data => Poll.toFront(data)))
                .toPromise();
        });
    }
    createPoll(teamId, poll) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/polls/`, Poll.toBack(poll))
                .pipe(map(data => Poll.toFront(data)))
                .toPromise();
        });
    }
    getUsersStatistic(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/statistics/`)
                .pipe(map(data => BasketballStatistic.toFront(data)))
                .toPromise();
        });
    }
    getVolleyballStatistic(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/volleyball_statistics/`)
                .pipe(map(data => VolleyballStatistic.toFront(data)))
                .toPromise();
        });
    }
    joinTeam(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/join/`, {})
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    leaveTeam(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/leave/`, {})
                .toPromise();
        });
    }
    getGames(teamId, archive = false) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/games/${archive ? '?archive=1' : ''}`)
                .pipe(map(data => Game.toFront(data)))
                .toPromise();
        });
    }
    createGame(teamId, game) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/games/`, Game.toBack(game))
                .pipe(map(data => Game.toFront(data)))
                .toPromise();
        });
    }
    getTeamEvents(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/events/`)
                .pipe(map(data => TeamEvent.toFront(data)))
                .toPromise();
        });
    }
    createTeamEvent(teamId, teamEvent) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/events/`, TeamEvent.toBack(teamEvent))
                .pipe(map(data => TeamEvent.toFront(data)))
                .toPromise();
        });
    }
    getTournaments(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/tournaments/`)
                .pipe(map(data => Tournament.toFront(data)))
                .toPromise();
        });
    }
    getTournamentTeams(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/tournament_teams/`)
                .pipe(map(data => TournamentTeam.toFront(data)))
                .toPromise();
        });
    }
    getTournamentInvites(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/tournament_invites/`)
                .pipe(map(data => TournamentInvite.toFront(data)))
                .toPromise();
        });
    }
    getTournamentGames(teamId, tournamentId, page, size) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString());
            if (size) {
                params = params.set('size', size.toString());
            }
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/tournaments/${tournamentId}/games/`, { params, observe: 'response' })
                .pipe(map((response) => {
                return {
                    total: +response.headers.get('X-Page-Count'),
                    data: Game.toFront(response.body)
                };
            }))
                .toPromise();
        });
    }
    acceptTournamentInvite(inviteId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/tournament_invite/${inviteId}/accept/`, {})
                .pipe(map(data => TournamentInvite.toFront(data)))
                .toPromise();
        });
    }
    declineTournamentInvite(inviteId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/tournament_invite/${inviteId}/decline/`, {})
                .pipe(map(data => TournamentInvite.toFront(data)))
                .toPromise();
        });
    }
    registerLazyUser(teamId, userData) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/lazy_user/`, { user: User.toBack(userData) })
                .pipe(map(data => TeamUser.toFront(data)))
                .toPromise();
        });
    }
    getLazyUser(teamUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/lazy_user/${teamUserId}/`)
                .pipe(map(data => TeamUser.toFront(data)))
                .toPromise();
        });
    }
    updateLazyUser(teamUserId, userData) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/lazy_user/${teamUserId}/`, { user: User.toBack(userData) })
                .pipe(map(data => TeamUser.toFront(data)))
                .toPromise();
        });
    }
    deleteLazyUser(teamUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .delete(`${this.configService.get('apiUrl')}/api/v1/lazy_user/${teamUserId}/`)
                .toPromise();
        });
    }
    resendLazyUserEmail(teamUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/lazy_user/${teamUserId}/resend_email/`, {})
                .toPromise();
        });
    }
}
TeamApi.ɵfac = function TeamApi_Factory(t) { return new (t || TeamApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
TeamApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function TeamApi_Factory() { return new TeamApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: TeamApi, providedIn: "root" });
TeamApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class TeamEventApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getTeamEvent(teamEventId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEventId}/`)
                .pipe(map(data => TeamEvent.toFront(data)))
                .toPromise();
        });
    }
    updateTeamEvent(teamEvent) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEvent.id}/`, TeamEvent.toBack(teamEvent))
                .pipe(map(data => TeamEvent.toFront(data)))
                .toPromise();
        });
    }
    deleteTeamEvent(teamEventId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .delete(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEventId}/`)
                .toPromise();
        });
    }
    getTeamEventInvites(teamEventId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEventId}/invites/`)
                .pipe(map(data => TeamEventInvite.toFront(data)))
                .toPromise();
        });
    }
    createTeamEventInvite(teamEventId, teamUserId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team_event/${teamEventId}/invites/`, { team_user_id: teamUserId })
                .pipe(map(data => TeamEventInvite.toFront(data)))
                .toPromise();
        });
    }
    acceptTeamEventInvite(teamEventInvite) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team_event_invite/${teamEventInvite.id}/accept/`, {})
                .pipe(map(data => TeamEventInvite.toFront(data)))
                .toPromise();
        });
    }
    declineTeamEventInvite(teamEventInvite) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/team_event_invite/${teamEventInvite.id}/decline/`, {})
                .pipe(map(data => TeamEventInvite.toFront(data)))
                .toPromise();
        });
    }
}
TeamEventApi.ɵfac = function TeamEventApi_Factory(t) { return new (t || TeamEventApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
TeamEventApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function TeamEventApi_Factory() { return new TeamEventApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: TeamEventApi, providedIn: "root" });
TeamEventApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let TournamentJoinData = class TournamentJoinData extends BaseModel {
    get usersCount() {
        return this.validUsersCount + this.invalidUsersCount;
    }
    get valid() {
        return this.hasAccess && !this.inviteSent && !this.alreadyInTournament;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentJoinData, "toFront", null);
__decorate([
    ToBackHook
], TournamentJoinData, "toBack", null);
TournamentJoinData = __decorate([
    ModelInstance({
        mappingFields: {
            valid_users_count: 'validUsersCount',
            invalid_users_count: 'invalidUsersCount',
            has_access: 'hasAccess',
            invite_sent: 'inviteSent',
            already_in_tournament: 'alreadyInTournament'
        }
    })
], TournamentJoinData);
let TournamentJoinTeam = class TournamentJoinTeam extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentJoinTeam, "toFront", null);
__decorate([
    ToBackHook
], TournamentJoinTeam, "toBack", null);
TournamentJoinTeam = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            join_data: 'joinData'
        },
        relation: {
            team: Team,
            joinData: TournamentJoinData
        }
    })
], TournamentJoinTeam);

let TournamentJoin1x1Data = class TournamentJoin1x1Data extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentJoin1x1Data, "toFront", null);
__decorate([
    ToBackHook
], TournamentJoin1x1Data, "toBack", null);
TournamentJoin1x1Data = __decorate([
    ModelInstance({
        mappingFields: {
            email: 'email',
            phone: 'phone',
            gender: 'gender',
            birth_date: 'birthDate',
            size: 'size',
            nickname: 'nickname',
            city: 'city',
        },
        relation: {
            birthDate: DateField,
            gender: enumField(UserGender),
        }
    })
], TournamentJoin1x1Data);

var TournamentJoin1x1Status;
(function (TournamentJoin1x1Status) {
    TournamentJoin1x1Status[TournamentJoin1x1Status["not_sent"] = 1] = "not_sent";
    TournamentJoin1x1Status[TournamentJoin1x1Status["invite_sent"] = 2] = "invite_sent";
    TournamentJoin1x1Status[TournamentJoin1x1Status["in_tournament"] = 3] = "in_tournament";
    TournamentJoin1x1Status[TournamentJoin1x1Status["not_valid"] = 4] = "not_valid";
})(TournamentJoin1x1Status || (TournamentJoin1x1Status = {}));
class TournamentJoinApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getTeamsForJoin(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/teams_for_join/`).pipe(map(response => TournamentJoinTeam.toFront(response))).toPromise();
        });
    }
    getTeamUsers(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/team/${teamId}/users/`)
                .pipe(map(data => TeamUser.toFront(data))).toPromise();
        });
    }
    joinTournament(tournamentId, teamId, invites) {
        return __awaiter(this, void 0, void 0, function* () {
            const body = {
                team: { id: teamId },
                user_invites: TournamentTeamUserInvite.toBack(invites)
            };
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/join/`, body)
                .pipe(map(data => TournamentInvite.toFront(data)))
                .toPromise();
        });
    }
    join1x1Tournament(tournamentId, additionalData) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.post(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/join_1x1/`, TournamentJoin1x1Data.toBack(additionalData))
                .pipe(map(data => TournamentInvite.toFront(data)))
                .toPromise();
        });
    }
    join1x1TournamentStatus(tournamentId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament/${tournamentId}/join_1x1_status/`)
                .pipe(map((data) => TournamentJoin1x1Status[data.status]))
                .toPromise();
        });
    }
}
TournamentJoinApi.ɵfac = function TournamentJoinApi_Factory(t) { return new (t || TournamentJoinApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
TournamentJoinApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function TournamentJoinApi_Factory() { return new TournamentJoinApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: TournamentJoinApi, providedIn: "root" });
TournamentJoinApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let RoundTeamGame = class RoundTeamGame extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], RoundTeamGame, "toFront", null);
__decorate([
    ToBackHook
], RoundTeamGame, "toBack", null);
RoundTeamGame = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            team_id: 'teamId',
            competitor_team_id: 'competitorTeamId',
            team_score: 'teamScore',
            competitor_team_score: 'competitorTeamScore',
        }
    })
], RoundTeamGame);
let TournamentRoundTeam = class TournamentRoundTeam extends BaseModel {
    constructor() {
        super(...arguments);
        this.gamesMapping = {};
    }
    set games(value) {
        this._games = value;
        this.gamesMapping = value.reduce((acc, game) => {
            const competitorTeamId = game.teamId === this.tournamentTeam.team.id ? game.competitorTeamId : game.teamId;
            return Object.assign(Object.assign({}, acc), { [competitorTeamId]: [
                    ...(acc[competitorTeamId] || []),
                    game,
                ] });
        }, {});
    }
    get games() {
        return this._games;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], TournamentRoundTeam, "toFront", null);
__decorate([
    ToBackHook
], TournamentRoundTeam, "toBack", null);
TournamentRoundTeam = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            tournament_team: 'tournamentTeam',
            group: 'group',
            division: 'division',
            division_id: 'divisionId',
            points: 'points',
            handicap: 'handicap',
            games_count: 'gamesCount',
            won_games_count: 'wonGamesCount',
            lose_games_count: 'loseGamesCount',
            draw_games_count: 'drawGamesCount',
            score_sum: 'scoreSum',
            missed_sum: 'missedSum',
            games_won_percent: 'gamesWonPercent',
            score_points_sum: 'scorePointsSum',
            missed_points_sum: 'missedPointsSum',
            win_normal_time_games_count: 'winNormalTimeGamesCount',
            lose_normal_time_games_count: 'loseNormalTimeGamesCount',
            win_overtime_games_count: 'winOvertimeGamesCount',
            lose_overtime_games_count: 'loseOvertimeGamesCount',
            last_games_won: 'lastGamesWon',
            last_games_count: 'lastGamesCount',
            tries_scored: 'triesScored',
            tries_missed: 'triesMissed',
            attack_bonuses: 'attackBonuses',
            defense_bonuses: 'defenseBonuses',
            games_by_score_count: 'gamesByScoreCount',
            games: 'games',
        },
        relation: {
            group: TournamentGroup,
            division: TournamentDivision,
            tournamentTeam: TournamentTeam,
            games: listField(RoundTeamGame),
        }
    })
], TournamentRoundTeam);

class TournamentRoundApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(tournamentRoundId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_round/${tournamentRoundId}/`).pipe(map(data => TournamentRound.toFront(data))).toPromise();
        });
    }
    getTeams(tournamentRoundId, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (filters) {
                if (filters.divisionId) {
                    params = params.set('division_id', filters.divisionId);
                }
                if (filters.groupId) {
                    params = params.set('group_id', filters.groupId);
                }
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_round/${tournamentRoundId}/teams/`, { params }).pipe(map(data => TournamentRoundTeam.toFront(data))).toPromise();
        });
    }
    getPlayoffs(tournamentRoundId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_round/${tournamentRoundId}/playoffs/`).pipe(map(data => Playoff.toFront(data))).toPromise();
        });
    }
    getGroups(tournamentRoundId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_round/${tournamentRoundId}/groups/`).pipe(map(data => TournamentGroup.toFront(data))).toPromise();
        });
    }
    getGames(roundId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString());
            if (size) {
                params = params.set('size', size.toString());
            }
            params = applyGamesFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_round/${roundId}/games/`, { params, observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: Game.toFront(result.body)
            }))).toPromise();
        });
    }
}
TournamentRoundApi.ɵfac = function TournamentRoundApi_Factory(t) { return new (t || TournamentRoundApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
TournamentRoundApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function TournamentRoundApi_Factory() { return new TournamentRoundApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: TournamentRoundApi, providedIn: "root" });
TournamentRoundApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class TournamentSeasonApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getByAlias(leagueId, alias) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/league/${leagueId}/tournament_seasons/${alias}/`).pipe(map(result => TournamentSeason.toFront(result))).toPromise();
        });
    }
    getTournaments(seasonId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_season/${seasonId}/tournaments/`).pipe(map(result => Tournament.toFront(result))).toPromise();
        });
    }
    getGames(seasonId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString());
            if (size) {
                params = params.set('size', size.toString());
            }
            params = applyGamesFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_season/${seasonId}/games/`, { params, observe: 'response' }).pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: Game.toFront(result.body)
            }))).toPromise();
        });
    }
    getEvents(seasonId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString())
                .set('size', size.toString());
            if (filters) {
                if (filters.event) {
                    params = params.set('event', TournamentEventTypes[filters.event]);
                }
                if (filters.search) {
                    params = params.set('search', filters.search);
                }
                if (filters.tournamentTour) {
                    params = params.set('tournament_tour', filters.tournamentTour.toString());
                }
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_season/${seasonId}/events/`, { params, observe: 'response' })
                .pipe(map(result => ({
                total: +result.headers.get('X-Page-Count'),
                data: TournamentEvent.toFront(result.body)
            })))
                .toPromise();
        });
    }
    getGameMedia(seasonId, page, size, filters) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams().set('page', page.toString()).set('size', size.toString());
            params = applyGameMediaFilters(filters, params);
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_season/${seasonId}/game_media/`, { observe: 'response', params })
                .pipe(map(response => {
                return {
                    total: +response.headers.get('X-Page-Count'),
                    data: Game.toFront(response.body)
                };
            })).toPromise();
        });
    }
    getTeams(seasonId, short) {
        return __awaiter(this, void 0, void 0, function* () {
            let params = new HttpParams();
            if (short) {
                params = params.set('short', '1');
            }
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_season/${seasonId}/teams/`, { params }).pipe(map(result => TournamentTeam.toFront(result))).toPromise();
        });
    }
    getPlayoffs(seasonId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_season/${seasonId}/playoffs/`).pipe(map(result => Playoff.toFront(result))).toPromise();
        });
    }
    getGamesStages(seasonId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_season/${seasonId}/games_stages/`)
                .pipe(map(data => GameTimelineStages.toFront(data)))
                .toPromise();
        });
    }
}
TournamentSeasonApi.ɵfac = function TournamentSeasonApi_Factory(t) { return new (t || TournamentSeasonApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
TournamentSeasonApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function TournamentSeasonApi_Factory() { return new TournamentSeasonApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: TournamentSeasonApi, providedIn: "root" });
TournamentSeasonApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class TournamentStageApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(id) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${id}/`)
                .pipe(map(result => TournamentStage.toFront(result)))
                .toPromise();
        });
    }
    getGroups(stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${stageId}/groups/`)
                .pipe(map(result => TournamentGroup.toFront(result)))
                .toPromise();
        });
    }
    getTeamsAchievements(stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${stageId}/achievements/`)
                .pipe(map(result => TeamAchievement.toFront(result)))
                .toPromise();
        });
    }
    getPlayoffs(stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${stageId}/playoff/`)
                .pipe(map(result => Playoff.toFront(result)))
                .toPromise();
        });
    }
    getTeams(stageId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_stage/${stageId}/teams/`)
                .pipe(map(result => TournamentStageTeam.toFront(result)))
                .toPromise();
        });
    }
}
TournamentStageApi.ɵfac = function TournamentStageApi_Factory(t) { return new (t || TournamentStageApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
TournamentStageApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function TournamentStageApi_Factory() { return new TournamentStageApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: TournamentStageApi, providedIn: "root" });
TournamentStageApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let UserAccess = class UserAccess extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], UserAccess, "toFront", null);
__decorate([
    ToBackHook
], UserAccess, "toBack", null);
UserAccess = __decorate([
    ModelInstance({
        mappingFields: {
            edit: 'edit',
            personal_data: 'personalData',
            teams: 'teams',
            statistic: 'statistic',
            games: 'games'
        }
    })
], UserAccess);

var UserPermissionTypes;
(function (UserPermissionTypes) {
    UserPermissionTypes[UserPermissionTypes["denied"] = 1] = "denied";
    UserPermissionTypes[UserPermissionTypes["for_all"] = 2] = "for_all";
    UserPermissionTypes[UserPermissionTypes["for_users"] = 3] = "for_users";
    UserPermissionTypes[UserPermissionTypes["for_team"] = 4] = "for_team";
})(UserPermissionTypes || (UserPermissionTypes = {}));
let UserPermission = class UserPermission extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], UserPermission, "toFront", null);
__decorate([
    ToBackHook
], UserPermission, "toBack", null);
UserPermission = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            personal_data: 'personalData',
            games: 'games',
            teams: 'teams',
            statistic: 'statistic'
        },
        relation: {
            personalData: enumField(UserPermissionTypes),
            games: enumField(UserPermissionTypes),
            teams: enumField(UserPermissionTypes),
            statistic: enumField(UserPermissionTypes)
        }
    })
], UserPermission);

class UserApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getCurrentUser() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/current/`)
                .pipe(map(data => User.toFront(data)))
                .toPromise();
        });
    }
    getUserById(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/`)
                .pipe(map(data => User.toFront(data)))
                .toPromise();
        });
    }
    getAccess(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/user/${userId || 'current'}/access/`)
                .pipe(map(data => UserAccess.toFront(data)))
                .toPromise();
        });
    }
    updateUser(userId, data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/`, User.toBack(data))
                .pipe(map(result => User.toFront(result)))
                .toPromise();
        });
    }
    updateUserPhoto(file, filename) {
        return __awaiter(this, void 0, void 0, function* () {
            const formData = new FormData();
            formData.append('file', file, filename);
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/user/current/photo/`, formData)
                .pipe(map(data => File.toFront(data)))
                .toPromise();
        });
    }
    changePassword(userId, oldPassword, password, passwordConfirm) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = {
                old_password: oldPassword,
                password,
                password_confirm: passwordConfirm
            };
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/change_password/`, payload)
                .toPromise();
        });
    }
    changeEmail(userId, email, password) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = { email, password };
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/change_email/`, payload)
                .toPromise();
        });
    }
    changeEmailConfirm(userId, email, password, token) {
        return __awaiter(this, void 0, void 0, function* () {
            const payload = { email, password, token };
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/change_email_confirm/`, payload)
                .toPromise();
        });
    }
    getUserProfile(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/profile/`)
                .pipe(map(data => UserProfile.toFront(data)))
                .toPromise();
        });
    }
    getBasketballProfile(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/basketball_profile/`)
                .pipe(map(data => BasketballProfile.toFront(data)))
                .toPromise();
        });
    }
    getVolleyballProfile(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/volleyball_profile/`)
                .pipe(map(data => VolleyballProfile.toFront(data)))
                .toPromise();
        });
    }
    updateUserProfile(userProfile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/user/${userProfile.userId}/profile/`, UserProfile.toBack(userProfile))
                .pipe(map(data => UserProfile.toFront(data)))
                .toPromise();
        });
    }
    updateUserBasketballProfile(basketballProfile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/user/${basketballProfile.userId}/basketball_profile/`, BasketballProfile.toBack(basketballProfile))
                .pipe(map(data => BasketballProfile.toFront(data)))
                .toPromise();
        });
    }
    updateUserVolleyballProfile(volleyballProfile) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/user/${volleyballProfile.userId}/volleyball_profile/`, VolleyballProfile.toBack(volleyballProfile))
                .pipe(map(data => VolleyballProfile.toFront(data)))
                .toPromise();
        });
    }
    getUserPermissions(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId || 'current'}/permission/`)
                .pipe(map(data => UserPermission.toFront(data)))
                .toPromise();
        });
    }
    updateUserPermission(data) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .patch(`${this.configService.get('apiUrl')}/api/v1/user/current/permission/`, UserPermission.toBack(data))
                .pipe(map(result => UserPermission.toFront(result)))
                .toPromise();
        });
    }
    getTeams(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/teams/`)
                .pipe(map(data => Team.toFront(data)))
                .toPromise();
        });
    }
    getInvites() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/current/invites/`)
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    acceptInvite(inviteId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/user/current/invites/${inviteId}/accept/`, {})
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    declineInvite(inviteId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/user/current/invites/${inviteId}/decline/`, {})
                .pipe(map(data => TeamInvite.toFront(data)))
                .toPromise();
        });
    }
    getStatistics(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/statistics/`)
                .pipe(map(data => BasketballStatistic.toFront(data)))
                .toPromise();
        });
    }
    getStreetballStatistics(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/streetball_statistics/`)
                .pipe(map(data => BasketballStatistic.toFront(data)))
                .toPromise();
        });
    }
    getVolleyballStatistic(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/volleyball_statistics/`)
                .pipe(map(data => VolleyballStatistic.toFront(data)))
                .toPromise();
        });
    }
    getGames(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/${userId}/games/`)
                .pipe(map(data => Game.toFront(data)))
                .toPromise();
        });
    }
    getGameInvites() {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/current/game_invites/`)
                .pipe(map(data => GameInvite.toFront(data)))
                .toPromise();
        });
    }
    acceptGameInvite(inviteId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/user/current/game_invites/${inviteId}/accept/`, {})
                .pipe(map(data => GameInvite.toFront(data)))
                .toPromise();
        });
    }
    declineGameInvite(inviteId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .post(`${this.configService.get('apiUrl')}/api/v1/user/current/game_invites/${inviteId}/decline/`, {})
                .pipe(map(data => GameInvite.toFront(data)))
                .toPromise();
        });
    }
    searchUsers(query) {
        return __awaiter(this, void 0, void 0, function* () {
            const params = (new HttpParams()).set('search', query);
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/`, { params })
                .pipe(map(data => User.toFront(data)))
                .toPromise();
        });
    }
    setWizardShowed(wizard) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .put(`${this.configService.get('apiUrl')}/api/v1/user/current/wizards/`, { wizard })
                .pipe(map(data => User.toFront(data)))
                .toPromise();
        });
    }
    getTeamEvents(userId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/user/current/team_events/`)
                .pipe(map(data => TeamEvent.toFront(data)))
                .toPromise();
        });
    }
}
UserApi.ɵfac = function UserApi_Factory(t) { return new (t || UserApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
UserApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function UserApi_Factory() { return new UserApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: UserApi, providedIn: "root" });
UserApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let VolleyballGameTeamStatistic = class VolleyballGameTeamStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], VolleyballGameTeamStatistic, "toFront", null);
__decorate([
    ToBackHook
], VolleyballGameTeamStatistic, "toBack", null);
VolleyballGameTeamStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            competitor_team: 'competitorTeam',
        },
        relation: {
            team: VolleyballStatistic,
            competitorTeam: VolleyballStatistic,
        }
    })
], VolleyballGameTeamStatistic);

let VolleyballGameStatistic = class VolleyballGameStatistic extends BaseModel {
    get id() {
        return this.gameUserId;
    }
    get attacks() {
        return Math.floor(10 * (this.attackSpikes + this.attackShots)) / 10;
    }
    get blocks() {
        return Math.floor(10 * (this.stuffBlocks + this.blockRebounds)) / 10;
    }
    get totalReceives() {
        return Math.floor(10 * (this.receives + this.excellentReceives + this.receiveFaults)) / 10;
    }
    get totalServeReceives() {
        return Math.floor(10 * (this.serveReceives + this.excellentServeReceives + this.serveReceiveFaults)) / 10;
    }
    get totalServes() {
        return Math.floor(10 * (this.serveAces + this.serveHits + this.serveFaults + this.goodServes)) / 10;
    }
    get totalAttacks() {
        return Math.floor(10 * (this.attackSpikes + this.attackShots + this.attackFaults)) / 10;
    }
    get totalBlocks() {
        return Math.floor(10 * (this.stuffBlocks + this.blockRebounds + this.blockFaults)) / 10;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], VolleyballGameStatistic, "toFront", null);
__decorate([
    ToBackHook
], VolleyballGameStatistic, "toBack", null);
VolleyballGameStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            game_user_id: 'gameUserId',
            serve_hits: 'serveHits',
            serve_faults: 'serveFaults',
            serve_aces: 'serveAces',
            good_serves: 'goodServes',
            stuff_blocks: 'stuffBlocks',
            block_faults: 'blockFaults',
            block_rebounds: 'blockRebounds',
            attack_spikes: 'attackSpikes',
            attack_faults: 'attackFaults',
            attack_shots: 'attackShots',
            receives: 'receives',
            receive_faults: 'receiveFaults',
            excellent_receives: 'excellentReceives',
            serve_receives: 'serveReceives',
            serve_receive_faults: 'serveReceiveFaults',
            excellent_serve_receives: 'excellentServeReceives',
            points: 'points',
            faults: 'faults',
            yellow_cards: 'yellowCards',
        }
    })
], VolleyballGameStatistic);

var VolleyballGameLogType;
(function (VolleyballGameLogType) {
    VolleyballGameLogType[VolleyballGameLogType["enter_game"] = 1] = "enter_game";
    VolleyballGameLogType[VolleyballGameLogType["exit_game"] = 2] = "exit_game";
    VolleyballGameLogType[VolleyballGameLogType["remove_game"] = 3] = "remove_game";
    VolleyballGameLogType[VolleyballGameLogType["serve_hit"] = 4] = "serve_hit";
    VolleyballGameLogType[VolleyballGameLogType["serve_fault"] = 5] = "serve_fault";
    VolleyballGameLogType[VolleyballGameLogType["serve_ace"] = 6] = "serve_ace";
    VolleyballGameLogType[VolleyballGameLogType["stuff_block"] = 7] = "stuff_block";
    VolleyballGameLogType[VolleyballGameLogType["block_fault"] = 8] = "block_fault";
    VolleyballGameLogType[VolleyballGameLogType["block_rebound"] = 9] = "block_rebound";
    VolleyballGameLogType[VolleyballGameLogType["attack_spike"] = 10] = "attack_spike";
    VolleyballGameLogType[VolleyballGameLogType["attack_fault"] = 11] = "attack_fault";
    VolleyballGameLogType[VolleyballGameLogType["attack_shot"] = 12] = "attack_shot";
    VolleyballGameLogType[VolleyballGameLogType["receive"] = 13] = "receive";
    VolleyballGameLogType[VolleyballGameLogType["receive_fault"] = 14] = "receive_fault";
    VolleyballGameLogType[VolleyballGameLogType["excellent_receive"] = 15] = "excellent_receive";
    VolleyballGameLogType[VolleyballGameLogType["point"] = 16] = "point";
    VolleyballGameLogType[VolleyballGameLogType["fault"] = 17] = "fault";
    VolleyballGameLogType[VolleyballGameLogType["serve_receive"] = 18] = "serve_receive";
    VolleyballGameLogType[VolleyballGameLogType["serve_receive_fault"] = 19] = "serve_receive_fault";
    VolleyballGameLogType[VolleyballGameLogType["excellent_serve_receive"] = 20] = "excellent_serve_receive";
    VolleyballGameLogType[VolleyballGameLogType["timeout"] = 21] = "timeout";
    VolleyballGameLogType[VolleyballGameLogType["yellow_card"] = 22] = "yellow_card";
    VolleyballGameLogType[VolleyballGameLogType["tie_ball"] = 23] = "tie_ball";
    VolleyballGameLogType[VolleyballGameLogType["good_serve"] = 24] = "good_serve";
})(VolleyballGameLogType || (VolleyballGameLogType = {}));
const SCORE_LOG_TYPES = [
    VolleyballGameLogType.serve_ace, VolleyballGameLogType.stuff_block,
    VolleyballGameLogType.attack_spike, VolleyballGameLogType.point
];
const FAULT_LOG_TYPES = [
    VolleyballGameLogType.serve_fault, VolleyballGameLogType.attack_fault,
    VolleyballGameLogType.block_fault, VolleyballGameLogType.receive_fault,
    VolleyballGameLogType.fault, VolleyballGameLogType.serve_receive_fault
];
let VolleyballGameLog = class VolleyballGameLog extends BaseModel {
    constructor() {
        super(...arguments);
        this.active = true;
    }
    compare(model) {
        if (this.rally === model.rally && this.set === model.set) {
            if (this.datetime && model.datetime) {
                return this.datetime.getTime() < model.datetime.getTime() ? 1 : -1;
            }
            else {
                return this.id < model.id ? 1 : -1;
            }
        }
        if (this.set === model.set) {
            return this.rally < model.rally ? 1 : -1;
        }
        return this.set < model.set ? 1 : -1;
    }
    isScoreType() {
        return SCORE_LOG_TYPES.includes(this.logType);
    }
    isFaultType() {
        return FAULT_LOG_TYPES.includes(this.logType);
    }
    isServe() {
        return [
            VolleyballGameLogType.serve_hit,
            VolleyballGameLogType.serve_ace,
            VolleyballGameLogType.serve_fault,
            VolleyballGameLogType.good_serve,
        ].includes(this.logType);
    }
    isAttack() {
        return [
            VolleyballGameLogType.attack_fault,
            VolleyballGameLogType.attack_spike,
            VolleyballGameLogType.attack_shot
        ].includes(this.logType);
    }
    isReceive() {
        return [
            VolleyballGameLogType.receive_fault,
            VolleyballGameLogType.receive,
            VolleyballGameLogType.excellent_receive
        ].includes(this.logType);
    }
    isServeReceive() {
        return [
            VolleyballGameLogType.serve_receive_fault,
            VolleyballGameLogType.serve_receive,
            VolleyballGameLogType.excellent_serve_receive
        ].includes(this.logType);
    }
    isBlock() {
        return [
            VolleyballGameLogType.block_fault,
            VolleyballGameLogType.block_rebound,
            VolleyballGameLogType.stuff_block
        ].includes(this.logType);
    }
    isEnterExit() {
        return [
            VolleyballGameLogType.enter_game,
            VolleyballGameLogType.exit_game,
            VolleyballGameLogType.timeout
        ].includes(this.logType);
    }
    isComboType() {
        return ![
            VolleyballGameLogType.receive,
            VolleyballGameLogType.serve_receive
        ].includes(this.logType);
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], VolleyballGameLog, "toFront", null);
__decorate([
    ToBackHook
], VolleyballGameLog, "toBack", null);
VolleyballGameLog = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            unique_id: 'uniqueId',
            game_id: 'gameId',
            game_user_id: 'gameUserId',
            log_type: 'logType',
            set: 'set',
            rally: 'rally',
            position: 'position',
            team_id: 'teamId',
            datetime: 'datetime',
            is_highlight: 'isHighlight',
            group: 'group',
        },
        relation: {
            logType: enumField(VolleyballGameLogType),
            datetime: DateTimeField
        }
    })
], VolleyballGameLog);

class VolleyballGameApi extends GameBaseApi {
    constructor(httpClient, configService) {
        super(httpClient, configService);
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getTeamStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/team_statistic/`).pipe(map(result => VolleyballGameTeamStatistic.toFront(result))).toPromise();
        });
    }
    getUserStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/user_statistic/`).pipe(map(result => VolleyballGameStatistic.toFront(result))).toPromise();
        });
    }
    getLogs(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/logs/`).pipe(map(result => VolleyballGameLog.toFront(result))).toPromise();
        });
    }
    downloadProtocolLight(gameId, format) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/game_protocol_light/`, {
                params: new HttpParams().set('file_type', format),
                responseType: 'blob'
            }).toPromise();
        });
    }
    downloadProtocolAdvanced(gameId, format) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/game_protocol_advanced/`, {
                params: new HttpParams().set('file_type', format),
                responseType: 'blob'
            }).toPromise();
        });
    }
    downloadProtocol(gameId, format) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_volleyball_game/${gameId}/game_protocol/`, {
                params: new HttpParams().set('file_type', format),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
VolleyballGameApi.ɵfac = function VolleyballGameApi_Factory(t) { return new (t || VolleyballGameApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
VolleyballGameApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function VolleyballGameApi_Factory() { return new VolleyballGameApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: VolleyballGameApi, providedIn: "root" });
VolleyballGameApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

var WaterpoloGameLogTypes;
(function (WaterpoloGameLogTypes) {
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["enter_game"] = 1] = "enter_game";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["exit_game"] = 2] = "exit_game";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["shot_miss"] = 3] = "shot_miss";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["shot_on_goal"] = 4] = "shot_on_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["shot_blocked"] = 5] = "shot_blocked";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["goal"] = 6] = "goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["shootout_attempt"] = 7] = "shootout_attempt";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["shootout_goal"] = 8] = "shootout_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["assist"] = 9] = "assist";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["block_shot"] = 10] = "block_shot";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["free_kick_on_goal"] = 11] = "free_kick_on_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["minor_penalty"] = 12] = "minor_penalty";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["major_penalty"] = 13] = "major_penalty";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["match_penalty"] = 14] = "match_penalty";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["foul"] = 15] = "foul";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["yellow_card"] = 16] = "yellow_card";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["red_card"] = 17] = "red_card";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["penalty_shot"] = 18] = "penalty_shot";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["face_off_lose"] = 19] = "face_off_lose";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["face_off_win"] = 20] = "face_off_win";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["save"] = 21] = "save";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["timeout"] = 22] = "timeout";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["penalty_start"] = 23] = "penalty_start";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["penalty_end"] = 24] = "penalty_end";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["after_game_shootout_attempt"] = 25] = "after_game_shootout_attempt";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["after_game_shootout_goal"] = 26] = "after_game_shootout_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["after_game_shootout_save"] = 27] = "after_game_shootout_save";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["shootout_save"] = 28] = "shootout_save";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["loss"] = 29] = "loss";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["steal"] = 30] = "steal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["free_kick_miss"] = 31] = "free_kick_miss";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["free_kick_goal"] = 32] = "free_kick_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["free_kick_pass"] = 33] = "free_kick_pass";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["free_kick_self"] = 34] = "free_kick_self";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["corner_on_goal"] = 35] = "corner_on_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["corner_miss"] = 36] = "corner_miss";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["corner_goal"] = 37] = "corner_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["corner_pass"] = 38] = "corner_pass";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["corner_self"] = 39] = "corner_self";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["personal_foul"] = 40] = "personal_foul";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["counterattack_goal"] = 41] = "counterattack_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["counterattack_on_goal"] = 42] = "counterattack_on_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["counterattack_miss"] = 43] = "counterattack_miss";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["counterattack_save"] = 44] = "counterattack_save";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["maneuver_goal"] = 45] = "maneuver_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["maneuver_on_goal"] = 46] = "maneuver_on_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["maneuver_miss"] = 47] = "maneuver_miss";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["maneuver_save"] = 48] = "maneuver_save";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["center_forward_goal"] = 49] = "center_forward_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["center_forward_on_goal"] = 50] = "center_forward_on_goal";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["center_forward_miss"] = 51] = "center_forward_miss";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["center_forward_save"] = 52] = "center_forward_save";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["free_kick_save"] = 53] = "free_kick_save";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["corner_save"] = 54] = "corner_save";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["tackle"] = 55] = "tackle";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["penalty_foul"] = 56] = "penalty_foul";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["attack_foul"] = 57] = "attack_foul";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["turnover"] = 58] = "turnover";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["counter_attack_shot_blocked"] = 59] = "counter_attack_shot_blocked";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["maneuver_shot_blocked"] = 60] = "maneuver_shot_blocked";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["center_forward_shot_blocked"] = 61] = "center_forward_shot_blocked";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["free_kick_shot_blocked"] = 62] = "free_kick_shot_blocked";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["corner_shot_blocked"] = 63] = "corner_shot_blocked";
    WaterpoloGameLogTypes[WaterpoloGameLogTypes["complete_penalty_time"] = 64] = "complete_penalty_time";
})(WaterpoloGameLogTypes || (WaterpoloGameLogTypes = {}));
var WaterpoloAdvantageTypes;
(function (WaterpoloAdvantageTypes) {
    WaterpoloAdvantageTypes[WaterpoloAdvantageTypes["power_play"] = 1] = "power_play";
    WaterpoloAdvantageTypes[WaterpoloAdvantageTypes["shorthanded"] = 2] = "shorthanded";
    WaterpoloAdvantageTypes[WaterpoloAdvantageTypes["even_strength"] = 3] = "even_strength";
})(WaterpoloAdvantageTypes || (WaterpoloAdvantageTypes = {}));
let WaterpoloGameLog = class WaterpoloGameLog extends BaseModel {
    constructor() {
        super(...arguments);
        this.active = true;
    }
    get penalizedGameUserId() {
        if (this._penalizedGameUserId) {
            return this._penalizedGameUserId;
        }
        return this.gameUserId;
    }
    set penalizedGameUserId(value) {
        this._penalizedGameUserId = value;
    }
    compare(model) {
        if (this.time === model.time && this.period === model.period) {
            return this.datetime.getTime() < model.datetime.getTime() ? 1 : -1;
        }
        if (this.period === model.period) {
            return this.time < model.time ? 1 : -1;
        }
        return this.period < model.period ? 1 : -1;
    }
    get timeFormatted() {
        const minutes = Math.floor(this.time / 60);
        const seconds = this.time - minutes * 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
    isScoreType() {
        return [WaterpoloGameLogTypes.goal, WaterpoloGameLogTypes.shootout_goal, WaterpoloGameLogTypes.after_game_shootout_goal,
            WaterpoloGameLogTypes.free_kick_goal, WaterpoloGameLogTypes.corner_goal,
            WaterpoloGameLogTypes.counterattack_goal, WaterpoloGameLogTypes.maneuver_goal, WaterpoloGameLogTypes.center_forward_goal].indexOf(this.logType) > -1;
    }
    isPenaltyType() {
        return [
            WaterpoloGameLogTypes.minor_penalty, WaterpoloGameLogTypes.major_penalty, WaterpoloGameLogTypes.match_penalty, WaterpoloGameLogTypes.personal_foul
        ].indexOf(this.logType) > -1;
    }
    isFoulType() {
        return [
            WaterpoloGameLogTypes.minor_penalty, WaterpoloGameLogTypes.major_penalty, WaterpoloGameLogTypes.match_penalty,
            WaterpoloGameLogTypes.personal_foul, WaterpoloGameLogTypes.foul, WaterpoloGameLogTypes.attack_foul, WaterpoloGameLogTypes.penalty_foul
        ].indexOf(this.logType) > -1;
    }
    isAfter(log) {
        if (this.time === log.time && this.period === log.period) {
            return this.id > log.id;
        }
        if (this.period === log.period) {
            return this.time > log.time;
        }
        return this.period > log.period;
    }
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], WaterpoloGameLog, "toFront", null);
__decorate([
    ToBackHook
], WaterpoloGameLog, "toBack", null);
WaterpoloGameLog = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            unique_id: 'uniqueId',
            game_id: 'gameId',
            game_user_id: 'gameUserId',
            team_id: 'teamId',
            log_type: 'logType',
            datetime: 'datetime',
            time: 'time',
            period: 'period',
            active: 'active',
            is_highlight: 'isHighlight',
            advantage: 'advantage',
            advantage_num: 'advantageNum',
            is_goalie: 'isGoalie',
            penalized_game_user_id: 'penalizedGameUserId',
            foul_on_game_user_id: 'foulOnGameUserId',
            mutual_penalty: 'mutualPenalty',
        },
        relation: {
            datetime: DateTimeField,
            logType: enumField(WaterpoloGameLogTypes),
            advantage: enumField(WaterpoloAdvantageTypes),
        }
    })
], WaterpoloGameLog);

let WaterpoloGameStatistic = class WaterpoloGameStatistic extends BaseModel {
    get id() {
        return this.gameUserId;
    }
    get gameMinutes() {
        return Math.floor(this.gameTime / 60);
    }
    get penaltyTime() {
        if (!this.penaltyMinutes) {
            return '00:00';
        }
        const minutes = Math.floor(this.penaltyMinutes / 60);
        const seconds = Math.floor(this.penaltyMinutes - minutes * 60);
        return `${minutes < 10 ? 0 : ''}${minutes}:${seconds < 10 ? 0 : ''}${seconds}`;
    }
    get assists() {
        return (this.ppAssists || 0) + (this.shAssists || 0) + (this.evAssists || 0);
    }
    get totalCounterAttackGoals() {
        return (this.ppCounterAttackGoals || 0) + (this.evCounterAttackGoals || 0) + (this.shCounterAttackGoals || 0);
    }
    get ppCounterAttackShots() {
        return (this.ppCounterAttackOnGoals || 0) + (this.ppCounterAttackMisses || 0) + (this.ppCounterAttackShotsBlocked || 0);
    }
    get shCounterAttackShots() {
        return (this.shCounterAttackOnGoals || 0) + (this.shCounterAttackMisses || 0) + (this.shCounterAttackShotsBlocked || 0);
    }
    get evCounterAttackShots() {
        return (this.evCounterAttackOnGoals || 0) + (this.evCounterAttackMisses || 0) + (this.evCounterAttackShotsBlocked || 0);
    }
    get counterAttackShotMisses() {
        return (this.ppCounterAttackMisses || 0) + (this.shCounterAttackMisses || 0) + (this.evCounterAttackMisses || 0);
    }
    get counterAttackShotOnGoals() {
        return (this.ppCounterAttackOnGoals || 0) + (this.shCounterAttackOnGoals || 0) + (this.evCounterAttackOnGoals || 0);
    }
    get counterAttackShotsBlocked() {
        return (this.ppCounterAttackShotsBlocked || 0) + (this.shCounterAttackShotsBlocked || 0) + (this.evCounterAttackShotsBlocked || 0);
    }
    get counterAttackShots() {
        return this.counterAttackShotMisses + this.counterAttackShotOnGoals + this.counterAttackShotsBlocked;
    }
    get counterAttackGoalsPercent() {
        if (!this.totalCounterAttackGoals || !this.counterAttackShots) {
            return 0;
        }
        return Math.round(1000 * this.totalCounterAttackGoals / this.counterAttackShots) / 10;
    }
    get totalManeuverGoals() {
        return (this.ppManeuverGoals || 0) + (this.shManeuverGoals || 0) + (this.evManeuverGoals || 0);
    }
    get ppManeuverShots() {
        return (this.ppManeuverOnGoals || 0) + (this.ppManeuverMisses || 0) + (this.ppManeuverShotsBlocked || 0);
    }
    get shManeuverShots() {
        return (this.shManeuverOnGoals || 0) + (this.shManeuverMisses || 0) + (this.shManeuverShotsBlocked || 0);
    }
    get evManeuverShots() {
        return (this.evManeuverOnGoals || 0) + (this.evManeuverMisses || 0) + (this.evManeuverShotsBlocked || 0);
    }
    get maneuverShotMisses() {
        return (this.ppManeuverMisses || 0) + (this.shManeuverMisses || 0) + (this.evManeuverMisses || 0);
    }
    get maneuverShotOnGoals() {
        return (this.ppManeuverOnGoals || 0) + (this.shManeuverOnGoals || 0) + (this.evManeuverOnGoals || 0);
    }
    get maneuverShotsBlocked() {
        return (this.ppManeuverShotsBlocked || 0) + (this.shManeuverShotsBlocked || 0) + (this.evManeuverShotsBlocked || 0);
    }
    get maneuverShots() {
        return this.maneuverShotMisses + this.maneuverShotOnGoals + this.maneuverShotsBlocked;
    }
    get maneuverGoalsPercent() {
        if (!this.totalManeuverGoals || !this.maneuverShots) {
            return 0;
        }
        return Math.round(1000 * this.totalManeuverGoals / this.maneuverShots) / 10;
    }
    get totalCenterForwardGoals() {
        return (this.ppCenterForwardGoals || 0) + (this.shCenterForwardGoals || 0) + (this.evCenterForwardGoals || 0);
    }
    get ppCenterForwardShots() {
        return (this.ppCenterForwardOnGoals || 0) + (this.ppCenterForwardMisses || 0) + (this.ppCenterForwardShotsBlocked || 0);
    }
    get shCenterForwardShots() {
        return (this.shCenterForwardOnGoals || 0) + (this.shCenterForwardMisses || 0) + (this.shCenterForwardShotsBlocked || 0);
    }
    get evCenterForwardShots() {
        return (this.evCenterForwardOnGoals || 0) + (this.evCenterForwardMisses || 0) + (this.evCenterForwardShotsBlocked || 0);
    }
    get centerForwardShotMisses() {
        return (this.ppCenterForwardMisses || 0) + (this.shCenterForwardMisses || 0) + (this.evCenterForwardMisses || 0);
    }
    get centerForwardShotOnGoals() {
        return (this.ppCenterForwardOnGoals || 0) + (this.shCenterForwardOnGoals || 0) + (this.evCenterForwardOnGoals || 0);
    }
    get centerForwardShotsBlocked() {
        return (this.ppCenterForwardShotsBlocked || 0) + (this.shCenterForwardShotsBlocked || 0) + (this.evCenterForwardShotsBlocked || 0);
    }
    get centerForwardShots() {
        return this.centerForwardShotMisses + this.centerForwardShotOnGoals + this.centerForwardShotsBlocked;
    }
    get centerForwardGoalsPercent() {
        if (!this.totalCenterForwardGoals || !this.centerForwardShots) {
            return 0;
        }
        return Math.round(1000 * this.totalCenterForwardGoals / this.centerForwardShots) / 10;
    }
    get ppShots() {
        return (this.ppShotMisses || 0) + (this.ppShotsOnGoal || 0) + (this.ppShotsBlocked || 0) +
            (this.ppFreeKickMisses || 0) + (this.ppFreeKickOnGoals || 0) + (this.ppFreeKickShotsBlocked || 0) +
            (this.ppCornerMisses || 0) + (this.ppCornerOnGoals || 0) + (this.ppCornerShotsBlocked || 0) +
            this.ppCounterAttackShots + this.ppManeuverShots + this.ppCenterForwardShots;
    }
    get evShots() {
        return (this.evShotMisses || 0) + (this.evShotsOnGoal || 0) + (this.evShotsBlocked || 0) +
            (this.evFreeKickMisses || 0) + (this.evFreeKickOnGoals || 0) + (this.evFreeKickShotsBlocked || 0) +
            (this.evCornerMisses || 0) + (this.evCornerOnGoals || 0) + (this.evCornerShotsBlocked || 0) +
            this.evCounterAttackShots + this.evManeuverShots + this.evCenterForwardShots;
    }
    get shShots() {
        return (this.shShotMisses || 0) + (this.shShotsOnGoal || 0) + (this.shShotsBlocked || 0) +
            (this.shFreeKickMisses || 0) + (this.shFreeKickOnGoals || 0) + (this.shFreeKickShotsBlocked || 0) +
            (this.shCornerMisses || 0) + (this.shCornerOnGoals || 0) + (this.shCornerShotsBlocked || 0) +
            this.shCounterAttackShots + this.shManeuverShots + this.shCenterForwardShots;
    }
    get totalShGoals() {
        return (this.shGoals || 0) + (this.shFreeKickGoals || 0) + (this.shCornerGoals || 0) +
            (this.shCounterAttackGoals || 0) + (this.shManeuverGoals || 0) + (this.shCenterForwardGoals || 0);
    }
    get totalEvGoals() {
        return (this.evGoals || 0) + (this.evFreeKickGoals || 0) + (this.evCornerGoals || 0) +
            (this.evCounterAttackGoals || 0) + (this.evManeuverGoals || 0) + (this.evCenterForwardGoals || 0);
    }
    get totalPpGoals() {
        return (this.ppGoals || 0) + (this.ppFreeKickGoals || 0) + (this.ppCornerGoals || 0) +
            (this.ppCounterAttackGoals || 0) + (this.ppManeuverGoals || 0) + (this.ppCenterForwardGoals || 0);
    }
    get goals() {
        return this.totalShGoals + this.totalEvGoals + this.totalPpGoals;
    }
    get totalGoals() {
        return this.goals + (this.shootoutGoals || 0);
    }
    get shootoutShots() {
        return (this.shootoutGoals || 0) + (this.shootoutAttempts || 0);
    }
    get inGameShotMisses() {
        return (this.ppShotMisses || 0) + (this.evShotMisses || 0) + (this.shShotMisses || 0) +
            this.counterAttackShotMisses + this.maneuverShotMisses + this.centerForwardShotMisses;
    }
    get shotMisses() {
        return (this.ppFreeKickMisses || 0) + (this.evFreeKickMisses || 0) + (this.shFreeKickMisses || 0) +
            (this.ppCornerMisses || 0) + (this.evCornerMisses || 0) + (this.shCornerMisses || 0) +
            this.inGameShotMisses;
    }
    get totalPpShotMisses() {
        return (this.ppShotMisses || 0) + (this.ppFreeKickMisses || 0) + (this.ppCornerMisses || 0) +
            (this.ppCounterAttackMisses || 0) + (this.ppManeuverMisses || 0) + (this.ppCenterForwardMisses || 0);
    }
    get shotsOnGoal() {
        return (this.ppShotsOnGoal || 0) + (this.evShotsOnGoal || 0) + (this.shShotsOnGoal || 0) +
            (this.ppFreeKickOnGoals || 0) + (this.evFreeKickOnGoals || 0) + (this.shFreeKickOnGoals || 0) +
            (this.ppCornerOnGoals || 0) + (this.evCornerOnGoals || 0) + (this.shCornerOnGoals || 0) +
            this.counterAttackShotOnGoals + this.maneuverShotOnGoals + this.centerForwardShotOnGoals;
    }
    get totalPpShotsOnGoal() {
        return (this.ppShotsOnGoal || 0) + (this.ppFreeKickOnGoals || 0) + (this.ppCornerOnGoals || 0) +
            (this.ppCounterAttackOnGoals || 0) + (this.ppManeuverOnGoals || 0) + (this.ppCenterForwardOnGoals || 0);
    }
    get inGameShotsOnGoals() {
        return (this.ppShotsOnGoal || 0) + (this.evShotsOnGoal || 0) + (this.shShotsOnGoal || 0) +
            this.counterAttackShotOnGoals + this.maneuverShotOnGoals + this.centerForwardShotOnGoals;
    }
    get shots() {
        return this.ppShots + this.evShots + this.shShots;
    }
    get totalShots() {
        return this.shots + this.shootoutShots;
    }
    get faceOffs() {
        return (this.faceOffWins || 0) + (this.faceOffLosses || 0);
    }
    get freeKickShotMisses() {
        return (this.ppFreeKickMisses || 0) + (this.evFreeKickMisses || 0) + (this.shFreeKickMisses || 0);
    }
    get freeKickShotsBlocked() {
        return (this.ppFreeKickShotsBlocked || 0) + (this.evFreeKickShotsBlocked || 0) + (this.shFreeKickShotsBlocked || 0);
    }
    get freeKickOnGoals() {
        return (this.ppFreeKickOnGoals || 0) + (this.evFreeKickOnGoals || 0) + (this.shFreeKickOnGoals || 0);
    }
    get totalFreeKickGoals() {
        return (this.ppFreeKickGoals || 0) + (this.shFreeKickGoals || 0) + (this.evFreeKickGoals || 0);
    }
    get totalFreeKicks() {
        return (this.freeKickSelfs || 0) + (this.freeKickPasses || 0) +
            this.freeKickShotMisses + this.freeKickOnGoals + this.totalFreeKickGoals + this.freeKickShotsBlocked;
    }
    get freeKickGoalsPercent() {
        if (!this.totalFreeKickGoals || !this.totalFreeKicks) {
            return 0;
        }
        return Math.round(1000 * this.totalFreeKickGoals / this.totalFreeKicks) / 10;
    }
    get totalCornerGoals() {
        return (this.ppCornerGoals || 0) + (this.shCornerGoals || 0) + (this.evCornerGoals || 0);
    }
    get cornerShotMisses() {
        return (this.ppCornerMisses || 0) + (this.shCornerMisses || 0) + (this.evCornerMisses || 0);
    }
    get cornerOnGoals() {
        return (this.ppCornerOnGoals || 0) + (this.shCornerOnGoals || 0) + (this.evCornerOnGoals || 0);
    }
    get cornerShotsBlocked() {
        return (this.ppCornerShotsBlocked || 0) + (this.shCornerShotsBlocked || 0) + (this.evCornerShotsBlocked || 0);
    }
    get totalCorners() {
        return (this.cornerSelfs || 0) + (this.cornerPasses || 0) + this.cornerShotsBlocked +
            this.cornerOnGoals + this.cornerShotMisses + this.totalCornerGoals;
    }
    get shotsBlocked() {
        return (this.ppShotsBlocked || 0) + (this.evShotsBlocked || 0) + (this.shShotsBlocked || 0) +
            this.counterAttackShotsBlocked + this.maneuverShotsBlocked + this.centerForwardShotsBlocked +
            this.freeKickShotsBlocked + this.cornerShotsBlocked;
    }
    get totalFouls() {
        return (this.fouls || 0) + (this.personalFouls || 0);
    }
    get totalPenalties() {
        return (this.minorPenalties || 0) + (this.majorPenalties || 0) + (this.matchPenalties || 0);
    }
    get positionAttackGoals() {
        return (this.shGoals || 0) + (this.evGoals || 0) + (this.ppGoals || 0);
    }
    get positionAttackShotsOnGoal() {
        return (this.ppShotsOnGoal || 0) + (this.evShotsOnGoal || 0) + (this.shShotsOnGoal || 0);
    }
    get positionAttackShotsMiss() {
        return (this.ppShotMisses || 0) + (this.evShotMisses || 0) + (this.shShotMisses || 0);
    }
    get positionAttackShots() {
        return this.positionAttackShotsOnGoal + this.positionAttackShotsMiss;
    }
    get positionAttackGoalsPercent() {
        if (!this.positionAttackGoals || !this.positionAttackShots) {
            return 0;
        }
        return Math.round(1000 * this.positionAttackGoals / this.positionAttackShots) / 10;
    }
    get totalInGameGoals() {
        return this.totalCenterForwardGoals + this.totalManeuverGoals + this.totalCounterAttackGoals + this.positionAttackGoals;
    }
    get ppGoalsPercent() {
        if (!this.totalPpGoals || !this.ppShots) {
            return 0;
        }
        return Math.round(1000 * this.totalPpGoals / this.ppShots) / 10;
    }
    get evGoalsPercent() {
        if (!this.totalEvGoals || !this.evShots) {
            return 0;
        }
        return Math.round(1000 * this.totalEvGoals / this.evShots) / 10;
    }
    get shGoalsPercent() {
        if (!this.totalShGoals || !this.shShots) {
            return 0;
        }
        return Math.round(1000 * this.totalShGoals / this.shShots) / 10;
    }
    get shotsOnGoalPercent() {
        if (!this.shotsOnGoal || !this.shots) {
            return 0;
        }
        return Math.round(1000 * this.shotsOnGoal / this.shots) / 10;
    }
    get goalsPercent() {
        if (!this.goals || !this.shots) {
            return 0;
        }
        return Math.round(1000 * this.goals / this.shots) / 10;
    }
    get totalGoalsPercent() {
        if (!this.totalGoals || !this.totalShots) {
            return 0;
        }
        return Math.round(1000 * this.totalGoals / this.totalShots) / 10;
    }
    get faceOffPercent() {
        if (!this.faceOffWins || !this.faceOffs) {
            return 0;
        }
        return Math.round(1000 * this.faceOffWins / this.faceOffs) / 10;
    }
    get shootoutGoalsPercent() {
        if (!this.shootoutGoals || !this.shootoutShots) {
            return 0;
        }
        return Math.round(1000 * this.shootoutGoals / this.shootoutShots) / 10;
    }
    get goalpass() {
        return (this.totalGoals || 0) + (this.assists || 0);
    }
    /*goalie stat */
    get positionAttackSaves() {
        return (this.ppSaves || 0) + (this.shSaves || 0) + (this.evSaves || 0);
    }
    get positionAttackShotsAgainst() {
        return this.positionAttackSaves + (this.goalsAgainst || 0);
    }
    get positionAttackSavesPercent() {
        if (!this.positionAttackSaves || !this.positionAttackShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.positionAttackSaves / this.positionAttackShotsAgainst) / 10;
    }
    get counterAttackSaves() {
        return (this.ppCounterAttackSaves || 0) + (this.shCounterAttackSaves || 0) + (this.evCounterAttackSaves || 0);
    }
    get counterAttackShotsAgainst() {
        return this.counterAttackSaves + (this.counterAttackGoalsAgainst || 0);
    }
    get counterAttackSavesPercent() {
        if (!this.counterAttackSaves || !this.counterAttackShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.counterAttackSaves / this.counterAttackShotsAgainst) / 10;
    }
    get centerForwardSaves() {
        return (this.ppCenterForwardSaves || 0) + (this.shCenterForwardSaves || 0) + (this.evCenterForwardSaves || 0);
    }
    get centerForwardShotsAgainst() {
        return this.centerForwardSaves + (this.centerForwardGoalsAgainst || 0);
    }
    get centerForwardSavesPercent() {
        if (!this.centerForwardSaves || !this.centerForwardShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.centerForwardSaves / this.centerForwardShotsAgainst) / 10;
    }
    get maneuverSaves() {
        return (this.ppManeuverSaves || 0) + (this.shManeuverSaves || 0) + (this.evManeuverSaves || 0);
    }
    get maneuverShotsAgainst() {
        return this.maneuverSaves + (this.maneuverGoalsAgainst || 0);
    }
    get maneuverSavesPercent() {
        if (!this.maneuverSaves || !this.maneuverShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.maneuverSaves / this.maneuverShotsAgainst) / 10;
    }
    get freeKickSaves() {
        return (this.ppFreeKickSaves || 0) + (this.shFreeKickSaves || 0) + (this.evFreeKickSaves || 0);
    }
    get freeKickShotsAgainst() {
        return this.freeKickSaves + (this.freeKickGoalsAgainst || 0);
    }
    get freeKickSavesPercent() {
        if (!this.freeKickSaves || !this.freeKickShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.freeKickSaves / this.freeKickShotsAgainst) / 10;
    }
    get cornerSaves() {
        return (this.ppCornerSaves || 0) + (this.shCornerSaves || 0) + (this.evCornerSaves || 0);
    }
    get cornerShotsAgainst() {
        return this.cornerSaves + (this.cornerGoalsAgainst || 0);
    }
    get cornerSavesPercent() {
        if (!this.cornerSaves || !this.cornerShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.cornerSaves / this.cornerShotsAgainst) / 10;
    }
    get inGameSaves() {
        return (this.shSaves || 0) + (this.evSaves || 0) + (this.ppSaves || 0) +
            this.counterAttackSaves + this.maneuverSaves + this.centerForwardSaves;
    }
    get saves() {
        return this.inGameSaves + this.freeKickSaves + this.cornerSaves;
    }
    get totalSaves() {
        return this.saves + (this.shootoutSaves || 0);
    }
    get inGameGoalsAgainst() {
        return (this.goalsAgainst || 0) + (this.counterAttackGoalsAgainst || 0) + (this.maneuverGoalsAgainst || 0) +
            (this.centerForwardGoalsAgainst || 0);
    }
    get shootoutShotsAgainst() {
        return (this.shootoutSaves || 0) + (this.shootoutGoalsAgainst || 0);
    }
    get gameGoalsAgainst() {
        return this.inGameGoalsAgainst + (this.freeKickGoalsAgainst || 0) + (this.cornerGoalsAgainst || 0);
    }
    get totalGoalsAgainst() {
        return this.gameGoalsAgainst + (this.shootoutGoalsAgainst || 0);
    }
    get gameShotsAgainst() {
        return this.saves + this.gameGoalsAgainst;
    }
    get totalShotsAgainst() {
        return this.gameShotsAgainst + this.shootoutShotsAgainst;
    }
    get shootoutSavesPercent() {
        if (!this.shootoutSaves || !this.shootoutShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.shootoutSaves / this.shootoutShotsAgainst) / 10;
    }
    get savesPercent() {
        if (!this.saves || !this.gameShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.saves / this.gameShotsAgainst) / 10;
    }
    get totalSavesPercent() {
        if (!this.totalSaves || !this.totalShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.totalSaves / this.totalShotsAgainst) / 10;
    }
    get totalShSaves() {
        return (this.shCounterAttackSaves || 0) + (this.shManeuverSaves || 0) + (this.shCenterForwardSaves || 0) +
            (this.shSaves || 0) + (this.shFreeKickSaves || 0) + (this.shCornerSaves || 0);
    }
    get totalShGoalsAgainst() {
        return (this.shGoalsAgainst || 0) + (this.shFreeKickGoalsAgainst || 0) + (this.shCornerGoalsAgainst || 0) +
            (this.shCounterAttackGoalsAgainst || 0) + (this.shManeuverGoalsAgainst || 0) + (this.shCenterForwardGoalsAgainst || 0);
    }
    get totalShShotsAgainst() {
        return this.totalShSaves + this.totalShGoalsAgainst;
    }
    get totalShSavesPercent() {
        if (!this.totalShSaves || !this.totalShShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.totalShSaves / this.totalShShotsAgainst) / 10;
    }
    get totalEvSaves() {
        return (this.evCounterAttackSaves || 0) + (this.evManeuverSaves || 0) + (this.evCenterForwardSaves || 0) +
            (this.evSaves || 0) + (this.evFreeKickSaves || 0) + (this.evCornerSaves || 0);
    }
    get totalEvGoalsAgainst() {
        return (this.evGoalsAgainst || 0) + (this.evFreeKickGoalsAgainst || 0) + (this.evCornerGoalsAgainst || 0) +
            (this.evCounterAttackGoalsAgainst || 0) + (this.evManeuverGoalsAgainst || 0) + (this.evCenterForwardGoalsAgainst || 0);
    }
    get totalEvShotsAgainst() {
        return this.totalEvSaves + this.totalEvGoalsAgainst;
    }
    get totalEvSavesPercent() {
        if (!this.totalEvSaves || !this.totalEvShotsAgainst) {
            return 0;
        }
        return Math.round(1000 * this.totalEvSaves / this.totalEvShotsAgainst) / 10;
    }
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], WaterpoloGameStatistic, "toFront", null);
__decorate([
    ToBackHook
], WaterpoloGameStatistic, "toBack", null);
WaterpoloGameStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            game_user_id: 'gameUserId',
            updated_at: 'updatedAt',
            points: 'points',
            pp_shot_misses: 'ppShotMisses',
            pp_shots_on_goal: 'ppShotsOnGoal',
            pp_shots_blocked: 'ppShotsBlocked',
            ev_shot_misses: 'evShotMisses',
            ev_shots_on_goal: 'evShotsOnGoal',
            ev_shots_blocked: 'evShotsBlocked',
            sh_shot_misses: 'shShotMisses',
            sh_shots_on_goal: 'shShotsOnGoal',
            sh_shots_blocked: 'shShotsBlocked',
            pp_total_shots_on_goal: 'ppTotalShotsOnGoal',
            ev_total_shots_on_goal: 'evTotalShotsOnGoal',
            sh_total_shots_on_goal: 'shTotalShotsOnGoal',
            pp_goals: 'ppGoals',
            ev_goals: 'evGoals',
            sh_goals: 'shGoals',
            pp_counterattack_goals: 'ppCounterAttackGoals',
            pp_counterattack_on_goals: 'ppCounterAttackOnGoals',
            pp_counterattack_misses: 'ppCounterAttackMisses',
            pp_counterattack_shots_blocked: 'ppCounterAttackShotsBlocked',
            ev_counterattack_goals: 'evCounterAttackGoals',
            ev_counterattack_on_goals: 'evCounterAttackOnGoals',
            ev_counterattack_misses: 'evCounterAttackMisses',
            ev_counterattack_shots_blocked: 'evCounterAttackShotsBlocked',
            sh_counterattack_goals: 'shCounterAttackGoals',
            sh_counterattack_on_goals: 'shCounterAttackOnGoals',
            sh_counterattack_misses: 'shCounterAttackMisses',
            sh_counterattack_shots_blocked: 'shCounterAttackShotsBlocked',
            pp_maneuver_goals: 'ppManeuverGoals',
            pp_maneuver_on_goals: 'ppManeuverOnGoals',
            pp_maneuver_misses: 'ppManeuverMisses',
            pp_maneuver_shots_blocked: 'ppManeuverShotsBlocked',
            ev_maneuver_goals: 'evManeuverGoals',
            ev_maneuver_on_goals: 'evManeuverOnGoals',
            ev_maneuver_misses: 'evManeuverMisses',
            ev_maneuver_shots_blocked: 'evManeuverShotsBlocked',
            sh_maneuver_goals: 'shManeuverGoals',
            sh_maneuver_on_goals: 'shManeuverOnGoals',
            sh_maneuver_misses: 'shManeuverMisses',
            sh_maneuver_shots_blocked: 'shManeuverShotsBlocked',
            pp_center_forward_goals: 'ppCenterForwardGoals',
            pp_center_forward_on_goals: 'ppCenterForwardOnGoals',
            pp_center_forward_misses: 'ppCenterForwardMisses',
            pp_center_forward_shots_blocked: 'ppCenterForwardShotsBlocked',
            ev_center_forward_goals: 'evCenterForwardGoals',
            ev_center_forward_on_goals: 'evCenterForwardOnGoals',
            ev_center_forward_misses: 'evCenterForwardMisses',
            ev_center_forward_shots_blocked: 'evCenterForwardShotsBlocked',
            sh_center_forward_goals: 'shCenterForwardGoals',
            sh_center_forward_on_goals: 'shCenterForwardOnGoals',
            sh_center_forward_misses: 'shCenterForwardMisses',
            sh_center_forward_shots_blocked: 'shCenterForwardShotsBlocked',
            pp_assists: 'ppAssists',
            ev_assists: 'evAssists',
            sh_assists: 'shAssists',
            shootout_attempts: 'shootoutAttempts',
            shootout_goals: 'shootoutGoals',
            after_game_shootout_attempts: 'afterGameShootoutAttempts',
            after_game_shootout_goals: 'afterGameShootoutGoals',
            block_shots: 'blockShots',
            face_off_losses: 'faceOffLosses',
            face_off_wins: 'faceOffWins',
            pp_saves: 'ppSaves',
            sh_saves: 'shSaves',
            ev_saves: 'evSaves',
            pp_counterattack_saves: 'ppCounterAttackSaves',
            sh_counterattack_saves: 'shCounterAttackSaves',
            ev_counterattack_saves: 'evCounterAttackSaves',
            pp_maneuver_saves: 'ppManeuverSaves',
            sh_maneuver_saves: 'shManeuverSaves',
            ev_maneuver_saves: 'evManeuverSaves',
            pp_center_forward_saves: 'ppCenterForwardSaves',
            sh_center_forward_saves: 'shCenterForwardSaves',
            ev_center_forward_saves: 'evCenterForwardSaves',
            pp_free_kick_saves: 'ppFreeKickSaves',
            sh_free_kick_saves: 'shFreeKickSaves',
            ev_free_kick_saves: 'evFreeKickSaves',
            pp_corner_saves: 'ppCornerSaves',
            sh_corner_saves: 'shCornerSaves',
            ev_corner_saves: 'evCornerSaves',
            pp_total_game_saves: 'ppTotalGameSaves',
            sh_total_game_saves: 'shTotalGameSaves',
            ev_total_game_saves: 'evTotalGameSaves',
            shootout_saves: 'shootoutSaves',
            after_game_shootout_saves: 'afterGameShootoutSaves',
            pp_goals_against: 'ppGoalsAgainst',
            sh_goals_against: 'shGoalsAgainst',
            ev_goals_against: 'evGoalsAgainst',
            goals_against: 'goalsAgainst',
            pp_counterattack_goals_against: 'ppCounterAttackGoalsAgainst',
            sh_counterattack_goals_against: 'shCounterAttackGoalsAgainst',
            ev_counterattack_goals_against: 'evCounterAttackGoalsAgainst',
            counterattack_goals_against: 'counterAttackGoalsAgainst',
            pp_maneuver_goals_against: 'ppManeuverGoalsAgainst',
            sh_maneuver_goals_against: 'shManeuverGoalsAgainst',
            ev_maneuver_goals_against: 'evManeuverGoalsAgainst',
            maneuver_goals_against: 'maneuverGoalsAgainst',
            pp_center_forward_goals_against: 'ppCenterForwardGoalsAgainst',
            sh_center_forward_goals_against: 'shCenterForwardGoalsAgainst',
            ev_center_forward_goals_against: 'evCenterForwardGoalsAgainst',
            center_forward_goals_against: 'centerForwardGoalsAgainst',
            pp_free_kick_goals_against: 'ppFreeKickGoalsAgainst',
            sh_free_kick_goals_against: 'shFreeKickGoalsAgainst',
            ev_free_kick_goals_against: 'evFreeKickGoalsAgainst',
            free_kick_goals_against: 'freeKickGoalsAgainst',
            pp_corner_goals_against: 'ppCornerGoalsAgainst',
            sh_corner_goals_against: 'shCornerGoalsAgainst',
            ev_corner_goals_against: 'evCornerGoalsAgainst',
            corner_goals_against: 'cornerGoalsAgainst',
            shootout_goals_against: 'shootoutGoalsAgainst',
            after_game_shootout_goals_against: 'afterGameShootoutGoalsAgainst',
            safety_rate: 'safetyRate',
            penalty_minutes: 'penaltyMinutes',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            fouls: 'fouls',
            minor_penalties: 'minorPenalties',
            major_penalties: 'majorPenalties',
            match_penalties: 'matchPenalties',
            penalty_fouls: 'penaltyFouls',
            turnovers: 'turnovers',
            attack_fouls: 'attackFouls',
            personal_fouls: 'personalFouls',
            drawn_fouls: 'drawnFouls',
            drawn_turnovers: 'drawnTurnovers',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            losses: 'losses',
            steals: 'steals',
            pp_free_kick_goals: 'ppFreeKickGoals',
            pp_free_kick_on_goals: 'ppFreeKickOnGoals',
            pp_free_kick_misses: 'ppFreeKickMisses',
            pp_free_kick_shots_blocked: 'ppFreeKickShotsBlocked',
            sh_free_kick_goals: 'shFreeKickGoals',
            sh_free_kick_on_goals: 'shFreeKickOnGoals',
            sh_free_kick_misses: 'shFreeKickMisses',
            sh_free_kick_shots_blocked: 'shFreeKickShotsBlocked',
            ev_free_kick_goals: 'evFreeKickGoals',
            ev_free_kick_on_goals: 'evFreeKickOnGoals',
            ev_free_kick_misses: 'evFreeKickMisses',
            ev_free_kick_shots_blocked: 'evFreeKickShotsBlocked',
            free_kick_passes: 'freeKickPasses',
            free_kick_selfs: 'freeKickSelfs',
            pp_corner_goals: 'ppCornerGoals',
            pp_corner_on_goals: 'ppCornerOnGoals',
            pp_corner_misses: 'ppCornerMisses',
            pp_corner_shots_blocked: 'ppCornerShotsBlocked',
            sh_corner_goals: 'shCornerGoals',
            sh_corner_on_goals: 'shCornerOnGoals',
            sh_corner_misses: 'shCornerMisses',
            sh_corner_shots_blocked: 'shCornerShotsBlocked',
            ev_corner_goals: 'evCornerGoals',
            ev_corner_on_goals: 'evCornerOnGoals',
            ev_corner_misses: 'evCornerMisses',
            ev_corner_shots_blocked: 'evCornerShotsBlocked',
            corner_passes: 'cornerPasses',
            corner_selfs: 'cornerSelfs',
            tackles: 'tackles',
            player_efficiency: 'playerEfficiency'
        },
        relation: {
            updatedAt: DateTimeField,
        }
    })
], WaterpoloGameStatistic);

let WaterpoloGameTeamStatistic = class WaterpoloGameTeamStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], WaterpoloGameTeamStatistic, "toFront", null);
__decorate([
    ToBackHook
], WaterpoloGameTeamStatistic, "toBack", null);
WaterpoloGameTeamStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            competitor_team: 'competitorTeam'
        },
        relation: {
            team: WaterpoloStatistic,
            competitorTeam: WaterpoloStatistic
        }
    })
], WaterpoloGameTeamStatistic);

class WaterpoloGameApi extends GameBaseApi {
    constructor(httpClient, configService) {
        super(httpClient, configService);
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_waterpolo_game/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getTeamStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_waterpolo_game/${gameId}/team_statistic/`).pipe(map(result => WaterpoloGameTeamStatistic.toFront(result))).toPromise();
        });
    }
    getUserStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_waterpolo_game/${gameId}/user_statistic/`).pipe(map(result => WaterpoloGameStatistic.toFront(result))).toPromise();
        });
    }
    getLogs(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_waterpolo_game/${gameId}/logs/`).pipe(map(result => WaterpoloGameLog.toFront(result))).toPromise();
        });
    }
    downloadProtocol(gameId, format) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_waterpolo_game/${gameId}/game_protocol/`, {
                params: new HttpParams().set('file_type', format),
                responseType: 'blob'
            }).toPromise();
        });
    }
    downloadApplication(gameId, format, type) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_waterpolo_game/${gameId}/game_application_file/`, {
                params: new HttpParams().set('file_type', format).set('application_type', type),
                responseType: 'blob'
            }).toPromise();
        });
    }
}
WaterpoloGameApi.ɵfac = function WaterpoloGameApi_Factory(t) { return new (t || WaterpoloGameApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
WaterpoloGameApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function WaterpoloGameApi_Factory() { return new WaterpoloGameApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: WaterpoloGameApi, providedIn: "root" });
WaterpoloGameApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

let WrestballGameTeamStatistic = class WrestballGameTeamStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], WrestballGameTeamStatistic, "toFront", null);
__decorate([
    ToBackHook
], WrestballGameTeamStatistic, "toBack", null);
WrestballGameTeamStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            team: 'team',
            competitor_team: 'competitorTeam'
        },
        relation: {
            team: WrestballStatistic,
            competitorTeam: WrestballStatistic
        }
    })
], WrestballGameTeamStatistic);

let WrestballGameStatistic = class WrestballGameStatistic extends BaseModel {
    get id() {
        return this.gameUserId;
    }
    static toFront(data) { }
    static toBack(data) { }
    get totalFouls() {
        return (this.personalFouls || 0)
            + (this.technicalFouls || 0)
            + (this.unsportsmanlikeFouls || 0)
            + (this.disqualificationFouls || 0)
            + (this.yellowCards || 0)
            + (this.redCards || 0);
    }
    set onePointPercent(v) { }
    get onePointPercent() {
        if (!this.onePointsMade || !this.onePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.onePointsMade / this.onePointAttempts) / 10;
    }
    set twoPointPercent(v) { }
    get twoPointPercent() {
        if (!this.twoPointsMade || !this.twoPointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.twoPointsMade / this.twoPointAttempts) / 10;
    }
    set threePointPercent(v) { }
    get threePointPercent() {
        if (!this.threePointsMade || !this.threePointAttempts) {
            return 0;
        }
        return Math.round(1000 * this.threePointsMade / this.threePointAttempts) / 10;
    }
    set freeThrowPercent(v) { }
    get freeThrowPercent() {
        if (!this.freeThrowsMade || !this.freeThrowAttempts) {
            return 0;
        }
        return Math.round(1000 * this.freeThrowsMade / this.freeThrowAttempts) / 10;
    }
    set totalFreeThrowPercent(v) { }
    get totalFreeThrowPercent() {
        if (!this.totalFreeThrowMade || !this.totalFreeThrowAttempts) {
            return 0;
        }
        return Math.round(1000 * this.totalFreeThrowMade / this.totalFreeThrowAttempts) / 10;
    }
    set dunksMadePercent(v) { }
    get dunksMadePercent() {
        return !this.dunksMade || !this.dunkAttempts ? 0 : Math.round(1000 * this.dunksMade / this.dunkAttempts) / 10;
    }
    get totalRebounds() {
        return Math.floor(10 * ((this.offensiveRebounds || 0) + (this.defensiveRebounds || 0))) / 10;
    }
    get wrestlerScrums() {
        return (this.wrestlerScrumsWon || 0)
            + (this.wrestlerScrumsLost || 0)
            + (this.wrestlerScrumsTie || 0)
            + (this.wrestlerScrumsCounterattack || 0);
    }
    get wrestlerScrumsWonPercent() {
        if (!this.wrestlerScrumsWon || !this.wrestlerScrums) {
            return 0;
        }
        return Math.round(1000 * this.wrestlerScrumsWon / this.wrestlerScrums) / 10;
    }
    get scrums() {
        return (this.scrumsWon || 0) + (this.scrumsLost || 0) + (this.scrumsTie || 0);
    }
    get scrumsWonPercent() {
        if (!this.scrumsWon || !this.scrums) {
            return 0;
        }
        return Math.round(1000 * this.scrumsWon / this.scrums) / 10;
    }
    get scrumsBallAdvantageTotal() {
        return (this.scrumsBallAdvantageWon || 0) + (this.scrumsBallAdvantageLost || 0) + (this.scrumsBallAdvantageTie || 0);
    }
    get scrumsBallAdvantageWonPercent() {
        if (!this.scrumsBallAdvantageWon || !this.scrumsBallAdvantageTotal) {
            return 0;
        }
        return Math.round(1000 * this.scrumsBallAdvantageWon / this.scrumsBallAdvantageTotal) / 10;
    }
    get totalScrums() {
        return (this.wrestlerScrums || 0) + (this.scrums || 0) + (this.scrumsBallAdvantageTotal || 0);
    }
};
__decorate([
    ToFrontHook
], WrestballGameStatistic, "toFront", null);
__decorate([
    ToBackHook
], WrestballGameStatistic, "toBack", null);
WrestballGameStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            game_user_id: 'gameUserId',
            points: 'points',
            free_throws_made: 'freeThrowsMade',
            two_points_free_throw_made: 'twoPointsFreeThrowMade',
            three_points_free_throw_made: 'threePointsFreeThrowMade',
            total_free_throw_made: 'totalFreeThrowMade',
            two_points_made: 'twoPointsMade',
            three_points_made: 'threePointsMade',
            one_points_made: 'onePointsMade',
            dunks_made: 'dunksMade',
            two_point_attempts: 'twoPointAttempts',
            three_point_attempts: 'threePointAttempts',
            free_throw_attempts: 'freeThrowAttempts',
            two_point_free_throw_attempts: 'twoPointFreeThrowAttempts',
            three_point_free_throw_attempts: 'threePointFreeThrowAttempts',
            total_free_throw_attempts: 'totalFreeThrowAttempts',
            one_point_attempts: 'onePointAttempts',
            dunk_attempts: 'dunkAttempts',
            one_point_percent: 'onePointPercent',
            two_point_percent: 'twoPointPercent',
            three_point_percent: 'threePointPercent',
            free_throw_percent: 'freeThrowPercent',
            total_free_throw_percent: 'totalFreeThrowPercent',
            dunks_made_percent: 'dunksMadePercent',
            assists: 'assists',
            blocks: 'blocks',
            rebounds: 'rebounds',
            offensive_rebounds: 'offensiveRebounds',
            defensive_rebounds: 'defensiveRebounds',
            steals: 'steals',
            turnovers: 'turnovers',
            personal_fouls: 'personalFouls',
            drawn_fouls: 'drawnFouls',
            drawn_wrestler_attempts: 'drawnWrestlerAttempts',
            drawn_wrestler_won_attempts: 'drawnWrestlerWonAttempts',
            drawn_wrestler_lost_attempts: 'drawnWrestlerLostAttempts',
            wrestler_scrums_won: 'wrestlerScrumsWon',
            wrestler_scrums_lost: 'wrestlerScrumsLost',
            wrestler_scrums_tie: 'wrestlerScrumsTie',
            wrestler_scrum_points: 'wrestlerScrumPoints',
            wrestler_scrums_counterattack: 'wrestlerScrumsCounterattack',
            wrestler_scrums_counterattack_points: 'wrestlerScrumsCounterattackPoints',
            scrums_won: 'scrumsWon',
            scrums_lost: 'scrumsLost',
            scrums_tie: 'scrumsTie',
            scrum_points: 'scrumPoints',
            scrums_ball_advantage_won: 'scrumsBallAdvantageWon',
            scrums_ball_advantage_lost: 'scrumsBallAdvantageLost',
            scrums_ball_advantage_tie: 'scrumsBallAdvantageTie',
            yellow_cards: 'yellowCards',
            red_cards: 'redCards',
            game_time: 'gameTime',
            plus_minus: 'plusMinus',
            updated_at: 'updatedAt',
        },
        relation: {
            updatedAt: DateTimeField,
        }
    })
], WrestballGameStatistic);

var WrestballGameLogTypes;
(function (WrestballGameLogTypes) {
    WrestballGameLogTypes[WrestballGameLogTypes["enter_game"] = 1] = "enter_game";
    WrestballGameLogTypes[WrestballGameLogTypes["exit_game"] = 2] = "exit_game";
    WrestballGameLogTypes[WrestballGameLogTypes["remove_game"] = 3] = "remove_game";
    WrestballGameLogTypes[WrestballGameLogTypes["one_point_made"] = 4] = "one_point_made";
    WrestballGameLogTypes[WrestballGameLogTypes["one_point_attempt"] = 5] = "one_point_attempt";
    WrestballGameLogTypes[WrestballGameLogTypes["two_point_made"] = 6] = "two_point_made";
    WrestballGameLogTypes[WrestballGameLogTypes["two_point_attempt"] = 7] = "two_point_attempt";
    WrestballGameLogTypes[WrestballGameLogTypes["three_point_made"] = 8] = "three_point_made";
    WrestballGameLogTypes[WrestballGameLogTypes["three_point_attempt"] = 9] = "three_point_attempt";
    WrestballGameLogTypes[WrestballGameLogTypes["free_throw_made"] = 10] = "free_throw_made";
    WrestballGameLogTypes[WrestballGameLogTypes["free_throw_attempt"] = 11] = "free_throw_attempt";
    WrestballGameLogTypes[WrestballGameLogTypes["assist"] = 12] = "assist";
    WrestballGameLogTypes[WrestballGameLogTypes["block"] = 13] = "block";
    WrestballGameLogTypes[WrestballGameLogTypes["rebound"] = 14] = "rebound";
    WrestballGameLogTypes[WrestballGameLogTypes["offensive_rebound"] = 15] = "offensive_rebound";
    WrestballGameLogTypes[WrestballGameLogTypes["defensive_rebound"] = 16] = "defensive_rebound";
    WrestballGameLogTypes[WrestballGameLogTypes["team_rebound"] = 17] = "team_rebound";
    WrestballGameLogTypes[WrestballGameLogTypes["steal"] = 18] = "steal";
    WrestballGameLogTypes[WrestballGameLogTypes["turnover"] = 19] = "turnover";
    WrestballGameLogTypes[WrestballGameLogTypes["personal_foul"] = 20] = "personal_foul";
    WrestballGameLogTypes[WrestballGameLogTypes["timeout"] = 21] = "timeout";
    WrestballGameLogTypes[WrestballGameLogTypes["wrestler_scrum"] = 22] = "wrestler_scrum";
    WrestballGameLogTypes[WrestballGameLogTypes["wrestler_scrum_won"] = 23] = "wrestler_scrum_won";
    WrestballGameLogTypes[WrestballGameLogTypes["wrestler_scrum_lost"] = 24] = "wrestler_scrum_lost";
    WrestballGameLogTypes[WrestballGameLogTypes["wrestler_scrum_tie"] = 25] = "wrestler_scrum_tie";
    WrestballGameLogTypes[WrestballGameLogTypes["scrum"] = 26] = "scrum";
    WrestballGameLogTypes[WrestballGameLogTypes["scrum_won"] = 27] = "scrum_won";
    WrestballGameLogTypes[WrestballGameLogTypes["scrum_lost"] = 28] = "scrum_lost";
    WrestballGameLogTypes[WrestballGameLogTypes["scrum_tie"] = 29] = "scrum_tie";
    WrestballGameLogTypes[WrestballGameLogTypes["yellow_card"] = 30] = "yellow_card";
    WrestballGameLogTypes[WrestballGameLogTypes["red_card"] = 31] = "red_card";
    WrestballGameLogTypes[WrestballGameLogTypes["wrestler_scrum_counterattack"] = 32] = "wrestler_scrum_counterattack";
    WrestballGameLogTypes[WrestballGameLogTypes["scrum_ball_advantage_won"] = 33] = "scrum_ball_advantage_won";
    WrestballGameLogTypes[WrestballGameLogTypes["scrum_ball_advantage_lost"] = 34] = "scrum_ball_advantage_lost";
    WrestballGameLogTypes[WrestballGameLogTypes["scrum_ball_advantage_tie"] = 35] = "scrum_ball_advantage_tie";
    WrestballGameLogTypes[WrestballGameLogTypes["dunk_made"] = 36] = "dunk_made";
    WrestballGameLogTypes[WrestballGameLogTypes["dunk_attempt"] = 37] = "dunk_attempt";
    WrestballGameLogTypes[WrestballGameLogTypes["two_point_free_throw_made"] = 38] = "two_point_free_throw_made";
    WrestballGameLogTypes[WrestballGameLogTypes["two_point_free_throw_attempt"] = 39] = "two_point_free_throw_attempt";
    WrestballGameLogTypes[WrestballGameLogTypes["three_point_free_throw_made"] = 40] = "three_point_free_throw_made";
    WrestballGameLogTypes[WrestballGameLogTypes["three_point_free_throw_attempt"] = 41] = "three_point_free_throw_attempt";
})(WrestballGameLogTypes || (WrestballGameLogTypes = {}));
let WrestballGameLog = class WrestballGameLog extends BaseModel {
    constructor() {
        super(...arguments);
        this.active = true;
    }
    isPointsType() {
        return [
            WrestballGameLogTypes.two_point_made,
            WrestballGameLogTypes.three_point_made,
            WrestballGameLogTypes.free_throw_made,
            WrestballGameLogTypes.two_point_free_throw_made,
            WrestballGameLogTypes.three_point_free_throw_made,
            WrestballGameLogTypes.one_point_made,
            WrestballGameLogTypes.scrum_won,
            WrestballGameLogTypes.wrestler_scrum_won,
            WrestballGameLogTypes.wrestler_scrum_counterattack,
            WrestballGameLogTypes.dunk_made,
        ].indexOf(this.logType) > -1;
    }
    isReboundType() {
        return [
            WrestballGameLogTypes.rebound,
            WrestballGameLogTypes.offensive_rebound,
            WrestballGameLogTypes.defensive_rebound,
            WrestballGameLogTypes.team_rebound,
        ].indexOf(this.logType) > -1;
    }
    isFoulType() {
        return [
            WrestballGameLogTypes.personal_foul,
            WrestballGameLogTypes.yellow_card,
            WrestballGameLogTypes.red_card,
        ].indexOf(this.logType) > -1;
    }
    isScrumType() {
        return [
            WrestballGameLogTypes.wrestler_scrum_won,
            WrestballGameLogTypes.wrestler_scrum_lost,
            WrestballGameLogTypes.wrestler_scrum_tie,
            WrestballGameLogTypes.scrum_won,
            WrestballGameLogTypes.scrum_lost,
            WrestballGameLogTypes.scrum_tie,
            WrestballGameLogTypes.scrum_ball_advantage_won,
            WrestballGameLogTypes.scrum_ball_advantage_lost,
            WrestballGameLogTypes.scrum_ball_advantage_tie
        ].indexOf(this.logType) > -1;
    }
    isRestlerScrumType() {
        return [
            WrestballGameLogTypes.wrestler_scrum_won,
            WrestballGameLogTypes.wrestler_scrum_lost,
            WrestballGameLogTypes.wrestler_scrum_tie
        ].indexOf(this.logType) > -1;
    }
    getScore() {
        const scoreMapping = {
            [WrestballGameLogTypes.one_point_made]: 1,
            [WrestballGameLogTypes.free_throw_made]: 1,
            [WrestballGameLogTypes.two_point_free_throw_made]: 2,
            [WrestballGameLogTypes.three_point_free_throw_made]: 3,
            [WrestballGameLogTypes.two_point_made]: 2,
            [WrestballGameLogTypes.three_point_made]: 3,
            [WrestballGameLogTypes.scrum_won]: 2,
            [WrestballGameLogTypes.wrestler_scrum_won]: 2,
            [WrestballGameLogTypes.wrestler_scrum_counterattack]: 2,
            [WrestballGameLogTypes.dunk_made]: 2,
        };
        return scoreMapping[this.logType] || 0;
    }
    compare(model) {
        if (this.time === model.time && this.period === model.period) {
            if (this.datetime.getTime() === model.datetime.getTime()) {
                return this.id > model.id ? 1 : -1;
            }
            return this.datetime.getTime() < model.datetime.getTime() ? 1 : -1;
        }
        if (this.period === model.period) {
            return this.time < model.time ? 1 : -1;
        }
        return this.period < model.period ? 1 : -1;
    }
    get timeFormatted() {
        const minutes = Math.floor(this.time / 60);
        const seconds = this.time - minutes * 60;
        return `${minutes < 10 ? '0' : ''}${minutes}:${seconds < 10 ? '0' : ''}${seconds}`;
    }
    static toFront(value) { }
    static toBack(value) { }
};
__decorate([
    ToFrontHook
], WrestballGameLog, "toFront", null);
__decorate([
    ToBackHook
], WrestballGameLog, "toBack", null);
WrestballGameLog = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            unique_id: 'uniqueId',
            game_id: 'gameId',
            game_user_id: 'gameUserId',
            team_id: 'teamId',
            log_type: 'logType',
            datetime: 'datetime',
            time: 'time',
            period: 'period',
            active: 'active',
            is_highlight: 'isHighlight',
            foul_on_game_user_id: 'foulOnGameUserId',
            wrestler_attempt_on_game_user_id: 'wrestlerAttemptOnGameUserId',
            is_coach: 'isCoach',
            is_bench: 'isBench',
            marked: 'marked',
        },
        relation: {
            datetime: DateTimeField,
            logType: enumField(WrestballGameLogTypes),
        }
    })
], WrestballGameLog);

class WrestballGameApi extends GameBaseApi {
    constructor(httpClient, configService) {
        super(httpClient, configService);
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_wrestball_game/${gameId}/`).pipe(map(result => Game.toFront(result))).toPromise();
        });
    }
    getTeamStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_wrestball_game/${gameId}/team_statistic/`).pipe(map(result => WrestballGameTeamStatistic.toFront(result))).toPromise();
        });
    }
    getUserStatistic(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_wrestball_game/${gameId}/user_statistic/`).pipe(map(result => WrestballGameStatistic.toFront(result))).toPromise();
        });
    }
    getLogs(gameId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/tournament_wrestball_game/${gameId}/logs/`).pipe(map(result => WrestballGameLog.toFront(result))).toPromise();
        });
    }
}
WrestballGameApi.ɵfac = function WrestballGameApi_Factory(t) { return new (t || WrestballGameApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
WrestballGameApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function WrestballGameApi_Factory() { return new WrestballGameApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: WrestballGameApi, providedIn: "root" });
WrestballGameApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class PublicTeamApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(teamId) {
        return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_team/${teamId}/`).pipe(map(result => Team.toFront(result))).toPromise();
    }
    getTournamentTeams(teamId, leagueId) {
        const params = new HttpParams().set('league_id', leagueId.toString());
        return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_team/${teamId}/tournament_teams/`, { params }).pipe(map(result => TournamentTeam.toFront(result))).toPromise();
    }
    getUsers(teamId) {
        return __awaiter(this, void 0, void 0, function* () {
            return this.httpClient
                .get(`${this.configService.get('apiUrl')}/api/v1/public_team/${teamId}/users/`)
                .pipe(map(data => TeamUser.toFront(data)))
                .toPromise();
        });
    }
}
PublicTeamApi.ɵfac = function PublicTeamApi_Factory(t) { return new (t || PublicTeamApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
PublicTeamApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function PublicTeamApi_Factory() { return new PublicTeamApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: PublicTeamApi, providedIn: "root" });
PublicTeamApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

class PublicUserApi {
    constructor(httpClient, configService) {
        this.httpClient = httpClient;
        this.configService = configService;
    }
    getById(userId) {
        return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_user/${userId}/`).pipe(map(result => User.toFront(result))).toPromise();
    }
    getTournaments(userId, leagueId) {
        const params = new HttpParams().set('league_id', leagueId.toString());
        return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_user/${userId}/tournaments/`, { params }).pipe(map(result => Tournament.toFront(result))).toPromise();
    }
    getTournamentUser(userId, seasonId) {
        const params = new HttpParams().set('season_id', seasonId.toString());
        return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_user/${userId}/tournament_user/`, { params }).pipe(map(result => TournamentTeamUser.toFront(result))).toPromise();
    }
    getLeaguePlayer(userId, leagueId) {
        const params = new HttpParams().set('league_id', leagueId.toString());
        return this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/public_user/${userId}/league_player/`, { params }).pipe(map(result => LeaguePlayer.toFront(result))).toPromise();
    }
}
PublicUserApi.ɵfac = function PublicUserApi_Factory(t) { return new (t || PublicUserApi)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService)); };
PublicUserApi.ɵprov = i0.ɵɵdefineInjectable({ factory: function PublicUserApi_Factory() { return new PublicUserApi(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService)); }, token: PublicUserApi, providedIn: "root" });
PublicUserApi.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService }
];

const BasketballGameLogTypeLocalization = {
    [Locales.ru]: {
        [BasketballGameLogTypes.enter_game]: 'Выход на площадку',
        [BasketballGameLogTypes.exit_game]: 'Ушел с площадки',
        [BasketballGameLogTypes.remove_game]: 'Удаление с площадки',
        [BasketballGameLogTypes.two_point_attempt]: 'Бросок 2 очка',
        [BasketballGameLogTypes.three_point_attempt]: 'Бросок 3 очка',
        [BasketballGameLogTypes.free_throw_attempt]: 'Штрафной бросок',
        [BasketballGameLogTypes.one_point_attempt]: 'Бросок 1 очко',
        [BasketballGameLogTypes.two_point_made]: '2 очка',
        [BasketballGameLogTypes.three_point_made]: '3 очка',
        [BasketballGameLogTypes.free_throw_made]: '1 очко, штрафной',
        [BasketballGameLogTypes.one_point_made]: '1 очко',
        [BasketballGameLogTypes.assist]: 'Передача',
        [BasketballGameLogTypes.block]: 'Блокшот',
        [BasketballGameLogTypes.rebound]: 'Подбор',
        [BasketballGameLogTypes.offensive_rebound]: 'Подбор в нападении',
        [BasketballGameLogTypes.defensive_rebound]: 'Подбор в защите',
        [BasketballGameLogTypes.steal]: 'Перехват',
        [BasketballGameLogTypes.turnover]: 'Потеря',
        [BasketballGameLogTypes.personal_foul]: 'Фол',
        [BasketballGameLogTypes.technical_foul]: 'Технический фол',
        [BasketballGameLogTypes.unsportsmanlike_foul]: 'Неспортиный фол',
        [BasketballGameLogTypes.timeout]: 'Таймаут',
        [BasketballGameLogTypes.team_rebound]: 'Командный подбор',
        [BasketballGameLogTypes.dunk_attempt]: 'Данк мимо',
        [BasketballGameLogTypes.dunk_made]: 'Данк',
        [BasketballGameLogTypes.four_point_attempt]: 'Бросок 4 очка',
        [BasketballGameLogTypes.four_point_made]: '4 очка',
        [BasketballGameLogTypes.shootout]: 'Буллит',
        [BasketballGameLogTypes.shootout_won]: 'Буллит выигран',
        [BasketballGameLogTypes.shootout_lost]: 'Буллит проигран',
        [BasketballGameLogTypes.moneyball_free_throw_attempt]: 'Штрафной бросок',
        [BasketballGameLogTypes.moneyball_free_throw_made]: '2 очка, штрафной',
    },
    [Locales.en]: {
        [BasketballGameLogTypes.enter_game]: 'Entering the court',
        [BasketballGameLogTypes.exit_game]: 'Exit the court',
        [BasketballGameLogTypes.remove_game]: 'Remove from the court',
        [BasketballGameLogTypes.two_point_attempt]: 'Two point attempt',
        [BasketballGameLogTypes.three_point_attempt]: 'Three point attempt',
        [BasketballGameLogTypes.free_throw_attempt]: 'Free throw attempt',
        [BasketballGameLogTypes.one_point_attempt]: 'One point attempt',
        [BasketballGameLogTypes.two_point_made]: '2 points',
        [BasketballGameLogTypes.three_point_made]: '3 points',
        [BasketballGameLogTypes.free_throw_made]: '1 point, free throw',
        [BasketballGameLogTypes.one_point_made]: '1 point',
        [BasketballGameLogTypes.assist]: 'Assist',
        [BasketballGameLogTypes.block]: 'Block',
        [BasketballGameLogTypes.rebound]: 'Rebound',
        [BasketballGameLogTypes.offensive_rebound]: 'Offensive rebound',
        [BasketballGameLogTypes.defensive_rebound]: 'Defensive rebound',
        [BasketballGameLogTypes.steal]: 'Steal',
        [BasketballGameLogTypes.turnover]: 'Turnover',
        [BasketballGameLogTypes.personal_foul]: 'Foul',
        [BasketballGameLogTypes.technical_foul]: 'Technical foul',
        [BasketballGameLogTypes.unsportsmanlike_foul]: 'Unsportsmanlike foul',
        [BasketballGameLogTypes.timeout]: 'Timeout',
        [BasketballGameLogTypes.team_rebound]: 'Team rebound',
        [BasketballGameLogTypes.four_point_attempt]: 'Four point attempt',
        [BasketballGameLogTypes.four_point_made]: '4 points',
        [BasketballGameLogTypes.dunk_attempt]: 'Dunk miss',
        [BasketballGameLogTypes.dunk_attempt]: 'Dunk',
        [BasketballGameLogTypes.shootout]: 'Shootout',
        [BasketballGameLogTypes.shootout_won]: 'Shootout won',
        [BasketballGameLogTypes.shootout_lost]: 'Shootout lost',
        [BasketballGameLogTypes.moneyball_free_throw_attempt]: 'Free throw attempt',
        [BasketballGameLogTypes.moneyball_free_throw_made]: '2 points, free throw',
    }
};

const BasketballGameSubLogTypesLocalization = {
    [Locales.ru]: {
        // Shots
        [BasketballSubLogTypes.jump_shot]: 'Джампшот',
        [BasketballSubLogTypes.step_back_jump_shot]: 'Степ-бэк',
        [BasketballSubLogTypes.floating_jump_shot]: 'Флоатинг',
        [BasketballSubLogTypes.fade_away_jump_shot]: 'Фэйдавэй',
        [BasketballSubLogTypes.pull_up_jump_shot]: 'Пуллап',
        [BasketballSubLogTypes.turnaround_jump_shot]: 'Турнэраунд',
        [BasketballSubLogTypes.dunk]: 'Данк',
        [BasketballSubLogTypes.layup]: 'Лэйап',
        [BasketballSubLogTypes.driving_layup]: 'Драйвинг лэйап',
        [BasketballSubLogTypes.alley_oop]: 'Алейуп',
        [BasketballSubLogTypes.hook_shot]: 'Хукшот',
        // foul
        [BasketballSubLogTypes.offensive_foul]: 'В нападении',
        [BasketballSubLogTypes.shot_foul]: 'При броксе',
        [BasketballSubLogTypes.mutual_foul]: 'Обоюдный фол',
        // Turnover
        [BasketballSubLogTypes.bad_pass]: 'Плохой пас',
        [BasketballSubLogTypes.ball_handling]: 'На ведении',
        [BasketballSubLogTypes.travel]: 'Пробежка',
        [BasketballSubLogTypes.double_dribble]: 'Двойное ведение',
        [BasketballSubLogTypes.out_of_bounds]: 'Заступ в аут',
        [BasketballSubLogTypes.three_seconds]: '3 секунды',
        [BasketballSubLogTypes.five_seconds]: '5 секунд',
        [BasketballSubLogTypes.eight_seconds]: '8 секунд',
        [BasketballSubLogTypes.twenty_four_seconds]: '24 секунды',
        [BasketballSubLogTypes.back_court]: 'Зона',
        [BasketballSubLogTypes.offensive_goal_tending]: 'Гоалтендинг',
        [BasketballSubLogTypes.other_turnover]: 'Другое',
    },
    [Locales.en]: {
        // Shots
        [BasketballSubLogTypes.jump_shot]: 'Jump shot',
        [BasketballSubLogTypes.step_back_jump_shot]: 'Step back',
        [BasketballSubLogTypes.floating_jump_shot]: 'Floating',
        [BasketballSubLogTypes.fade_away_jump_shot]: 'Fade-away',
        [BasketballSubLogTypes.pull_up_jump_shot]: 'Pull-up',
        [BasketballSubLogTypes.turnaround_jump_shot]: 'Turnaround',
        [BasketballSubLogTypes.dunk]: 'Dunk',
        [BasketballSubLogTypes.layup]: 'Layup',
        [BasketballSubLogTypes.driving_layup]: 'Driving layup',
        [BasketballSubLogTypes.alley_oop]: 'Alley-oop',
        [BasketballSubLogTypes.hook_shot]: 'Hook-shot',
        // foul
        [BasketballSubLogTypes.offensive_foul]: 'Offensive foul',
        [BasketballSubLogTypes.shot_foul]: 'Shot foul',
        [BasketballSubLogTypes.mutual_foul]: 'Mutual foul',
        // Turnover
        [BasketballSubLogTypes.bad_pass]: 'Bad pass',
        [BasketballSubLogTypes.ball_handling]: 'Ball handling',
        [BasketballSubLogTypes.travel]: 'Travel',
        [BasketballSubLogTypes.double_dribble]: 'Double dribble',
        [BasketballSubLogTypes.out_of_bounds]: 'Out of bounds',
        [BasketballSubLogTypes.three_seconds]: '3 second',
        [BasketballSubLogTypes.five_seconds]: '5 second',
        [BasketballSubLogTypes.eight_seconds]: '8 second',
        [BasketballSubLogTypes.twenty_four_seconds]: '24 second',
        [BasketballSubLogTypes.back_court]: 'Back court',
        [BasketballSubLogTypes.offensive_goal_tending]: 'Goal tending',
        [BasketballSubLogTypes.other_turnover]: 'Other',
    }
};

const CountryLocalization = {
    [Locales.ru]: {
        [Country.RU]: 'Россия',
        [Country.BL]: 'Беларусь',
        [Country.AM]: 'Армения',
        [Country.KZ]: 'Казахстан',
        [Country.KG]: 'Кыргызстан',
        [Country.USA]: 'США',
        [Country.GE]: 'Грузия',
        [Country.AZ]: 'Азербайджан',
        [Country.CHN]: 'Китай',
        [Country.EGY]: 'Египет',
        [Country.IRN]: 'Иран',
        [Country.GRC]: 'Греция',
    },
    [Locales.en]: {
        [Country.RU]: 'Russia',
        [Country.BL]: 'Belarus',
        [Country.AM]: 'Armenia',
        [Country.KZ]: 'Kazakhstan',
        [Country.KG]: 'Kyrgyzstan',
        [Country.USA]: 'USA',
        [Country.GE]: 'Georgia',
        [Country.AZ]: 'Azerbaijan',
        [Country.CHN]: 'China',
        [Country.EGY]: 'Egypt',
        [Country.IRN]: 'Iran',
        [Country.GRC]: 'Greece',
    },
};

const HockeyGameLogTypeLocalization = {
    [Locales.ru]: {
        [HockeyGameLogTypes.enter_game]: 'Выход на площадку',
        [HockeyGameLogTypes.exit_game]: 'Ушел с площадки',
        [HockeyGameLogTypes.shot_miss]: 'Бросок мимо',
        [HockeyGameLogTypes.shot_on_goal]: 'Бросок по воротам',
        [HockeyGameLogTypes.shot_blocked]: 'Заблокированный бросок',
        [HockeyGameLogTypes.goal]: 'Гол',
        [HockeyGameLogTypes.shootout_attempt]: 'Буллит промах',
        [HockeyGameLogTypes.shootout_goal]: 'Буллит гол',
        [HockeyGameLogTypes.after_game_shootout_attempt]: 'Буллит промах',
        [HockeyGameLogTypes.after_game_shootout_goal]: 'Буллит гол',
        [HockeyGameLogTypes.assist]: 'Передача',
        [HockeyGameLogTypes.block_shot]: 'Блокировка броска',
        [HockeyGameLogTypes.minor_penalty]: 'Малый штраф',
        [HockeyGameLogTypes.major_penalty]: 'Большой штраф',
        [HockeyGameLogTypes.misconduct_penalty]: 'Дисциплинарный штраф',
        [HockeyGameLogTypes.game_misconduct_penalty]: 'Дисциплинарный штраф до конца игры',
        [HockeyGameLogTypes.match_penalty]: 'Матч-штраф',
        [HockeyGameLogTypes.penalty_shot]: 'Штрафной бросок',
        [HockeyGameLogTypes.face_off_lose]: 'Проигрыш в вбрасывании',
        [HockeyGameLogTypes.face_off_win]: 'Победа в вбрасывании',
        [HockeyGameLogTypes.save]: 'Отражен бросок',
        [HockeyGameLogTypes.shootout_save]: 'Отражен бросок',
        [HockeyGameLogTypes.after_game_shootout_save]: 'Отражен бросок',
        [HockeyGameLogTypes.timeout]: 'Таймаут',
        [HockeyGameLogTypes.penalty_start]: 'Начало штрафного времени',
        [HockeyGameLogTypes.penalty_end]: 'Конец штрафного времени',
        [HockeyGameLogTypes.steal]: 'Отбор',
        [HockeyGameLogTypes.loss]: 'Потеря',
        [HockeyGameLogTypes.sharp_pass]: 'Острая передача',
    },
    [Locales.en]: {
        [HockeyGameLogTypes.enter_game]: 'Entering the court',
        [HockeyGameLogTypes.exit_game]: 'Exit the court',
        [HockeyGameLogTypes.shot_miss]: 'Missing shot',
        [HockeyGameLogTypes.shot_on_goal]: 'Shot on a goal',
        [HockeyGameLogTypes.shot_blocked]: 'Blocked shot',
        [HockeyGameLogTypes.goal]: 'Goal',
        [HockeyGameLogTypes.shootout_attempt]: 'Shootout miss',
        [HockeyGameLogTypes.shootout_goal]: 'Shootout goal',
        [HockeyGameLogTypes.after_game_shootout_attempt]: 'Shootout miss',
        [HockeyGameLogTypes.after_game_shootout_goal]: 'Shootout goal',
        [HockeyGameLogTypes.assist]: 'Assist',
        [HockeyGameLogTypes.block_shot]: 'Shot is blocked',
        [HockeyGameLogTypes.minor_penalty]: 'Minor penalty',
        [HockeyGameLogTypes.major_penalty]: 'Major penalty',
        [HockeyGameLogTypes.misconduct_penalty]: 'Misconduct penalty',
        [HockeyGameLogTypes.game_misconduct_penalty]: 'Disciplinary penalty until the end of the game',
        [HockeyGameLogTypes.match_penalty]: 'Match penalty',
        [HockeyGameLogTypes.penalty_shot]: 'Penalty shot',
        [HockeyGameLogTypes.face_off_lose]: 'Face-off lose',
        [HockeyGameLogTypes.face_off_win]: 'Face-off win',
        [HockeyGameLogTypes.save]: 'Throw is reflected',
        [HockeyGameLogTypes.shootout_save]: 'Throw is reflected',
        [HockeyGameLogTypes.after_game_shootout_save]: 'Throw is reflected',
        [HockeyGameLogTypes.timeout]: 'Timeout',
        [HockeyGameLogTypes.penalty_start]: 'The beginning of the penalty time',
        [HockeyGameLogTypes.penalty_end]: 'End of penalty time',
        [HockeyGameLogTypes.steal]: 'Steal',
        [HockeyGameLogTypes.loss]: 'Loss',
        [HockeyGameLogTypes.sharp_pass]: 'Sharp pass',
    }
};

const FootballGameLogTypeLocalization = {
    [Locales.ru]: {
        [FootballGameLogTypes.enter_game]: 'Выход на поле',
        [FootballGameLogTypes.exit_game]: 'Ушел с поля',
        [FootballGameLogTypes.shot_miss]: 'Удар мимо',
        [FootballGameLogTypes.shot_on_goal]: 'Удар в створ',
        [FootballGameLogTypes.shot_blocked]: 'Заблокированный удар',
        [FootballGameLogTypes.goal]: 'Гол',
        [FootballGameLogTypes.assist]: 'Передача',
        [FootballGameLogTypes.penalty_attempt]: 'Пенальти промах',
        [FootballGameLogTypes.penalty_goal]: 'Пенальти гол',
        [FootballGameLogTypes.small_penalty_attempt]: '10-метровый промах',
        [FootballGameLogTypes.small_penalty_goal]: '10-метровый гол',
        [FootballGameLogTypes.block_shot]: 'Блокировка удара',
        [FootballGameLogTypes.corner]: 'Угловой',
        [FootballGameLogTypes.free_kick]: 'Штрафной удар',
        [FootballGameLogTypes.save]: 'Отражен удар',
        [FootballGameLogTypes.penalty_save]: 'Отражен пенальти',
        [FootballGameLogTypes.small_penalty_save]: 'Отражен 10 метровый',
        [FootballGameLogTypes.foul]: 'Фол',
        [FootballGameLogTypes.yellow_card]: 'Желтая карточка',
        [FootballGameLogTypes.red_card]: 'Красная карточка',
        [FootballGameLogTypes.perfect_pass]: 'Пас',
        [FootballGameLogTypes.loss]: 'Потеря',
        [FootballGameLogTypes.steal]: 'Перехват',
        [FootballGameLogTypes.out]: 'Аут',
        [FootballGameLogTypes.timeout]: 'Таймаут',
        [FootballGameLogTypes.auto_goal]: 'Автогол',
        [FootballGameLogTypes.end_game_penalty_goal]: 'Пенальти гол',
        [FootballGameLogTypes.end_game_penalty_miss]: 'Пенальти промах',
        [FootballGameLogTypes.end_game_penalty_save]: 'Отражен пенальти',
        [FootballGameLogTypes.duel_won]: 'Дуэль выиграна',
        [FootballGameLogTypes.duel_lost]: 'Дуэль проиграна',
        [FootballGameLogTypes.double_goal]: 'Гол+2',
        [FootballGameLogTypes.super_game]: 'Супер игра',
        [FootballGameLogTypes.color_ball]: 'Цветной мяч',
    },
    [Locales.en]: {
        [FootballGameLogTypes.enter_game]: 'Entering the court',
        [FootballGameLogTypes.exit_game]: 'Exit the court',
        [FootballGameLogTypes.shot_miss]: 'Missing shot',
        [FootballGameLogTypes.shot_on_goal]: 'Shot on goal',
        [FootballGameLogTypes.shot_blocked]: 'Shot is blocked',
        [FootballGameLogTypes.goal]: 'Goal',
        [FootballGameLogTypes.assist]: 'Assist',
        [FootballGameLogTypes.penalty_attempt]: 'Penalty miss',
        [FootballGameLogTypes.penalty_goal]: 'Penalty goal',
        [FootballGameLogTypes.small_penalty_attempt]: '10-meters shot miss',
        [FootballGameLogTypes.small_penalty_goal]: '10-meters goal',
        [FootballGameLogTypes.block_shot]: 'Blocking shot',
        [FootballGameLogTypes.corner]: 'Corner',
        [FootballGameLogTypes.free_kick]: 'Free kick',
        [FootballGameLogTypes.save]: 'Save',
        [FootballGameLogTypes.penalty_save]: 'Penalty save',
        [FootballGameLogTypes.small_penalty_save]: '10-meters save',
        [FootballGameLogTypes.foul]: 'Foul',
        [FootballGameLogTypes.yellow_card]: 'Yellow card',
        [FootballGameLogTypes.red_card]: 'Red card',
        [FootballGameLogTypes.perfect_pass]: 'Pass',
        [FootballGameLogTypes.loss]: 'Loss',
        [FootballGameLogTypes.steal]: 'Steal',
        [FootballGameLogTypes.out]: 'Out',
        [FootballGameLogTypes.timeout]: 'Timeout',
        [FootballGameLogTypes.auto_goal]: 'Own goal',
        [FootballGameLogTypes.end_game_penalty_goal]: 'Penalty goal',
        [FootballGameLogTypes.end_game_penalty_miss]: 'Penalty miss',
        [FootballGameLogTypes.end_game_penalty_save]: 'Penalty save',
        [FootballGameLogTypes.duel_won]: 'Duel won',
        [FootballGameLogTypes.duel_lost]: 'Duel lost',
        [FootballGameLogTypes.double_goal]: 'Goal+2',
        [FootballGameLogTypes.super_game]: 'Super game',
        [FootballGameLogTypes.color_ball]: 'Color ball',
    }
};

const HandballGameLogTypeLocalization = {
    [Locales.ru]: {
        [HandballGameLogTypes.enter_game]: 'Выход на поле',
        [HandballGameLogTypes.exit_game]: 'Ушел с поля',
        [HandballGameLogTypes.shot_miss]: 'Бросок мимо',
        [HandballGameLogTypes.shot_on_goal]: 'Бросок в створ',
        [HandballGameLogTypes.shot_blocked]: 'Заблокированный бросок',
        [HandballGameLogTypes.goal]: 'Гол',
        [HandballGameLogTypes.assist]: 'Передача',
        [HandballGameLogTypes.penalty_miss]: '7м промах',
        [HandballGameLogTypes.penalty_shot_on_goal]: '7м в створ',
        [HandballGameLogTypes.penalty_goal]: '7м гол',
        [HandballGameLogTypes.save]: 'Сэйв',
        [HandballGameLogTypes.penalty_save]: 'Сэйв 7м',
        [HandballGameLogTypes.foul]: 'Фол',
        [HandballGameLogTypes.yellow_card]: 'Желлтая карточка',
        [HandballGameLogTypes.red_card]: 'Красная карточка',
        [HandballGameLogTypes.two_minute_foul]: '2х минутный штраф',
        [HandballGameLogTypes.turnover]: 'Потеря',
        [HandballGameLogTypes.steal]: 'Перехват',
        [HandballGameLogTypes.block_shot]: 'Блок броска',
        [HandballGameLogTypes.timeout]: 'Таймаут',
    },
    [Locales.en]: {
        [HandballGameLogTypes.enter_game]: 'Entering the court',
        [HandballGameLogTypes.exit_game]: 'Exit the court',
        [HandballGameLogTypes.shot_miss]: 'Missing shot',
        [HandballGameLogTypes.shot_on_goal]: 'Shot on goal',
        [HandballGameLogTypes.shot_blocked]: 'Blocking shot',
        [HandballGameLogTypes.goal]: 'Goal',
        [HandballGameLogTypes.assist]: 'Assist',
        [HandballGameLogTypes.penalty_miss]: 'Penalty miss',
        [HandballGameLogTypes.penalty_shot_on_goal]: 'Penalty on goal',
        [HandballGameLogTypes.penalty_goal]: 'Penalty goal',
        [HandballGameLogTypes.save]: 'Save',
        [HandballGameLogTypes.penalty_save]: 'Penalty save',
        [HandballGameLogTypes.foul]: 'Foul',
        [HandballGameLogTypes.yellow_card]: 'Yellow card',
        [HandballGameLogTypes.red_card]: 'Red card',
        [HandballGameLogTypes.two_minute_foul]: '2-minute penalty',
        [HandballGameLogTypes.turnover]: 'Turnover',
        [HandballGameLogTypes.steal]: 'Steal',
        [HandballGameLogTypes.block_shot]: 'Block shot',
        [HandballGameLogTypes.timeout]: 'Timeout',
    }
};

const WaterpoloGameLogTypeLocalization = {
    [Locales.ru]: {
        [WaterpoloGameLogTypes.enter_game]: 'Выход на площадку',
        [WaterpoloGameLogTypes.exit_game]: 'Ушел с площадки',
        [WaterpoloGameLogTypes.shot_miss]: 'Бросок мимо',
        [WaterpoloGameLogTypes.counterattack_miss]: 'Бросок мимо в контратаке',
        [WaterpoloGameLogTypes.maneuver_miss]: 'Бросок мимо с маневра',
        [WaterpoloGameLogTypes.center_forward_miss]: 'Бросок мимо со столба',
        [WaterpoloGameLogTypes.shot_on_goal]: 'Бросок по воротам',
        [WaterpoloGameLogTypes.counterattack_on_goal]: 'Бросок по воротам в контратаке',
        [WaterpoloGameLogTypes.maneuver_on_goal]: 'Бросок по воротам с маневра',
        [WaterpoloGameLogTypes.center_forward_on_goal]: 'Бросок по воротам со столба',
        [WaterpoloGameLogTypes.shot_blocked]: 'Заблокирован бросок',
        [WaterpoloGameLogTypes.counter_attack_shot_blocked]: 'Заблокирован бросок в контратаке',
        [WaterpoloGameLogTypes.maneuver_shot_blocked]: 'Заблокирован бросок с маневра',
        [WaterpoloGameLogTypes.center_forward_shot_blocked]: 'Заблокирован бросок со столба',
        [WaterpoloGameLogTypes.goal]: 'Гол',
        [WaterpoloGameLogTypes.maneuver_goal]: 'Гол с маневра',
        [WaterpoloGameLogTypes.counterattack_goal]: 'Гол в контратаке',
        [WaterpoloGameLogTypes.center_forward_goal]: 'Гол со столба',
        [WaterpoloGameLogTypes.shootout_attempt]: 'Пенальти промах',
        [WaterpoloGameLogTypes.shootout_goal]: 'Пенальти гол',
        [WaterpoloGameLogTypes.after_game_shootout_attempt]: 'Пенальти промах',
        [WaterpoloGameLogTypes.after_game_shootout_goal]: 'Пенальти гол',
        [WaterpoloGameLogTypes.assist]: 'Голевая передача',
        [WaterpoloGameLogTypes.block_shot]: 'Блокировка броска',
        [WaterpoloGameLogTypes.minor_penalty]: 'Удаление на 20 сек.',
        [WaterpoloGameLogTypes.major_penalty]: 'Удаление + 20 сек. штраф',
        [WaterpoloGameLogTypes.match_penalty]: 'Удаление + 4 мин. штраф',
        [WaterpoloGameLogTypes.foul]: 'Фол',
        [WaterpoloGameLogTypes.penalty_foul]: 'Фол пенальти',
        [WaterpoloGameLogTypes.attack_foul]: 'Фол в нападении',
        [WaterpoloGameLogTypes.personal_foul]: 'Персональный фол',
        [WaterpoloGameLogTypes.penalty_shot]: 'Штрафной бросок',
        [WaterpoloGameLogTypes.face_off_lose]: 'Проигрыш в спринте',
        [WaterpoloGameLogTypes.face_off_win]: 'Победа в спринте',
        [WaterpoloGameLogTypes.save]: 'Отражен бросок',
        [WaterpoloGameLogTypes.counterattack_save]: 'Отражен бросок в контратаке',
        [WaterpoloGameLogTypes.maneuver_save]: 'Отражен бросок с маневра',
        [WaterpoloGameLogTypes.center_forward_save]: 'Отражен бросок со столба',
        [WaterpoloGameLogTypes.free_kick_save]: 'Отражен бросок со свободного',
        [WaterpoloGameLogTypes.corner_save]: 'Отражен бросок с углового',
        [WaterpoloGameLogTypes.shootout_save]: 'Отражен бросок с пенальти',
        [WaterpoloGameLogTypes.after_game_shootout_save]: 'Отражен бросок с пенальти',
        [WaterpoloGameLogTypes.timeout]: 'Таймаут',
        [WaterpoloGameLogTypes.penalty_start]: 'Начало штрафного времени',
        [WaterpoloGameLogTypes.penalty_end]: 'Конец штрафного времени',
        [WaterpoloGameLogTypes.yellow_card]: 'Желтая карточка',
        [WaterpoloGameLogTypes.red_card]: 'Красная карточка',
        [WaterpoloGameLogTypes.turnover]: 'Переход владения',
        [WaterpoloGameLogTypes.loss]: 'Потеря',
        [WaterpoloGameLogTypes.steal]: 'Перехват',
        [WaterpoloGameLogTypes.tackle]: 'Отбор',
        [WaterpoloGameLogTypes.free_kick_goal]: 'Гол со свободного удара',
        [WaterpoloGameLogTypes.free_kick_on_goal]: 'Бросок со свободного удара в створ',
        [WaterpoloGameLogTypes.free_kick_miss]: 'Бросок мимо со свободного удара',
        [WaterpoloGameLogTypes.free_kick_shot_blocked]: 'Заблокирован бросок со свободного удара',
        [WaterpoloGameLogTypes.free_kick_pass]: 'Пас со свободного удара',
        [WaterpoloGameLogTypes.free_kick_self]: 'Розыгрыш свободного удара',
        [WaterpoloGameLogTypes.corner_goal]: 'Гол с углового',
        [WaterpoloGameLogTypes.corner_on_goal]: 'Бросок с углового в створ',
        [WaterpoloGameLogTypes.corner_miss]: 'Бросок мимо с углового',
        [WaterpoloGameLogTypes.corner_shot_blocked]: 'Заблокирован бросок с углового',
        [WaterpoloGameLogTypes.corner_pass]: 'Пас с углового',
        [WaterpoloGameLogTypes.corner_self]: 'Розыгрыш углового',
        [WaterpoloGameLogTypes.complete_penalty_time]: 'Досрочное завершение штрафа',
    },
    [Locales.en]: {
        [WaterpoloGameLogTypes.enter_game]: 'Entering the court',
        [WaterpoloGameLogTypes.exit_game]: 'Exit the court',
        [WaterpoloGameLogTypes.shot_miss]: 'Missing shoot',
        [WaterpoloGameLogTypes.counterattack_miss]: 'Throw past on the counterattack',
        [WaterpoloGameLogTypes.maneuver_miss]: 'Throw past from the manoeuvre',
        [WaterpoloGameLogTypes.center_forward_miss]: 'Throw past from center forward',
        [WaterpoloGameLogTypes.shot_on_goal]: 'Shot at the goal',
        [WaterpoloGameLogTypes.counterattack_on_goal]: 'Shot at the goal in a counterattack',
        [WaterpoloGameLogTypes.maneuver_on_goal]: 'Shot at the goal from a maneuver',
        [WaterpoloGameLogTypes.center_forward_on_goal]: 'Shot at the goal from center forward',
        [WaterpoloGameLogTypes.shot_blocked]: 'The throw is blocked',
        [WaterpoloGameLogTypes.counter_attack_shot_blocked]: 'A counterattack throw is blocked',
        [WaterpoloGameLogTypes.maneuver_shot_blocked]: 'The maneuver throw is blocked',
        [WaterpoloGameLogTypes.center_forward_shot_blocked]: 'The shot from the center forward is blocked',
        [WaterpoloGameLogTypes.goal]: 'Goal',
        [WaterpoloGameLogTypes.maneuver_goal]: 'Goal from a maneuver',
        [WaterpoloGameLogTypes.counterattack_goal]: 'Goal in a counterattack',
        [WaterpoloGameLogTypes.center_forward_goal]: 'Goal from the center forward',
        [WaterpoloGameLogTypes.shootout_attempt]: 'Penalty miss',
        [WaterpoloGameLogTypes.shootout_goal]: 'Penalty goal',
        [WaterpoloGameLogTypes.after_game_shootout_attempt]: 'Penalty miss',
        [WaterpoloGameLogTypes.after_game_shootout_goal]: 'Penalty goal',
        [WaterpoloGameLogTypes.assist]: 'Assist',
        [WaterpoloGameLogTypes.block_shot]: 'Blocking a throw',
        [WaterpoloGameLogTypes.minor_penalty]: 'Exclusion for 20 sec.',
        [WaterpoloGameLogTypes.major_penalty]: 'Exclusion with substitution 20 sec.',
        [WaterpoloGameLogTypes.match_penalty]: 'Exclusion with substitution after 4 min.',
        [WaterpoloGameLogTypes.foul]: 'Foul',
        [WaterpoloGameLogTypes.penalty_foul]: 'Penalty foul',
        [WaterpoloGameLogTypes.attack_foul]: 'Attack foul',
        [WaterpoloGameLogTypes.personal_foul]: 'Personal foul',
        [WaterpoloGameLogTypes.penalty_shot]: 'Penalty shot',
        [WaterpoloGameLogTypes.face_off_lose]: 'Losing in the sprint',
        [WaterpoloGameLogTypes.face_off_win]: 'Winning the sprint',
        [WaterpoloGameLogTypes.save]: 'Throw is reflected',
        [WaterpoloGameLogTypes.counterattack_save]: 'Throw in the counterattack is reflected',
        [WaterpoloGameLogTypes.maneuver_save]: 'Throw from a maneuver is reflected',
        [WaterpoloGameLogTypes.center_forward_save]: 'Throw from the center forward is reflected',
        [WaterpoloGameLogTypes.free_kick_save]: 'Free throw is reflected',
        [WaterpoloGameLogTypes.corner_save]: 'Shot from a corner is reflected',
        [WaterpoloGameLogTypes.shootout_save]: 'Penalty kick was deflected',
        [WaterpoloGameLogTypes.after_game_shootout_save]: 'Penalty kick was deflected',
        [WaterpoloGameLogTypes.timeout]: 'Timeout',
        [WaterpoloGameLogTypes.penalty_start]: 'The beginning of the penalty time',
        [WaterpoloGameLogTypes.penalty_end]: 'End of penalty time',
        [WaterpoloGameLogTypes.yellow_card]: 'Yellow card',
        [WaterpoloGameLogTypes.red_card]: 'Red card',
        [WaterpoloGameLogTypes.turnover]: 'Change of possession',
        [WaterpoloGameLogTypes.loss]: 'Loss',
        [WaterpoloGameLogTypes.steal]: 'Steal',
        [WaterpoloGameLogTypes.tackle]: 'Tackle',
        [WaterpoloGameLogTypes.free_kick_goal]: 'Free kick goal',
        [WaterpoloGameLogTypes.free_kick_on_goal]: 'Free kick shot on target',
        [WaterpoloGameLogTypes.free_kick_miss]: 'A throw by with a free kick',
        [WaterpoloGameLogTypes.free_kick_shot_blocked]: 'A free kick shot is blocked',
        [WaterpoloGameLogTypes.free_kick_pass]: 'Free kick pass',
        [WaterpoloGameLogTypes.free_kick_self]: 'Free kick draw',
        [WaterpoloGameLogTypes.corner_goal]: 'Corner goal',
        [WaterpoloGameLogTypes.corner_on_goal]: 'Shot from a corner into the target',
        [WaterpoloGameLogTypes.corner_miss]: 'Shot past from a corner',
        [WaterpoloGameLogTypes.corner_shot_blocked]: 'Blocked a shot from a corner',
        [WaterpoloGameLogTypes.corner_pass]: 'Pass from the corner',
        [WaterpoloGameLogTypes.corner_self]: 'Drawing a corner',
        [WaterpoloGameLogTypes.complete_penalty_time]: 'Early completion of the fine',
    }
};

const OvertimeTypeLocalization = {
    [Locales.ru]: {
        [OvertimeTypes.to_score_diff]: 'До разницы в N мячей',
        [OvertimeTypes.to_score_total]: 'До N очков',
        [OvertimeTypes.time]: 'По времени',
        [OvertimeTypes.without_overtime]: 'Без овертайма',
        [OvertimeTypes.to_first_goal]: 'На N минут до первой шайбы',
        [OvertimeTypes.to_first_goal_and_bullitts]: 'На N минут до первой шайбы + буллиты',
        [OvertimeTypes.bullitts]: 'Буллиты',
        [OvertimeTypes.penalties]: 'Пенальти',
        [OvertimeTypes.time_and_penalties]: 'Дополнительное время + пенальти',
    },
    [Locales.en]: {
        [OvertimeTypes.to_score_diff]: 'Up to the difference of N balls',
        [OvertimeTypes.to_score_total]: 'Up to N points',
        [OvertimeTypes.time]: 'By time',
        [OvertimeTypes.without_overtime]: 'Without overtime',
        [OvertimeTypes.to_first_goal]: 'N minutes until the first goal',
        [OvertimeTypes.to_first_goal_and_bullitts]: 'N minutes until the first goal + shootout',
        [OvertimeTypes.bullitts]: 'Shootouts',
        [OvertimeTypes.penalties]: 'Penalty',
        [OvertimeTypes.time_and_penalties]: 'Extra time + penalty',
    }
};

const RugbyFoulSanctionLocalization = {
    [Locales.ru]: {
        [RugbyFoulSanctions.scrum]: 'Схватка',
        [RugbyFoulSanctions.lineout]: 'Коридор',
        [RugbyFoulSanctions.start_kick]: 'Начальный удар',
        [RugbyFoulSanctions.free_kick]: 'Свободный удар',
        [RugbyFoulSanctions.penalty_shot]: 'Штрафной удар',
        [RugbyFoulSanctions.twenty_two_meters_kick]: 'Удар с 22 метров',
        [RugbyFoulSanctions.conversion_cancel]: 'Отмена удара',
        [RugbyFoulSanctions.yellow_card]: 'Желтая карточка',
        [RugbyFoulSanctions.red_card]: 'Красная карточка',
    },
    [Locales.en]: {
        [RugbyFoulSanctions.scrum]: 'Scrum',
        [RugbyFoulSanctions.lineout]: 'Lineout',
        [RugbyFoulSanctions.start_kick]: 'Start kick',
        [RugbyFoulSanctions.free_kick]: 'Free kick',
        [RugbyFoulSanctions.penalty_shot]: 'Penalty kick',
        [RugbyFoulSanctions.twenty_two_meters_kick]: 'Kick from 22 meters',
        [RugbyFoulSanctions.conversion_cancel]: 'Conversion cancel',
        [RugbyFoulSanctions.yellow_card]: 'Yellow card',
        [RugbyFoulSanctions.red_card]: 'Red card',
    }
};

const RugbyFoulGameStageLocalization = {
    [Locales.ru]: {
        [RugbyFoulGameStage.start_kick]: 'Начальные удары',
        [RugbyFoulGameStage.open_game]: 'Открытая игра',
        [RugbyFoulGameStage.tackle]: 'Игроки на земле, Захват',
        [RugbyFoulGameStage.ruck_or_maul]: 'Рак, мол',
        [RugbyFoulGameStage.scrum]: 'Схватка',
        [RugbyFoulGameStage.out_and_lineout]: 'Аут и коридор',
        [RugbyFoulGameStage.scoring_field]: 'Зачетное поле',
        [RugbyFoulGameStage.kick_on_goal]: 'Удар по воротам',
        [RugbyFoulGameStage.free_kick]: 'Штрафной, свободный удар',
        [RugbyFoulGameStage.team]: 'Команда',
    },
    [Locales.en]: {
        [RugbyFoulGameStage.start_kick]: 'Initial kicks',
        [RugbyFoulGameStage.open_game]: 'Open game',
        [RugbyFoulGameStage.tackle]: 'Players on the ground, Capture',
        [RugbyFoulGameStage.ruck_or_maul]: 'Ruck, maul',
        [RugbyFoulGameStage.scrum]: 'Scrum',
        [RugbyFoulGameStage.out_and_lineout]: 'Out and lineout',
        [RugbyFoulGameStage.scoring_field]: 'Scoring field',
        [RugbyFoulGameStage.kick_on_goal]: 'Kick on goal',
        [RugbyFoulGameStage.free_kick]: 'Free kick',
        [RugbyFoulGameStage.team]: 'Team',
    }
};

const RugbyGameLogTypeLocalization = {
    [Locales.ru]: {
        [RugbyGameLogTypes.enter_game]: 'Вышел на поле',
        [RugbyGameLogTypes.exit_game]: 'Ушел с поля',
        [RugbyGameLogTypes.try]: 'Попытка',
        [RugbyGameLogTypes.penalty_try]: 'Штрафная попытка',
        [RugbyGameLogTypes.conversion_goal]: 'Реализация',
        [RugbyGameLogTypes.conversion_miss]: 'Реализация промах',
        [RugbyGameLogTypes.penalty_miss]: 'Штрафной промах',
        [RugbyGameLogTypes.penalty_goal]: 'Штрафной гол',
        [RugbyGameLogTypes.penalty_kick_to_touch]: 'Штрафной в аут',
        [RugbyGameLogTypes.tap_penalty]: 'Штрафной разыгран',
        [RugbyGameLogTypes.drop_goal]: 'Дроп-гол',
        [RugbyGameLogTypes.drop_goal_miss]: 'Дроп-гол промах',
        [RugbyGameLogTypes.free_kick]: 'Свободный удар',
        [RugbyGameLogTypes.foul]: 'Фол',
        [RugbyGameLogTypes.yellow_card]: 'Желтая карточка',
        [RugbyGameLogTypes.red_card]: 'Красная карточка',
        [RugbyGameLogTypes.offload]: 'Скидка при завхвате',
        [RugbyGameLogTypes.tackle]: 'Успешный захват',
        [RugbyGameLogTypes.handling_error]: 'Ошибка приема',
        [RugbyGameLogTypes.carries_over_gainline]: 'Прорыв линии',
        [RugbyGameLogTypes.bleeding_injury]: 'Кровоточащая травма',
        [RugbyGameLogTypes.head_injury]: 'Травма головы',
        [RugbyGameLogTypes.end_game_penalty_miss]: 'Штрафной промах',
        [RugbyGameLogTypes.end_game_penalty_goal]: 'Штрафной гол',
        [RugbyGameLogTypes.foot_field_shot]: 'Удар ногой в поле',
        [RugbyGameLogTypes.foot_out_shot]: 'Удар ногой в аут',
        [RugbyGameLogTypes.foot_kick_50_22]: 'Удар ногой 50/22',
        [RugbyGameLogTypes.run]: 'Забег',
        [RugbyGameLogTypes.timeout]: 'Таймаут',
        [RugbyGameLogTypes.scrum_won]: 'Схватка выиграна',
        [RugbyGameLogTypes.scrum_lost]: 'Схватка проиграна',
        [RugbyGameLogTypes.scrum_won_free]: 'Схватка выиграна без сопротивления',
        [RugbyGameLogTypes.lineout_won]: 'Коридор выигран',
        [RugbyGameLogTypes.lineout_lost]: 'Коридор проигран',
        [RugbyGameLogTypes.quick_throw]: 'Быстрый вброс',
        [RugbyGameLogTypes.ruck_won]: 'Рак выигран',
        [RugbyGameLogTypes.ruck_lost]: 'Рак проигран',
        [RugbyGameLogTypes.maul_won]: 'Мол выигран',
        [RugbyGameLogTypes.maul_lost]: 'Мол проигран',
        [RugbyGameLogTypes.team_foul]: 'Нарушение',
        [RugbyGameLogTypes.start_kick]: 'Начальный удар',
        [RugbyGameLogTypes.twenty_two_meters_kick]: 'Удар с 22 метров',
        [RugbyGameLogTypes.goal_kick]: 'Удар от ворот',
        [RugbyGameLogTypes.out]: 'Аут',
    },
    [Locales.en]: {
        [RugbyGameLogTypes.enter_game]: 'Entering the court',
        [RugbyGameLogTypes.exit_game]: 'Exit the court',
        [RugbyGameLogTypes.try]: 'Attempt',
        [RugbyGameLogTypes.penalty_try]: 'Penalty attempt',
        [RugbyGameLogTypes.conversion_goal]: 'Touchdown',
        [RugbyGameLogTypes.conversion_miss]: 'Touchdown miss',
        [RugbyGameLogTypes.penalty_miss]: 'Penalty kick miss',
        [RugbyGameLogTypes.penalty_goal]: 'Penalty goal',
        [RugbyGameLogTypes.penalty_kick_to_touch]: 'Penalty kick to out',
        [RugbyGameLogTypes.tap_penalty]: 'Penalty has been played',
        [RugbyGameLogTypes.drop_goal]: 'Drop goal',
        [RugbyGameLogTypes.drop_goal_miss]: 'Drop goal miss',
        [RugbyGameLogTypes.free_kick]: 'Free kick',
        [RugbyGameLogTypes.foul]: 'Foul',
        [RugbyGameLogTypes.yellow_card]: 'Yellow card',
        [RugbyGameLogTypes.red_card]: 'Red card',
        [RugbyGameLogTypes.offload]: 'Offload',
        [RugbyGameLogTypes.tackle]: 'Successful tackle',
        [RugbyGameLogTypes.handling_error]: 'Error receiving',
        [RugbyGameLogTypes.carries_over_gainline]: 'Line breakout',
        [RugbyGameLogTypes.bleeding_injury]: 'Bleeding injury',
        [RugbyGameLogTypes.head_injury]: 'Head injury',
        [RugbyGameLogTypes.end_game_penalty_miss]: 'Penalty miss',
        [RugbyGameLogTypes.end_game_penalty_goal]: 'Penalty goal',
        [RugbyGameLogTypes.foot_field_shot]: 'Foot field shot',
        [RugbyGameLogTypes.foot_out_shot]: 'Kick out of bounds',
        [RugbyGameLogTypes.foot_kick_50_22]: 'Foot kick 50/22',
        [RugbyGameLogTypes.run]: 'Run',
        [RugbyGameLogTypes.timeout]: 'Timeout',
        [RugbyGameLogTypes.scrum_won]: 'Scrum is won',
        [RugbyGameLogTypes.scrum_lost]: 'Scrum is lost',
        [RugbyGameLogTypes.scrum_won_free]: 'Scrum was won without resistance',
        [RugbyGameLogTypes.lineout_won]: 'Lineout was won',
        [RugbyGameLogTypes.lineout_lost]: 'Lineout was lost',
        [RugbyGameLogTypes.quick_throw]: 'Quick throw',
        [RugbyGameLogTypes.ruck_won]: 'Ruck won',
        [RugbyGameLogTypes.ruck_lost]: 'Ruck lost',
        [RugbyGameLogTypes.maul_won]: 'Maul won',
        [RugbyGameLogTypes.maul_lost]: 'Maul lost',
        [RugbyGameLogTypes.team_foul]: 'Foul',
        [RugbyGameLogTypes.start_kick]: 'Start kick',
        [RugbyGameLogTypes.twenty_two_meters_kick]: '22 metres kick',
        [RugbyGameLogTypes.goal_kick]: 'Удар от ворот',
        [RugbyGameLogTypes.out]: 'Out',
    }
};

const TeamUserRoleLocalization = {
    [Locales.ru]: {
        [TeamUserRole.member]: 'Пользователь',
        [TeamUserRole.moderator]: 'Модератор',
        [TeamUserRole.admin]: 'Владелец',
        [TeamUserRole.coach]: 'Тренер',
        [TeamUserRole.head_coach]: 'Главный тренер',
        [TeamUserRole.playing_coach]: 'Играющий тренер',
        [TeamUserRole.manager]: 'Менеджер',
        [TeamUserRole.head_manager]: 'Генеральный менеджер',
        [TeamUserRole.captain]: 'Капитан',
        [TeamUserRole.assistant]: 'Ассистент',
        [TeamUserRole.president]: 'Президент',
        [TeamUserRole.vice_president]: 'Вице-президент',
        [TeamUserRole.press_attache]: 'Пресс-атташе',
        [TeamUserRole.executive]: 'Администратор',
        [TeamUserRole.senior_coach]: 'Старший тренер',
        [TeamUserRole.assistant_coach]: 'Помощник тренера',
        [TeamUserRole.serviceman]: 'Сервисмен',
        [TeamUserRole.game_application_manager]: 'Менеджер по заявкам на игры',
    },
    [Locales.en]: {
        [TeamUserRole.moderator]: 'Moderator',
        [TeamUserRole.member]: 'User',
        [TeamUserRole.admin]: 'Owner',
        [TeamUserRole.coach]: 'Coach',
        [TeamUserRole.head_coach]: 'Head coach',
        [TeamUserRole.playing_coach]: 'Playing coach',
        [TeamUserRole.manager]: 'Manager',
        [TeamUserRole.head_manager]: 'General Manager',
        [TeamUserRole.captain]: 'Captain',
        [TeamUserRole.assistant]: 'Assistant',
        [TeamUserRole.president]: 'President',
        [TeamUserRole.vice_president]: 'Vice President',
        [TeamUserRole.press_attache]: 'Press Attache',
        [TeamUserRole.executive]: 'Administrator',
        [TeamUserRole.senior_coach]: 'Senior Coach',
        [TeamUserRole.assistant_coach]: 'Assistant Coach',
        [TeamUserRole.serviceman]: 'Serviceman',
        [TeamUserRole.game_application_manager]: 'Game Application Manager',
    }
};

const GameBasketballPositionLocalization = {
    [Locales.ru]: {
        [GameBasketballPosition.point_guard]: 'Разыгрывающий защитник',
        [GameBasketballPosition.shooting_guard]: 'Атакующий защитник',
        [GameBasketballPosition.small_forward]: 'Легкий форвард',
        [GameBasketballPosition.power_forward]: 'Мощный форвард',
        [GameBasketballPosition.center]: 'Центровой',
    },
    [Locales.en]: {
        [GameBasketballPosition.point_guard]: 'Point guard',
        [GameBasketballPosition.shooting_guard]: 'Shooting guard',
        [GameBasketballPosition.small_forward]: 'Small forward',
        [GameBasketballPosition.power_forward]: 'Power forward',
        [GameBasketballPosition.center]: 'Center',
    }
};
const GameBasketballPositionShortLocalization = {
    [Locales.ru]: {
        [GameBasketballPosition.point_guard]: 'PG',
        [GameBasketballPosition.shooting_guard]: 'SG',
        [GameBasketballPosition.small_forward]: 'SF',
        [GameBasketballPosition.power_forward]: 'PF',
        [GameBasketballPosition.center]: 'C',
    },
    [Locales.en]: {
        [GameBasketballPosition.point_guard]: 'PG',
        [GameBasketballPosition.shooting_guard]: 'SG',
        [GameBasketballPosition.small_forward]: 'SF',
        [GameBasketballPosition.power_forward]: 'PF',
        [GameBasketballPosition.center]: 'C',
    }
};
const WorkHandLocalization = {
    [Locales.ru]: {
        [WorkHand.left]: 'Левая',
        [WorkHand.right]: 'Правая',
    },
    [Locales.en]: {
        [WorkHand.left]: 'Left',
        [WorkHand.right]: 'Right',
    }
};
const HockeyWorkHandLocalization = {
    [Locales.ru]: {
        [WorkHand.left]: 'Левый',
        [WorkHand.right]: 'Правый'
    },
    [Locales.en]: {
        [WorkHand.left]: 'Left',
        [WorkHand.right]: 'Right',
    }
};
const GameVolleyballPositionLocalization = {
    [Locales.ru]: {
        [GameVolleyballPosition.setter]: 'Связующий',
        [GameVolleyballPosition.libero]: 'Либеро',
        [GameVolleyballPosition.middle_player]: 'Центральный блокирующий',
        [GameVolleyballPosition.receiver_attacker]: 'Доигровщик',
        [GameVolleyballPosition.dioganal]: 'Диагональный',
    },
    [Locales.en]: {
        [GameVolleyballPosition.setter]: 'Setter',
        [GameVolleyballPosition.libero]: 'Libero',
        [GameVolleyballPosition.middle_player]: 'Middle blocker',
        [GameVolleyballPosition.receiver_attacker]: 'Outside hitter',
        [GameVolleyballPosition.dioganal]: 'Diagonal',
    }
};
const GameVolleyballPositionShortLocalization = {
    [Locales.ru]: {
        [GameVolleyballPosition.setter]: 'S',
        [GameVolleyballPosition.libero]: 'L',
        [GameVolleyballPosition.middle_player]: 'MP',
        [GameVolleyballPosition.receiver_attacker]: 'RA',
        [GameVolleyballPosition.dioganal]: 'D',
    },
    [Locales.en]: {
        [GameVolleyballPosition.setter]: 'S',
        [GameVolleyballPosition.libero]: 'L',
        [GameVolleyballPosition.middle_player]: 'MP',
        [GameVolleyballPosition.receiver_attacker]: 'RA',
        [GameVolleyballPosition.dioganal]: 'D',
    }
};
const GameVolleyballPositionShortRuLocalization = {
    [Locales.ru]: {
        [GameVolleyballPosition.setter]: 'связ.',
        [GameVolleyballPosition.libero]: 'либеро',
        [GameVolleyballPosition.middle_player]: 'блок.',
        [GameVolleyballPosition.receiver_attacker]: 'доигр.',
        [GameVolleyballPosition.dioganal]: 'диаг.',
    },
    [Locales.en]: {
        [GameVolleyballPosition.setter]: 'Setter',
        [GameVolleyballPosition.libero]: 'Libero',
        [GameVolleyballPosition.middle_player]: 'Middle blocker',
        [GameVolleyballPosition.receiver_attacker]: 'Outside hitter',
        [GameVolleyballPosition.dioganal]: 'Diagonal',
    }
};
const VolleyballWorkHandLocalization = {
    [Locales.ru]: {
        [VolleyballWorkHand.left]: 'Левая',
        [VolleyballWorkHand.right]: 'Правая'
    },
    [Locales.en]: {
        [WorkHand.left]: 'Left',
        [WorkHand.right]: 'Right',
    }
};
const GameHockeyPositionLocalization = {
    [Locales.ru]: {
        [GameHockeyPosition.goaltender]: 'Вратарь',
        [GameHockeyPosition.defensemen]: 'Защитник',
        [GameHockeyPosition.forward]: 'Нападающий',
    },
    [Locales.en]: {
        [GameHockeyPosition.defensemen]: 'Defender',
        [GameHockeyPosition.forward]: 'Forward',
        [GameHockeyPosition.goaltender]: 'Goalkeeper',
    }
};
const GameFootballPositionLocalization = {
    [Locales.ru]: {
        [GameFootballPosition.goalkeeper]: 'Вратарь',
        [GameFootballPosition.defensemen]: 'Защитник',
        [GameFootballPosition.midfielder]: 'Полузащитник',
        [GameFootballPosition.forward]: 'Нападающий',
    },
    [Locales.en]: {
        [GameFootballPosition.defensemen]: 'Defender',
        [GameFootballPosition.midfielder]: 'Midfielder',
        [GameFootballPosition.forward]: 'Forward',
        [GameFootballPosition.goalkeeper]: 'Goalkeeper',
    }
};
const FootballWorkFootLocalization = {
    [Locales.ru]: {
        [FootballWorkFoot.left]: 'Левая',
        [FootballWorkFoot.right]: 'Правая',
        [FootballWorkFoot.both]: 'Обе'
    },
    [Locales.en]: {
        [FootballWorkFoot.left]: 'Left',
        [FootballWorkFoot.right]: 'Right',
        [FootballWorkFoot.both]: 'Both',
    }
};
const GameHandballPositionLocalization = {
    [Locales.ru]: {
        [GameHandballPosition.goalkeeper]: 'Вратарь',
        [GameHandballPosition.winger]: 'Крайний',
        [GameHandballPosition.pivot]: 'Линейный',
        [GameHandballPosition.centre_back]: 'Центральный',
        [GameHandballPosition.fullback]: 'Полусредний',
    },
    [Locales.en]: {
        [GameHandballPosition.goalkeeper]: 'Goalkeeper',
        [GameHandballPosition.winger]: 'Wing',
        [GameHandballPosition.pivot]: 'Pivot',
        [GameHandballPosition.centre_back]: 'Centre back',
        [GameHandballPosition.fullback]: 'Back',
    }
};
const GameRugbyPositionLocalization = {
    [Locales.ru]: {
        [GameRugbyPosition.front_line]: 'Надающий первой линии',
        [GameRugbyPosition.second_line]: 'Нападающий второй линии',
        [GameRugbyPosition.back_line]: 'Нападающий задней линии',
        [GameRugbyPosition.halfback]: 'Полузащитник',
        [GameRugbyPosition.three_quarter]: 'Трехчетвертный',
        [GameRugbyPosition.fullback]: 'Замыкающий',
    },
    [Locales.en]: {
        [GameRugbyPosition.front_line]: 'The forward of the first line',
        [GameRugbyPosition.second_line]: 'The forward of the second line',
        [GameRugbyPosition.back_line]: 'The forward of the back line',
        [GameRugbyPosition.halfback]: 'Halfback',
        [GameRugbyPosition.three_quarter]: 'Three quarter',
        [GameRugbyPosition.fullback]: 'Fullback',
    }
};
const GameWaterpoloPositionLocalization = {
    [Locales.ru]: {
        [GameWaterpoloPosition.defensemen]: 'Защитник',
        [GameWaterpoloPosition.goalkeeper]: 'Вратарь',
        [GameWaterpoloPosition.center_forward]: 'Центральный нападающий',
        [GameWaterpoloPosition.mobile_forward]: 'Подвижный нападающий',
    },
    [Locales.en]: {
        [GameWaterpoloPosition.defensemen]: 'Defender',
        [GameWaterpoloPosition.goalkeeper]: 'Goalkeeper',
        [GameWaterpoloPosition.center_forward]: 'Center forward',
        [GameWaterpoloPosition.mobile_forward]: 'Mobile forward',
    }
};
const GameWaterpoloPositionShortRuLocalization = {
    [Locales.ru]: {
        [GameWaterpoloPosition.defensemen]: 'З',
        [GameWaterpoloPosition.goalkeeper]: 'Вр',
        [GameWaterpoloPosition.center_forward]: 'ЦН',
        [GameWaterpoloPosition.mobile_forward]: 'ПН',
    },
    [Locales.en]: {
        [GameWaterpoloPosition.defensemen]: 'D',
        [GameWaterpoloPosition.goalkeeper]: 'G',
        [GameWaterpoloPosition.center_forward]: 'CF',
        [GameWaterpoloPosition.mobile_forward]: 'MF',
    }
};
const WaterpoloWorkHandLocalization = {
    [Locales.ru]: {
        [WaterpoloWorkHand.left]: 'Левая',
        [WaterpoloWorkHand.right]: 'Правая',
    },
    [Locales.en]: {
        [WaterpoloWorkHand.left]: 'Left',
        [WaterpoloWorkHand.right]: 'Right'
    }
};
const WrestballWorkHandLocalization = {
    [Locales.ru]: {
        [WrestballWorkHand.left]: 'Левая',
        [WrestballWorkHand.right]: 'Правая'
    },
    [Locales.en]: {
        [WrestballWorkHand.left]: 'Left',
        [WrestballWorkHand.right]: 'Right'
    }
};

const VolleyballGameLogTypeLocalization = {
    [Locales.ru]: {
        [VolleyballGameLogType.enter_game]: 'Выход на площадку',
        [VolleyballGameLogType.exit_game]: 'Уход с площадки',
        [VolleyballGameLogType.remove_game]: 'Удаление с площадки',
        [VolleyballGameLogType.serve_ace]: 'Эйс',
        [VolleyballGameLogType.serve_hit]: 'Подача',
        [VolleyballGameLogType.serve_fault]: 'Ошибка на подаче',
        [VolleyballGameLogType.good_serve]: 'Усложнённая подача',
        [VolleyballGameLogType.attack_spike]: 'Результативная атака',
        [VolleyballGameLogType.attack_shot]: 'Атака',
        [VolleyballGameLogType.attack_fault]: 'Ошибка атаки',
        [VolleyballGameLogType.stuff_block]: 'Результативный блок',
        [VolleyballGameLogType.block_rebound]: 'Блок',
        [VolleyballGameLogType.block_fault]: 'Ошибка на блоке',
        [VolleyballGameLogType.excellent_receive]: 'Отличный прием',
        [VolleyballGameLogType.receive]: 'Прием',
        [VolleyballGameLogType.receive_fault]: 'Ошибка на приеме',
        [VolleyballGameLogType.serve_receive]: 'Прием подачи',
        [VolleyballGameLogType.excellent_serve_receive]: 'Отличный прием подачи',
        [VolleyballGameLogType.serve_receive_fault]: 'Ошибка приема подачи',
        [VolleyballGameLogType.point]: 'Очко',
        [VolleyballGameLogType.fault]: 'Ошибка',
        [VolleyballGameLogType.timeout]: 'Таймаут',
        [VolleyballGameLogType.yellow_card]: 'Предупреждение',
        [VolleyballGameLogType.tie_ball]: 'Спорный мяч',
    },
    [Locales.en]: {
        [VolleyballGameLogType.enter_game]: 'Entering the court',
        [VolleyballGameLogType.exit_game]: 'Exit the court',
        [VolleyballGameLogType.remove_game]: 'Removed from the court',
        [VolleyballGameLogType.serve_ace]: 'Ace',
        [VolleyballGameLogType.serve_hit]: 'Serve',
        [VolleyballGameLogType.serve_fault]: 'Mistake on a serve',
        [VolleyballGameLogType.good_serve]: 'Good serve',
        [VolleyballGameLogType.attack_spike]: 'Resulting attack',
        [VolleyballGameLogType.attack_shot]: 'Attack',
        [VolleyballGameLogType.attack_fault]: 'Attack fault',
        [VolleyballGameLogType.stuff_block]: 'Resulting block',
        [VolleyballGameLogType.block_rebound]: 'Block',
        [VolleyballGameLogType.block_fault]: 'Block fault',
        [VolleyballGameLogType.excellent_receive]: 'Excellent receive',
        [VolleyballGameLogType.receive]: 'Receive',
        [VolleyballGameLogType.receive_fault]: 'Receive fault',
        [VolleyballGameLogType.serve_receive]: 'Serve receive',
        [VolleyballGameLogType.excellent_serve_receive]: 'Excellent serve receive',
        [VolleyballGameLogType.serve_receive_fault]: 'Serve receive fault',
        [VolleyballGameLogType.point]: 'Point',
        [VolleyballGameLogType.fault]: 'Fault',
        [VolleyballGameLogType.timeout]: 'Timeout',
        [VolleyballGameLogType.yellow_card]: 'Warning',
        [VolleyballGameLogType.tie_ball]: 'Tie ball',
    }
};

const OrganizationStatusesLocalization = {
    [Locales.ru]: {
        [OrganizationStatuses.active]: 'Активен',
        [OrganizationStatuses.blocked]: 'Заблокирован',
        [OrganizationStatuses.not_confirmed]: 'Не подтвержден'
    },
    [Locales.en]: {
        [OrganizationStatuses.active]: 'Active',
        [OrganizationStatuses.blocked]: 'Blocked',
        [OrganizationStatuses.not_confirmed]: 'Not confirmed',
    }
};

const WrestballGameLogTypeLocalization = {
    [Locales.ru]: {
        [WrestballGameLogTypes.enter_game]: 'Выход на площадку',
        [WrestballGameLogTypes.exit_game]: 'Ушел с площадки',
        [WrestballGameLogTypes.remove_game]: 'Удаление с площадки',
        [WrestballGameLogTypes.two_point_attempt]: 'Бросок 2 очка',
        [WrestballGameLogTypes.three_point_attempt]: 'Бросок 3 очка',
        [WrestballGameLogTypes.free_throw_attempt]: 'Штрафной бросок 1 очко',
        [WrestballGameLogTypes.two_point_free_throw_attempt]: 'Штрафной бросок 2 очка',
        [WrestballGameLogTypes.three_point_free_throw_attempt]: 'Штрафной бросок 3 очка',
        [WrestballGameLogTypes.one_point_attempt]: 'Бросок 1 очко',
        [WrestballGameLogTypes.two_point_made]: '2 очка',
        [WrestballGameLogTypes.three_point_made]: '3 очка',
        [WrestballGameLogTypes.free_throw_made]: '1 очко, штрафной',
        [WrestballGameLogTypes.two_point_free_throw_made]: '2 очка, штрафной',
        [WrestballGameLogTypes.three_point_free_throw_made]: '3 очка, штрафной',
        [WrestballGameLogTypes.one_point_made]: '1 очко',
        [WrestballGameLogTypes.dunk_made]: '2 очка, данк',
        [WrestballGameLogTypes.dunk_attempt]: 'Попытка данка',
        [WrestballGameLogTypes.assist]: 'Передача',
        [WrestballGameLogTypes.block]: 'Блокшот',
        [WrestballGameLogTypes.rebound]: 'Подбор',
        [WrestballGameLogTypes.offensive_rebound]: 'Подбор в нападении',
        [WrestballGameLogTypes.defensive_rebound]: 'Подбор в защите',
        [WrestballGameLogTypes.steal]: 'Перехват',
        [WrestballGameLogTypes.turnover]: 'Потеря',
        [WrestballGameLogTypes.personal_foul]: 'Фол',
        [WrestballGameLogTypes.timeout]: 'Таймаут',
        [WrestballGameLogTypes.team_rebound]: 'Командный подбор',
        [WrestballGameLogTypes.scrum]: 'Схватка',
        [WrestballGameLogTypes.scrum_won]: 'Схватка выиграна',
        [WrestballGameLogTypes.scrum_lost]: 'Схватка проиграна',
        [WrestballGameLogTypes.scrum_tie]: 'Схватка в ничью',
        [WrestballGameLogTypes.wrestler_scrum]: 'Атака рестлера',
        [WrestballGameLogTypes.wrestler_scrum_won]: 'Атака рестлера успешна',
        [WrestballGameLogTypes.wrestler_scrum_lost]: 'Атака рестлера неудачна',
        [WrestballGameLogTypes.wrestler_scrum_tie]: 'Атака рестлера в ничью',
        [WrestballGameLogTypes.wrestler_scrum_counterattack]: 'Контратака на рестлере',
        [WrestballGameLogTypes.scrum_ball_advantage_won]: 'Схватка за начало выиграна',
        [WrestballGameLogTypes.scrum_ball_advantage_lost]: 'Схватка за начало проиграна',
        [WrestballGameLogTypes.scrum_ball_advantage_tie]: 'Схватка за начало в ничью',
        [WrestballGameLogTypes.yellow_card]: 'Желтая карточка',
        [WrestballGameLogTypes.red_card]: 'Красная карточка',
    },
    [Locales.en]: {
        [WrestballGameLogTypes.enter_game]: 'Entering the court',
        [WrestballGameLogTypes.exit_game]: 'Exit the court',
        [WrestballGameLogTypes.remove_game]: 'Removal from the court',
        [WrestballGameLogTypes.two_point_attempt]: 'Throw 2 points',
        [WrestballGameLogTypes.three_point_attempt]: 'Throw 3 points',
        [WrestballGameLogTypes.free_throw_attempt]: 'Free throw 1 point',
        [WrestballGameLogTypes.two_point_free_throw_attempt]: 'Free throw 2 points',
        [WrestballGameLogTypes.three_point_free_throw_attempt]: 'Free throw 3 points',
        [WrestballGameLogTypes.one_point_attempt]: 'Throw 1 point',
        [WrestballGameLogTypes.two_point_made]: '2 points',
        [WrestballGameLogTypes.three_point_made]: '3 points',
        [WrestballGameLogTypes.free_throw_made]: '1 point, free throw',
        [WrestballGameLogTypes.two_point_free_throw_made]: '2 points, free throw',
        [WrestballGameLogTypes.three_point_free_throw_made]: '3 points, free throw',
        [WrestballGameLogTypes.one_point_made]: '1 point',
        [WrestballGameLogTypes.dunk_made]: '2 points, dunk',
        [WrestballGameLogTypes.dunk_attempt]: 'Dunk attempt',
        [WrestballGameLogTypes.assist]: 'Assist',
        [WrestballGameLogTypes.block]: 'Block',
        [WrestballGameLogTypes.rebound]: 'Rebound',
        [WrestballGameLogTypes.offensive_rebound]: 'Offensive rebound',
        [WrestballGameLogTypes.defensive_rebound]: 'Defensive rebound',
        [WrestballGameLogTypes.steal]: 'Steal',
        [WrestballGameLogTypes.turnover]: 'Turnover',
        [WrestballGameLogTypes.personal_foul]: 'Personal foul',
        [WrestballGameLogTypes.timeout]: 'Timeout',
        [WrestballGameLogTypes.team_rebound]: 'Team rebound',
        [WrestballGameLogTypes.scrum]: 'Scrum',
        [WrestballGameLogTypes.scrum_won]: 'Scrum is won',
        [WrestballGameLogTypes.scrum_lost]: 'Scrum is lost',
        [WrestballGameLogTypes.scrum_tie]: 'Scrum is in a draw',
        [WrestballGameLogTypes.wrestler_scrum]: 'Wrestler attack',
        [WrestballGameLogTypes.wrestler_scrum_won]: 'Successful Wrestler attack',
        [WrestballGameLogTypes.wrestler_scrum_lost]: 'Unsuccessful Wrestler attack',
        [WrestballGameLogTypes.wrestler_scrum_tie]: 'Wrestler\'s attack in a draw',
        [WrestballGameLogTypes.wrestler_scrum_counterattack]: 'Counterattack on the wrestler',
        [WrestballGameLogTypes.scrum_ball_advantage_won]: 'Scrum for the beginning is won',
        [WrestballGameLogTypes.scrum_ball_advantage_lost]: 'Scrum for the beginning is lost',
        [WrestballGameLogTypes.scrum_ball_advantage_tie]: 'Scrum for the beginning is in draw',
        [WrestballGameLogTypes.yellow_card]: 'Yellow card',
        [WrestballGameLogTypes.red_card]: 'Red card',
    }
};

var OrganizationBillStatuses;
(function (OrganizationBillStatuses) {
    OrganizationBillStatuses[OrganizationBillStatuses["pending"] = 1] = "pending";
    OrganizationBillStatuses[OrganizationBillStatuses["paid"] = 2] = "paid";
    OrganizationBillStatuses[OrganizationBillStatuses["canceled"] = 3] = "canceled";
})(OrganizationBillStatuses || (OrganizationBillStatuses = {}));
const OrganizationBillStatusLocalization = {
    [Locales.ru]: {
        [OrganizationBillStatuses.pending]: 'Новый',
        [OrganizationBillStatuses.paid]: 'Оплачен',
        [OrganizationBillStatuses.canceled]: 'Отменен',
    },
    [Locales.en]: {
        [OrganizationBillStatuses.pending]: 'New',
        [OrganizationBillStatuses.paid]: 'Paid',
        [OrganizationBillStatuses.canceled]: 'Canceled',
    }
};
let OrganizationBill = class OrganizationBill extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], OrganizationBill, "toFront", null);
__decorate([
    ToBackHook
], OrganizationBill, "toBack", null);
OrganizationBill = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            organization: 'organization',
            status: 'status',
            sum: 'sum',
            payment_date: 'paymentDate',
            pay_till_date: 'payTillDate',
            date_from: 'dateFrom',
            date_to: 'dateTo',
            created_at: 'createdAt',
        },
        relation: {
            organization: Organization,
            status: enumField(OrganizationBillStatuses),
            paymentDate: DateTimeField,
            payTillDate: DateTimeField,
            dateFrom: DateTimeField,
            dateTo: DateTimeField,
            createdAt: DateTimeField,
        }
    })
], OrganizationBill);

var GameBillStatuses;
(function (GameBillStatuses) {
    GameBillStatuses[GameBillStatuses["pending"] = 1] = "pending";
    GameBillStatuses[GameBillStatuses["paid"] = 2] = "paid";
    GameBillStatuses[GameBillStatuses["canceled"] = 3] = "canceled";
})(GameBillStatuses || (GameBillStatuses = {}));
const GameBillStatusLocalization = {
    [Locales.ru]: {
        [GameBillStatuses.pending]: 'Новый',
        [GameBillStatuses.paid]: 'Оплачен',
        [GameBillStatuses.canceled]: 'Отменен',
    },
    [Locales.en]: {
        [GameBillStatuses.pending]: 'New',
        [GameBillStatuses.paid]: 'Paid',
        [GameBillStatuses.canceled]: 'Canceled',
    }
};
let GameBill = class GameBill extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], GameBill, "toFront", null);
__decorate([
    ToBackHook
], GameBill, "toBack", null);
GameBill = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            game: 'game',
            status: 'status',
            organization_bill: 'organizationBill',
            paid_date: 'paidDate',
            price: 'price',
            created_at: 'createdAt',
        },
        relation: {
            game: Game,
            organizationBill: OrganizationBill,
            status: enumField(GameBillStatuses),
            paidDate: DateTimeField,
            createdAt: DateTimeField,
        }
    })
], GameBill);

let LeaguePlaylist = class LeaguePlaylist extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], LeaguePlaylist, "toFront", null);
__decorate([
    ToBackHook
], LeaguePlaylist, "toBack", null);
LeaguePlaylist = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            name: 'name',
            files: 'files',
            key_code: 'keyCode',
        },
        relation: {
            files: listField(File)
        }
    })
], LeaguePlaylist);

let OrganizationTariff = class OrganizationTariff extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], OrganizationTariff, "toFront", null);
__decorate([
    ToBackHook
], OrganizationTariff, "toBack", null);
OrganizationTariff = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            organization: 'organization',
            price: 'price',
            sport: 'sport',
        },
        relation: {
            organization: Organization,
            sport: Sport,
        }
    })
], OrganizationTariff);

let OrganizationStatistic = class OrganizationStatistic extends BaseModel {
    static toFront(data) { }
    static toBack(data) { }
};
__decorate([
    ToFrontHook
], OrganizationStatistic, "toFront", null);
__decorate([
    ToBackHook
], OrganizationStatistic, "toBack", null);
OrganizationStatistic = __decorate([
    ModelInstance({
        mappingFields: {
            id: 'id',
            players_count: 'playersCount',
            teams_count: 'teamsCount',
            games_count: 'gamesCount',
            paid_sum: 'paidSum',
            debt_sum: 'debtSum',
        },
    })
], OrganizationStatistic);
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BaseService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return []; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ConfigService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: undefined, decorators: [{
                type: Optional
            }, {
                type: Inject,
                args: [CONFIG_DATA]
            }] }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(GameBaseApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(BasketballGameApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FeedbackApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FileApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HockeyGameApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(FootballGameApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HandballGameApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TournamentApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeagueApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeagueNewsApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeaguePlayerApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(LeagueTeamApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(MediaApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationBaseApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(NotificationApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(OrgNotificationApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], null, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(ReferenceApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(RugbyGameApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TeamApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TeamEventApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TournamentJoinApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TournamentRoundApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TournamentSeasonApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(TournamentStageApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(UserApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(VolleyballGameApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WaterpoloGameApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(WrestballGameApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PublicTeamApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(PublicUserApi, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }]; }, null); })();

class CentrifugoService {
    constructor(httpClient, configService, platformId) {
        this.httpClient = httpClient;
        this.configService = configService;
        this.platformId = platformId;
        this.channels$ = {};
        this.subscriptions = {};
        this.connectedSubject = new BehaviorSubject(false);
    }
    get connected$() {
        return this.connectedSubject;
    }
    listen(channel) {
        if (!isPlatformBrowser(this.platformId)) {
            console.error('Centrifugo is not available in ssr mode');
            return new Observable(observer => { });
        }
        if (channel in this.channels$) {
            return this.channels$[channel];
        }
        this.channels$[channel] = new Subject();
        this.connect().subscribe(connected => {
            this.subscriptions[channel] = this.addEngineSubscription(channel);
        });
        return this.channels$[channel];
    }
    unsubscribe(channel) {
        if (this.subscriptions[channel]) {
            this.subscriptions[channel].unsubscribe();
            this.centrifuge.removeSubscription(this.subscriptions[channel]);
            delete this.subscriptions[channel];
        }
        if (this.channels$[channel]) {
            this.channels$[channel].complete();
            delete this.channels$[channel];
        }
    }
    connect() {
        if (!isPlatformBrowser(this.platformId)) {
            console.error('Centrifugo is not available in ssr mode');
            return new Observable(observer => { });
        }
        if (!this.initializeEngineSubject) {
            this.initializeEngineSubject = new ReplaySubject(1);
            this.httpClient.get(`${this.configService.get('apiUrl')}/api/v1/centrifugo_v2/`)
                .subscribe(config => {
                this.initializeEngine({
                    url: this.configService.get('centrifugoUrl'),
                    token: config.token,
                    transports: ['websocket']
                });
                this.centrifuge.on('connected', () => {
                    this.initializeEngineSubject.next(true);
                    this.connectedSubject.next(true);
                });
                this.centrifuge.on('disconnected', () => {
                    this.connectedSubject.next(false);
                    this.initializeEngineSubject.next(false);
                });
                this.centrifuge.connect();
            });
        }
        return this.initializeEngineSubject.pipe(filter(item => Boolean(item)), take(1));
    }
    publish(channel, message) {
        if (!isPlatformBrowser(this.platformId)) {
            console.error('Centrifugo is not available in ssr mode');
            return new Observable(observer => { });
        }
        return this.connect().pipe(tap(() => this.centrifuge.publish(channel, message)));
    }
    disconnect() {
        if (this.centrifuge) {
            this.centrifuge.disconnect();
        }
        this.initializeEngineSubject = undefined;
        for (const channel of Object.keys(this.channels$)) {
            this.unsubscribe(channel);
        }
        this.channels$ = {};
        this.subscriptions = {};
    }
    initializeEngine(config) {
        this.centrifuge = new Centrifuge(config.url, {
            token: config.token,
            maxReconnectDelay: 3000,
            maxServerPingDelay: 3000,
            timeout: 1000,
        });
    }
    addEngineSubscription(channel) {
        let sub = this.centrifuge.getSubscription(channel);
        if (!sub) {
            sub = this.centrifuge.newSubscription(channel);
            sub.on('publication', ctx => {
                this.resolveMessage(channel, ctx.data);
            });
        }
        sub.subscribe();
        return sub;
    }
    resolveMessage(channel, message) {
        if (!this.channels$[channel]) {
            return;
        }
        this.channels$[channel].next(message);
    }
}
CentrifugoService.ɵfac = function CentrifugoService_Factory(t) { return new (t || CentrifugoService)(ɵngcc0.ɵɵinject(ɵngcc1.HttpClient), ɵngcc0.ɵɵinject(ConfigService), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
CentrifugoService.ɵprov = i0.ɵɵdefineInjectable({ factory: function CentrifugoService_Factory() { return new CentrifugoService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(ConfigService), i0.ɵɵinject(i0.PLATFORM_ID)); }, token: CentrifugoService, providedIn: "root" });
CentrifugoService.ctorParameters = () => [
    { type: HttpClient },
    { type: ConfigService },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(CentrifugoService, [{
        type: Injectable,
        args: [{ providedIn: 'root' }]
    }], function () { return [{ type: ɵngcc1.HttpClient }, { type: ConfigService }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

class StorageEngineField {
    constructor(defaultValue, modelClass) {
        this.modelClass = modelClass;
        this.defaultValue = defaultValue;
    }
    toFront(value) {
        if (this.modelClass) {
            return this.modelClass.toFront(value);
        }
        return value;
    }
    toBack(value) {
        if (this.modelClass) {
            return this.modelClass.toBack(value);
        }
        return value;
    }
}
class StorageEngine {
    constructor(name, fields) {
        this.name = name;
        this.fields = fields;
    }
    addField(key, field) {
        this.fields[key] = field;
    }
    save(key, value) {
        if (!this.fields[key]) {
            return;
        }
        this.setItem(`${this.name}_${key}`, this.fields[key].toBack(value));
    }
    get(key) {
        if (!this.fields[key]) {
            return;
        }
        let value = this.getItem(`${this.name}_${key}`);
        if (value === null) {
            value = this.fields[key].defaultValue;
        }
        if (value === null || value === undefined) {
            return value;
        }
        return this.fields[key].toFront(value);
    }
    clear() {
        for (const field of Object.keys(this.fields)) {
            this.removeItem(field);
        }
    }
    getItem(key) {
        throw new Error(`Function getItem for store engine ${typeof this} not implemented`);
    }
    setItem(key, value) {
        throw new Error(`Function setItem for store engine ${typeof this} not implemented`);
    }
    removeItem(key) {
        throw new Error(`Function deleteItem for store engine ${typeof this} not implemented`);
    }
}

class LocalStorageEngine extends StorageEngine {
    setItem(key, value) {
        localStorage.setItem(key, JSON.stringify(value));
    }
    getItem(key) {
        try {
            return JSON.parse(localStorage.getItem(key));
        }
        catch (e) {
            return;
        }
    }
    removeItem(key) {
        localStorage.removeItem(key);
    }
}

function componentDestroyed(component) {
    if (!component.__decoratorApplied) {
        throw new Error('Use @UntilDestroy decorator in class');
    }
    if (!component.__componentDestroyed$) {
        component.__componentDestroyed$ = new Subject$1();
    }
    return component.__componentDestroyed$;
}
function UntilDestroy(cmpType) {
    const original = cmpType.prototype.ngOnDestroy;
    cmpType.prototype.__decoratorApplied = true;
    cmpType.prototype.ngOnDestroy = function () {
        original.call(this);
        if (this.__componentDestroyed$) {
            this.__componentDestroyed$.next();
            this.__componentDestroyed$.complete();
            delete this.__componentDestroyed$;
        }
    };
}
function getDef(type) {
    return type.ɵcmp || type.ɵdir;
}

function getCookie(name) {
    const value = `; ${document.cookie}`;
    const parts = value.split(`; ${name}=`);
    if (parts.length === 2) {
        return parts.pop().split(';').shift();
    }
    return null;
}

function parseDate(input, format = 'yyyy-mm-dd') {
    const parts = input.match(/(\d+)/g);
    let i = 0;
    const result = {};
    // extract date-part indexes from the format
    format.replace(/(yyyy|dd|mm)/g, (part) => {
        result[part] = +parts[i++];
        return '';
    });
    return new Date(result.yyyy, result.mm - 1, result.dd);
}

function isTouchDevice() {
    const prefixes = ' -webkit- -moz- -o- -ms- '.split(' ');
    const mq = (q) => {
        return window.matchMedia(q).matches;
    };
    if (('ontouchstart' in window) || window.DocumentTouch && document instanceof window.DocumentTouch) {
        return true;
    }
    // include the 'heartz' as a way to have a non matching MQ to help terminate the join
    // https://git.io/vznFH
    const query = ['(', prefixes.join('touch-enabled),('), 'heartz', ')'].join('');
    return mq(query);
}

function getEnumOptions(enumClass) {
    return Object.keys(enumClass)
        .map(v => enumClass[v])
        .filter(v => isNaN(+v) === false)
        .map(v => +v);
}

function handleError(error, force = false, production = true) {
    if (!(error && (error.status === 0 || error.status === 404)) || (force && error.status !== 0)) {
        captureException(error);
    }
    if (!production) {
        console.error(error);
    }
}

function getIconsData(folder) {
    return [
        { rel: 'apple-touch-icon', sizes: '180x180', href: `/assets/favicon/${folder}apple-touch-icon.png` },
        { rel: 'icon', type: 'image/png', sizes: '32x32', href: `/assets/favicon/${folder}favicon-32x32.png` },
        { rel: 'icon', type: 'image/png', sizes: '16x16', href: `/assets/favicon/${folder}favicon-16x16.png` },
        { rel: 'shortcut icon', href: `/assets/favicon/${folder}favicon.ico` },
        { rel: 'manifest', href: `/assets/favicon/${folder}site.webmanifest` },
        { rel: 'mask-icon', href: `/assets/favicon/${folder}safari-pinned-tab.svg`, color: '#ff0000' }
    ];
}
function changeFavicons(document, leagueAlias) {
    let folder = '';
    if (leagueAlias === 'ablmoscow') {
        folder = 'abl/';
    }
    const data = getIconsData(folder);
    for (const item of data) {
        const link = document.createElement('link');
        for (const key of Object.keys(item)) {
            link.setAttribute(key, item[key]);
        }
        document.head.appendChild(link);
    }
}

function markFormGroupTouched(formGroup) {
    Object.values(formGroup.controls).forEach(control => {
        control.markAsTouched();
        control.markAsDirty();
        if (control instanceof FormGroup) {
            markFormGroupTouched(control);
        }
        else if (control.controls) {
            control.controls.forEach(c => {
                if (c instanceof FormGroup) {
                    markFormGroupTouched(c);
                }
                else {
                    c.markAsTouched();
                    c.markAsDirty();
                }
            });
        }
    });
}

const minLengthArrayValidator = (minLength) => {
    return (c) => {
        return c.value.length < minLength
            ? { minLengthArray: { valid: false } }
            : null;
    };
};
const validatePhone = (control) => {
    if (!control.value) {
        return null;
    }
    const value = `${control.value}`.replace(/\D/gi, '');
    return value.length === 11 ? null : { invalidPhone: { valid: false } };
};
const validateDate = (control) => {
    const re = /\d{2}\.\d{2}\.\d{4}/gi;
    if (!control.value || re.test(control.value)) {
        return null;
    }
    return { invalidDate: { valid: false } };
};
const validateEmail = (authService, selfCheck = true, ignore = []) => {
    const subject = of(null).pipe(delay(500));
    return (control) => {
        if (ignore.indexOf(control.value) > -1) {
            return of(null);
        }
        return subject.pipe(switchMap(() => authService.checkEmail(control.value, selfCheck).pipe(map(valid => valid ? null : { emailTaken: true }))));
    };
};
const validateUrl = (control) => {
    const re = /^(?:http(s)?:\/\/)[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\(\)\*\+,;=.]+$/;
    if (!control.value || re.test(control.value)) {
        return null;
    }
    return { invalidUrl: true };
};
function fileSizeValidator(maxFileSize) {
    return (control) => {
        if (!control.value) {
            return null;
        }
    };
}

class HttpCookieInterceptor {
    constructor(injector, configService, platformId) {
        this.injector = injector;
        this.configService = configService;
        this.platformId = platformId;
        this.isBrowser = isPlatformBrowser(this.platformId);
    }
    intercept(req, next) {
        if (!this.isBrowser) {
            return next.handle(req);
        }
        const apiUrl = this.configService.get('apiUrl');
        if (apiUrl === req.url.substr(0, apiUrl.length)) {
            req = req.clone({ withCredentials: true });
        }
        const csrf = getCookie('csrftoken');
        if (csrf) {
            req = req.clone({
                setHeaders: { 'X-CSRFToken': csrf }
            });
        }
        return next.handle(req);
    }
}
HttpCookieInterceptor.ɵfac = function HttpCookieInterceptor_Factory(t) { return new (t || HttpCookieInterceptor)(ɵngcc0.ɵɵinject(ɵngcc0.Injector), ɵngcc0.ɵɵinject(ConfigService), ɵngcc0.ɵɵinject(PLATFORM_ID)); };
HttpCookieInterceptor.ɵprov = /*@__PURE__*/ ɵngcc0.ɵɵdefineInjectable({ token: HttpCookieInterceptor, factory: HttpCookieInterceptor.ɵfac });
HttpCookieInterceptor.ctorParameters = () => [
    { type: Injector },
    { type: ConfigService },
    { type: String, decorators: [{ type: Inject, args: [PLATFORM_ID,] }] }
];
(function () { (typeof ngDevMode === "undefined" || ngDevMode) && ɵngcc0.ɵsetClassMetadata(HttpCookieInterceptor, [{
        type: Injectable
    }], function () { return [{ type: ɵngcc0.Injector }, { type: ConfigService }, { type: String, decorators: [{
                type: Inject,
                args: [PLATFORM_ID]
            }] }]; }, null); })();

/**
 * Generated bundle index. Do not edit.
 */

export { Achievement, AchievementTypes, BannerLocation, BaseModel, BaseService, BasketballCourtSides, BasketballCourtZones, BasketballGameApi, BasketballGameConfig, BasketballGameLog, BasketballGameLogTypeLocalization, BasketballGameLogTypes, BasketballGameStatistic, BasketballGameSubLogTypesLocalization, BasketballGameTeamStatistic, BasketballPenaltyTypes, BasketballProfile, BasketballStatistic, BasketballStatisticTypes, BasketballSubLogTypes, CONFIG_DATA, CentrifugoService, City, ConfigService, Country, CountryLocalization, DateField, DateTimeField, FAULT_LOG_TYPES, Feedback, FeedbackApi, File, FileApi, FileEngine, FootballGameApi, FootballGameConfig, FootballGameLog, FootballGameLogTypeLocalization, FootballGameLogTypes, FootballGameStatistic, FootballGameTeamStatistic, FootballProfile, FootballStatistic, FootballWorkFoot, FootballWorkFootLocalization, Game, GameAdditionalData, GameBaseApi, GameBasketballPosition, GameBasketballPositionLocalization, GameBasketballPositionShortLocalization, GameBill, GameBillStatusLocalization, GameBillStatuses, GameFootballPosition, GameFootballPositionLocalization, GameHandballPosition, GameHandballPositionLocalization, GameHockeyPosition, GameHockeyPositionLocalization, GameInvite, GameInviteStatus, GameResultTypes, GameRugbyPosition, GameRugbyPositionLocalization, GameStatuses, GameTeamAdditionalData, GameTimeTypes, GameTimelineStageItem, GameTimelineStages, GameUser, GameUserDisqualification, GameUserLimitationTypes, GameUserLimitations, GameVolleyballPosition, GameVolleyballPositionLocalization, GameVolleyballPositionShortLocalization, GameVolleyballPositionShortRuLocalization, GameWaterpoloPosition, GameWaterpoloPositionLocalization, GameWaterpoloPositionShortRuLocalization, HandballGameApi, HandballGameConfig, HandballGameLog, HandballGameLogTypeLocalization, HandballGameLogTypes, HandballGameStatistic, HandballGameTeamStatistic, HandballProfile, HandballStatistic, HockeyAdvantageTypes, HockeyGameApi, HockeyGameConfig, HockeyGameLog, HockeyGameLogTypeLocalization, HockeyGameLogTypes, HockeyGameStatistic, HockeyGameTeamStatistic, HockeyPenaltyTypes, HockeyPenaltyTypesEn, HockeyProfile, HockeyStatistic, HockeyWorkHand, HockeyWorkHandLocalization, HttpCookieInterceptor, League, LeagueApi, LeagueBanner, LeagueCourt, LeagueDocument, LeagueFieldBase, LeagueFieldBaseValue, LeagueFieldTypes, LeagueNews, LeagueNewsApi, LeagueNewsType, LeaguePartner, LeaguePlayer, LeaguePlayerApi, LeaguePlayerField, LeaguePlayerFieldValue, LeaguePlaylist, LeagueTeamApi, LeagueTeamField, LocalStorageEngine, MODEL_MAPPING_FIELDS_KEY, MODEL_RELATION_KEY, MODEL_TO_BACK_KEY, MODEL_TO_FRONT_KEY, MediaApi, MediaItem, MhlCarousel, MhlCarouselTeam, ModelInstance, Notification, NotificationAllowTypes, NotificationApi, NotificationBaseApi, NotificationServiceEnum, NotificationSettings, NotificationType, OrgNotificationApi, Organization, OrganizationBill, OrganizationBillStatusLocalization, OrganizationBillStatuses, OrganizationStatistic, OrganizationStatuses, OrganizationStatusesLocalization, OrganizationTariff, OvertimeTypeLocalization, OvertimeTypes, Playoff, PlayoffSettings, PlayoffTypes, Poll, PollAnswer, PollStatuses, PollVariant, PublicTeamApi, PublicUserApi, Qualification, QualificationLocalization, RUGBY_GAME_LOG_TYPE_POINTS, RUGBY_TEAM_LOG_TYPES, ReferenceApi, RoundTeamGame, RugbyFoulGameStage, RugbyFoulGameStageLocalization, RugbyFoulSanctionLocalization, RugbyFoulSanctions, RugbyFoulType, RugbyGameApi, RugbyGameConfig, RugbyGameLog, RugbyGameLogTypeLocalization, RugbyGameLogTypes, RugbyGameStatistic, RugbyGameTeamStatistic, RugbyProfile, RugbyStatistic, RugbyStatisticTypes, SCORE_LOG_TYPES, Sport, SportTypes, StageTeamGame, StorageEngine, StorageEngineField, Store, SubstituteManageTypes, Team, TeamAccess, TeamAchievement, TeamAdditionalData, TeamApi, TeamEvent, TeamEventApi, TeamEventInvite, TeamEventInviteStatuses, TeamEventTypeLocalization, TeamEventTypes, TeamInvite, TeamInviteExternal, TeamPermission, TeamPermissionTypes, TeamUser, TeamUserRole, TeamUserRoleLocalization, TeamsAndUsers, TimerTypes, ToBackHook, ToFrontHook, Tournament, TournamentApi, TournamentDisqualification, TournamentDivision, TournamentEvent, TournamentEventTypes, TournamentGender, TournamentGroup, TournamentInvite, TournamentJoin1x1Data, TournamentJoin1x1Status, TournamentJoinApi, TournamentJoinData, TournamentJoinTeam, TournamentNews, TournamentRound, TournamentRoundApi, TournamentRoundSettings, TournamentRoundTeam, TournamentRoundTypes, TournamentSeason, TournamentSeasonApi, TournamentSeasonStatuses, TournamentSettings, TournamentStage, TournamentStageApi, TournamentStageStatuses, TournamentStageTeam, TournamentStatuses, TournamentTeam, TournamentTeamFieldValue, TournamentTeamShort, TournamentTeamUser, TournamentTeamUserInvite, TournamentTeamWinner, TournamentTypes, UntilDestroy, User, UserAccess, UserApi, UserGender, UserPermission, UserPermissionTypes, UserProfile, VolleyballGameApi, VolleyballGameConfig, VolleyballGameLog, VolleyballGameLogType, VolleyballGameLogTypeLocalization, VolleyballGameStatistic, VolleyballGameTeamStatistic, VolleyballGameTypes, VolleyballProfile, VolleyballStatistic, VolleyballStatisticTypes, VolleyballWorkHand, VolleyballWorkHandLocalization, WaterpoloAdvantageTypes, WaterpoloGameApi, WaterpoloGameConfig, WaterpoloGameLog, WaterpoloGameLogTypeLocalization, WaterpoloGameLogTypes, WaterpoloGameStatistic, WaterpoloGameTeamStatistic, WaterpoloProfile, WaterpoloStatistic, WaterpoloStatisticTypes, WaterpoloWorkHand, WaterpoloWorkHandLocalization, WorkHand, WorkHandLocalization, WrestballGameApi, WrestballGameConfig, WrestballGameLog, WrestballGameLogTypeLocalization, WrestballGameLogTypes, WrestballGameStatistic, WrestballGameTeamStatistic, WrestballProfile, WrestballStatistic, WrestballStatisticTypes, WrestballWorkHand, WrestballWorkHandLocalization, addItemInArray, addItemsInArray, applyGameMediaFilters, applyGamesFilters, applyStatisticFilters, applyStatisticLeadersFilters, changeFavicons, componentDestroyed, deleteItemFromArray, enumField, fileSizeValidator, generateArray, getArrayChunks, getCookie, getEnumOptions, getIconsData, handleError, isTouchDevice, listField, markFormGroupTouched, minLengthArrayValidator, parseDate, patchItemInArray, penaltyTypeField, updateItemInArray, updateItemsInArray, validateDate, validateEmail, validatePhone, validateUrl };

